/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 * created on 16.12.2017
 */
(function () {
  'use strict';

  angular.module('AomsLumi.pages', [
    'ui.router',

    'AomsLumi.pages.main',
    'AomsLumi.pages.login',
    'AomsLumi.pages.signup',
    'AomsLumi.pages.dashboard',
    'AomsLumi.pages.data',
    'AomsLumi.pages.analysis',
    'AomsLumi.pages.lumicon',
    'AomsLumi.pages.diagnostics',
    'AomsLumi.pages.settings',
    'AomsLumi.pages.advanced'
    // 'AomsLumi.pages.profile',
  ])
  .config(routeConfig)
  .run(['$rootScope', '$injector', '$state', '$log', 'toastr', 'LumiService', function ($rootScope, $injector, $state, $log, toastr, LumiService) {
      $rootScope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams) {
        if(toState.name.includes('main.lumicon') && !env.enableLumiCon)  {
            toastr.error("The LumiCon module is currently not enabled");
            e.preventDefault();
        } 
        else if(toState.name.includes('main.analysis.outlier') && !env.enableAnalysisOutlier)  {
            toastr.error("The Outlier Monitor module is currently not enabled");
            e.preventDefault();
        }
        else  {
          const companyInfo = env.standalone ? true : LumiService.hasCompanyInfo();
          const userInfo = JSON.parse(localStorage.getItem('key_AOMS_LUMI_USERINFO'));
          let tenant = LumiService.getTenant();
          // Transition to the dashboard page if an authenticated user attempts to access the login page without logging out
          if(toState.name === 'login')  {
              if(companyInfo && userInfo)  {
                  $state.go('main.dashboard');
                  e.preventDefault();
              }
          }
          else if(toState.authenticate)  {
              if(companyInfo && userInfo)  {
                // Prevent state change if the user's role is not whitelisted for the toState
                if(toState.roles && toState.roles
                        .filter(r => userInfo.roles.indexOf(r) > -1)
                        .length === 0)  {
                    toastr.error("You do not have the required role to view this page");
                    e.preventDefault();
                }
                else  {
                  if(tenant !== null)  {
                    let InternalSettingsService = $injector.get('InternalSettingsService');
                    if(toState.name === 'main.dashboard' &&
                      (fromState.name === '' || fromState.name === 'login' || fromState.name === 'main.dashboard'))  {
                      // If authenticated but not FLAG_IS_CH_DIAG is set, transition to Channel Diagnostics Tool
                      if(env.cableType === 'fibre')  {
                        InternalSettingsService.settings.get({ tenant: tenant, key: "FLAG_IS_CH_DIAG" }, function(res)  {
                          const isChannelDiagnostics = res.val ? (res.val === "1") : false;
                          if(isChannelDiagnostics)  {
                              $log.info("Currently in Channel Diagnostics mode.  Transition to Channel Diagnostics Tool");
                              $state.go('main.diagnostics.channel');
                              e.preventDefault();
                          }
                          else  {
                              // If FLAG_IS_CH_DIAG is not set and FLAG_IS_INIT is not set, transition to Channel Manager
                              InternalSettingsService.settings.get({ tenant: tenant, key: "FLAG_IS_INIT" }, function(res)  {
                                  const globalInit = res.val ? (res.val === "1") : false;
                                  if(!globalInit)  {
                                      if(env.readOnly)  {
                                        toastr.error("The system has not been initialized and the system is not a mode that supports initialization");

                                        // Go back to login page
                                        //$window.localStorage.clear();
                                        $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                                        $state.go('login');
                                        e.preventDefault();
                                      }
                                      else  {
                                        $log.info("AOMS Admin not initialized.  Transition to Channel Manager");
                                        $state.go('main.advanced.channelmanagement');
                                        e.preventDefault();
                                      }
                                  }
                              }, function(err)  {
                                  const errData = err.data;
                                  $log.error("An error has occurred getting FLAG_IS_INIT internal setting during a state change to main.dashboard: "
                                      .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
  
                                  // Go back to login page
                                  //$window.localStorage.clear();
                                  $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                                  $window.localStorage.removeItem('key_AOMS_LUMI_TENANT');
                                  $state.go('login');
                                  e.preventDefault();
                              });
                          }
                        }, function(err)  {
                            const errData = err.data;
                            $log.error("An error has occurred getting FLAG_IS_CH_DIAG internal setting during a state change to main.dashboard: "
                                .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
    
                            // Go back to login page
                            //$window.localStorage.clear();
                            $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                            $window.localStorage.removeItem('key_AOMS_LUMI_TENANT');
                            $state.go('login');
                            e.preventDefault();
                      });
                      }
                      else if (env.cableType === 'electronic')  {
                        // Transition to Cable Manager FLAG_IS_INIT is false
                        InternalSettingsService.settings.get({ tenant: tenant, key: "FLAG_IS_INIT" }, function(res)  {
                          const globalInit = res.val ? (res.val === "1") : false;
                          if(!globalInit)  {
                              if(env.readOnly)  {
                                toastr.error("The system has not been initialized and the system is not a mode that supports initialization");

                                // Go back to login page
                                //$window.localStorage.clear();
                                $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                                $state.go('login');
                                e.preventDefault();
                              }
                              else  {
                                $log.info("AOMS Admin not initialized.  Transition to Cable Manager");
                                $state.go('main.advanced.cablemanagement');
                                e.preventDefault();
                              }
                          }
                        }, function(err)  {
                            const errData = err.data;
                            $log.error("An error has occurred getting FLAG_IS_INIT internal setting during a state change to main.dashboard: "
                                .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                            // Go back to login page
                            //$window.localStorage.clear();
                            $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                            $window.localStorage.removeItem('key_AOMS_LUMI_TENANT');
                            $state.go('login');
                            e.preventDefault();
                        });
                      }
                      else  {
                        $log.error("Failed to determine cable type");
                        
                        // Go back to login page
                        //$window.localStorage.clear();
                        $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                        $state.go('login');
                        e.preventDefault();
                      }
                    }
                  }
                  else  {
                    // Empty tenant
                    if(toState.name !== 'login' && !((fromState.name === 'login' || fromState.name === '') && toState.name === 'main.dashboard'))  {
                      $state.reload();
                      e.preventDefault();
                    }
                  }
                }
              }
              else  {
                  // Transition to login state if user is not authenticated
                  $state.go('login', {}, { reload: true });
                  e.preventDefault();
              }
          }
        }   
      });
  }]);


  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
      $urlRouterProvider.otherwise('/login');

    // baSidebarServiceProvider.addStaticItem({
    //   title: 'Pages',
    //   icon: 'ion-document',
    //   subMenu: [{
    //     title: 'Sign In',
    //     fixedHref: 'auth.html',
    //     blank: true
    //   }, {
    //     title: 'Sign Up',
    //     fixedHref: 'reg.html',
    //     blank: true
    //   }, {
    //     title: 'User Profile',
    //     stateRef: 'profile'
    //   }, {
    //     title: '404 Page',
    //     fixedHref: '404.html',
    //     blank: true
    //   }]
    // });
    // baSidebarServiceProvider.addStaticItem({
    //   title: 'Menu Level 1',
    //   icon: 'ion-ios-more',
    //   subMenu: [{
    //     title: 'Menu Level 1.1',
    //     disabled: true
    //   }, {
    //     title: 'Menu Level 1.2',
    //     subMenu: [{
    //       title: 'Menu Level 1.2.1',
    //       disabled: true
    //     }]
    //   }]
    // });
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'textAngular',
      'AomsLumi.theme.components',
      'AomsLumi.theme.inputs'
  ]);

})();

/**
 * @author Charles Fung
 * created on 25.06.2017
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.analysis', ['nya.bootstrap.select','ngResource'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('main.analysis', {
                    url: '/analysis',
                    template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                    abstract: true,
                    title: 'Analysis',
                    sidebarMeta: {
                        icon: 'ion-ios-analytics',
                        order: 2,
                    },
                    authenticate: true,
                    requiresInit: true
                })
                .state('main.analysis.outlier', {
                    url: '/outlier',
                    templateUrl: 'app/pages/analysis/outlier/outlier.html',
                    controller: 'OutlierCtrl',
                    controllerAs: 'vm',
                    title: 'Outlier Detection',
                    sidebarMeta: {
                        order: 0,
                    },
                    hidden: !env.enableAnalysisOutlier,
                    authenticate: true,
                    requiresInit: true
                });
        });
})();
/**
 * @author Charles Fung
 * created on 27.12.2017
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.advanced', ['ui.select', 'ngSanitize', 'ngResource'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('main.advanced', {
                    url: '/advanced',
                    template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                    abstract: true,
                    title: 'Advanced',
                    sidebarMeta: {
                        icon: 'ion-lock-combination',
                        order: 4,
                    },
                    hidden: false,
                    authenticate: true,
                    roles: ['AOMS_ADMIN', 'AOMS_SUPPORT', 'ADMIN']
                })
                .state('main.advanced.admin', {
                    url: '/admin',
                    templateUrl: 'app/pages/advanced/admin/admin.html',
                    controller: 'AdminCtrl',
                    controllerAs: 'vm',
                    title: 'Admin Panel',
                    sidebarMeta: {
                        order: 0,
                    },
                    hidden: false || env.readOnly,
                    authenticate: true,
                    requiresInit: true,
                    roles: ['AOMS_ADMIN', 'AOMS_SUPPORT', 'ADMIN']
                })
                .state('main.advanced.internalsettings', {
                    url: '/settings/internal',
                    templateUrl: 'app/pages/advanced/internalsettings/internalsettings.html',
                    controller: 'InternalSettingsCtrl',
                    controllerAs: 'vm',
                    title: 'Internal Settings',
                    sidebarMeta: {
                        order: 1,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true,
                    roles: ['AOMS_ADMIN', 'AOMS_SUPPORT', 'ADMIN']
                })
                .state('main.advanced.networking', {
                    url: '/networking',
                    templateUrl: 'app/pages/advanced/networking/networking.html',
                    controller: 'NetworkingCtrl',
                    controllerAs: 'vm',
                    title: 'Networking',
                    sidebarMeta: {
                        order: 2,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true,
                    roles: ['AOMS_ADMIN', 'AOMS_SUPPORT', 'ADMIN']
                })
                .state('main.advanced.cablemanagement', {
                    url: '/management/cable',
                    templateUrl: 'app/pages/advanced/cableManagement/cableManagement.html',
                    controller: 'CableManagementCtrl',
                    controllerAs: 'vm',
                    title: 'Cable Manager',
                    sidebarMeta: {
                        order: 3,
                    },
                    hidden: false || env.readOnly || env.cableType !== 'electronic',
                    authenticate: true,
                    requiresInit: false,
                    roles: ['AOMS_ADMIN', 'AOMS_SUPPORT', 'ADMIN']
                })
                .state('main.advanced.channelmanagement', {
                    url: '/management/channel',
                    templateUrl: 'app/pages/advanced/channelManagement/channelManagement.html',
                    controller: 'ChannelManagementCtrl',
                    controllerAs: 'vm',
                    title: 'Channel Manager',
                    sidebarMeta: {
                        order: 4,
                    },
                    hidden: false || env.readOnly || env.cableType !== 'fibre',
                    authenticate: true,
                    requiresInit: false,
                    roles: ['AOMS_ADMIN', 'AOMS_SUPPORT', 'ADMIN']
                });
        });
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.dashboard', [])
        .config(function($stateProvider) {
            $stateProvider
                .state('main.dashboard', {
                    url: '/dashboard',
                    templateUrl: 'app/pages/dashboard/dashboard.html',
                    title: 'Dashboard',
                    sidebarMeta: {
                        icon: 'ion-android-home',
                        order: 0,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true
                });
        });
})();

/**
 * @author Charles Fung
 * created on 27.06.2017
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.data', [])
        .config(function ($stateProvider) {
            $stateProvider
                .state('main.data', {
                    url: '/data',
                    template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                    abstract: true,
                    title: 'Data',
                    sidebarMeta: {
                        icon: 'ion-stats-bars',
                        order: 1,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true
                })
                .state('main.data.measurement', {
                    url: '/measurement',
                    templateUrl: 'app/pages/data/measurement/measurementData.html',
                    controller: 'MeasurementCtrl',
                    controllerAs: 'vm',
                    title: 'Measurement',
                    sidebarMeta: {
                        order: 0,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true
                })
                .state('main.data.wavelength', {
                    url: '/wavelength',
                    templateUrl: 'app/pages/data/wavelength/wavelengthData.html',
                    controller: 'WavelengthCtrl',
                    controllerAs: 'vm',
                    title: 'Wavelength',
                    sidebarMeta: {
                        order: 1,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true,
                    roles: ['AOMS_ADMIN', 'AOMS_SUPPORT', 'ADMIN']
                });
        });
})();

/**
 * @author Charles Fung
 * created on 25.06.2017
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.diagnostics', ['nya.bootstrap.select','ngResource'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('main.diagnostics', {
                    url: '/diagnostics',
                    template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                    abstract: true,
                    title: 'Diagnostics',
                    sidebarMeta: {
                        icon: 'ion-flash',
                        order: 2,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: false || env.cableType !== 'fibre'
                })
                .state('main.diagnostics.events', {
                    url: '/events',
                    templateUrl: 'app/pages/diagnostics/events/events.html',
                    controller: 'EventsCtrl',
                    controllerAs: 'vm',
                    title: 'Events',
                    sidebarMeta: {
                        order: 0,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true
                })
                .state('main.diagnostics.channel', {
                    url: '/channel',
                    templateUrl: 'app/pages/diagnostics/channel/channeldiagnostics.html',
                    controller: 'ChannelDiagnosticsCtrl',
                    controllerAs: 'vm',
                    title: 'Channel Diagnostics',
                    sidebarMeta: {
                        order: 0,
                    },
                    hidden: false || env.readOnly || env.cableType !== 'fibre',
                    authenticate: true,
                    requiresInit: false,
                    roles: ['AOMS_ADMIN', 'AOMS_SUPPORT', 'ADMIN']
                });
        });
})();
/**
 * Created by Charles Fung on 2018-01-10.
 */
(function() {
    'use strict';

    angular.module('AomsLumi.pages.login', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('login', {
                url: '/login',
                templateUrl: 'app/pages/login/login.html',
                title: 'Login',
                controller: 'LoginCtrl',
                controllerAs: 'vm',
                sidebarMeta: {
                    order: 800,
                },
                hidden: false,
                authenticate: false,
            });
    }

})();
/**
 * @author Charles Fung
 * created on 25.06.2017
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.lumicon', ['nya.bootstrap.select','ngResource'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('main.lumicon', {
                    url: '/lumicon',
                    template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                    abstract: true,
                    title: 'LumiCon',
                    sidebarMeta: {
                        icon: 'ion-cube',
                        order: 2,
                    },
                    hidden: !env.enableLumiCon,
                    authenticate: true,
                    requiresInit: true
                })
                .state('main.lumicon.maturity', {
                    url: '/maturity',
                    templateUrl: 'app/pages/lumicon/maturity/maturity.html',
                    controller: 'MaturityCtrl',
                    controllerAs: 'vm',
                    title: 'Maturity Strength',
                    sidebarMeta: {
                        order: 0,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true
                });
        });
})();
/**
 * Created by Charles Fung on 2018-01-11.
 */
(function() {
    'use strict';

    angular.module('AomsLumi.pages.main', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main', {
                url: '/main',
                templateUrl: 'app/pages/main/main.html',
                redirectTo: 'main.dashboard',
                hidden: false,
                authenticate: true,
            });
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.pages.profile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.profile', {
          url: '/profile',
          title: 'Profile',
          templateUrl: 'app/pages/profile/profile.html',
          controller: 'ProfilePageCtrl',
          hidden: false,
          authenticate: true
        });
  }

})();

/**
 * @author Charles Fung
 * created on 27.06.2017
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.settings', ['ui.select', 'ngSanitize', 'ngResource'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('main.settings', {
                    url: '/settings',
                    template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                    abstract: true,
                    title: 'Settings',
                    sidebarMeta: {
                        icon: 'ion-wrench',
                        order: 3,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true
                })
                .state('main.settings.general', {
                    url: '/general',
                    templateUrl: 'app/pages/settings/general/general.html',
                    controller: 'GeneralCtrl',
                    controllerAs: 'vm',
                    title: 'General',
                    sidebarMeta: {
                        order: 0,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true
                })
                .state('main.settings.channel', {
                    url: '/channel',
                    templateUrl: 'app/pages/settings/channel/channel.html',
                    controller: 'ChannelCtrl',
                    controllerAs: 'vm',
                    title: 'Channel',
                    sidebarMeta: {
                        order: 1,
                    },
                    hidden: false || env.cableType !== 'fibre',
                    authenticate: true,
                    requiresInit: true
                })
                .state('main.settings.alarm', {
                    url: '/alarm',
                    templateUrl: 'app/pages/settings/alarm/alarm.html',
                    controller: 'AlarmCtrl',
                    controllerAs: 'vm',
                    title: 'Alarm',
                    sidebarMeta: {
                        order: 2,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true
                })
                .state('main.settings.emailnotification', {
                    url: '/emailnotification',
                    templateUrl: 'app/pages/settings/email/emailnotification.html',
                    controller: 'EmailNotificationCtrl',
                    controllerAs: 'vm',
                    title: 'Email Notification',
                    sidebarMeta: {
                        order: 3,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true
                })
                .state('main.settings.user', {
                    url: '/user',
                    templateUrl: 'app/pages/settings/user/user.html',
                    controller: 'UserCtrl',
                    controllerAs: 'vm',
                    title: 'User',
                    sidebarMeta: {
                        order: 4,
                    },
                    hidden: false,
                    authenticate: true,
                    requiresInit: true
                });
        });
})();

/**
 * Created by Charles Fung on 2018-01-10.
 */
(function() {
    'use strict';

    angular.module('AomsLumi.pages.signup', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('signup', {
                url: '/signup',
                templateUrl: 'app/pages/signup/signup.html',
                title: 'Sign Up',
                controller: 'SignupCtrl',
                sidebarMeta: {
                    order: 800,
                },
                authenticate: false
            });
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

    angular.module('AomsLumi.theme.components', ['ngResource', 'ngSanitize']);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme.inputs', []);

})();

/**
 * Created by Charles Fung on 2017-10-23.
 */
/*jshint esversion: 6 */
/*eslint-env es6 */
let env = {};

// Import environmental variables if present from env.js
if(window)  {
    Object.assign(env, window.__env);
}

angular.module('AomsLumi', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',

  'ngResource',
  'ngFileSaver',
  'angularMoment',
  'ngMaterial',
  'chart.js',
  'ngMaterialDatePicker',
  'timer',

  'AomsLumi.theme',
  'AomsLumi.pages'
])
.constant('env', env)
.config(function($logProvider, env) {
    'use strict';
    $logProvider.debugEnabled(env.debugEnabled);
});
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('AdminService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();

            if(serverUrl)  {
                return {
                    filetypes: $resource(serverUrl.concat("/filetypes"), {}),
                    granularities: $resource(serverUrl.concat("/granularities"), {}),
                    system: $resource(serverUrl.concat("/system"), {},
                        {
                            // Polling service
                            'cpuStat': {
                                url: serverUrl.concat("/system/cpuStat"),
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }},
                            // Polling service
                            'memoryStat': {
                                url: serverUrl.concat("/system/memoryStat"),
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }},
                            // Polling service
                            'time': {
                                url: serverUrl.concat("/system/time"),
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }},
                        }),

                    tenants: $resource(serverUrl.concat("/tenants"), {}, {
                        'init': {
                            url: serverUrl.concat("/init_tenant"),    
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant",
                                project_name: "@project_name"
                            }},

                        'terminate': {
                            url: serverUrl.concat("/terminate_tenant"),    
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant"
                            }}    
                    })      
                };
            }
            else  {
                return null;
            }
            
        });
})();
/**
 * Created by Charles Fung on 2017-12-14.
 */
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';
    angular.module('AomsLumi')
        .factory('ChannelData', function ($log, $q, $resource, $filter, env) {
            const fileStatuses = {
                valid: 'Valid',
                empty: 'Empty',
                unsupported: 'Unsupported',
                error: 'Error',
            };

            const calibrationFileTypes = {
                calibrationMTS: 'MTS',
                calibrationLPS: 'LPS',
                calibrationMHS: 'MHS'
            };


            const createChannelSettingsDataWrapper = function(filename, data, status)  {
                return {
                    filename: filename,
                    data: data,
                    status: status
                };
            };

            const createSensorsCalibrationDataWrapper = function(path, channelId, serialNumber, calibrationFileType, data, status)  {
                return {
                    filename: path,
                    channelId: channelId,
                    serialNumber: serialNumber,
                    calibrationFileType: calibrationFileType,
                    data: data,
                    status: status
                };
            };


            const processChannelSettingsFile = function(numChannels, filename, fileContent)  {
                const channelSettingsData = [];
                const headers = env.configurationFileHeaders.channelSettings;
                if(headers)  {
                    const dataRows = fileContent.toString().replace("%22%",'').replace(/"/g,'').split('\n');
                    for (let i=0; i<numChannels; i++) {
                        let dataRow = dataRows[i].trim().replace(/"/g,'').split(/[,;]+/);
                        if(dataRow.length === headers.length)  {
                            channelSettingsData.push({
                                channelId: i+1,
                                channelSettingsData: {
                                    WIDTH:  dataRow[headers.findIndex(h => h === 'WIDTH')],
                                    NOISE_FLOOR:  dataRow[headers.findIndex(h => h === 'NOISE_FLOOR')],
                                    WIDTH_LVL:  dataRow[headers.findIndex(h => h === 'WIDTH_LVL')],
                                    REL_THRESHOLD:  dataRow[headers.findIndex(h => h === 'REL_THRESHOLD')],
                                    LENGTH:  dataRow[headers.findIndex(h => h === 'LENGTH')]
                                }
                            });
                        }
                        else  {
                            $log.error("Cannot process channel settings file due to bad file format.  Number of channel settings data attributes must equal to the file headers length.");
                            return createChannelSettingsDataWrapper(filename, null, fileStatuses.error);
                        }
                    }
                    return createChannelSettingsDataWrapper(filename, channelSettingsData, fileStatuses.valid);
                }
                else {
                    $log.error("Cannot process  channel settings file as file headers cannot be found");
                    return createChannelSettingsDataWrapper(filename, null, fileStatuses.error);
                }
            };


            const processCalibrationFile = function(channelId, serialNumber, calibrationFileType, numSensors, path, fileContent)  {
                const sensorsCalibrationData = [];
                const headers = env.configurationFileHeaders.sensorsCalibration[calibrationFileType];
                if(headers)  {
                    const dataRows = fileContent.toString().replace("%22%",'').replace(/"/g,'').split('\n');
                    if(numSensors === 0 || dataRows.length === numSensors+1)  {
                        for (let i=0; i<dataRows.length-1; i++) {
                            let dataRow = dataRows[i].trim().replace(/"/g,'').split(/[,;]+/);
                            if(dataRow.length === headers.length)  {
                                switch(calibrationFileType)  {
                                    case calibrationFileTypes.calibrationMTS:
                                        sensorsCalibrationData.push({
                                            sensorId: i+1,
                                            LAMBDA_A:  dataRow[headers.findIndex(h => h === 'LAMBDA_A')],
                                            T0:  dataRow[headers.findIndex(h => h === 'T0')],
                                            G1:  dataRow[headers.findIndex(h => h === 'G1')],
                                            G2:  dataRow[headers.findIndex(h => h === 'G2')],
                                            CONST:  dataRow[headers.findIndex(h => h === 'CONST')],
                                            LBOUND:  dataRow[headers.findIndex(h => h === 'LBOUND')],
                                            HBOUND:  dataRow[headers.findIndex(h => h === 'HBOUND')],
                                            LAMBDA_B:  dataRow[headers.findIndex(h => h === 'LAMBDA_B')],
                                            OFFSET:  dataRow[headers.findIndex(h => h === 'OFFSET')],
                                        });
                                        break;
                                    case calibrationFileTypes.calibrationLPS:
                                        $log.warn("Cannot process calibration LPS file as it is currently unsupported");
                                        return createSensorsCalibrationDataWrapper(path, channelId, serialNumber, calibrationFileType, null, fileStatuses.unsupported);
                                    case calibrationFileTypes.calibrationMHS:
                                        $log.warn("Cannot process calibration MHS file as it is currently unsupported");
                                        return createSensorsCalibrationDataWrapper(path, channelId, serialNumber, calibrationFileType, null, fileStatuses.unsupported);
                                    default:
                                        $log.warn("Cannot process sensors calibration file as it is of a currently unsupported type: ".concat(calibrationFileType));
                                        return createSensorsCalibrationDataWrapper(path, channelId, serialNumber, calibrationFileType, null, fileStatuses.unsupported);
                                }
                            }
                            else  {
                                $log.error("Cannot process sensors calibration file due to bad file format.  Number of sensor calibrations data attributes must equal to the file headers length.");
                                return createSensorsCalibrationDataWrapper(path, channelId, serialNumber, calibrationFileType, null, fileStatuses.error);
                            }
                        }
                        return createSensorsCalibrationDataWrapper(path, channelId, serialNumber, calibrationFileType, sensorsCalibrationData, fileStatuses.valid);
                    }
                    else  {
                        $log.error("Cannot process sensors calibration file due to bad file format.  Number of file rows must equal to the number of sensors.");
                        return createSensorsCalibrationDataWrapper(path, channelId, serialNumber, calibrationFileType, null, fileStatuses.error);
                    }
                }
                else {
                    $log.error("Cannot process sensors calibration file as file headers cannot be found for the calibration type: ".concat(calibrationFileType));
                    return createSensorsCalibrationDataWrapper(path, channelId, serialNumber, calibrationFileType, null, fileStatuses.error);
                }
            };


            return {
                createChannelSettingsData: function(numChannels, channelSettingsFile)  {
                    let deferred = $q.defer();

                    const fileReader = new FileReader();
                    const filename = channelSettingsFile.name;

                    let res = null;

                    try  {
                        if(channelSettingsFile.size === 0)  {
                            $log.warn("Cannot process channel settings file as it is empty: ".concat(filename));
                            res = createChannelSettingsDataWrapper(filename, null, fileStatuses.empty);
                        }
                        else  {
                            fileReader.onload = function()  {
                                deferred.resolve(processChannelSettingsFile(numChannels, filename, fileReader.result));
                            };

                            fileReader.readAsBinaryString(channelSettingsFile);
                        }

                        if(res)  {
                            deferred.resolve(res);
                        }
                    }
                    catch(err)  {
                        $log.error("An error has occurred processing channel settings file: ".concat(err.toString()));
                        deferred.resolve(processChannelSettingsFile(filename, null, fileStatuses.error));
                    }
                    return deferred.promise;
                },

                createSensorsCalibrationData: function(channelId, serialNumber, calibrationFileType, numSensors, sensorsCalibrationFile)  {
                    let deferred = $q.defer();

                    const fileReader = new FileReader();
                    const filename = sensorsCalibrationFile.name;
                    let path = sensorsCalibrationFile.webkitRelativePath;
                    if(!path || path.length === 0)  {
                        path = filename;
                    }

                    let res = null;

                    try  {
                        if(sensorsCalibrationFile.size === 0)  {
                            $log.warn("Cannot process sensors calibration file as it is empty: ".concat(filename));
                            res = createSensorsCalibrationDataWrapper(path, channelId, serialNumber, calibrationFileType, null, fileStatuses.empty);
                        }
                        else  {
                            if(calibrationFileType === calibrationFileTypes.calibrationMTS)  {
                                fileReader.onload = function()  {
                                    deferred.resolve(processCalibrationFile(channelId, serialNumber, calibrationFileType, numSensors, path, fileReader.result));
                                };

                                fileReader.readAsBinaryString(sensorsCalibrationFile);
                            }
                            else if(calibrationFileType === calibrationFileTypes.calibrationLPS)   {
                                $log.warn("Cannot process calibration LPS file as it is currently unsupported");
                                res = createSensorsCalibrationDataWrapper(path, channelId, serialNumber, calibrationFileType, null, fileStatuses.unsupported);
                            }
                            else if(calibrationFileType === calibrationFileTypes.calibrationMHS)   {
                                $log.warn("Cannot process calibration MHS file as it is currently unsupported");
                                res = createSensorsCalibrationDataWrapper(path, channelId, serialNumber, calibrationFileType, null, fileStatuses.unsupported);
                            }
                            else  {
                                $log.error("Cannot process sensors calibration file due to invalid type: ".concat(calibrationFileType));
                                res = createSensorsCalibrationDataWrapper(path, channelId, serialNumber, calibrationFileType, null, fileStatuses.error);
                            }
                        }

                        if(res)  {
                            deferred.resolve(res);
                        }
                    }
                    catch(err)  {
                        $log.error("An error has occurred processing sensors calibration file: ".concat(err.toString()));
                        deferred.resolve(createSensorsCalibrationDataWrapper(path, channelId, serialNumber, calibrationFileType, null, fileStatuses.error));
                    }
                    return deferred.promise;
                },

                getCalibrationFileTypes: function()  {
                    return calibrationFileTypes;
                }
            };
        })
        .factory('ChannelService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();
            
            if(serverUrl)  {
                return {
                    channels: $resource(serverUrl.concat("/channels"), {},
                        {
                            'query': {
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }},
                            'channelsWithAlarmData': {
                                url: serverUrl.concat("/channels/with_alarm"),
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'channelsByGroup': {
                                url: serverUrl.concat("/channels/by_group/:cgId"),
                                method: 'GET',
                                params: {
                                    tenant: "@tenant",
                                    cgId: "@cgId"
                                }},
                            'createChannels': {
                                url: serverUrl.concat("/channels/list"),
                                method: 'POST',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'assignAlarm': {
                                url: serverUrl.concat("/alarms/cmd/assign_channel"),
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'toggle': {
                                url: serverUrl.concat("/channels/cmd/toggle"),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'decommissionList': {
                                url: serverUrl.concat("/channels/cmd/decommission/list"),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            params: {
                                tenant: "@tenant"
                            }
                        }),
                    // Polling service
                    channelStatuses: $resource(serverUrl.concat("/channels/statuses/latest"), {},
                        {
                            'statusTypesByChannel': {
                                url: serverUrl.concat("/channels/statuses/latest"),
                                method: 'POST',
                            },
                            params: {
                                tenant: "@tenant"
                            }
                        }),
                    settings: $resource(serverUrl.concat("/settings/channel/:channelId"), {channelId: "@channelId" },
                        {
                            'query': {
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }},
                            'update': {
                                url: serverUrl.concat("/settings/channel"),
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }},
                            'updateAll': {
                                url: serverUrl.concat("/settings/channel/list"),
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            params: {
                                tenant: "@tenant"
                            }    
                        }),
                    sensors: $resource(serverUrl.concat("/channels/sensors"), {},
                        {
                            'sensorsByChannelId': {
                                url: serverUrl.concat("/channels/sensors/list/by_channelid/:channelId"),
                                method: 'GET',
                                params: {
                                    tenant: "@tenant",
                                    channelId: "@channelId"
                                }},
                            'sensorsBySensorType': {
                                url: serverUrl.concat("/channels/sensors/list/by_sensortype/:sensorTypeName"),
                                method: 'GET',
                                params: {
                                    tenant: "@tenant",
                                    sensorTypeName: "@sensorTypeName"
                                }},
                            // Polling service
                            'sensorsWithLatestDataStatuses': {
                                url: serverUrl.concat("/channels/sensors/list/with_data/with_statuses/:channelId"),
                                method: 'GET',
                                params: {
                                    tenant: "@tenant",
                                    channelId: "@channelId"
                                }},
                            'createSensors': {
                                url: serverUrl.concat("/channels/sensors/list"),
                                method: 'POST',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'types': {
                                url: serverUrl.concat("/channels/sensors/types"),
                                method: 'GET',
                                isArray: true,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }},
                            'getMTS': {
                                url: serverUrl.concat("/channels/sensors/calibration/mts"),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'getLPS': {
                                url: serverUrl.concat("/channels/sensors/calibration/lps"),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'getMHS': {
                                url: serverUrl.concat("/channels/sensors/calibration/mhs"),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},   
                            'updateMTS': {
                                url: serverUrl.concat("/channels/sensors/calibration/mts"),
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'updateMTSList': {
                                url: serverUrl.concat("/channels/sensors/calibration/mts/list"),
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'updateLPS': {
                                url: serverUrl.concat("/channels/sensors/calibration/lps"),
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'updateLPSList': {
                                url: serverUrl.concat("/channels/sensors/calibration/lps/list"),
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'updateMHS': {
                                url: serverUrl.concat("/channels/sensors/calibration/mhs"),
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'updateMHSList': {
                                url: serverUrl.concat("/channels/sensors/calibration/mhs/list"),
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            params: {
                                tenant: "@tenant"
                            }     
                        }),
                    channelGroups: $resource(serverUrl.concat("/channels/groups"), {cgId: "@cgId" },
                    {
                        'getChannelGroupsByType': {
                            url: serverUrl.concat("/channels/groups/by_type/:channelGroupTypeName"),
                            method: 'GET',
                            isArray: false,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant",
                                channelGroupTypeName: "@channelGroupTypeName"
                            }},
                        'dissociateNode': {
                            url: serverUrl.concat("/channels/nodes/cmd/dissociate/:cgId"),
                            method: 'POST',
                            isArray: false,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant",
                                cgId: "@cgId"
                            }},
                        params: {
                            tenant: "@tenant"
                        }    
                    }),
                    diagnosticChannels: $resource(serverUrl.concat("/channels/diagnostics"), {channelId: "@channelId" },
                    {
                        'query': {
                            method: 'GET',
                            isArray: false,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant",
                            }},
                        'toggle': {
                            url: serverUrl.concat("/channels/diagnostic/cmd/toggle"),
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant",
                            }},
                        'deactivateAll': {
                            url: serverUrl.concat("/channels/diagnostic/cmd/deactivate/all"),
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant",
                            }},
                        'getHealth': {
                            url: serverUrl.concat("/channels/diagnostics/health/:channelId"),
                            method: 'GET',
                            params: {
                                tenant: "@tenant",
                                channelId: "@channelId"
                            }},    
                    }),
                    diagnosticSensors: $resource(serverUrl.concat("/channels/sensors/diagnostics"), {},
                    {
                        'query': {
                            method: 'GET',
                            isArray: false,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant",
                            }},
                        'decommissionAll': {
                            url: serverUrl.concat("/channels/sensors/diagnostic/cmd/decommission/all"),
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant",
                            }},
                        'getHealthsByChannelId': {
                            url: serverUrl.concat("/channels/sensors/diagnostics/health/:channelId"),
                            method: 'GET',
                            params: {
                                tenant: "@tenant",
                                channelId: "@channelId"
                            }},
                        params: {
                            tenant: "@tenant"
                        }         
                    })
                };
            }
            else  {
                return null;
            }
        });
})();

/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('DiagnosticsService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();

            if(serverUrl)  {
                return {
                    statuses: $resource(serverUrl.concat("/statuses"), {},
                        {
                            'query': {
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }},
                            'statusByName': {
                                url: serverUrl.concat("/statuses/by_name/:name"),
                                method: 'GET',
                                params: {
                                    tenant: "@tenant",
                                    name: "@name"
                                }
                            },
                            // Polling service
                            'statusesWithPercentage': {
                                url: serverUrl.concat("/statuses/with_percentage"),
                                method: 'GET',
                                params: {
                                    tenant: "@tenant"
                                }
                            },
                            // Polling service
                            'statusTypesByFlags': {
                                url: serverUrl.concat("/statuses/types/latest/:statusName"),
                                method: 'GET',
                                params: {
                                    tenant: "@tenant",
                                    name: "@statusName"
                                },
                            },
                            params: {
                                tenant: "@tenant"
                            }
                        }),
                };
            }
            else  {
                return null;
            }
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('EnvironSensorService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();

            if(serverUrl)  {
                return {
                    sensors: $resource(serverUrl.concat("/environ/sensors/:id"), { id: "@id" },
                        {
                            'query': {
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }},
                            params: {
                                tenant: "@tenant"
                            }    
                        }),
                    environSensorStatuses: $resource(serverUrl.concat("/environ/sensors/statuses/:status"), { status: "@status" },
                        {
                            // Polling service
                            'statusTypesBySensor': {
                                url: serverUrl.concat("/environ/sensors/statuses/latest"),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }}
                        }),
                    // Polling service
                    latestTemperatures: $resource(serverUrl.concat("/environ/temperatures/latest"), { environSensorId: "@environSensorId" }, { tenant: "@tenant" }),
                    // Polling service
                    latestPressures: $resource(serverUrl.concat("/environ/pressures/latest"), { environSensorId: "@environSensorId" }, { tenant: "@tenant" }),
                    // Polling service
                    latestHumidities: $resource(serverUrl.concat("/environ/humidities/latest"), { environSensorId: "@environSensorId" }, { tenant: "@tenant" }),
                    // Polling service
                    latestDewpoints: $resource(serverUrl.concat("/environ/dewpoints/latest"), { environSensorId: "@environSensorId" }, { tenant: "@tenant" })
                };
            }   
            else  {
                return null;
            } 
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('EventService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();

            if(serverUrl)  {
                return {
                    eventBySeverity: $resource(serverUrl.concat("/events/paged/by_severity"), {},
                        {
                            // Polling service
                            'query': {
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    page: "@page",
                                    rpp: "@rpp",
                                    sortdir: "@sortdir",
                                    severityNameFilter: "@severityNameFilter"
                                }
                            },
                            params: {
                                tenant: "@tenant"
                            }
                        }),
                    latestEvent: $resource(serverUrl.concat("/events/latest/:id"), { id: "@id" },
                        {
                            // Polling service
                            'query': {
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }},
                            params: {
                                tenant: "@tenant",
                            }
                        }),
                    eventSeverities: $resource(serverUrl.concat("/events/severities"), {},
                        {
                            'query': {
                                method: 'GET',
                                isArray: true,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }}
                        })
                };
            }
            else  {
                return null;
            }    
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('LumiService', function ($log, $window, $state, env) {
            const verifyAlvinConfigInternal = function()  {
                if(env.standalone)  {
                    return true;
                }
                else  {
                    if(((env.alvinApiUrl === null || env.alvinApiUrl === undefined) || 
                        (env.alvinServerPort === null || env.alvinServerPort === undefined))) {
                        return false;
                    }
                    else  {
                        return true;
                    }
                }
            };
            
            const verifyAlfredConfigInternal = function()  {
                if(env.standalone)  {
                    if((env.apiUrl === null || env.apiUrl === undefined) || 
                        (env.serverPort === null || env.serverPort === undefined))  {
                            return false;
                    }
                    else if(env.tenant === undefined || env.tenant === null)  {
                        return false;
                    }
                    return true;
                }
                else  {
                    return true;
                }
            };

            const companyInfoInternal = function()  {
                const companyInfo = JSON.parse(localStorage.getItem('key_ALVIN_LUMI_COMPANYINFO'));
                if(companyInfo && companyInfo.token && companyInfo.companyId && companyInfo.alfredServer)  {
                    return companyInfo;
                }
                else  {
                    // Transition to login state if user is not authorized on Alvin
                    $log.error("Failed to get companyInfo.  Transition to login state");
                    $window.localStorage.clear();
                    $state.go('login');
                    
                    return null;
                }
            }

            return {
                verifyAlvinConfig: function()  {
                    return verifyAlvinConfigInternal();
                },

                verifyAlfredConfig: function()  {
                    return verifyAlfredConfigInternal();
                },

                getAlvinServerUrl: function()  {
                    if(verifyAlvinConfigInternal())  {
                        return env.alvinApiUrl.concat(":").concat(env.alvinServerPort.toString());
                    }
                    else  {
                        $log.error("Failed to verify Alvin config.  Transition to login state");
                        $window.localStorage.clear();
                        $state.go('login', {}, { reload: true });

                        return null;
                    }  
                },

                getServerUrl: function()  {
                    if(verifyAlfredConfigInternal())  {
                        if(env.standalone)  {
                            return env.apiUrl.concat(":").concat(env.serverPort.toString());
                        }
                        else  {
                            if((env.apiUrl !== null && env.apiUrl !== undefined) && 
                                (env.serverPort !== null && env.serverPort !== undefined))  {
                                return env.apiUrl.concat(":").concat(env.serverPort.toString());
                            }
                            else  {
                                let companyInfo = companyInfoInternal();
                                return companyInfo ? companyInfo.alfredServer : null; 
                            }
                        } 
                    }
                    else  {
                        $log.error("Failed to verify Alfred config.  Transition to login state");
                        $window.localStorage.clear();
                        $state.go('login', {}, { reload: true });

                        return null;
                    }  
                },

                getTenant: function()  {
                    let tenant = env.tenant;
                    if(tenant === null || tenant === undefined)  {
                        if(env.standalone)  {
                            return null;
                        }
                        else  {
                            const t = localStorage.getItem('key_AOMS_LUMI_TENANT');
                            tenant = t != null ? parseInt(t) : null
                        }  
                    }
                    return tenant;
                },

                companyInfo: function()  {
                    if(env.standalone)  {
                        return null;
                    }
                    else  {
                        return companyInfoInternal();
                    }
                },

                hasCompanyInfo: function()  {
                    const companyInfo = JSON.parse(localStorage.getItem('key_ALVIN_LUMI_COMPANYINFO'));
                    return companyInfo && companyInfo.token && companyInfo.companyId && companyInfo.alfredServer;
                },
            };
        });
})();
/**
 * Created by Charles Fung on 2017-12-14.
 */
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';
    angular.module('AomsLumi')
        .factory('MeasurementData', function ($log, $q, $resource, $filter, moment, env, LumiService, MeasurementDataService, UtilService) {
            const serverUrl = LumiService.getServerUrl();


            const measurementDataTimeouts = {
                realtime: env.realtimeMeasurementDataTimeout,
                snapshot: env.snapshotMeasurementDataTimeout,
                historical: env.historicalMeasurementDataTimeout
            };


            let master = {
                realtime: {},
                snapshot: {},
            };

            if(serverUrl)  {
                return {
                    clearMaster: function(datatype)  {
                        Object.keys(master[datatype]).forEach(k => delete master[datatype][k]);
                    },
    
                    // Polling service
                    pruneMaster: function(datatype, amount, unit, currChannelId)  {
                        $log.debug("Pruning all master measurement data (".concat(datatype).concat(") older than ")
                            .concat(amount).concat(" ").concat(unit));
    
                        let cutoff = moment().subtract(amount, unit);
                        Object.entries(master[datatype]).forEach(
                            ([k, v]) => {
                                if(UtilService.szudzikUnpairing(k.valueOf())[0] === currChannelId)  {
                                    master[datatype][k] = v.filter(data => moment(data.x) > cutoff);
    
                                    // Remove data array if empty after pruning
                                    if(master[datatype][k].length === 0)  {
                                        delete master[datatype][k];
                                    }
                                }
                                else  {
                                    // Remove data that does not belong to the current channel
                                    delete master[datatype][k];
                                }
                            }
                        );
                    },
    
                    // Polling service
                    updateMaster: function(tenant, datatype, sensors, granularity, sortdir)  {
                        $log.debug("Updating master measurement data (".concat(datatype)
                            .concat(") for sensors: ").concat(JSON.stringify(sensors)));
                        let deferred = $q.defer();
    
                        let sensorInfos = sensors.map(ss => UtilService.szudzikPairing(ss.channelId, ss.sensorId).toString());
    
                        // Build requests from existing measurement data in master.
                        // Cutoff id for each sensor is determined by the maximum id of the sensor data.
                        // From date for each sensor is the maximum of 30 seconds ago (real-time datatype) or 12-hours ago (snapshot datatype) from current time and the max timestamp of the sensor data.
                        let to = moment();
                        let from = datatype === 'snapshot' ?  moment(to).subtract(12, 'hours') : moment(to).subtract(30, 'seconds');
    
                        let curr = Object.keys(master[datatype])
                            .filter(sensor => sensors.map(ss => (UtilService.szudzikPairing(ss.channelId, ss.sensorId).toString()))
                                .includes(sensor) && master[datatype][sensor].length > 0)
                            .reduce((filtered, sensorInfo) =>  {
                                filtered.push({
                                    sensorInfo: parseFloat(sensorInfo),
                                    sensorType: sensors.filter(ss => UtilService.szudzikPairing(ss.channelId, ss.sensorId) === parseFloat(sensorInfo)).map(ss => ss.sensorType)[0],
                                    cutoffId: master[datatype][sensorInfo].reduce((max, s) => s.id > max ? s.id : max, master[datatype][sensorInfo][0].id),
                                    from: Math.max(from.valueOf(), master[datatype][sensorInfo].reduce((max, s) => s.x > max ? s.x : max, master[datatype][sensorInfo][0].x)),
                                    to: to.valueOf()
                                });
                                return filtered;
                            }, []);
    
                        // Concatenate requests for existing measurement data sensor with requests built from new sensors
                        // For new sensors, we get data up to 30 seconds ago (real-time datatype) or 12-hours ago (snapshot datatype) with cutoff id greater than 0
                        let requests = curr.concat(
                            sensors.filter(ss => !curr.map(c => c.sensorInfo)
                                .some(c => UtilService.szudzikPairing(ss.channelId, ss.sensorId) === c))
                                .reduce((filtered, sensor) =>  {
                                    filtered.push({
                                        sensorInfo: UtilService.szudzikPairing(sensor.channelId, sensor.sensorId),
                                        sensorType: sensor.sensorType,
                                        cutoffId: 0,
                                        from: datatype === 'snapshot' ?  moment(to).subtract(12, 'hours').valueOf() : moment(to).subtract(30, 'seconds').valueOf(),
                                        to: to.valueOf()
                                    });
                                    return filtered;
                                }, [])
                        );
    
                        $log.debug("Measurement data request (".concat(datatype).concat("): ")
                            .concat(JSON.stringify(requests)));
                        let params = {
                            tenant: tenant,
                            granularity: granularity,
                            sortdir: sortdir,
                            timeout: 1000
                        };
    
                        const measurementDataReqStart = moment();
                        MeasurementDataService.measurementDataByTimeRange(measurementDataTimeouts[datatype])
                            .data(params, requests, function(res) {
                                const duration = moment.duration(moment().diff(measurementDataReqStart));
                                $log.debug("Done measurement data request (updateMaster, " + datatype + ") in " + duration.asSeconds() + " seconds");
    
                                // Update existing senor data
                                Object.keys(master[datatype]).forEach(k => {
                                    if(sensorInfos.includes(k) && res[k]) {
                                        master[datatype][k].push(...res[k]);
                                    }
                                });
    
                                // Add new sensor data
                                sensorInfos.filter(sensorInfo => !(Object.keys(master[datatype]).some(k => k === sensorInfo)))
                                    .forEach(a => {
                                        if(res[a])  {
                                            master[datatype][a] = res[a];
                                        }
                                    });
    
                                // Return only the delta for real-time updates.  Nothing for snapshot updates.  Else, return the entire master dataset.
                                if(datatype === 'realtime') {
                                    deferred.resolve(res);
                                }
                                else if(datatype === 'snapshot') {
                                    deferred.resolve(true);
                                }
                                else  {
                                    deferred.resolve(master[datatype]);
                                }
                            }, function(err)  {
                                const errData = err.data;
                                $log.error("Measurement data request (updateMaster, " + datatype + ") has encountered an error or has timed out: "
                                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
    
                                const duration = moment.duration(moment().diff(measurementDataReqStart));
                                $log.error("Abandoned or completed measurement data request (updateMaster, " + datatype + ") with error after " +
                                    duration.asSeconds() + " seconds.  Timeout for updating master (" + datatype + ") is " +
                                    measurementDataTimeouts[datatype]/1000 + " seconds.");
    
                                deferred.reject(false);
                            });
    
                        return deferred.promise;
                    },
    
                    // Polling service
                    latestMaster : function(datatype, sensors) {
                        let res = [];
                        for (let ss of sensors) {
                            let sensorInfo = UtilService.szudzikPairing(ss.channelId, ss.sensorId).toString();
                            let datapoint = null;
                            if(sensorInfo in master[datatype])  {
                                let data = master[datatype][sensorInfo];
                                let len = data.length;
                                if(len > 0)  {
                                    datapoint = data[len-1].y;
                                }
                            }
                            res.push(datapoint);
                        }
                        return res;
                    },
    
                    // Polling service
                    filterMaster : function(datatype, sensors, from, to) {
                        return Object.keys(master[datatype])
                            .filter(sensor => sensors.map(ss => UtilService.szudzikPairing(ss.channelId, ss.sensorId).toString())
                                .includes(sensor))
                            .reduce((filtered, sensor) =>  {
                                filtered[sensor] = master[datatype][sensor]
                                    .filter(data => moment(data.x).isBetween(from, to));
                                return filtered;
                            }, {});
                    },
    
                    getHistoricalData: function(tenant, sensors, from, to, granularity, tolerance, sortdir)  {
                        $log.debug("Getting historical measurement data (".concat(granularity).concat(") for sensors: ").concat(JSON.stringify(sensors)));
                        let deferred = $q.defer();
    
                        let requests = sensors.reduce((reduced, sensor) =>  {
                            reduced.push({
                                sensorInfo: UtilService.szudzikPairing(sensor.channelId, sensor.sensorId),
                                sensorType: sensor.sensorType,
                                cutoffId: 0,
                                from: from.valueOf(),
                                to: to.valueOf()
                            });
                            return reduced;
                        }, []);
    
                        let params = {
                            tenant: tenant,
                            granularity: granularity,
                            sortdir: sortdir
                        };
    
                        $log.debug("Historical measurement data request: ".concat(JSON.stringify(requests)));
    
                        const measurementDataReqStart = moment();
                        MeasurementDataService.measurementDataByTimeRange(measurementDataTimeouts.historical, tolerance, false)
                            .data(params, requests, function(res) {
                                const duration = moment.duration(moment().diff(measurementDataReqStart));
                                $log.debug("Done measurement data request (getHistoricalData) in " + duration.asSeconds() + " seconds");
    
                                deferred.resolve(res.toJSON());
                            }, function(err)  {
                                const errData = err.data;
                                $log.error("Measurement data request (getHistoricalData) has encountered an error or has timed out: "
                                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
    
                                const duration = moment.duration(moment().diff(measurementDataReqStart));
                                $log.error("Abandoned or completed measurement data request (getHistoricalData) with error after " + duration.asSeconds() + " seconds.  " +
                                    "Timeout for getting historical data is " + (measurementDataTimeouts.historical)/1000 + " seconds.");
                                deferred.reject(err);
                            });
    
                        return deferred.promise;
                    },
    
                    getHistoricalDataFileLink: function(tenant, sensors, sensorTypeName, from, to, fileTypeName, granularity, displayTZ, sortdir, useSensorInfo, customFilename)  {
                        const userInfo = JSON.parse(localStorage.getItem('key_AOMS_LUMI_USERINFO'));
                        if(userInfo && userInfo.token)  {
                            try {
                                const authTokenParam = "&auth_token=" + userInfo.token;
                                let sensorInfoParams = sensors.map(sensor => {
                                    return useSensorInfo ? UtilService.szudzikPairing(sensor.channelId, sensor.sensorId) : sensor.id;
                                }).reduce((queryStr, sensor, currIndex) =>  {
                                    queryStr = queryStr + ((currIndex === 0) ? "" : "&") + "sensors=" + sensor;
                                    return queryStr;
                                }, "");
    
                                if(granularity === 'tick')  {
                                    // Return URL for tick data
                                    return serverUrl + "/data/measurement/" + sensorTypeName.toLowerCase() +
                                        "/file?tenant=" + tenant + "&" + sensorInfoParams + "&sensortype=" + sensorTypeName + 
                                        (customFilename ? ('&customFilename=' + customFilename) : '') +
                                        "&from=" + from.valueOf() + "&to=" + to.valueOf() +
                                        "&format=" + fileTypeName + "&timezone=" + displayTZ + "&sortdir=" + sortdir + "&useSensorInfo=" + useSensorInfo + authTokenParam;
                                }
                                else  {
                                    // Return URL for aggregated data
                                    return serverUrl + "/data/measurement/aggregated/file?tenant=" + tenant + "&" + 
                                        sensorInfoParams + "&sensortype=" + sensorTypeName + 
                                        (customFilename ? ('&customFilename=' + customFilename) : '') +
                                        "&from=" + from.valueOf() + "&to=" + to.valueOf() +
                                        "&format=" + fileTypeName + "&granularity=" + granularity + "&timezone=" + displayTZ + 
                                        "&sortdir=" + sortdir + "&useSensorInfo=" + useSensorInfo + authTokenParam;
                                }
                            }
                            catch(err)  {
                                throw err;
                            }
                        }
                        else  {
                            throw "User may not be authenticated";
                        }
                    },
                };
            }
            else  {
                return null;
            }
        })
        .factory('MeasurementDataService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();
            
            if(serverUrl)  {
                return {
                    measurementDataByTimeRange: function(timeout, tolerance, allowDecommissioned) {
                        return $resource(serverUrl.concat("/data/measurement/time"), {},
                            {
                                // Polling service
                                'data': {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Accept': 'application/json'
                                    },
                                    params: {
                                        tenant: "@tenant",
                                        id: "@id",
                                        from: "@from",
                                        to: "@to",
                                        granularity: "@granularity",
                                        tolerance: tolerance ? tolerance : 0,
                                        allowDecommissioned: allowDecommissioned ? allowDecommissioned : false,
                                        sortdir: "@sortdir"
                                    },
                                    timeout: timeout
                                },
                            });
                    }
                };
            }
            else  {
                return null;
            }
        });
})();

/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('UtilService', function ($log, $window) {
            return {
                isObjectEmpty: function(obj)  {
                    for(const key in obj) {
                        if(obj.hasOwnProperty(key))  {
                            return false;
                        }
                    }
                    return true;
                },

                groupBy: function(list, keyGetter) {
                    const map = new Map();
                    list.forEach((item) => {
                        const key = keyGetter(item);
                        const collection = map.get(key);
                        if (!collection) {
                            map.set(key, [item]);
                        } else {
                            collection.push(item);
                        }
                    });
                    return map;
                },

                getDisplayTZOverride: function()  {
                    let displayTZOverride = null;
                    if(env.readOnly)  {
                        const usersettings = sessionStorage.getItem('key_AOMS_LUMI_USERSETTINGS');
                        if(usersettings)  {
                            const displayTZJson = JSON.parse(usersettings).filter(s => s.name === 'Display Time Zone');
                            if(displayTZJson && displayTZJson.length > 0)  {
                                displayTZOverride = displayTZJson[0].val;
                            }
                        }
                    }
                    return displayTZOverride;
                },

                convertUTCTimestamp: function(timestamp, displayTZ)  {
                    // If in read-only mode, see if there exists a displayTZ user setting in session storage
                    // If so, we override the displayTZ with the one in session storage
                    if(timestamp)  {
                        const displayTZOverride = this.getDisplayTZOverride();
                        $log.debug("Override displayTZ " + displayTZ + " with " + displayTZOverride + " from session storage");
                        return moment.tz(timestamp, displayTZOverride ? displayTZOverride : displayTZ)
                            .format('YYYY-MM-DD HH:mm:ss:SSSZ');
                    }
                },

                szudzikPairing: function(x, y)  {
                    return (x >= y) ? (x * x + x + y) : (y * y + x);
                },

                szudzikUnpairing: function(z)  {
                    let sqrtz = Math.floor(Math.sqrt(z)),
                        sqz = sqrtz * sqrtz;
                    return ((z - sqz) >= sqrtz) ? [sqrtz, z - sqz - sqrtz] : [z - sqz, sqrtz];
                },
            };
        });
})();
/**
 * Created by Charles Fung on 2017-12-14.
 */
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';
    angular.module('AomsLumi')
        .factory('WavelengthData', function ($log, $q, $resource, $filter, moment, env, LumiService, UtilService) {
            const serverUrl = LumiService.getServerUrl();  

            if(serverUrl)  {
                return {
                    getHistoricalDataFileLink: function(tenant, sensors, sensorTypeName, from, to, fileTypeName, sortdir, customFilename)  {
                        const userInfo = JSON.parse(localStorage.getItem('key_AOMS_LUMI_USERINFO'));
                        if(userInfo && userInfo.token)  {
                            try  {
                                const authTokenParam = "&auth_token=" + userInfo.token;
                                let sensorInfoParams = sensors.map(sensor => {
                                    return UtilService.szudzikPairing(sensor.channelId, sensor.sensorId);
                                }).reduce((queryStr, sensor, currIndex) =>  {
                                    queryStr = queryStr + ((currIndex === 0) ? "" : "&") + "sensors=" + sensor;
                                    return queryStr;
                                }, "");
    
                                return serverUrl + "/data/wavelength/file?tenant=" + tenant + "&" + 
                                    sensorInfoParams + "&sensortype=" + sensorTypeName + 
                                    (customFilename ? ('&customFilename=' + customFilename) : '') +
                                    "&from=" + from.valueOf() + "&to=" + to.valueOf() +
                                    "&format=" + fileTypeName + "&sortdir=" + sortdir + authTokenParam;
                            }
                            catch(err)  {
                                throw err;
                            }
                        }
                        else  {
                            throw "User may not be authenticated";
                        }
                    }
                };
            }   
            else  {
                return null;
            } 
        });
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('AomsLumi.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('AomsLumi.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('AomsLumi.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('AomsLumi.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * Created by Charles Fung on 2017-06-19.
 */
angular.module('AomsLumi.pages.advanced')
    .directive('directoryUpload', function()  {
        return {
            require: "ngModel",
            restrict: 'A',
            link: function ($scope, el, attrs, ngModel) {
                el.bind('change', function (event) {
                    ngModel.$setViewValue([...event.target.files]);
                    $scope.$apply();
                });

                $scope.$watch(function () {
                    return ngModel.$viewValue;
                }, function (values) {
                    if (!values) {
                        el.val("");
                    }
                });
            }
        };
    });

/**
 * Created by Charles Fung on 2017-06-19.
 */
angular.module('AomsLumi.pages.settings')
    .directive('fileUpload', function()  {
        return {
            require: "ngModel",
            restrict: 'A',
            link: function ($scope, el, attrs, ngModel) {
                el.bind('change', function (event) {
                    ngModel.$setViewValue(event.target.files[0]);
                    $scope.$apply();
                });

                $scope.$watch(function () {
                    return ngModel.$viewValue;
                }, function (value) {
                    if (!value) {
                        el.val("");
                    }
                });
            }
        };
    });

/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-12-27
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.login')
        .controller('LoginCtrl', LoginCtrl)
        .controller('AuthCodeCtrl', AuthCodeCtrl);

    /** @ngInject */
    function LoginCtrl($state, $log, $window, $injector, $mdDialog, toastr, env, LumiService) {
        let vm = this;
        let AuthService = null;
        let InternalSettingsService = null;

        vm.isLoading = false;
        vm.isInit = false;

        vm.allowAnonymousUsers = env.allowAnonymousUsers;

        const adminRoles = new Set(['AOMS_ADMIN', 'AOMS_SUPPORT', 'ADMIN']);


        vm.login = function()  {
            vm.authFailed = false;

            if(vm.credentials.username.length > 0 && vm.credentials.password.length > 0)  {
                $log.info("Logging in as ".concat(vm.credentials.username));
                vm.isLoading = true;
                
                const companyInfo = LumiService.companyInfo();
                AuthService.login(companyInfo ? companyInfo.companyId : null, vm.credentials).query(function(res) {
                    $log.info("Login successful (id ".concat(res.id).concat(", username ").concat(res.username)
                        .concat(", roles ").concat(res.roles).concat(", expiration ").concat(res.exp ? res.exp : "never").concat(")"));
                    const ar = new Set([...res.roles].filter(r => adminRoles.has(r)));
                    
                    // Store userInfo in localStorage    
                    localStorage.setItem('key_AOMS_LUMI_USERINFO', JSON.stringify(res));
                    
                    // Check if AOMS Admin has been initialized
                    const tenant = LumiService.getTenant();
                    if(tenant === null)  {
                        if(env.standalone)  {
                            $log.error("Cannot get tenant during login");
                            toastr.error("Failed to obtain current Project during login");
                            
                            //$window.localStorage.clear();
                            $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                            resetCredentials();
                        }
                        else  {
                            $state.go('main.dashboard');
                        }
                    }
                    else  {
                        InternalSettingsService.settings.get({ tenant: tenant, key: "FLAG_IS_INIT" }, function(res)  {
                            const globalInit = res.val ? (res.val === "1") : false;
                            
                            // Check if user has ADMIN roles
                            if(ar.size === 0)  {
                                if(globalInit)  {
                                    // AOMS Admin has been initialized.  Transition to the dashboard page.
                                    $state.go('main.dashboard');
                                }
                                else  {
                                    toastr.error("The system has not been initialized and you do not have the required role to perform initialization");
                                    //$window.localStorage.clear();
                                    $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                                    resetCredentials();
                                }
                            }
                            else  {
                                // Check to see if we are in read-only mode and that AOMS Admin has not been initialized.  
                                // If so, it is not possible to initialize AOMS Admin.
                                // If not, transition to the dashboard page.
                                if(env.readOnly && !globalInit)  {
                                    toastr.error("The system has not been initialized and the system is not a mode that supports initialization");
                                    //$window.localStorage.clear();
                                    $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                                    resetCredentials();
                                }
                                else  {
                                    $state.go('main.dashboard');                                
                                }
                            }
                        }, function(err)  {
                            const errData = err.data;
                            $log.error("An error has occurred getting FLAG_IS_INIT internal setting during login: "
                                .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
    
                            toastr.error("Failed to determine if the system has been initialized");
                            //$window.localStorage.clear();
                            $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                            $window.localStorage.removeItem('key_AOMS_LUMI_TENANT');
                            resetCredentials();
                        }).$promise.finally(function()  {
                            vm.isLoading = false;
                        });
                    }
                }, function(err)  {
                    const errData = err.data;
                    if(err.status === 401)  {
                        vm.authFailed = true;
                    }
                    else  {
                        toastr.error("An error has occurred logging in as ".concat(vm.credentials.username)
                            .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
                    }

                    //$window.localStorage.clear();
                    $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                    resetCredentials();

                    $log.error("An error has occurred logging in as ".concat(vm.credentials.username)
                        .concat(": ").concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                    
                    vm.isLoading = false;
                });
            }
            else  {
                $log.error("Failed to log in with empty credentials");
                vm.authFailed = true;
            }
        };

        vm.loginAnonymously = function()  {
            // vm.credentials = {
            //     username: env.defaultUsername,
            //     password: env.defaultPassword
            // };

            // vm.login();
        };


        const showAuthCodeModal = function() {
            $mdDialog.show({
                controller: 'AuthCodeCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/login/authCode.html',
                parent: angular.element(document.body),
                clickOutsideToClose:false,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
            }).then(function(res) {
                if(!res)  {
                    // Should not happen
                    $log.error("An unexpected error has occurred performing authorization");
                }
                else  {
                    injectServices();
                }
            }, function(errData)  {
                // Should not happen
                $log.error("An unexpected error has occurred performing authorization");
            });
        };
        

        const injectServices = function()  {
            AuthService = $injector.get('AuthService');
            InternalSettingsService = $injector.get('InternalSettingsService');
        };

        const resetCredentials = function()  {
            vm.credentials = {
                username: '',
                password: ''
            };
        };


        const init = function()  {
            vm.isInit = false;
            $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');

            if(!LumiService.verifyAlvinConfig()) {
                toastr.error("Invalid Alvin server configuration");
            }
            else if(!LumiService.verifyAlfredConfig()) {
                toastr.error("Invalid Alfred server configuration");
            }
            else  {
                if(env.standalone || LumiService.hasCompanyInfo())  {
                    injectServices();
                }
                else  {
                    showAuthCodeModal();
                }

                vm.isInit = true;
            }
        };


        
        init();
    }


    function AuthCodeCtrl($log, $window, $mdDialog, toastr, AlvinAuthService, OrganizationService) {
        let vm = this;
        vm.isLoading = false;

        vm.submitAuthCode = function()  {
            vm.alvinAuthFailed = false;
            if(vm.authCode.length === 5)  {
                $log.info("Submitting auth code");
                vm.isLoading = true;
                AlvinAuthService.login(vm.authCode).query(function(res) {
                    $log.info("Authorization completed");
                    // Store companyInfo in localStorage    
                    localStorage.setItem('key_ALVIN_LUMI_COMPANYINFO', JSON.stringify(res));

                    // Get company name
                    OrganizationService.companies.get({ companyId: res.companyId }, function(res2)  {
                        if(res2.isActive)  {
                            localStorage.setItem('key_ALVIN_LUMI_USERCOMPANY', JSON.stringify({
                                name: res2.name,
                                description: res2.description 
                            }));

                            // Get Alfred Server info
                            OrganizationService.alfredServers.query({ companyId: res.companyId }, function(res3)  {
                                const alfredServers = res3.filter(a => a.isActive);
                                if(alfredServers.length > 0)  {
                                    // For now, use the first server only
                                    res.alfredServer = alfredServers[0].host + ":" + alfredServers[0].port;
                                    localStorage.setItem('key_ALVIN_LUMI_COMPANYINFO', JSON.stringify(res));

                                    $log.info("Alfred server associated with company obtained");
                                    toastr.success("User authorized for " + res2.name);

                                    $mdDialog.hide(res);
                                }
                                else  {
                                    $log.error("No active Alfred server infos found for " + res2.name);
                                    toastr.error("Failed to initialize user environment upon authorization");
                                }
                            }, function(err3)  {
                                const errData = err3.data;
                                $log.error("An error has occurred getting Alfred server info for ".concat(res2.name).concat(": ")
                                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
        
                                toastr.error("Failed to initialize user environment upon authorization");
                                $window.localStorage.clear();
                            }).$promise.finally(function()  {
                                vm.isLoading = false;
                                vm.authCode = null;
                            });
                        }
                        else  {
                            $log.error("Company " + res2.name +  " is not active");
                            toastr.error("Failed to initialize user environment as  " + res2.name + " is not an active organization");
                            $window.localStorage.clear();
                        }
                    }, function(err2)  {
                        const errData = err2.data;
                        $log.error("An error has occurred getting company info: "
                            .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                        toastr.error("Failed to initialize user environment upon authorization");
                        $window.localStorage.clear();
                    }).$promise.finally(function()  {
                        vm.isLoading = false;
                        vm.authCode = null;
                    });
                }, function(err)  {
                    const errData = err.data;
                    if(err.status === 401)  {
                        vm.alvinAuthFailed = true;
                    }
                    else  {
                        toastr.error("An error has occurred during authorization "
                            .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
                    }

                    $log.error("An error has occurred during authorization "
                        .concat(": ").concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                    
                    $window.localStorage.clear();
                    vm.authCode = null;
                    vm.isLoading = false;
                });
            }
            else  {
                $log.error("Invalid auth code");
                vm.alvinAuthFailed = true;
                vm.authCode = null;
            }
        };

        vm.cancel = function() {
            $mdDialog.cancel();
        };
    }

})();

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('AomsLumi.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal) {
    $scope.picture = $filter('profilePicture')('Nasta');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-12-27
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.signup')
        .controller('SignupCtrl', SignupCtrl);

    /** @ngInject */
    function SignupCtrl($log, $timeout) {
        let vm = this;

    }

})();

/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('AlvinAuthService', function ($resource, LumiService) {
            const serverUrl = LumiService.getAlvinServerUrl();

            const basicAuthHeader = function(authCode)  {
                return 'Basic ' + btoa('' + ':' + authCode);
            };

            if(serverUrl)  {
                return {
                    login: function(authCode) {
                        return $resource(serverUrl.concat("/login"), {}, {
                            query: {
                                method: 'GET',
                                headers: {
                                    Authorization: basicAuthHeader(authCode),
                                    'AOMS-Alvin': true
                                }},
                        });
                    },
                    logout: $resource(serverUrl.concat("/logout"), {}),
                };
            }
            else  {
                return null;
            }
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('CableService', function ($resource, LumiService) {
            const serverUrl = LumiService.getAlvinServerUrl();

            if(serverUrl)  {
                return {
                    cables: $resource(serverUrl.concat("/cables/:cableId"), { cableId : "@cableId" }, {
                        'getCable': {
                            url: serverUrl.concat("/cables/:cableId"),
                            method: 'GET',
                            isArray: false,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                allowAttached: "@allowAttached",
                                cableId: "@cableId"
                            }
                        }
                    }),
                    nodes: $resource(serverUrl.concat("/nodes/:nodeId"), { nodeId : "@nodeId" },
                        {
                            'fetchNodes': {
                                url: serverUrl.concat("/nodes/cmd/fetch"),
                                method: 'GET',
                                isArray: true,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json',
                                    'AOMS-Alvin': true,
                                }
                            },
                            'fetchNodeByNodeId': {
                                url: serverUrl.concat("/nodes/cmd/fetch/:nodeId"),
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json',
                                    'AOMS-Alvin': true,
                                },
                                params: {
                                    nodeId: "@nodeId"
                                },
                            },
                            'getCableNodeAssociationInfo': {
                                url: serverUrl.concat("/nodes/association/info"),
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json',
                                    'AOMS-Alvin': true,
                                },
                                params: {
                                    cableId: "@cableId",
                                    nodeId: "@nodeId"
                                },
                            },
                            'assignNode': {
                                url: serverUrl.concat("/nodes/cmd/assign_node"),
                                method: 'PUT',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json',
                                    'AOMS-Alvin': true,
                                },
                            },
                            'unassignNode': {
                                url: serverUrl.concat("/nodes/cmd/unassign_node"),
                                method: 'PUT',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json',
                                    'AOMS-Alvin': true,
                                },
                            }
                        }),
                };
            }
            else  {
                return null;
            }
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('OrganizationService', function ($resource, LumiService) {
            const serverUrl = LumiService.getAlvinServerUrl();

            if(serverUrl)  {
                return {
                    companies: $resource(serverUrl.concat("/companies/:companyId"), { companyId : "@companyId" },
                        {
                            'get': {
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json',
                                    'AOMS-Alvin': true,
                                }},
                        }),
    
                    tenants: $resource(serverUrl.concat("/tenants/:tenant"), { tenant : "@tenant" },
                        {
                            'tenantsByCompany': {
                                url: serverUrl.concat("/tenants"),
                                method: 'GET',
                                isArray: true,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json',
                                    'AOMS-Alvin': true,
                                },
                                params: {
                                    companyId: "@companyId"
                                }},
                        }),
                    tenantStates: $resource(serverUrl.concat("/tenant/states"), {},
                    {
                        'update': {
                            url: serverUrl.concat("/tenants/cmd/assign_state"),
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant",
                                tenantStateTypeName: "@tenantStateTypeName"
                            }
                        }
                    }),      
    
                    alfredServers: $resource(serverUrl.concat("/servers/alfred"), {},
                        {
                            'query': {
                                method: 'GET',
                                isArray: true,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json',
                                    'AOMS-Alvin': true,
                                }},
                                params: {
                                    companyId: "@companyId"
                                }
                        }),    
                };
            }
            else  {
                return null;
            }
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('ChannelJobService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();

            if(serverUrl)  {
                return {
                    channelJobGroups: $resource(serverUrl.concat("/analytics/channel/jobs/groups/:id"), { id: "@id" },
                    {
                        'assignChannelJobGroup': {
                            url: serverUrl.concat("/analytics/channel/jobs/cmd/assign_channeljobgroup"),
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant"
                            }},
                        params: {
                            tenant: "@tenant"
                        }
                    }),

                    channelJobs: $resource(serverUrl.concat("/analytics/channel/jobs/:id"), { id: "@id" },
                    {
                        'assignAlarm': {
                            url: serverUrl.concat("/alarms/cmd/assign_channeljob"),
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant"
                            }},
                        params: {
                            tenant: "@tenant"
                        }
                    }),
                    
                    channelJobVisibilities: $resource(serverUrl.concat("/analytics/channel/jobs/visibilities"), {},
                    {
                        'query': {
                            method: 'GET',
                            isArray: true,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }}
                    }),
    
                    channelJobStatusTypes: $resource(serverUrl.concat("/analytics/channel/jobs/statuses/types"), {},
                    {
                        'query': {
                            method: 'GET',
                            isArray: true,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }}
                    })
                };
            }   
            else  {
                return null;
            } 
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * Created by Charles Fung on 2018-01-14.
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('AuthHttpInterceptor', function ($log, $q, $injector, $window, env) {
            const bearerAuthHeader = function(token)  {
                return 'Bearer ' + token;
            };

            return {
                request: function(req)  {
                    const url = req.url;
                    if(url && url.match(env.tokenPathMatcher1) && !url.match(env.tokenPathMatcher2))  {
                        const useAlvin = req.headers['AOMS-Alvin'];
                        if(useAlvin)  {
                            const companyInfo = JSON.parse(localStorage.getItem('key_ALVIN_LUMI_COMPANYINFO'));
                            req.headers.Authorization = bearerAuthHeader(companyInfo.token);
                        }
                        else  {
                            const userInfo = JSON.parse(localStorage.getItem('key_AOMS_LUMI_USERINFO'));
                            if(userInfo)  {
                                req.headers.Authorization = bearerAuthHeader(userInfo.token);
                            }
                        }
                    }
                    return req;
                },

                responseError: function(rejection) {
                    const status = rejection.status;
                    if(status === 401 || status === 403)  {
                        $log.info("Status ".concat(status).concat(" returned from server"));

                        if(rejection.headers && rejection.headers['AOMS-Alvin'])  {
                            // Clear localStorage
                            $window.localStorage.clear();
                        }
                        else  {
                            // Clear userInfo from localStorage
                            $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                        }

                        // Transition to login state
                        $injector.get('$state').transitionTo('login');
                    }
                    return $q.reject(rejection);
                },
            };
        })
        .config(function($httpProvider) {
            $httpProvider.interceptors.push('AuthHttpInterceptor');
        });
})();

/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('AuthService', function ($log, $window, $state, $resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();
                
            const basicAuthHeader = function(credentials)  {
                return 'Basic ' + btoa(credentials.username + ':' + credentials.password);
            };

            if(serverUrl)  {
                return {
                    login: function (companyId, credentials) {
                        return $resource(serverUrl.concat("/login"), {}, 
                        {
                            query: {
                                method: 'GET',
                                headers: {
                                    Authorization: basicAuthHeader(credentials),
                                    Company: companyId
                                }
                            }
                        });
                    },
                    logout: $resource(serverUrl.concat("/logout"), {}), 
                    
                    userInfo: function ()  {
                        const userInfo = JSON.parse(localStorage.getItem('key_AOMS_LUMI_USERINFO'));
                        if(userInfo && userInfo.token)  {
                            return userInfo;
                        }
                        else  {
                            // Transition to login state if user is not authenticated
                            $log.error("Failed to get userInfo.  Transition to login state");
                            $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                            $state.go('login');
                            
                            return null;
                        }
                    }
                };   
            }
            else  {
                return null;
            }
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi.pages.settings')
        .factory('AlarmSettingsService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();  

            if(serverUrl)  {
                return {
                    alarms : $resource(serverUrl.concat("/alarms"), { id: "@id" },
                    {
                        'alarmsByAlarmType': {
                            url: serverUrl.concat("/alarms/by_type/:alarmTypeName"),
                            method: 'GET',
                            params: {
                                tenant: "@tenant",
                                alarmTypeName: "@alarmTypeName"
                            }},
                        'update': {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant",
                            }},
                        params: {
                            tenant: "@tenant"
                        }    
                    })
                };
            }   
            else  {
                return null;
            } 
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi.pages.settings')
        .factory('EmailNotificationSettingsService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();  

            if(serverUrl)  {
                return {
                    emailNotifications: $resource(serverUrl.concat("/emailnotifications/:id"), { id: "@id" },
                        {
                            'query': {
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }},
                            'toggle': {
                                url: serverUrl.concat("/emailnotifications/cmd/toggle"),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            params: {
                                tenant: "@tenant"
                            }
                        })
                };
            }   
            else  {
                return null;
            } 
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi.pages.settings')
        .factory('EnvironSensorSettingsService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();

            if(serverUrl)  {
                return $resource(serverUrl.concat("/settings/environ/sensors"), {},
                {
                    'assignAlarm': {
                        url: serverUrl.concat("/alarms/cmd/assign_environ"),
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        params: {
                            tenant: "@tenant"
                        }},
                });
            }   
            else  {
                return null;
            } 
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi.pages.settings')
        .factory('GeneralSettingsService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();  

            if(serverUrl)  {
                return {
                    settings: $resource(serverUrl.concat("/settings/general/:key"), { key: "@key" },
                    {
                        'updateAll': {
                            url: serverUrl.concat("/settings/general"),
                            method: 'PUT',
                            headers: {
                            'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant"
                            }},
                        'getScaleSettings': {
                            url: serverUrl.concat("/settings/scale"),
                            method: 'GET',
                            isArray: true,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                tenant: "@tenant"
                            }},
                        params: {
                            tenant: "@tenant"
                        }    
                    }),
                };
            }   
            else  {
                return null;
            } 
        });
})();


/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi.pages.settings')
        .factory('InternalSettingsService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();  

            if(serverUrl)  {
                return {
                    // Polling service
                    settings: $resource(serverUrl.concat("/settings/internal/:key"), { key: "@key" },
                        {
                            'update': {
                                url: serverUrl.concat("/settings/internal"),
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'updateByKey': {
                                url: serverUrl.concat("/settings/internal/:key"),
                                method: 'PUT',
                                params: {
                                    tenant: "@tenant",
                                    key: "@key"
                                }},    
                            'save': {
                                url: serverUrl.concat("/settings/internal"),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }},
                            'delete': {
                                url: serverUrl.concat("/settings/internal/:id"),
                                method: 'DELETE',
                                params: {
                                    id: "@id",
                                    tenant: "@tenant"
                                },
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }},
                            params: {
                                tenant: "@tenant"
                            }    
                        }),
                };
            }
            else  {
                return null;
            }   
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi.pages.advanced')
        .factory('NetworkingSettingsService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();  

            if(serverUrl)  {
                return {
                    settings: $resource(serverUrl.concat("/settings/networking/:key"), { key: "@key" },
                        {
                            'updateAll': {
                                url: serverUrl.concat("/settings/networking"),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }}
                        }),
                };
            }
            else  {
                return null;
            } 
        });
})();


/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi.pages.settings')
        .factory('UserSettingsService', function ($resource, LumiService) {
            const serverUrl = LumiService.getServerUrl();  
            
            if(serverUrl)  {
                return {
                    settings: $resource(serverUrl.concat("/settings/user"), {},
                    {
                        'getUserSettings': {
                            url: serverUrl.concat("/settings/user/list"),
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            isArray: true,
                            params: {
                                companyId: "@companyId",
                                username: "@username"
                            }
                        },
                        'getUserSetting': {
                            url: serverUrl.concat("/settings/user"),
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                companyId: "@companyId",
                                username: "@username",
                                userSettingType: "@userSettingType"
                            }
                        },
                        'getUserSettingOptions': {
                            url: serverUrl.concat("/settings/user/types"),
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        },
                        'updateUserSettings': {
                            url: serverUrl.concat("/settings/user/list"),
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                companyId: "@companyId",
                                username: "@username",
                            }
                        },
                        'updateUserSetting': {
                            url: serverUrl.concat("/settings/user"),
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            params: {
                                companyId: "@companyId",
                                username: "@username",
                            }
                        }
                    }),
                };
            }   
            else  {
                return null;
            } 
        });
})();


/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('AomsLumi.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-06-19
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.analysis')
        .controller('OutlierCtrl', OutlierCtrl)
        .controller('OutlierDetectionJobCtrl', OutlierDetectionJobCtrl);
    
    /** @ngInject */
    function OutlierCtrl($log, $q, $mdDialog, toastr, 
        LumiService, AuthService, UserSettingsService, UtilService, 
        ChannelService, ChannelJobService, OutlierDetectionJobService) {
        let vm = this;

        vm.tenant = LumiService.getTenant();
        vm.isLoading = true;
        vm.isViewingDetails = false;

        vm.dataTotal = 0;
        vm.dataRpp = 20;

        vm.outlierDetectionJobFilter = {
            channelJobTypeName: 'Outlier Detection',
            cgId: null,
            companyId: null,
            username: null,
            channelJobVisibilityName: null,
            sensorTypeName: null,
            status: null
        }

        let alert;

        let isInit = false;
        let displayTZ = env.defaultTZ;


        vm.serverPipe = function(tableState) {
        	vm.isLoading = true;
        	vm.tableState = tableState;

            let params = {
                tenant: vm.tenant,
                page: tableState.pagination.start ?  tableState.pagination.start/vm.dataRpp : 0,
                rpp: vm.dataRpp,
                sortdir: (typeof tableState.sort.reverse !== 'undefined') ? (tableState.sort.reverse ? 'DESC' : 'ASC') : 'DESC',
            };

            Object.keys(vm.outlierDetectionJobFilter).forEach(function (key) {
                if(vm.outlierDetectionJobFilter[key] === 'ALL')  {
                    vm.outlierDetectionJobFilter[key] = null;
                }
             });

            $log.info("Getting outlier detection jobs");
            OutlierDetectionJobService.outlierDetectionJobs.getPagedList(params, vm.outlierDetectionJobFilter,function(data) {
                vm.outlierDetectionJobs = data.outlierDetectionJobMessages.map(odj => {
                    odj.creationDateMilliseconds = odj.creationDate;
                    odj.creationDate = UtilService.convertUTCTimestamp(odj.creationDate, displayTZ);

                    if(odj.startDate)  {
                        odj.startDateMilliseconds = odj.startDate;
                        odj.startDate = UtilService.convertUTCTimestamp(odj.startDate, displayTZ);
                    }

                    if(odj.terminationDate)  {
                        odj.terminationDateMilliseconds = odj.terminationDate;
                        odj.terminationDate = UtilService.convertUTCTimestamp(odj.terminationDate, displayTZ);
                    }

                    return odj;         
                });

                vm.displayedOutlierDetectionJobs = [].concat(vm.outlierDetectionJobs);
                
                vm.dataRpp = data.rpp;
                vm.dataTotal = data.total;

                vm.tableState.pagination.number = vm.dataRpp;
                vm.tableState.pagination.totalItemCount = vm.dataTotal;
                vm.tableState.pagination.numberOfPages = Math.ceil(vm.dataTotal / vm.dataRpp);
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred getting Outlier Monitors"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred getting outlier detection jobs: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            }).$promise.finally(function()  {
                vm.isLoading = false;
            });
        };

        
        vm.hasAlarm = function(odj)  {
            if(odj)  {
                if(odj.hasOwnProperty('averageCriterionAlarmStatus') && odj.averageCriterionAlarmStatus !== null)  {
                    if(odj.hasOwnProperty('rocCriterionAlarmStatus') && odj.rocCriterionAlarmStatus !== null)  {
                        return odj.averageCriterionAlarmStatus && odj.rocCriterionAlarmStatus;
                    }
                    else  {
                        return odj.averageCriterionAlarmStatus;
                    }
                }
            }
            return false;
        };

        vm.restartOutlierDetectionJob = function(odjId)  {
            $log.info("Updating outlier detection job status to NEW");
            updateOutlierDetectionJobStatus(odjId, 'NEW').then(function(res)  {
                if(res)  {
                    // Outlier detection job status updated to NEW.  Proceed to start job.
                    const reqBody = {
                        id: odjId
                    };
        
                    OutlierDetectionJobService.outlierDetectionJobs.start({ tenant: vm.tenant }, reqBody, function(res) {
                        $log.info("Outlier detection job " + odjId + " has restarted successfully");
                        toastr.success("Outlier Monitor " + odjId + " has restarted successfully!");
                        
                        // Outlier Detection Job started
                        vm.refreshData();
                    }, function(err)  {
                        const errData = err.data;
                        toastr.error("An error has occurred starting Outlier Monitor ".concat(odjId)
                            .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
        
                        $log.error("An error has occurred starting outlier detection job ".concat(odjId)
                            .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                        
                        // Failed to restart outlier detection job
                        vm.refreshData();
                    });
                }
            });
        };

        vm.stopOutlierDetectionJob = function(outlierDetectionJobId, channelJobId, outlierDetectionJobStatus)  {
            if(outlierDetectionJobStatus === 'RUNNING')  {
                terminateOutlierDetectionJob(outlierDetectionJobId);
            }
            else  {
                deleteOutlierDetectionJob(outlierDetectionJobId, channelJobId);
            }
        };

        vm.refreshData = function() {
            vm.tableState.pagination = { start: 0 };
            vm.serverPipe(vm.tableState);
        };

        vm.onCableFilterSelected = function(channelGroupMessage)  {
            vm.outlierDetectionJobFilter.cgId =
             channelGroupMessage.channelGroupId !== 'ALL' ? channelGroupMessage.id : null;
             
             if(isInit)  {
                vm.refreshData();
             }
        };

        vm.getStatusColor = function(status)  {
            if (status === 'RUNNING')  {
                return { color: '#388e3c' };
            }
            else if (status === 'TERMINATED')  {
                return { color: '#616161' };
            }
            else if (status === 'ERROR')  {
                return { color: '#d32f2f' };
            }
            else  {
                return { color: '#009fe3' };
            }
        }


        const getChannelJobStatusTypes = function () {
            $log.info("Getting all channel job statuses");
            let deferred = $q.defer();
        	ChannelJobService.channelJobStatusTypes.query({ tenant: vm.tenant }, function(res) {
        		vm.channelJobStatusTypes = res.map(function(t)  {
                	return t.name;
				});
                vm.channelJobStatusTypes.unshift("ALL");

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting channel job statsues: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getChannelGroups = function () {
            $log.info("Getting all channel groups of Cable type");
            let deferred = $q.defer();
        	ChannelService.channelGroups.getChannelGroupsByType({ tenant: vm.tenant, channelGroupTypeName: 'Cable' }, function(res) {
                vm.channelGroups = res.channelGroupMessages.filter((e, i) => res.channelGroupMessages.findIndex(a => a.channelGroupId === e.channelGroupId) === i);
                vm.channelGroups.unshift( { channelGroupId: "ALL" } );

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting channel groups of cable type: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        
        const updateOutlierDetectionJobStatus = function(outlierDetectionJobId, channelJobStatus)  {
            $log.info("Updating Outlier Detection Job Status to ".concat(channelJobStatus));
            let deferred = $q.defer();

            const reqBody = {
                id: outlierDetectionJobId,
                channelJobStatus: channelJobStatus
            };

        	OutlierDetectionJobService.outlierDetectionJobStatuses.update({ tenant: vm.tenant }, reqBody, function(res) {
                $log.info("Outlier Detection Status successfully updated to ".concat(channelJobStatus));
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred updating Outlier Monitor Status to ".concat(channelJobStatus)
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred updating outlier detection job status to ".concat(channelJobStatus)
                    .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                deferred.resolve(false);
            });
            return deferred.promise;       
        };

        const terminateOutlierDetectionJob = function(outlierDetectionJobId)  {
            let confirm = $mdDialog.confirm()
            .title("Confirmation")
            .textContent("Are you sure you want to terminate Outlier Monitor " + outlierDetectionJobId + "?")
            .targetEvent(event)
            .multiple(true)
            .ok('Yes')
            .cancel('No');

            $mdDialog.show(confirm).then(function() {
                $log.info("Terminate Outlier Detection Job ".concat(outlierDetectionJobId));
            
                OutlierDetectionJobService.outlierDetectionJobs.terminate({ tenant: vm.tenant }, { id: outlierDetectionJobId }, function(res) {                
                    $log.info("Outlier detection job " + outlierDetectionJobId + " has been terminated successfully");
                    toastr.success("Outlier Monitor " + outlierDetectionJobId + " has been terminated successfully!");
                    vm.refreshData();
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred terminating Outlier Monitor ".concat(outlierDetectionJobId)
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                    $log.error("An error has occurred terminating outlier detection job ".concat(outlierDetectionJobId)
                        .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                });
            });
        };

        const deleteOutlierDetectionJob = function(outlierDetectionJobId, channelJobId)  {
            let confirm = $mdDialog.confirm()
            .title("Confirmation")
            .textContent("Are you sure you want to remove Outlier Monitor " + outlierDetectionJobId + "?")
            .targetEvent(event)
            .ok('Yes')
            .cancel('No');

            $mdDialog.show(confirm).then(function() {
                $log.info("Remove Outlier Detection Job ".concat(outlierDetectionJobId));
                
                ChannelJobService.channelJobs.delete({ id: channelJobId, tenant: vm.tenant }, function(res) {
                    $log.info("Outlier detection job " + outlierDetectionJobId + " has been removed successfully");
                    toastr.success("Outlier Monitor " + outlierDetectionJobId + " has been removed successfully!");
                    if(vm.outlierDetectionJobs)  {
                        vm.outlierDetectionJobs = vm.outlierDetectionJobs.filter(odj => odj.id !== outlierDetectionJobId);
                        vm.displayedOutlierDetectionJobs = [].concat(vm.outlierDetectionJobs);
                    }
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred removing Outlier Monitor ".concat(outlierDetectionJobId)
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
    
                    $log.error("An error has occurred removing outlier detection job ".concat(outlierDetectionJobId).concat(": ") 
                        .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                });
            });
        };

        const refreshOutlierDetectionJobFilters = function()  {
            $log.info("Refresh outlier detection job filters");
            vm.isLoading = true;
            $q.all([
                getChannelJobStatusTypes(),
                getChannelGroups(),
            ]).then(function(res) {
                if(!res[0] && !res[1])  {
                    showAlert("Error", "An error has occurred getting Channel Job Status Types and Channel Groups");
                }
                else if(!res[0])  {
                    showAlert("Error", "An error has occurred getting Channel Job Status Types");
                }
                else if (!res[1])  {
                    showAlert("Error", "An error has occurred getting Channel Groups");
                }

                $log.info("Done refresh outlier detection job filters".concat((!res[0] || !res[1]) ? " with error" : ""));
                vm.isLoading = false;
            });
        };

        
        vm.showOutlierDetectionJobModal = function(ev, odj) {
            vm.isViewingDetails = true;
            $mdDialog.show({
                controller: 'OutlierDetectionJobCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/analysis/outlier/outlierDetectionJobModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                multiple : true,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
                locals: {
                    odj: odj,
                    channelGroups: vm.channelGroups,
                    companyId: vm.companyId,
                    username: vm.username,
                    displayTZ                
                }
            }).then(function() {
                $log.info("Outlier detection job dialog closed upon successful job creation");
                vm.refreshData();
                vm.isViewingDetails = false;
            }, function(err)  {
                // Refresh upon server error to ensure we are up-to-date with data
                if(err)  {
                    $log.info("Outlier detection job dialog closed upon error");
                    vm.refreshData();
                }
                vm.isViewingDetails = false;
            });
        };


        
        const init = function()  {
            if(!isInit)  {
                $log.info("Initializing Outlier Detection Jobs page");
                const companyInfo = LumiService.companyInfo();
                vm.companyId = companyInfo ? companyInfo.companyId : null;

                const userInfo = AuthService.userInfo();
                if(userInfo)  {
                    vm.username = userInfo.username;
                    UserSettingsService.settings.getUserSetting({ companyId: vm.companyId, username: vm.username, userSettingType: 'Display Time Zone' }, function(res) {
                        if(res && res.val)  {
                            displayTZ = res.val;
                        }
                        else  {
                            $log.debug("Empty display time zone.  Defaulting to ").concat(displayTZ);    
                        }
                    }, function(err)  {
                        const errData = err.data;
    
                        $log.debug("An error has occurred getting display time zone.  Defaulting to ".concat(displayTZ).concat(": ")
                            .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));    
                    }).$promise.finally(function()  {
                        moment.tz.setDefault(displayTZ);
                        isInit = true;
                        
                        refreshOutlierDetectionJobFilters();
                    });
                }
            }
        };



        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: true,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        init();
    }

    function OutlierDetectionJobCtrl($scope, $q, $log, $timeout, $mdDialog, toastr,
        LumiService, ChannelService, AlarmSettingsService, UtilService,
        ChannelJobService, OutlierDetectionJobService,
        odj, channelGroups, companyId, username, displayTZ) {
        let vm = this;

        vm.odj = odj;
        vm.channelGroups = channelGroups.filter(cg => cg.channelGroupId !== 'ALL');
        vm.companyId = companyId;
        vm.username = username;
        vm.singularAlarmThreshold = null;

        let outlierDetectionJobSensorMessages = {};
        vm.outlierDetectionJobSensors = {};
        let selectedOutlierDetectionJobSensors = {};

        vm.isLoading = false;


        let sensorStatusesPollingPromise = null;
        let sensorStatusesPollingInterval = 5000;
        let sensorStatusesPollingErrors = 0;
        
        let alert;

        let isAlive = true;

        let tenant = LumiService.getTenant();

        

        vm.createOutlierDetectionJob = function()  {
            vm.isLoading = true;
            $log.info("Creating Outlier Detection Job");

            // Verify that if rocInterval exists, it must be greater than the refresh rate
            if(vm.odj.rocInterval !== null && vm.odj.rocInterval < vm.odj.refreshRate)  {
                showAlert("Warning", "Rate of Change Interval must be greater than the Refresh Rate.  Please modify your input and try again.");
                vm.isLoading = false;
            }
            else  {
                OutlierDetectionJobService.outlierDetectionJobs.save({ tenant: tenant }, vm.odj, function(res) {
                    if(res)  {
                        const resId = res.id;
                        const channelJobId = res.channelJobId;
    
                        if(vm.odj.averageCriterionAlarmStatus !== null && vm.singularAlarmThreshold)  {
                            $log.info("Creating and assigning average criterion alarm for outlier detection job " + resId);
                            const reqBody = {
                                alarmData: {
                                    alarmType: 'OUTLIER_DETECTION_AVG_CRITERION_THRESHOLD',
                                    singularThreshold: vm.singularAlarmThreshold 
                                }
                            };
    
                            AlarmSettingsService.alarms.save({ tenant: tenant }, reqBody, function(resAlarm) {
                                $log.info("Average criterion alarm created for outlier detection job " + resId);
                                const alarmId = resAlarm.alarmData.id;
            
                                ChannelJobService.channelJobs.assignAlarm({ tenant: tenant }, { channelJobId: channelJobId, alarmId: alarmId}, function(r) {
                                    $log.info("Average criterion alarm assigned for outlier detection job " + resId);
                                    
                                    // Start outlierDetectionJob
                                    startOutlierDetectionJob(resId);
                                }, function(err)  {
                                    const errData = err.data;
                                    toastr.error("An error has occurred assigning Outlier Monitor Average Criterion Alarm"
                                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
                
                                    $log.error("An error has occurred assigning average criterion alarm: ".concat(errData ? JSON.stringify(errData) :
                                        JSON.stringify(err)));
                                        vm.isLoading = false;
                                });
                            }, function(err)  {
                                const errData = err.data;
                                toastr.error("An error has occurred creating Outlier Monitor Average Criterion Job Alarm"
                                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
            
                                $log.error("An error has occurred creating average criterion alarm: ".concat(errData ? JSON.stringify(errData) :
                                    JSON.stringify(err)));
                                    vm.isLoading = false;
                            });
                        }
                        else  {
                            // No average criterion alarm.  Do not create alarm.
                            // Start outlierDetectionJob
                            startOutlierDetectionJob(resId);
                        }
                    } 
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred creating Outlier Monitor"
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
    
                    $log.error("An error has occurred creating outlier detection job: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                    vm.isLoading = false;
                });
            }
        };

        vm.terminateOutlierDetectionJob = function(outlierDetectionJobId)  {
            let confirm = $mdDialog.confirm()
            .title("Confirmation")
            .textContent("Are you sure you want to terminate Outlier Monitor " + outlierDetectionJobId + "?")
            .targetEvent(event)
            .multiple(true)
            .ok('Yes')
            .cancel('No');

            $mdDialog.show(confirm).then(function() {
                $log.info("Terminate Outlier Detection Job ".concat(outlierDetectionJobId));
            
                OutlierDetectionJobService.outlierDetectionJobs.terminate({ tenant: tenant }, { id: outlierDetectionJobId }, function(res) {                
                    $log.info("Outlier detection job " + outlierDetectionJobId + " has been terminated successfully");
                    toastr.success("Outlier Monitor " + outlierDetectionJobId + " has been terminated successfully!");
                    
                    // Cancel polling tasks
                    cancelOdjSensorStatusesNextLoad();

                    //Update status
                    getOutlierDetectionJobStatusAlarm();
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred terminating Outlier Detection Job ".concat(outlierDetectionJobId)
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                    $log.error("An error has occurred terminating outlier detection job ".concat(outlierDetectionJobId)
                        .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                });
            });
        };

        vm.refresh = function() {
            // Refresh search inputs
            //vm.filterSensorStatusChannel = null;
            //vm.filterSensorStatusSensor = null;

            // Get status
            getOutlierDetectionJobStatusAlarm().then(function(res)  {
                if(res)  {
                    // Get sensor statuses
                    pollOutlierDetectionSensorStatuses();
                }
            }).catch(function(err)  {
                // Error for getting status and alarm for outlier detection job
                $log.error("Done getting status and alarm for outlier detection job with error"
                        .concat(": ".concat(JSON.stringify(err))));
            });
        };


        vm.hasAlarm = function()  {
            if(vm.odj)  {
                if(vm.odj.hasOwnProperty('averageCriterionAlarmStatus') && vm.odj.averageCriterionAlarmStatus !== null)  {
                    if(vm.odj.hasOwnProperty('rocCriterionAlarmStatus') && vm.odj.rocCriterionAlarmStatus !== null)  {
                        return vm.odj.averageCriterionAlarmStatus && vm.odj.rocCriterionAlarmStatus;
                    }
                    else  {
                        return vm.odj.averageCriterionAlarmStatus;
                    }
                }
            }
            return false;
        };

        vm.getCriterionAlarmStatusName = function(status)  {
            switch(status)  {
                case 0:
                    return 'None';
                case 1:
                    return 'Set';
                case 2:
                    return 'Unset';
                case 3: 
                    return 'Onset';
                case 4:
                    return 'Recovery';
                default:
                    return 'Unknown';

            }
        };

        vm.getStatusColor = function(status)  {
            if (status === 'RUNNING')  {
                return { color: '#388e3c' };
            }
            else if (status === 'TERMINATED')  {
                return { color: '#616161' };
            }
            else if (status === 'ERROR')  {
                return { color: '#d32f2f' };
            }
            else  {
                return { color: '#009fe3' };
            }
        };

        
        const getChannelJobVisibilities = function () {
            $log.info("Getting all channel job visibilities");
            let deferred = $q.defer();
        	ChannelJobService.channelJobVisibilities.query(function(res) {
                vm.channelJobVisibilities = res;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting channel job visibilities: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getSensorTypes = function () {
            $log.info("Getting all sensor types");
            let deferred = $q.defer();
        	ChannelService.sensors.types(function(res) {
                vm.sensorTypes = res;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting sensor types: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };


        const startOutlierDetectionJob = function(odjId)  {
            $log.info("Updating outlier detection job status to NEW");
            updateOutlierDetectionJobStatus(odjId, 'NEW').then(function(res)  {
                if(res)  {
                    // Outlier detection job status updated to NEW.  Proceed to start job.
                    const reqBody = {
                        id: odjId
                    };
        
                    OutlierDetectionJobService.outlierDetectionJobs.start({ tenant: tenant }, reqBody, function(res) {
                        $log.info("Outlier detection job " + odjId + " has started successfully");
                        toastr.success("Outlier Monitor " + odjId + " has started successfully!");
                        
                        // Outlier Detection Job started
                        vm.isLoading = false;
                        vm.hide(res);
                    }, function(err)  {
                        const errData = err.data;
                        toastr.error("An error has occurred starting Outlier Monitor ".concat(odjId)
                            .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
        
                        $log.error("An error has occurred starting outlier detection job ".concat(odjId)
                            .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                        
                        // Failed to start outlier detection job
                        vm.isLoading = false;
                        vm.cancel(true); 
                    });
                }
                else  {
                    // Failed to update outlier detection job status to NEW
                    vm.isLoading = false;
                    vm.cancel(true);  
                }
            });
        };

        const getOutlierDetectionJobStatusAlarm = function()  {
            $log.info("Getting status and alarm for outlier detection job " + vm.odj.id);
            let deferred = $q.defer();
            OutlierDetectionJobService.outlierDetectionJobs.get({ id: vm.odj.id, tenant: tenant }, function(res) {
                vm.odj.status = res.status;

                if(res.hasOwnProperty('averageCriterionAlarmStatus') && res.averageCriterionAlarmStatus !== null)  {
                    vm.odj.averageCriterionAlarmStatus = res.averageCriterionAlarmStatus;
                }
                if(res.hasOwnProperty('rocCriterionAlarmStatus') && res.rocCriterionAlarmStatus !== null)  {
                    vm.odj.rocCriterionAlarmStatus = res.rocCriterionAlarmStatus;
                }

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting status and alarm for outlier detection job ".concat(vm.odj.id)
                    .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                deferred.resolve(false);
            });
            return deferred.promise;
        }

        const pollOutlierDetectionSensorStatuses = function() {
            $log.debug("Polling sensor statuses for outlier detection job " + vm.odj.id);
            OutlierDetectionJobService.outlierDetectionJobs.sensorStatuses({ odjId: vm.odj.id, tenant: tenant }, function(res) {
                vm.sensorStatuses = res.map(s => {
                    s.lastModified = UtilService.convertUTCTimestamp(s.lastModified, displayTZ);
                    return s;         
                });
                
                vm.displayedSensorStatuses = [].concat(vm.sensorStatuses);

                sensorStatusesPollingErrors = 0;
                odjSensorStatusesNextLoad();
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred polling sensor statuses for outlier detection job ".concat(vm.odj.id)
                    .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));

                showAlert("Error", "Operational error as Outlier Monitor ".concat(vm.odj.id).concat(" may possibly have been removed.  Try again later or contact your system administrator."));
                vm.cancel(true);
            });
        };

        const updateOutlierDetectionJobStatus = function(outlierDetectionJobId, channelJobStatus)  {
            $log.info("Updating Outlier Detection Job Status to ".concat(channelJobStatus));
            let deferred = $q.defer();

            const reqBody = {
                id: outlierDetectionJobId,
                channelJobStatus: channelJobStatus
            };

        	OutlierDetectionJobService.outlierDetectionJobStatuses.update({ tenant: tenant }, reqBody, function(res) {
                $log.info("Outlier Detection Status successfully updated to ".concat(channelJobStatus));
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred updating Outlier Monitor Status to ".concat(channelJobStatus)
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred updating outlier detection job status to ".concat(channelJobStatus)
                    .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                deferred.resolve(false);
            });
            return deferred.promise;       
        };



        const cancelOdjSensorStatusesNextLoad = function()  {
            $timeout.cancel(sensorStatusesPollingPromise);
        };

        const odjSensorStatusesNextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || sensorStatusesPollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelOdjSensorStatusesNextLoad();

            if(isAlive)  {
                $log.debug("Poll outlier detection sensor statsues with delay: ".concat(pollingDelay).concat( " milliseconds"));
                sensorStatusesPollingPromise = $timeout(pollOutlierDetectionSensorStatuses, pollingDelay);
            }
        };



        vm.hide = function(res) {
            $mdDialog.hide(res);
        };

        vm.cancel = function(errData) {
            if(errData)  {
                $mdDialog.cancel(errData);
            }
            else  {
                $mdDialog.cancel();
            }
        };


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: true,
                multiple: true
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        const init = function()  {
            vm.isLoading = true;
            vm.isCreate = vm.odj ? false : true;
            $q.all([
                getSensorTypes(),
                getChannelJobVisibilities()
            ]).then(function(res) {
                if(!res[0] || !res[1])  {
                    vm.isLoading = false;
                    $log.error("An error has occurred getting parameter options");
                    showAlert("Error", "An error has occurred getting parameter options for creating Outlier Monitor");
                }
                else  {
                    // Create new Outlier Detection Job
                    if(vm.isCreate)  {
                        vm.odj = {
                            channelJobTypeName: 'Outlier Detection',
                            companyId: vm.companyId,
                            username: vm.username,
                            channelJobVisibilityName: 'UNRESTRICTED',
                            sensorTypeName: null,
                            refreshRate: 60,
                            rocInterval: null,
                            averageCriterionAlarmStatus: false,
                            rocCriterionAlarmStatus: null
                        };

                        vm.isLoading = false;
                    }
                    // View existing Outlier Detection Job
                    else  {
                        // Set singular alarm threshold
                        if(vm.odj.hasOwnProperty('averageCriterionAlarmStatus') && vm.odj.averageCriterionAlarmStatus !== null && 
                        vm.odj.alarmData && vm.odj.alarmData.singularThreshold)  {
                            vm.singularAlarmThreshold = vm.odj.alarmData.singularThreshold;
                        }

                        if(vm.odj.status === 'RUNNING')  {
                            // Get outlier detection sensor statuses
                            pollOutlierDetectionSensorStatuses();
                        }

                        vm.isLoading = false;
                    }  
                }
            });
        };



        init();


        
        $scope.$on('$destroy', function() {
            $log.debug("OutlierDetectionJobCtrl scope destroyed. Stopping polling tasks...");
            cancelOdjSensorStatusesNextLoad();
            
            isAlive = false;
        });
    }
})();

/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-12-27
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.advanced')
        .controller('AdminCtrl', AdminCtrl);

    /** @ngInject */
    function AdminCtrl($log, $mdDialog, toastr, LumiService, InternalSettingsService) {
        let vm = this;
        vm.tenant = LumiService.getTenant();
        vm.readOnly = env.readOnly;

        vm.isMasterSwitchLoading = true;
        vm.isOn = null;

        let alert;


        vm.toggle = function () {
            let confirm = $mdDialog.confirm()
                .title("Master Switch")
                .textContent("Are you sure you want to turn ".concat(vm.isOn.val === '1' ? "off" : "on").concat(" the AOMS System?"))
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                const reqBody = {
                    id: vm.isOn.id,
                    key: vm.isOn.key,
                    val: vm.isOn.val === '1' ? '0' : '1',
                    description: vm.isOn.description
                };

                $log.info("Toggling master switch: ".concat(vm.isOn.val === '1' ? "ON" : "OFF"));
                InternalSettingsService.settings.update({ tenant: vm.tenant }, reqBody, function(res) {
                    vm.isOn.val = vm.isOn.val === '1' ? '0' : '1';
                    toastr.success("AOMS System has been toggled successfully: ".concat(vm.isOn.val === '1' ? "ON" : "OFF"));
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred toggling AOMS System"
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
                    $log.error("An error has occurred toggling AOMS System: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                });
            }, function () {});
        };

        const getIsOn = function() {
            $log.info("Getting master switch");
            InternalSettingsService.settings.get({ tenant: vm.tenant, key: 'FLAG_IS_ON' }, function(res) {
                $log.info("Master switch is ".concat(res.val === '1' ? "ON" : "OFF"));
                vm.isOn = res;
            }, function(err)  {
                const errData = err.data;
                showAlert("Error", "An error has occurred getting Master Switch state"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred getting master switch state: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            }).$promise.finally(function()  {
                vm.isMasterSwitchLoading = false;
            });
        };



        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: false,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        getIsOn();
    }

})();

/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2018-01-12
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.advanced')
        .controller('CableManagementCtrl', CableManagementCtrl)
        .controller('NewNodeAssociationCtrl', NewNodeAssociationCtrl);

    /** @ngInject */
    function CableManagementCtrl($scope, $state, $log, $q, $mdDialog, $window, toastr,
                                   LumiService, CableService, InternalSettingsService, ChannelService,
                                   MaturityStrengthJobService, OutlierDetectionJobService) {
        let vm = this;
        vm.tenant = LumiService.getTenant();

        vm.isLoading = true;

        vm.cables = [];
        
        let globalInit;

        let alert;
        let globalInitCompletionAlert;

        vm.isInit = false;
        


        const getGlobalInit = function()  {
            let deferred = $q.defer();
            InternalSettingsService.settings.get({ tenant: vm.tenant, key: "FLAG_IS_INIT" }, function(res)  {
                globalInit = res;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting FLAG_IS_INIT internal setting during the initialization of the Cable Manager: "
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const setGlobalInit = function()  {
            $log.info("Set global init flag");

            globalInit.val = '1';
            globalInit.lastModified = null;
            InternalSettingsService.settings.update({ tenant: vm.tenant }, globalInit, function(res)  {
                $log.info("Global init flag set");

                globalInitCompletionAlert = $mdDialog.alert({
                    title: "Initialization Completed!",
                    textContent: "Your AOMS system is now initialized.  All other parts of AOMS Admin will be made available to you.",
                    ok: 'Close',
                    clickOutsideToClose: false,
                });

                $mdDialog.show(globalInitCompletionAlert)
                    .then(function(res) {
                        $state.go('main.advanced.cablemanagement', {}, { reload: true });
                    }).finally(function() {
                        globalInitCompletionAlert = undefined;
                    });
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred setting global init flag: "
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
            });
        };


        const getNumActiveMaturityStrengthJobs = function(cgId) {
            $log.info("Getting number of active maturity strength jobs");
            let deferred = $q.defer();
        	MaturityStrengthJobService.maturityStrengthJobs.getActiveCountByChannelGroup({ tenant: vm.tenant, cgId: cgId }, function(res) {
                $log.info("Number of active maturity strength jobs: " + res[0]);
                deferred.resolve(res[0]);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting number of active maturity strength jobs: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(null);
            });
            return deferred.promise;
        };

        const getNumActiveOutlierDetectionJobs = function(cgId) {
            $log.info("Getting number of active outlier detection jobs");
            let deferred = $q.defer();
        	OutlierDetectionJobService.outlierDetectionJobs.getActiveCountByChannelGroup({ tenant: vm.tenant, cgId: cgId }, function(res) {
                $log.info("Number of active outlier detection jobs: " + res[0]);
                deferred.resolve(res[0]);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting number of active outlier detection jobs: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(null);
            });
            return deferred.promise;
        };


        const createNodeAssociationHelper = function(cableId, nodeId) {
            $log.info("Creating Node Association");
            // Node not associated.  Get Cable Info
            CableService.cables.getCable({ allowAttached: false, cableId: cableId }, function(res2) {
                // Create Cable and Node in Alfred
                ChannelService.channelGroups.save({ tenant: vm.tenant }, { channelGroupId: res2.cableId,
                                            description: null,
                                            channelGroupTypeName: 'Cable',
                                            nodeId: nodeId}, function(res3) {
                    // Create Channels
                    const cableSpec = JSON.parse(res2.spec);
                    if(cableSpec.channels && cableSpec.channels.length > 0)  {
                        let sensorCounter = 0;
                        cableSpec.channels.forEach(c => {
                            if(c.sensors)  {
                                sensorCounter = sensorCounter + c.sensors.length;
                            }
                        });

                        if(sensorCounter > 0)  {
                            const channels = cableSpec.channels.map(c => {
                                return {
                                    channelId: c.channelId,
                                    serialNumber: c.serialNumber,
                                    cgId: res3.id,
                                    isActive: true,
                                    isDiagnostic: false
                                };
                            });

                            ChannelService.channels.createChannels({ tenant: vm.tenant }, channels, function(res4)  {
                                const sensors = [];
                                cableSpec.channels.forEach(c => {
                                    if(c.sensors && c.sensors.length > 0)  {
                                        sensors.push(...c.sensors.map(s => {
                                            return {
                                                channelId: c.channelId,
                                                sensorId: s.sensorId,
                                                isDiagnostic: false,
                                                sensorType: s.sensorType,
                                                isActive: true
                                            };
                                        }));
                                    }
                                });
                                
                                // Create Sensors
                                ChannelService.sensors.createSensors({ tenant: vm.tenant }, sensors, function(res5)  {
                                    // Assign Tenant and Cable to Node
                                    CableService.nodes.assignNode({ nodeId: nodeId, 
                                                                    cableId: cableId, 
                                                                    tenant: vm.tenant}, function(res6)  {
                                        toastr.success("Node Association has been updated successfully (Cable " + cableId + " => Node " + nodeId + ")");
                                        vm.getCables();
                                    }, function(err6)  {
                                        const errData = err6.data;
                                        $log.error("Failed to assign Node to Cable: ".concat(errData ? JSON.stringify(errData) :
                                            JSON.stringify(err6)));
                                        toastr.error("Failed to assign Node to Cable: ".concat(errData ? JSON.stringify(errData) :
                                            JSON.stringify(err6)));
                                        vm.getCables();
                                    });
                                }, function(err5)  {
                                    const errData = err5.data;
                                    $log.error("Failed to create sensors during node association: ".concat(errData ? JSON.stringify(errData) :
                                        JSON.stringify(err5)));
                                    toastr.error("Failed to initialize Cable and Node as Sensors creation has failed: ".concat(errData ? JSON.stringify(errData) :
                                        JSON.stringify(err5)));
                                    vm.getCables();
                                });
                            }, function(err4)  {
                                const errData = err4.data;
                                $log.error("Failed to create channels during node association: ".concat(errData ? JSON.stringify(errData) :
                                    JSON.stringify(err4)));
                                toastr.error("Failed to initialize Cable and Node as Channels creation has failed: ".concat(errData ? JSON.stringify(errData) :
                                    JSON.stringify(err4)));
                                vm.getCables();
                            });
                        }
                        else  {
                            $log.error("Cable " + cableId + " has empty sensors");
                            toastr.error("Failed to initialize Cable and Node as Cable specification is not valid");
                        }
                    }
                    else  {
                        $log.error("Cable " + cableId + " has empty channels");
                        toastr.error("Failed to initialize Cable and Node as Cable specification is not valid");
                    }
                }, function(err3)  {
                    const errData = err3.data;
                    $log.error("Failed to create cable and node when creating node association: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err3)));
                    toastr.error("Failed to initialize Cable and Node: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err3)));
                    vm.getCables();    
                });
            }, function(err2)  {
                const errData = err2.data;
                $log.error("Failed to get unattached cable by cable id when creating node association: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err2)));
                toastr.error("Failed to obtain information about Cable ".concat(cableId).concat(" or that Cable is currently attached: ").concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err2)));
                vm.getCables();
            });
        };


        vm.getCables = function() {
            $log.info("Getting all cables");
            let deferred = $q.defer();

            CableService.nodes.fetchNodes(function(res)  {
                const masterNodes = res.filter(n => n.tenant === vm.tenant);
                if(masterNodes.length > 0)  {
                    ChannelService.channelGroups.getChannelGroupsByType({ tenant: vm.tenant, channelGroupTypeName: 'Cable' }, function(res2) {
                        const c = res2.channelGroupMessages.sort((a,b) => {
                            const aUpper = a.channelGroupId.toUpperCase();
                            const bUpper = b.channelGroupId.toUpperCase();
                            return (aUpper < bUpper) ? -1 : (aUpper > bUpper) ? 1 : (b.creationDate - a.creationDate);
                        });
        
                        // TODO: use the isNodeAssociated flag
                        // vm.cables = c.filter(cc => cc.isNodeAssociated)
                        //     .filter(cc => {
                        //         return masterNodes.find(n => n.nodeId === cc.nodeId && n.cableId === cc.channelGroupId)
                        //     })
                        //     .filter((e, i) => {
                        //         return c.findIndex((x) => {
                        //             return x.channelGroupId == e.channelGroupId;
                        //         }) == i;
                        //     });

                        const allCables = c.filter(cc => {
                                return masterNodes.find(n => n.nodeId === cc.nodeId && n.cableId === cc.channelGroupId)
                            });
                        
                        vm.cables = allCables.filter(ac => ac.isNodeAssociated === true);
                        vm.displayedCables = [].concat(vm.cables);    
                        $log.info("Cables successfully obtained: " + JSON.stringify(vm.cables));    
                        deferred.resolve(true);
                    }, function(err2)  {
                        const errData = err.data;
                        $log.info("An error has occurred getting channel groups of cable type: ".concat(errData ? JSON.stringify(errData) :
                            JSON.stringify(err2)));
                        deferred.resolve(false);
                    });
                }
                else  {
                    // No nodes are found for the tenant
                    vm.cables.length = 0;
                    vm.displayedCables = [].concat(vm.cables); 
                    deferred.resolve(true);
                }
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting all nodes: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });

            return deferred.promise;
        };

        vm.createNodeAssociation = function(cgId, cableId, nodeId) {
            if(cableId != null && nodeId != null)  {
                CableService.nodes.getCableNodeAssociationInfo({ nodeId: nodeId }, function(res) {
                    if(res.destCableId)  {
                        if(res.destCableId !== cableId)  {
                            // Node is already associated
                            toastr.error("Cannot perform association as Node " + nodeId + " has already been associated with Cable " + res.destCableId);
                            vm.getCables();    
                        }
                    }
                    else  {
                        vm.removeNodeAssociation(cgId, cableId, vm.oldNodeId).then(function(res)  {
                            if(res)  {
                                createNodeAssociationHelper(cableId, nodeId);
                            }
                        });
                    }
                }, function(err)  {
                    const errData = err.data;
                    $log.error("Failed to get cable and node association when creating node association: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                    toastr.error("Failed to determine the state of Node ".concat(nodeId).concat(" and Cable ").concat(cableId).concat(": ").concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                    vm.getCables();
                });
            }
            else  {
                // Should not happen
                toastr.error("An error has occurred creating Node Association (null node association)");
                vm.getCables();
            }   
        };

        vm.removeNodeAssociation = function(cgId, cableId, nodeId) {
            let deferred = $q.defer();
            if(nodeId)  {
                CableService.nodes.fetchNodeByNodeId({ nodeId: nodeId }, function(res) {
                    if(res.cableId != null && res.tenant != null)  {
                        $q.all([
                            getNumActiveMaturityStrengthJobs(cgId),
                            getNumActiveOutlierDetectionJobs(cgId)
                        ]).then(function(res2) {
                            if(res2[0] === null || res2[1] === null)  {
                                toastr.error("Failed to disassociate Node ".concat(nodeId).concat(" from Cable ").concat(cableId).concat(" as we failed to determine the number of active Channel Jobs"));
                                vm.getCables();
    
                                deferred.resolve(false);
                            }
                            else if (res2[0] > 0 || res2[1] > 0)  {
                                showAlert("Error", "Cannot change Node Association as there are active Channel Jobs (Maturity Strength Jobs: " + res2[0] + ", Outlier Detection Jobs: " + res2[1] + ")");
                                vm.getCables();
    
                                deferred.resolve(false);
                            }
                            else  {
                                // Unassign Tenant and Cable from Node
                                ChannelService.channelGroups.dissociateNode({ tenant: vm.tenant, cgId: cgId }, function(res3)  {
                                    CableService.nodes.unassignNode({ nodeId: nodeId}, function(res4)  {
                                        toastr.success("Node " + nodeId + " successfully disassociated from Cable " + cableId);
                                        vm.getCables();
    
                                        deferred.resolve(true);
                                    }, function(err4)  {
                                        const errData = err4.data;
                                        $log.error("Failed to unassign Node from Cable in Alvin: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err4)));
                                        toastr.error("Failed to disassociate Node ".concat(nodeId).concat(" from Cable ".concat(cableId).concat(": ")
                                            .concat(errData ? JSON.stringify(errData) : JSON.stringify(err4))));
    
                                        deferred.resolve(false);
                                    });
                                }, function(err3)  {
                                    const errData = err3.data;
                                    $log.error("Failed to unassign Node from Cable in Alfred: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err3)));
                                    toastr.error("Failed to disassociate Node ".concat(nodeId).concat(" from Cable ".concat(cableId).concat(": ")
                                        .concat(errData ? JSON.stringify(errData) : JSON.stringify(err3))));
                                    vm.getCables();
    
                                    deferred.resolve(false);
                                });
                            }
                        });
                    }
                    else  {
                        // Node not associated
                        toastr.error("Cannot perform disassociation as Node " + nodeId + " is not associated with a cable");
                        vm.getCables();
    
                        deferred.resolve(true);
                    }
                }, function(err)  {
                    const errData = err.data;
                    $log.error("Failed to fetch node by node id when performing node disassociation: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                    toastr.error("Failed to determine the state of Node ".concat(nodeId).concat(": ").concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                        vm.getCables();    
    
                    deferred.resolve(false);
                });
            }
            return deferred.promise;
        };


        vm.showNodeAssociationModal = function(ev) {
            $mdDialog.show({
                controller: 'NewNodeAssociationCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/advanced/cableManagement/nodeAssociationModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
            }).then(function(res) {
                if(res)  {
                    $log.info("New node association (Cable " + res.cableId + " => Node " + res.nodeId + ") has been created successfully");
                    toastr.success("New Node Association (Cable " + res.cableId + " => Node " + res.nodeId + ") has been created successfully");
                    if(globalInit && (!globalInit.val || globalInit.val !== '1') && vm.cables.length === 0)  {
                        setGlobalInit();
                    }
                    
                    vm.getCables();
                }
            }, function(errData)  {
            });
        };


        const init = function()  {
            if(!vm.isInit)  {
                $log.info("Initializing Cable Manager");
                vm.isLoading = true;
                $q.all([
                    getGlobalInit(),
                    vm.getCables()
                ]).then(function(res) {
                    if(!res[0] || !res[1])  {
                        showAlert("Error", "An error has occurred initializing the Cable Manager");
                    }
                    else  {
                        $log.info("Cable Manager initialized: globalInit " + globalInit.val);
                        if(globalInit && (!globalInit.val || globalInit.val !== '1'))  {
                            showAlert("Welcome to AOMS Admin!", "Please add Cables and Nodes to initialize your AOMS system.");
                        }

                        vm.isInit = true;
                    }
                    vm.isLoading = false;
                });
            }
        };


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                multiple: true,
                clickOutsideToClose: false,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };


        init();
    }


    function NewNodeAssociationCtrl($log, $timeout, $mdDialog, toastr, LumiService, CableService, ChannelService) {
        let vm = this;
        let tenant = LumiService.getTenant();
        vm.nodeAssociation = {};

        
        vm.createNodeAssociation = function() {
            return $timeout(1000)
                .then(function()  {
                    $log.info("Creating Node Association");
                    if(vm.nodeAssociation)  {
                        CableService.nodes.getCableNodeAssociationInfo({ cableId: vm.nodeAssociation.cableId, nodeId: vm.nodeAssociation.nodeId }, function(res) {
                            if(res.destCableId || res.destNodeId)  {
                                // Node and/or Cable already associated
                                if(res.destCableId && res.destNodeId)  {
                                    toastr.error("Cannot perform association as Node " + vm.nodeAssociation.nodeId + " has already been associated with Cable " + res.destCableId + " and Cable " + vm.nodeAssociation.cableId + " has already been associated with Node " + res.destNodeId);
                                }
                                else if(!res.destCableId)  {
                                    toastr.error("Cannot perform association as Cable " + vm.nodeAssociation.cableId + " has already been associated with Node " + res.destNodeId);
                                }
                                else if(!res.destNodeId)  {
                                    toastr.error("Cannot perform association as Node " + vm.nodeAssociation.nodeId + " has already been associated with Cable " + res.destCableId);
                                }
                            }
                            else  {
                                // Node not associated.  Get Cable Info
                                CableService.cables.get({ cableId: vm.nodeAssociation.cableId }, function(res2) {
                                    // Create Cable and Node in Alfred
                                    ChannelService.channelGroups.save({ tenant: tenant }, { channelGroupId: res2.cableId,
                                                                description: null,
                                                                channelGroupTypeName: 'Cable',
                                                                nodeId: vm.nodeAssociation.nodeId}, function(res3) {
                                        // Create Channels
                                        const cableSpec = JSON.parse(res2.spec);
                                        if(cableSpec.channels && cableSpec.channels.length > 0)  {
                                            let sensorCounter = 0;
                                            cableSpec.channels.forEach(c => {
                                                if(c.sensors)  {
                                                    sensorCounter = sensorCounter + c.sensors.length;
                                                }
                                            });

                                            if(sensorCounter > 0)  {
                                                const channels = cableSpec.channels.map(c => {
                                                    return {
                                                        channelId: c.channelId,
                                                        serialNumber: c.serialNumber,
                                                        cgId: res3.id,
                                                        isActive: true,
                                                        isDiagnostic: false
                                                    };
                                                });
    
                                                ChannelService.channels.createChannels({ tenant: tenant }, channels, function(res4)  {
                                                    const sensors = [];
                                                    cableSpec.channels.forEach(c => {
                                                        if(c.sensors && c.sensors.length > 0)  {
                                                            sensors.push(...c.sensors.map(s => {
                                                                return {
                                                                    channelId: c.channelId,
                                                                    sensorId: s.sensorId,
                                                                    isDiagnostic: false,
                                                                    sensorType: s.sensorType,
                                                                    isActive: true
                                                                };
                                                            }));
                                                        }
                                                    });
                                                    
                                                    // Create Sensors
                                                    ChannelService.sensors.createSensors({ tenant: tenant }, sensors, function(res5)  {
                                                        // Assign Tenant and Cable to Node
                                                        CableService.nodes.assignNode({ nodeId: vm.nodeAssociation.nodeId, 
                                                                                        cableId: vm.nodeAssociation.cableId, 
                                                                                        tenant: tenant}, function(res6)  {
                                                            vm.hide();
                                                        }, function(err6)  {
                                                            const errData = err6.data;
                                                            $log.error("Failed to assign Node to Cable: ".concat(errData ? JSON.stringify(errData) :
                                                                JSON.stringify(err6)));
                                                            toastr.error("Failed to assign Node to Cable: ".concat(errData ? JSON.stringify(errData) :
                                                                JSON.stringify(err6)));
                                                        });
                                                    }, function(err5)  {
                                                        const errData = err5.data;
                                                        $log.error("Failed to create sensors during node association: ".concat(errData ? JSON.stringify(errData) :
                                                            JSON.stringify(err5)));
                                                        toastr.error("Failed to initialize Cable and Node as Sensors creation has failed: ".concat(errData ? JSON.stringify(errData) :
                                                            JSON.stringify(err5)));
                                                    });
                                                }, function(err4)  {
                                                    const errData = err4.data;
                                                    $log.error("Failed to create channels during node association: ".concat(errData ? JSON.stringify(errData) :
                                                        JSON.stringify(err4)));
                                                    toastr.error("Failed to initialize Cable and Node as Channels creation has failed: ".concat(errData ? JSON.stringify(errData) :
                                                        JSON.stringify(err4)));
                                                });
                                            }
                                            else  {
                                                $log.error("Cable " + vm.nodeAssociation.cableId + " has empty sensors");
                                                toastr.error("Failed to initialize Cable and Node as Cable specification is not valid");
                                            }
                                        }
                                        else  {
                                            $log.error("Cable " + vm.nodeAssociation.cableId + " has empty channels");
                                            toastr.error("Failed to initialize Cable and Node as Cable specification is not valid");
                                        }
                                    }, function(err3)  {
                                        const errData = err3.data;
                                        $log.error("Failed to create cable and node when creating node association: ".concat(errData ? JSON.stringify(errData) :
                                            JSON.stringify(err3)));
                                        toastr.error("Failed to initialize Cable and Node: ".concat(errData ? JSON.stringify(errData) :
                                            JSON.stringify(err3)));
                                    });
                                }, function(err2)  {
                                    const errData = err2.data;
                                    $log.error("Failed to get cable by cable id when creating node association: ".concat(errData ? JSON.stringify(errData) :
                                        JSON.stringify(err2)));
                                    toastr.error("Failed to obtain information about Cable ".concat(vm.nodeAssociation.cableId).concat(": ").concat(errData ? JSON.stringify(errData) :
                                        JSON.stringify(err2)));
                                });
                            }

                        }, function(err)  {
                            const errData = err.data;
                            $log.error("Failed to get cable and node association when creating node association: ".concat(errData ? JSON.stringify(errData) :
                                JSON.stringify(err)));
                            toastr.error("Failed to determine the state of Node ".concat(vm.nodeAssociation.nodeId).concat(" and Cable ").concat(vm.nodeAssociation.cableId).concat(": ").concat(errData ? JSON.stringify(errData) :
                                JSON.stringify(err)));
                        });
                    }
                    else  {
                        // Should not happen
                        toastr.error("An error has occurred creating Node Association (null node association)");
                        vm.cancel();
                    }
                });
        };


        vm.hide = function() {
            $mdDialog.hide(vm.nodeAssociation);
        };

        vm.cancel = function() {
            $mdDialog.cancel();
        };
    }

})();




/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2018-01-12
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.advanced')
        .controller('ChannelManagementCtrl', ChannelManagementCtrl)
        .controller('ChannelActivationExecutionCtrl', ChannelActivationExecutionCtrl);

    /** @ngInject */
    function ChannelManagementCtrl($scope, $state, $log, $q, $mdDialog, $window, toastr,
                                   LumiService, InternalSettingsService, ChannelData, ChannelService) {
        let vm = this;
        vm.tenant = LumiService.getTenant();

        vm.isLoading = true;
        vm.isEditingChannelSettings = false;
        vm.isSelectingCalibrationFiles = false;

        vm.isChannelSelectionsValid = true;

        vm.oldChannelSettings = [];
        vm.newChannelSettings = [];
        vm.newChannels = [];

        vm.hasSensorsCalibrations = true;
        vm.availableSensorsCalibrationFiles = 0;
        vm.matchedSensorsCalibrationFiles = 0;
        vm.unmatchedSensorsCalibrationFiles = 0;
        
        let numSensors = 0;
        let globalInit;

        const channelSelectionsRegex = /^(\d+)\s*-\s*(\d+)$/;
        const sensorConfigurationFileRegex = /^CAL_(MTS|LPS|MHS)-([a-zA-Z0-9_]+).cfg$/;
        let selectedChannelIds = [];


        vm.isDecommissionedChannelSelectionsValid = false;
        vm.decommissionedChannels = [];
        let selectedDecommissionedChannelIds = [];

        let alert;
        let globalInitCompletionAlert;

        vm.isInit = false;
        


        vm.initChannelActivationWizard = function()  {
            if(!vm.isInit)  {
                $log.info("Initializing Channel Management Wizard");
                vm.isLoading = true;
                $q.all([
                    getGlobalInit(),
                    getNumSensors()
                ]).then(function(res) {
                    if(!res[0] || !res[1])  {
                        showAlert("Error", "An error has occurred initializing the Channel Management Wizard");
                    }
                    else  {
                        $log.info("Channel Management Wizard initialized: globalInit " + globalInit.val + ", numSensors " + numSensors);
                        if(globalInit && (!globalInit.val || globalInit.val !== '1'))  {
                            showAlert("Welcome to AOMS Admin!", "Please complete the steps in the Channel Management Wizard to initialize your AOMS system.");
                        }

                        vm.isInit = true;
                    }
                    vm.isLoading = false;
                });
            }
        };

        vm.isChannelActivationDirty = function()  {
            return selectedChannelIds.length > 0;
        };


        const getGlobalInit = function()  {
            let deferred = $q.defer();
            InternalSettingsService.settings.get({ tenant: vm.tenant, key: "FLAG_IS_INIT" }, function(res)  {
                globalInit = res;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting FLAG_IS_INIT internal setting during the initialization of the Channel Management Wizard: "
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getNumSensors = function()  {
            let deferred = $q.defer();
            InternalSettingsService.settings.get({ tenant: vm.tenant, key: "ENFORCED_NUM_SENSORS" }, function(res)  {
                numSensors = parseInt(res.val);
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting ENFORCED_NUM_SENSORS internal setting: "
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const setGlobalInit = function()  {
            $log.info("Set global init flag");

            globalInit.val = '1';
            globalInit.lastModified = null;
            InternalSettingsService.settings.update({ tenant: vm.tenant }, globalInit, function(res)  {
                $log.info("Global init flag set");

                globalInitCompletionAlert = $mdDialog.alert({
                    title: "Initialization Completed!",
                    textContent: "Your AOMS system is now initialized.  All other parts of AOMS Admin will be made available to you.",
                    ok: 'Close',
                    clickOutsideToClose: false,
                });

                $mdDialog.show(globalInitCompletionAlert)
                    .then(function(res) {
                        $window.location.href = '/'
                    }).finally(function() {
                        globalInitCompletionAlert = undefined;
                    });
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred setting global init flag: "
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
            });
        };


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                multiple: true,
                clickOutsideToClose: false,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };

/*************************************************Channel Configurations************************************************/
        vm.processChannelSelections = function(oldChannelSelections)  {
            resetChannelSelections();

            if(vm.channelSelections && vm.channelSelections.length > 0)  {
                let cs = [];
                let trimmed = vm.channelSelections.split(",").map(c => c.trim());

                for (let i = 0; i < trimmed.length; i++) {
                    const c = trimmed[i];
                    if(isNaN(c) || c.length === 0)  {
                        const matches = c.match(channelSelectionsRegex);
                        if(matches && matches[1] <= matches[2])  {
                            let j = matches[1];
                            while(j <= matches[2])  {
                                cs.push(j++);
                            }
                        }
                        else  {
                            vm.isChannelSelectionsValid = false;
                            vm.channelsForm.channelSelections.$setValidity('validChannelSelections', false);
                            return;
                        }
                    }
                    else  {
                        cs.push(parseInt(c));
                    }
                }

                selectedChannelIds = cs.reduce((x, y) => x.includes(y) ? x : [...x, y], []).sort((c1, c2) => c1 - c2);
                $log.info("The following channels are to be activated: ".concat(selectedChannelIds));
            }
            else  {
                $log.info("No new channels are to be activated");
            }

            vm.isChannelSelectionsValid = true;
            vm.channelsForm.channelSelections.$setValidity('validChannelSelections', true);
            refreshChannelData();
        };

        const refreshChannelData = function()  {
            $log.info("Refreshing channel data");

            vm.isLoading = true;
            ChannelService.settings.query({ tenant: vm.tenant }, function(res) {
                // Get old channel settings data
                vm.oldChannelSettings = res.channelSettingsMessages;
                vm.displayedOldChannelSettings = [].concat(vm.oldChannelSettings);
                $log.info("Old channel settings data obtained: ".concat(JSON.stringify(vm.oldChannelSettings)));

                // Create new channel settings
                vm.newChannelSettings = res.channelSettingsMessages
                    .filter(cs => vm.isNewChannel(cs.channelId))
                    .map(m => createChannelSettings(m.channelId, null, null));

                const newChannelSettingsIds = vm.newChannelSettings.map(ncs => ncs.channelId);
                selectedChannelIds.filter(sc => !newChannelSettingsIds.includes(sc))
                    .forEach(nc => vm.newChannelSettings.push(createChannelSettings(nc, null, null)));

                vm.displayedNewChannelSettings = [].concat(vm.newChannelSettings);
                $log.info("New channel settings data created: ".concat(JSON.stringify(vm.newChannelSettings)));

                createChannels();
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting all channel settings: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            }).$promise.finally(function()  {
                vm.isLoading = false;
            });
        };


        vm.isNewChannel = function(channelId)  {
            return selectedChannelIds.includes(channelId);
        };

        const resetChannelSelections = function(all)  {
            if(all)  vm.channelSelections = null;

            if(selectedChannelIds)  {
                selectedChannelIds.length = 0;
            }
            vm.oldChannelSettings.length = 0;
            vm.newChannelSettings.length = 0;
            vm.newChannels.length = 0;
        };

        const createChannels = function()  {
            vm.newChannels = vm.newChannelSettings.map(cs => {
                return  {
                    channelId: cs.channelId,
                    serialNumber: cs.serialNumber,
                    isActive: true,
                    isDiagnostic: false
                };
            });

            resetSensorsCalibrationFiles(true);
            $log.info("New channels created: ".concat(JSON.stringify(vm.newChannels)));
        };

        const createChannelSettings = function(channelId, serialNumber, length)  {
            return {
                channelId: channelId,
                serialNumber: serialNumber,
                isDiagnostic: false,
                channelSettingsData: {
                    LENGTH: length
                }
            };
        };


        vm.validateNewSerialNumber = function(data)  {
            // const serialNumbers = vm.newChannelSettings.map(s => s.serialNumber);
            // if(data.length !== 0 && serialNumbers.includes(data))  {
            //     return "Duplicate Serial Number!";
            // }
        };

        vm.updateChannelSettings = function(channelId, data) {
            vm.isEditingChannelSettings = false;
            $log.info("New channel settings data updated: ".concat(JSON.stringify(vm.newChannelSettings)));

            const index = vm.newChannels.findIndex(cs => cs.channelId === channelId);
            if(index !== -1)  {
                vm.newChannels[index].serialNumber = data.serialNumber;
                $log.info("New channels updated: ".concat(JSON.stringify(vm.newChannels)));
            }

            resetSensorsCalibrationFiles(true);
        };


        $scope.$watch('selectedChannelIds', function() {
            refreshChannelData();
        });
/*******************************************End Channel Configurations**************************************************/

/*************************************************Sensor Configurations*************************************************/
        vm.onSelectingSensorsCalibrationDirectory = function()  {
            resetSensorsCalibrationFiles(true);
        };

        vm.onSensorsCalibrationDirectoryChanged = function()  {
            $log.info("Sensors calibration directory changed");
            vm.isSelectingCalibrationFiles = true;

            // Create new channels
            const numChannels = vm.newChannels.length;

            if(vm.sensorsCalibrationFileSelections)  {
                const newSerialNumbers = vm.newChannels.map(c => c.serialNumber);

                // Valid sensors calibration files must match the sensor calibration file regex
                // Matching sensors calibration files ChannelService the same serial number in the file name
                // as the serial number of the new channels
                let sensorsCalibrationFiles = vm.sensorsCalibrationFileSelections.filter(f => {
                    const matches = f.name.match(sensorConfigurationFileRegex);
                    if(matches)  {
                        vm.availableSensorsCalibrationFiles++;
                        return newSerialNumbers.includes(matches[1] + '-' + matches[2]);
                    }
                    return false;
                });

                createSensorsCalibrationData(numChannels, sensorsCalibrationFiles);
            }
            else  {
                vm.unmatchedSensorsCalibrationFiles = numChannels;
                vm.isSelectingCalibrationFiles = false;
            }
        };

        const createSensorsCalibrationData = function(numChannels, sensorsCalibrationFiles)  {
            $log.info("Processing sensors calibration files");
            let calibrationDataPromises = [];

            for(let i=0; i<sensorsCalibrationFiles.length; i++)  {
                // Each file would match a new channel, we need to validate its content and derive the calibration data to be sent to the server
                const sensorsCalibrationFile = sensorsCalibrationFiles[i];

                const match = sensorsCalibrationFile.name.match(sensorConfigurationFileRegex);
                const calibrationFileType = match[1];
                const serialNumber = calibrationFileType + '-' + match[2];
                const channelId = vm.newChannels.filter(nc => nc.serialNumber === serialNumber).map(nc => nc.channelId)[0];

                calibrationDataPromises.push(ChannelData.createSensorsCalibrationData(channelId, serialNumber, calibrationFileType, numSensors, sensorsCalibrationFiles[i]));
            }

            if(calibrationDataPromises.length > 0)  {
                $q.all(calibrationDataPromises).then(function(res) {
                    $log.info("Sensors Calibration Files have been processed: ".concat(res.length));
                    vm.sensorsCalibrationFileResults = res.map(r => {
                        return {
                            filename: r.filename,
                            status: r.status
                        }
                    });

                    // Create sensors calibration requests
                    const calibrationFileTypes = ChannelData.getCalibrationFileTypes();
                    vm.calibrationMTSRequestsLists = res.filter(r => r.status === 'Valid' && r.calibrationFileType === calibrationFileTypes.calibrationMTS)
                        .map(r => {
                            return {
                                channelId: r.channelId,
                                serialNumber: r.serialNumber,
                                isDiagnostic: false,
                                calibrationMTSData: r.data
                            }
                    });
                    $log.info("New Calibration MTS requests created");

                    vm.calibrationLPSRequestsLists = res.filter(r => r.status === 'Valid' && r.calibrationFileType === calibrationFileTypes.calibrationLPS)
                        .map(r => {
                            return {
                                channelId: r.channelId,
                                serialNumber: r.serialNumber,
                                isDiagnostic: false,
                                calibrationLPSData: r.data
                            }
                        });
                    $log.info("New Calibration LPS requests created");

                    vm.calibrationMHSRequestsLists = res.filter(r => r.status === 'Valid' && r.calibrationFileType === calibrationFileTypes.calibrationMHS)
                        .map(r => {
                            return {
                                channelId: r.channelId,
                                serialNumber: r.serialNumber,
                                isDiagnostic: false,
                                calibrationMHSData: r.data
                            }
                    });
                    $log.info("New Calibration MHS requests created");

                    vm.matchedSensorsCalibrationFiles = vm.sensorsCalibrationFileResults.filter(f => f.status === 'Valid').length;
                    vm.unmatchedSensorsCalibrationFiles = numChannels - vm.matchedSensorsCalibrationFiles;
                }, function(err) {
                    showAlert("Error", "An unexpected error has occurred processing Sensors Calibration Files");
                    $log.error("An unexpected error has occurred processing sensors calibration files: ".concat(JSON.stringify(err)));
                }).finally(function () {
                    sensorsCalibrationFiles.length = 0;
                    vm.isSelectingCalibrationFiles = false;
                });
            }
            else  {
                sensorsCalibrationFiles.length = 0;
                vm.unmatchedSensorsCalibrationFiles = numChannels;
                vm.isSelectingCalibrationFiles = false;
            }
        };


        const resetSensorsCalibrationFiles = function(all)  {
            if(all)  {
                if(vm.sensorsCalibrationFileSelections)  vm.sensorsCalibrationFileSelections = undefined;
            }

            if(vm.sensorsCalibrationFileResults)  vm.sensorsCalibrationFileResults.length = 0;
            if(vm.calibrationMTSRequestsLists)  vm.calibrationMTSRequestsLists = undefined;
            if(vm.calibrationLPSRequestsLists)  vm.calibrationLPSRequestsLists = undefined;
            if(vm.calibrationMHSRequestsLists)  vm.calibrationMHSRequestsLists = undefined;

            vm.hasSensorsCalibrations = true;
            vm.availableSensorsCalibrationFiles = 0;
            vm.matchedSensorsCalibrationFiles = 0;
            vm.unmatchedSensorsCalibrationFiles = 0;
        };
/********************************************End Sensor Configurations**************************************************/

/***************************************************Execution***********************************************************/
        vm.execute = function() {
            if(vm.newChannels.find(c => !c.serialNumber || c.serialNumber.length === 0))  {
                showAlert("Warning", "Cannot proceed as Serial Number has not been defined for one or more Channels.");
            }
            else if(!vm.hasSensorsCalibrations) {
                let confirm = $mdDialog.confirm()
                    .title("Warning")
                    .textContent("Sensors will not be created and assigned as no matching Sensors Calibration Files were specified or found.  Proceed?")
                    .targetEvent(event)
                    .ok('Yes')
                    .cancel('No');

                $mdDialog.show(confirm).then(function () {
                    vm.showChannelActivationExecutionModal();
                }, function () {});
            }
            else  {
                vm.showChannelActivationExecutionModal();
            }
        };


        vm.getNumSensorsCalibrations = function(channelId)  {
            const calibrationMTSRequestsLists = vm.calibrationMTSRequestsLists ? vm.calibrationMTSRequestsLists.filter(r => r.channelId === channelId) : null;
            const calibrationLPSRequestsLists = vm.calibrationLPSRequestsLists ? vm.calibrationLPSRequestsLists.filter(r => r.channelId === channelId) : null;
            const calibrationMHSRequestsLists = vm.calibrationMHSRequestsLists ? vm.calibrationMHSRequestsLists.filter(r => r.channelId === channelId) : null;

            const numCalibrationMTSCalibrations = (calibrationMTSRequestsLists && calibrationMTSRequestsLists.length > 0) ?
                calibrationMTSRequestsLists[0].calibrationMTSData.length : 0;
            const numCalibrationLPSCalibrations = (calibrationLPSRequestsLists && calibrationLPSRequestsLists.length > 0) ?
                calibrationLPSRequestsLists[0].length : 0;
            const numCalibrationMHSCalibrations = (calibrationMHSRequestsLists && calibrationMHSRequestsLists.length > 0) ?
                calibrationMHSRequestsLists[0].calibrationMHSData.length : 0;

            const numSensorsCalibrations = numCalibrationMTSCalibrations + numCalibrationLPSCalibrations + numCalibrationMHSCalibrations;
            vm.hasSensorsCalibrations = (numSensorsCalibrations !== 0);

            return numSensorsCalibrations;
        };



        vm.showChannelActivationExecutionModal = function(ev) {
            $mdDialog.show({
                controller: 'ChannelActivationExecutionCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/advanced/channelManagement/channelActivationExecutionModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
                locals: {
                    newChannels: vm.newChannels,
                    newChannelSettings: vm.newChannelSettings,
                    calibrationMTSRequestsLists: vm.calibrationMTSRequestsLists,
                    calibrationLPSRequestsLists: vm.calibrationLPSRequestsLists,
                    calibrationMHSRequestsLists: vm.calibrationMHSRequestsLists
                }
            }).then(function(res) {
                $log.info("Channels have been successfully activated");
                toastr.success("Channel Activation completed");

                if(globalInit && (!globalInit.val || globalInit.val !== '1'))  {
                    setGlobalInit();
                }
            }, function(err)  {
                $log.error("An error has occurred activating Channels");
                toastr.error("An error has occurred activating Channels");
            }).finally(function() {
                $state.go('main.advanced.channelmanagement', {}, { reload: true });
            });
        };
/*************************************************End Execution*********************************************************/

/************************************************Channel Decommission***************************************************/
        vm.processDecommissionedChannelSelections = function()  {
            vm.resetDecommissionedChannelSelections();

            if(vm.decommissionedChannelSelections && vm.decommissionedChannelSelections.length > 0)  {
                let cs = [];
                let trimmed = vm.decommissionedChannelSelections.split(",").map(c => c.trim());

                for (let i = 0; i < trimmed.length; i++) {
                    const c = trimmed[i];
                    if(isNaN(c) || c.length === 0)  {
                        const matches = c.match(channelSelectionsRegex);
                        if(matches && matches[1] <= matches[2])  {
                            let j = matches[1];
                            while(j <= matches[2])  {
                                cs.push(j++);
                            }
                        }
                        else  {
                            vm.isDecommissionedChannelSelectionsValid = false;
                            vm.decommissionChannelsForm.decommissionedChannelSelections.$setValidity('validDecommissionedChannelSelections', false);
                            return;
                        }
                    }
                    else  {
                        cs.push(parseInt(c));
                    }
                }

                selectedDecommissionedChannelIds = cs.reduce((x, y) => x.includes(y) ? x : [...x, y], []).sort();
                $log.info("The following channels are to be deactivated: ".concat(selectedDecommissionedChannelIds));
            }
            else  {
                vm.isDecommissionedChannelSelectionsValid = false;
                vm.decommissionChannelsForm.decommissionedChannelSelections.$setValidity('validDecommissionedChannelSelections', false);
                return;
            }

            vm.isDecommissionedChannelSelectionsValid = true;
            vm.decommissionChannelsForm.decommissionedChannelSelections.$setValidity('validDecommissionedChannelSelections', true);


            vm.decommissionedChannels = selectedDecommissionedChannelIds.map(c => {
                return {
                    channelId: c
                }
            });
            $log.info("Decommissioned channels created: ".concat(JSON.stringify(vm.decommissionedChannels)));
        };

        vm.decommissionChannels = function()  {
            if(vm.decommissionedChannels && vm.decommissionedChannels.length > 0)  {
                $log.info("Decommissioning channels");
                ChannelService.channels.decommissionList({ tenant: vm.tenant }, vm.decommissionedChannels, function(res) {
                    toastr.success(vm.decommissionedChannels.length + " Channels have been decommissioned successfully!");
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred decommissioning Channels"
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                    $log.error("An error has occurred decommissioning channels: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                });
            }
            else  {
                vm.isDecommissionedChannelSelectionsValid = false;
                vm.decommissionChannelsForm.decommissionedChannelSelections.$setValidity('validDecommissionedChannelSelections', false);
            }
        };


        vm.resetDecommissionedChannelSelections = function(all)  {
            if(all)  vm.decommissionedChannelSelections = null;

            if(selectedDecommissionedChannelIds)  {
                selectedDecommissionedChannelIds.length = 0;
            }

            vm.isDecommissionedChannelSelectionsValid = true;
            vm.decommissionedChannels.length = 0;
        };

/**********************************************End Channel Decommission*************************************************/
        // Responsive HTML attribute value based on screen size
        $(document).ready(function() {
            var $window = $(window);

            function checkWidth() {

                var windowsize = $window.width();
                if (windowsize < 630) {
                    $( ".ba-wizard-navigation" ).each(function( index ) {
                        $( this ).text(index + 1);
                    })
                }
                else {
                    $( ".ba-wizard-navigation" ).eq(0).text("Channel Selections");
                    $( ".ba-wizard-navigation" ).eq(1).text("Configure Channels");
                    $( ".ba-wizard-navigation" ).eq(2).text("Configure Sensors");
                    $( ".ba-wizard-navigation" ).eq(3).text("Review");
                    $( ".ba-wizard-navigation" ).eq(4).text("Execute");
                }
            }

            // Execute on load
            checkWidth();
            // Bind event listener on page resizing
            $(window).resize(checkWidth);
        });
    }



    function ChannelActivationExecutionCtrl($q, $log, $mdDialog, newChannels, newChannelSettings, calibrationMTSRequestsLists, calibrationLPSRequestsLists, calibrationMHSRequestsLists, 
        LumiService, ChannelService) {
        let vm = this;
        let tenant = LumiService.getTenant();

        
        vm.executionStates = {
            pending: 'PENDING',
            success: 'SUCCESS',
            error: 'ERROR',
            na: 'NOT APPLICABLE',
            none: '-'
        };

        vm.executionStatuses = [
            {
                name: 'Create Channels',
                status: vm.executionStates.pending
            },
            {
                name: 'Create and Assign Channel Settings',
                status: vm.executionStates.pending
            },
            {
                name: 'Create Sensors',
                status: vm.executionStates.pending
            },
            {
                name: 'Create and Assign Calibration MTS',
                status: vm.executionStates.pending
            },
            {
                name: 'Create and Assign Calibration LPS',
                status: vm.executionStates.pending
            },
            {
                name: 'Create and Assign Calibration MHS',
                status: vm.executionStates.pending
            }
        ];

        vm.result = null;


        const createNewChannels = function()  {
            $log.info("Creating new channels");
            let newChannelsStatus = vm.executionStatuses.filter(t => t.name === 'Create Channels')[0];
            ChannelService.channels.createChannels({ tenant: tenant }, newChannels, function(res) {
                $log.info(res.total + " new channels have been created successfully");
                newChannelsStatus.status = vm.executionStates.success;

                createNewChannelSettings();
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred creating channels: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                newChannelsStatus.status = vm.executionStates.error;

                vm.result = false;
                updateStatusesOnError();
            });
        };

        const createNewChannelSettings = function()  {
            $log.info("Creating and assigning new channel settings");
            let newChannelSettingsStatus = vm.executionStatuses.filter(t => t.name === 'Create and Assign Channel Settings')[0];
            ChannelService.settings.updateAll({ tenant: tenant }, newChannelSettings, function(res) {
                $log.info(newChannelSettings.length + " new channel settings have been created and assigned successfully");
                newChannelSettingsStatus.status = vm.executionStates.success;

                createNewSensors();
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred creating and assigning channel settings: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                newChannelSettingsStatus.status = vm.executionStates.error;

                vm.result = false;
                updateStatusesOnError();
            });
        };

        const createNewSensors = function()  {
            $log.info("Creating new sensors");
            let newSensorsStatus = vm.executionStatuses.filter(t => t.name === 'Create Sensors')[0];
            let newTemperatureSensors = [];
            let newPressureSensors = [];
            let newHumiditySensors = [];

            if(calibrationMTSRequestsLists)  {
                for(let i=0; i<calibrationMTSRequestsLists.length; i++)  {
                    const calibrationMTSRequest = calibrationMTSRequestsLists[i];
                    const calibrationMTSData = calibrationMTSRequest.calibrationMTSData;
                    if(calibrationMTSData)  {
                        for(let j=0; j<calibrationMTSData.length; j++)  {
                            newTemperatureSensors.push({
                                channelId: calibrationMTSRequest.channelId,
                                sensorId: calibrationMTSData[j].sensorId,
                                sensorType: 'Temperature',
                                isActive: true,
                                isDiagnostic: false
                            });
                        }
                    }
                }
            }

            if(calibrationLPSRequestsLists)  {
                for(let k=0; k<calibrationLPSRequestsLists.length; k++)  {
                    const calibrationLPSRequest = calibrationLPSRequestsLists[k];
                    const calibrationLPSData = calibrationLPSRequest.calibrationLPSData;
                    if(calibrationLPSData)  {
                        for(let l=0; l<calibrationLPSData.length; l++)  {
                            newPressureSensors.push({
                                channelId: calibrationLPSRequest.channelId,
                                sensorId: calibrationLPSData[l].sensorId,
                                sensorType: 'Pressure',
                                isActive: true,
                                isDiagnostic: false
                            });
                        }
                    }
                }
            }

            if(calibrationMHSRequestsLists)  {
                for(let i=0; i<calibrationMHSRequestsLists.length; i++)  {
                    const calibrationMHSRequest = calibrationMHSRequestsLists[i];
                    const calibrationMHSData = calibrationMHSRequest.calibrationMHSData;
                    if(calibrationMHSData)  {
                        for(let j=0; j<calibrationMHSData.length; j++)  {
                            newHumiditySensors.push({
                                channelId: calibrationMHSRequest.channelId,
                                sensorId: calibrationMHSData[j].sensorId,
                                sensorType: 'Humidity',
                                isActive: true,
                                isDiagnostic: false
                            });
                        }
                    }
                }
            }

            const newSensors = newTemperatureSensors
            .concat(newPressureSensors)
            .concat(newHumiditySensors)
                .sort((s1, s2) => {
                    const channelComparision = s1.channelId - s2.channelId;
                    return (channelComparision === 0) ? s1.sensorId - s2.sensorId : channelComparision;
                });

            if(newSensors.length > 0)  {
                ChannelService.sensors.createSensors({ tenant: tenant }, newSensors, function(res) {
                    $log.info(res.total + " new sensors have been created successfully");
                    newSensorsStatus.status = vm.executionStates.success;

                    createNewCalibrationMTS();
                }, function(err)  {
                    const errData = err.data;
                    $log.error("An error has occurred creating sensors: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                    newSensorsStatus.status = vm.executionStates.error;

                    vm.result = false;
                    updateStatusesOnError();
                });
            }
            else  {
                $log.info("Sensors unavailable to be created and assigned");
                newSensorsStatus.status = vm.executionStates.na;
                createNewCalibrationMTS();
            }
        };

        const createNewCalibrationMTS = function()  {
            let newCalibrationMTSStatus = vm.executionStatuses.filter(t => t.name === 'Create and Assign Calibration MTS')[0];
            if(calibrationMTSRequestsLists && calibrationMTSRequestsLists.length > 0)  {
                $log.info("Creating and assigning lists of new calibration MTS");
                let createNewCalibrationMTSPromises = [];
                for(let i=0; i<calibrationMTSRequestsLists.length; i++)  {
                    createNewCalibrationMTSPromises.push(createNewCalibrationMTSHelper(calibrationMTSRequestsLists[i]));
                }

                $q.all(createNewCalibrationMTSPromises).then(function(res) {
                    if(createNewCalibrationMTSPromises.find(m => !m))  {
                        newCalibrationMTSStatus.status = vm.executionStates.error;

                        vm.result = false;
                        updateStatusesOnError();
                    }
                    else  {
                        $log.info("New calibration MTS have been created and assigned successfully for " + calibrationMTSRequestsLists.length + " channels");
                        newCalibrationMTSStatus.status = vm.executionStates.success;
                        createNewCalibrationLPS();
                    }
                });
            }
            else  {
                $log.info("Calibration MTS unavailable to be created and assigned");
                newCalibrationMTSStatus.status = vm.executionStates.na;
                createNewCalibrationLPS();
            }
        };

        const createNewCalibrationMTSHelper = function(calibrationMTSRequests)  {
            let deferred = $q.defer();
            ChannelService.sensors.updateMTSList({ tenant: tenant}, calibrationMTSRequests, function(res) {
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred creating and assigning calibration MTS: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const createNewCalibrationLPS = function()  {
            let newCalibrationLPSStatus = vm.executionStatuses.filter(t => t.name === 'Create and Assign Calibration LPS')[0];
            if(calibrationLPSRequestsLists && calibrationLPSRequestsLists.length > 0)  {
                $log.info("Creating and assigning lists of new calibration LPS");
                let createNewCalibrationLPSPromises = [];
                for(let i=0; i<calibrationLPSRequestsLists.length; i++)  {
                    createNewCalibrationLPSPromises.push(createNewCalibrationLPSHelper(calibrationLPSRequestsLists[i]));
                }

                $q.all(createNewCalibrationLPSPromises).then(function(res) {
                    if(createNewCalibrationLPSPromises.find(l => !l))  {
                        newCalibrationLPSStatus.status = vm.executionStates.error;

                        vm.result = false;
                        updateStatusesOnError();
                    }
                    else  {
                        $log.info("New calibration LPS have been created and assigned successfully for " + calibrationLPSRequestsLists.length + " channels");
                        newCalibrationLPSStatus.status = vm.executionStates.success;
                        createNewCalibrationMHS();
                    }
                });
            }
            else  {
                $log.info("Calibration LPS unavailable to be created and assigned");
                newCalibrationLPSStatus.status = vm.executionStates.na;
                createNewCalibrationMHS();
            }
        };

        const createNewCalibrationLPSHelper = function(calibrationLPSRequests)  {
            let deferred = $q.defer();
            ChannelService.sensors.updateLPSList({ tenant: tenant}, calibrationLPSRequests, function(res) {
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred creating and assigning calibration LPS: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const createNewCalibrationMHS = function()  {
            let newCalibrationMHSStatus = vm.executionStatuses.filter(t => t.name === 'Create and Assign Calibration MHS')[0];
            if(calibrationMHSRequestsLists && calibrationMHSRequestsLists.length > 0)  {
                $log.info("Creating and assigning lists of new calibration MHS");
                let createNewCalibrationMHSPromises = [];
                for(let i=0; i<calibrationMHSRequestsLists.length; i++)  {
                    createNewCalibrationMHSPromises.push(createNewCalibrationMHSHelper(calibrationMHSRequestsLists[i]));
                }

                $q.all(createNewCalibrationMHSPromises).then(function(res) {
                    if(createNewCalibrationMHSPromises.find(l => !l))  {
                        newCalibrationMHSStatus.status = vm.executionStates.error;

                        vm.result = false;
                        updateStatusesOnError();
                    }
                    else  {
                        $log.info("New calibration MHS have been created and assigned successfully for " + calibrationMHSRequestsLists.length + " channels");
                        newCalibrationMHSStatus.status = vm.executionStates.success;
                        vm.result = 'success';
                    }
                });
            }
            else  {
                $log.info("Calibration MHS unavailable to be created and assigned");
                newCalibrationMHSStatus.status = vm.executionStates.na;
                vm.result = 'success';
            }
        };

        const createNewCalibrationMHSHelper = function(calibrationMHSRequests)  {
            let deferred = $q.defer();
            ChannelService.sensors.updateMHSList({ tenant: tenant}, calibrationMHSRequests, function(res) {
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred creating and assigning calibration MHS: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };


        const updateStatusesOnError = function()  {
            vm.executionStatuses.filter(t => t.status === vm.executionStates.pending)
                .forEach(filtered => filtered.status = vm.executionStates.none);
        };


        vm.complete = function()  {
            if(vm.result === 'success')  {
                $mdDialog.hide();
            }
            else  {
                $mdDialog.cancel(vm.result);
            }
        };


        createNewChannels();
    }

})();




/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-12-27
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.advanced')
        .controller('InternalSettingsCtrl', InternalSettingsCtrl)
        .controller('NewInternalSettingCtrl', NewInternalSettingCtrl);

    /** @ngInject */
    function InternalSettingsCtrl($scope, $log, $timeout, $mdDialog, toastr, LumiService, InternalSettingsService) {
        let vm = this;
        vm.tenant = LumiService.getTenant();
        vm.readOnly = env.readOnly;
        vm.isLoading = true;
        vm.isEditingSetting = false;

        let internalSettingsPollingPromise = null;
        let internalSettingsPollingInterval = 3500;
        let internalSettingsPollingErrors = 0;

        let alert;

        let isAlive = true;


        const getInternalSettings = function () {
            if(vm.isEditingSetting)  {
                internalSettingsNextLoad();
            }
            else  {
                $log.debug("Getting internal settings");
                InternalSettingsService.settings.query({ tenant: vm.tenant }, function(res) {
                    vm.internalsettings = res;
                    vm.displayedInternalSettings = [].concat(vm.internalsettings);

                    internalSettingsPollingErrors = 0;
                    internalSettingsNextLoad();
                }, function(err)  {
                    const errData = err.data;
                    $log.error("An error has occurred getting internal settings: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));

                    internalSettingsNextLoad(++internalSettingsPollingErrors * 2 * internalSettingsPollingInterval);
                }).$promise.finally(function()  {
                    vm.isLoading = false;
                });
            }
        };

        vm.updateInternalSetting = function(oldInternalSettingData, newInternalSettingData) {
            vm.isEditingSetting = true;

            newInternalSettingData.id = oldInternalSettingData.id;
            newInternalSettingData.key = oldInternalSettingData.key;
            Object.keys(newInternalSettingData).forEach(key => (!newInternalSettingData[key] && newInternalSettingData[key] !== undefined) && delete newInternalSettingData[key]);

            InternalSettingsService.settings.update({ tenant: vm.tenant }, newInternalSettingData, function(res) {
                toastr.success("Internal Setting ".concat(newInternalSettingData.id).concat(" has been updated successfully!"));
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred updating Internal Setting"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
                $log.error("An error has occurred updating internal setting: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            }).$promise.finally(function()  {
                // Refresh to ensure we are up-to-date with data
                vm.isEditingSetting = false;
            });
        };

        vm.deleteInternalSetting = function(internalSettingData) {
            const id = internalSettingData.id;
            const key = internalSettingData.key;

            InternalSettingsService.settings.delete({ id: id, tenant: vm.tenant }, function(res) {
                toastr.success("Internal Setting ".concat(key).concat(" has been removed successfully!"));
                if(vm.internalsettings)  {
                    vm.internalsettings = vm.internalsettings.filter(s => s.id !== id);
                }
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred removing Internal Setting"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred removing internal setting: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            });
        };


        const cancelInternalSettingsNextLoad = function() {
            $timeout.cancel(internalSettingsPollingPromise);
        };

        const internalSettingsNextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || internalSettingsPollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelInternalSettingsNextLoad();

            if(isAlive)  {
                $log.debug("Poll internal setting data with delay: ".concat(pollingDelay).concat( " milliseconds"));
                internalSettingsPollingPromise = $timeout(getInternalSettings, pollingDelay);
            }
        };



        vm.showNewInternalSettingModal = function(ev) {
            $mdDialog.show({
                controller: 'NewInternalSettingCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/advanced/internalsettings/newInternalSettingModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
            }).then(function(response) {
                $log.info("New internal setting ".concat(response).concat(" has been created successfully"));
                toastr.success("New Internal Setting ".concat(response).concat(" has been created successfully!"));
            }, function(errData)  {
            });
        };


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: false,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        getInternalSettings();

        $scope.$on('$destroy', function() {
            $log.debug("Internal Settings scope destroyed.  Cleaning up InternalSettingsCtrl resources...");
            cancelInternalSettingsNextLoad();
            isAlive = false;
        });
    }



    function NewInternalSettingCtrl($log, $timeout, $mdDialog, toastr, LumiService, InternalSettingsService) {
        let vm = this;
        let tenant = LumiService.getTenant();
        vm.internalSetting = null;

        
        vm.createInternalSetting = function() {
            return $timeout(1000)
                .then(function()  {
                    if(vm.internalSetting)  {
                        InternalSettingsService.settings.save({ tenant: tenant }, vm.internalSetting, function(res) {
                            $mdDialog.hide(vm.internalSetting.key);
                        }, function(err)  {
                            const errData = err.data;
                            toastr.error("An error has occurred creating Internal Setting"
                                .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                            $log.error("An error has occurred creating internal setting: ".concat(errData ? JSON.stringify(errData) :
                                JSON.stringify(err)));
                            vm.cancel();
                        });
                    }
                    else  {
                        // Should not happen
                        toastr.error("An error has occurred creating Internal Setting (null setting)");
                        vm.cancel();
                    }
                });
        };

        vm.cancel = function() {
            $mdDialog.cancel();
        };
    }

})();

/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-12-27
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.advanced')
        .controller('NetworkingCtrl', NetworkingCtrl);

    /** @ngInject */
    function NetworkingCtrl($log, $mdDialog, LumiService, NetworkingSettingsService) {
        let vm = this;
        vm.tenant = LumiService.getTenant();
        vm.isLoading = true;

        let alert;

        
        const getNetworkingSettings = function () {
            $log.info("Getting networking settings");
            NetworkingSettingsService.settings.query(function(res) {
                vm.networkingsettings = res;
            }, function(err)  {
                const errData = err.data;
                showAlert("Error", "An error has occurred getting Networking Information"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred getting networking settings: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            }).$promise.finally(function()  {
                vm.isLoading = false;
            });
        };


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: false,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        getNetworkingSettings();
    }

})();

/**
 * @author Charles Fung
 * created on 2017-06-12
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.dashboard')
        .directive('dashboardChannel', dashboardChannel);

    /** @ngInject */
    function dashboardChannel() {
        return {
            restrict: 'E',
            controller: 'DashboardChannelCtrl',
            templateUrl: 'app/pages/dashboard/dashboardChannel/dashboardChannel.html'
        };
    }
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 * created on 2017-06-14
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.dashboard')
        .controller('DashboardChannelCtrl', DashboardChannelCtrl)
        .controller('DashboardChannelStatusCtrl', DashboardChannelStatusCtrl);

    /** @ngInject */
    function DashboardChannelCtrl($scope, $log, $timeout, $mdDialog, LumiService, AuthService, UserSettingsService, ChannelService) {
        $scope.tenant = LumiService.getTenant();
        $scope.isChannelsLoading = true;

        $scope.displayChannelsStatusAlert = false;

        let channelPollingPromise = null;
        let channelPollingInterval = 2750;
        let channelPollingErrors = 0;

        let alert;

        let isInit = false;
        let isAlive = true;

        // Define the number of rows to limit before expand footer is enabled for table
        let numChannelRowsToLimit = 5;
        $scope.channelRowLimit = numChannelRowsToLimit;
        $scope.isChannelTableExpanded = false;

        // Expand/shrink rows
        $scope.modifyChannelRows = function() {
            $scope.channelRowLimit = $scope.isChannelTableExpanded ? numChannelRowsToLimit : undefined;
            $scope.isChannelTableExpanded = !$scope.isChannelTableExpanded;
        }
        
        const hasChannelStatusError = function(element) {
            return (element && element.isActive && (element.channelStatus > 0 || element.numErrSensors > 0));
        };

        const addChannelStatusLabel = function(channels) {
            channels.map(function(channel) {
                if(!channel.isActive) {
                    channel["statusLabel"] = "Inactive"
                } else if (channel.channelStatus > 0) {
                    channel["statusLabel"] = "Error"
                } else if (channel.isActive && channel.channelStatus === 0) {
                    channel["statusLabel"] = "Active"
                }
            })
        }

        const getChannels = function () {
            $log.debug("Getting channels");
            ChannelService.channels.query({ tenant: $scope.tenant }, function(res) {
                $scope.channels = res.channelMessages;

                // Adds the status label for each channel to be used in HTML
                addChannelStatusLabel($scope.channels);

                $scope.displayChannelsStatusAlert = $scope.channels.some(hasChannelStatusError);

                channelPollingErrors = 0;
                channelNextLoad();
            }, function(err)  {
                const errData = err.data;
                $log.debug("An error has occurred getting channels: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));

                $scope.displayChannelsStatusAlert = false;

                channelNextLoad(++channelPollingErrors * 2 * channelPollingInterval);
            }).$promise.finally(function()  {
                $scope.isChannelsLoading = false;
            });
        };


        const cancelChannelNextLoad = function() {
            $timeout.cancel(channelPollingPromise);
        };

        const channelNextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || channelPollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelChannelNextLoad();

            if(isAlive)  {
                $log.debug("Poll channel data with delay: ".concat(pollingDelay).concat( " milliseconds"));
                channelPollingPromise = $timeout(getChannels, pollingDelay);
            }
        };


        $scope.showDashboardChannelStatusModal = function(ev, channelId, isActive) {
            $mdDialog.show({
                controller: 'DashboardChannelStatusCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/dashboard/dashboardChannel/dashboardChannelStatusModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
                locals: {
                    channelId: channelId,
                    isActive: isActive
                }
            });
        };

        const showChannelAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: true,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };


        const init = function()  {
            if(!isInit && $scope.tenant !== null)  {
                const companyInfo = LumiService.companyInfo();
                const companyId = companyInfo ? companyInfo.companyId : null;

                const userInfo = AuthService.userInfo();
                if(userInfo)  {
                    UserSettingsService.settings.getUserSetting( {companyId: companyId, username: userInfo.username, userSettingType: 'enableDashboardChannel'}, function(res) {
                        if(res !== null)  {
                            $scope.enableDashboardChannel = res.val === '1';
                        }
                        else  {
                            $log.debug("Empty enableDashboardChannel.  Defaulting to ").concat(env.enableDashboardChannel);
                            $scope.enableDashboardChannel = env.enableDashboardChannel;     
                        }
                    }, function(err)  {
                        const errData = err.data;
                        $log.debug("Cannot get enableDashboardChannel.  Defaulting to ".concat(env.enableDashboardChannel).concat(": ")
                            .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));   
                        $scope.enableDashboardChannel = env.enableDashboardChannel;  
                    }).$promise.finally(function()  {
                        if($scope.enableDashboardChannel)  {
                            getChannels();
                        }

                        isInit = true;
                    });
                }   
            }
        };



        init();

        $scope.$on('$destroy', function() {
            if($scope.enableDashboardChannel)  {
                $log.debug("Dashboard scope destroyed.  Cleaning up DashboardChannelCtrl resources...");
                cancelChannelNextLoad();
                isAlive = false;
            }
        });
    }

    function DashboardChannelStatusCtrl($scope, $q, $log, $timeout, $mdDialog, toastr, channelId, isActive, 
        LumiService, AuthService, UserSettingsService, UtilService, ChannelService) {
        let vm = this;

        vm.readOnly = env.readOnly;
        vm.isChannelStatusLoading = true; 

        let pollingPromise = null;
        let pollingInterval = 3000;
        let pollingErrors = 0;

        vm.channelId = channelId;
        vm.isActive = isActive;

        let alert;

        let isInit = false;
        let displayTZ = env.defaultTZ;

        let tenant = LumiService.getTenant();
        
        let isAlive = true;

        
        vm.toggleChannel = function()  {
            $log.info("Toggling channel ".concat(vm.channelId));
            ChannelService.channels.toggle({ tenant: tenant }, {
                channelId: vm.channelId,
                isActive: !vm.isActive
            }, function(res) {
                toastr.success("Channel ".concat(vm.channelId).concat(" has been ")
                    .concat(vm.isActive ? "deactivated" : "activated").concat(" successfully!"));
                vm.isActive = !vm.isActive;
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred toggling Channel ".concat(vm.channelId)
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred toggling Channel ".concat(vm.channelId)
                    .concat(": ").concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
            });
        };

        vm.toggleChannelDisplay = function()  {
            return vm.isActive ? "Deactivate Channel" : "Activate Channel";
        };


        const getChannelStatusTypes = function(){
            let deferred = $q.defer();
            $log.debug("Getting channel status types for channel ".concat(vm.channelId));

            const reqBody = {
                channelId: vm.channelId
            };
            ChannelService.channelStatuses.statusTypesByChannel({ tenant: tenant }, reqBody, function(res) {
                vm.channelStatusTypes = res.channelStatusTypeMessages;
                if(vm.channelStatusTypes.length === 0)  {
                    vm.channelStatusTypes.push({description: 'OK'});
                }

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.debug("An error has occurred converting channel status types by flag: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getSensorLatestDataStatus = function(){
            let deferred = $q.defer();
            $log.debug("Getting sensors with latest data and statuses for channel ".concat(vm.channelId));

            ChannelService.sensors.sensorsWithLatestDataStatuses({ tenant: tenant, channelId: vm.channelId }, function(res) {
                vm.sensors = res.sensorMessages.map(m => { 
                    if(m.latestValueTimestamp)  {
                        m.latestValueTimestamp = UtilService.convertUTCTimestamp(m.latestValueTimestamp, displayTZ);
                    }
                    return m; 
                });

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.debug("An error has occurred getting sensors with latest data and statuses for channel "
                    .concat(vm.channelId).concat(": ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };


        const refresh = function()  {
            $log.debug("Refresh channel and sensor statuses");
            $q.all([
                getChannelStatusTypes(),
                getSensorLatestDataStatus()
            ]).then(function(res) {
                const err = (!res[0] || !res[1]);
                if(err)  {
                    nextLoad(++pollingErrors * 2 * pollingInterval);
                }
                else  {
                    pollingErrors = 0;
                    nextLoad();
                }

                vm.isChannelStatusLoading = false;
                $log.debug("Done refresh channel and sensor statuses".concat(err ? " with error" : ""));
            });
        };


        const cancelNextLoad = function() {
            $timeout.cancel(pollingPromise);
        };

        const nextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || pollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelNextLoad();

            if(isAlive)  {
                $log.debug("Poll environ sensor status types with delay: ".concat(pollingDelay).concat( " milliseconds"));
                pollingPromise = $timeout(refresh, pollingDelay);
            }
        };


        const init = function()  {
            if(!isInit)  {
                $log.info("Initializing Dashboard Channel Status Dialog");
                const companyInfo = LumiService.companyInfo();
                const companyId = companyInfo ? companyInfo.companyId : null;

                const userInfo = AuthService.userInfo();
                if(userInfo)  {
                    UserSettingsService.settings.getUserSetting({ companyId: companyId, username: userInfo.username, userSettingType: 'Display Time Zone' }, function(res) {
                        if(res && res.val)  {
                            displayTZ = res.val;
                        }
                        else  {
                            $log.debug("Empty display time zone.  Defaulting to ").concat(displayTZ);    
                        }
                    }, function(err)  {
                        const errData = err.data;
    
                        $log.debug("An error has occurred getting display time zone.  Defaulting to ".concat(displayTZ).concat(": ")
                            .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));    
                    }).$promise.finally(function()  {
                        moment.tz.setDefault(displayTZ);
                        isInit = true;
                        
                        refresh();
                    });
                }
            }
        };


        vm.hide = function() {
            cancelNextLoad();
            $mdDialog.hide();
        };

        vm.cancel = function() {
            cancelNextLoad();
            $mdDialog.cancel();
        };


        init();

        // vm.$onDestroy = function () {
        //     cancelNextLoad();
        //     isAlive = false;
        // };

        $scope.$on('$destroy', function() {
            cancelNextLoad();
            isAlive = false;
        });
    }

})();
/**
 * @author Charles Fung
 * created on 2017-06-12
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.dashboard')
        .directive('dashboardDiagnostics', dashboardDiagnostics);

    /** @ngInject */
    function dashboardDiagnostics() {
        return {
            restrict: 'E',
            controller: 'DashboardDiagnosticsCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/pages/dashboard/dashboardDiagnostics/dashboardDiagnostics.html'
        };
    }
})();
/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-06-14
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.dashboard')
        .controller('DashboardDiagnosticsCtrl', DashboardDiagnosticsCtrl);

    /** @ngInject */
    function DashboardDiagnosticsCtrl($scope, $state, $log, $timeout, moment, 
        LumiService, AuthService, UserSettingsService, UtilService, EventService) {
        let vm = this;
        vm.tenant = LumiService.getTenant();
        vm.enableDashboardDiagnostics = env.enableDashboardDiagnostics;
        vm.isDiagnosticsLoading = true;

        let diagnosticsPollingPromise = null;
        let diagnosticsPollingInterval = 4000;
        let diagnosticsPollingErrors = 0;

        vm.latestEvent = null;

        let isInit = false;
        let displayTZ = env.defaultTZ;

        let isAlive = true;


        vm.hasLatestEvent = function()  {
            return vm.latestEvent && vm.latestEvent.id;
        };

        const getLatestEvent = function () {
            $log.debug("Getting latest event");

            EventService.latestEvent.query({ tenant: vm.tenant }, function(res) {
               const prevEventId = vm.latestEvent ? vm.latestEvent.id : null;
               
                // Assign latest event if result is not null or empty
                let timestampEpoch = 0;
                if(res && Object.keys(res).length !== 0)  {
                    timestampEpoch = res.timestamp;

                    vm.latestEvent = res;
                    vm.latestEvent.timestamp = UtilService.convertUTCTimestamp(timestampEpoch, displayTZ);
                }

                if(vm.hasLatestEvent() && 
                    prevEventId !== vm.latestEvent.id &&
                    (typeof !vm.latestEventLastAccessed !== 'undefined' ||
                        moment(timestampEpoch) >= vm.latestEventLastAccessed))  {
                }

                diagnosticsPollingErrors = 0;
                diagnosticsNextLoad();
            }, function(err)  {
                const errData = err.data;
                $log.debug("An error has occurred getting latest event: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));

                diagnosticsNextLoad(++diagnosticsPollingErrors * 2 * diagnosticsPollingInterval);
            }).$promise.finally(function()  {
                vm.isDiagnosticsLoading = false;
            });
        };

        const cancelDiagnosticsNextLoad = function() {
            $timeout.cancel(diagnosticsPollingPromise);
        };

        const diagnosticsNextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || diagnosticsPollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelDiagnosticsNextLoad();

            if(isAlive)  {
                $log.debug("Poll latest event with delay: ".concat(pollingDelay).concat( " milliseconds"));
                diagnosticsPollingPromise = $timeout(getLatestEvent, pollingDelay);
            }
        };


        const init = function()  {
            if(!isInit && vm.tenant !== null)  {
                $log.info("Initializing Dashboard Diagnostics");
                const companyInfo = LumiService.companyInfo();
                const companyId = companyInfo ? companyInfo.companyId : null;

                const userInfo = AuthService.userInfo();
                if(userInfo)  {
                    UserSettingsService.settings.getUserSetting( {companyId: companyId, username: userInfo.username, userSettingType: 'enableDashboardDiagnostics'}, function(res) {
                        if(res !== null)  {
                            vm.enableDashboardDiagnostics = res.val === '1';
                        }
                        else  {
                            $log.debug("Empty enableDashboardDiagnostics.  Defaulting to ").concat(env.enableDashboardDiagnostics);
                            vm.enableDashboardDiagnostics = env.enableDashboardDiagnostics;     
                        }
                    }, function(err)  {
                        const errData = err.data;
                        $log.debug("Cannot get enableDashboardDiagnostics.  Defaulting to ".concat(env.enableDashboardDiagnostics).concat(": ")
                            .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));   
                        vm.enableDashboardDiagnostics = env.enableDashboardDiagnostics;  
                    }).$promise.finally(function()  {
                        if(vm.enableDashboardDiagnostics)  {
                            UserSettingsService.settings.getUserSetting({ companyId: companyId, username: userInfo.username, userSettingType: 'Display Time Zone' }, function(res2) {
                                if(res2 && res2.val)  {
                                    displayTZ = res2.val;
                                }
                                else  {
                                    $log.debug("Empty display time zone.  Defaulting to ").concat(displayTZ);    
                                }
                            }, function(err)  {
                                const errData = err.data;
            
                                $log.debug("An error has occurred getting display time zone.  Defaulting to ".concat(displayTZ).concat(": ")
                                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));    
                            }).$promise.finally(function()  {
                                moment.tz.setDefault(displayTZ);
                                isInit = true;
                                getLatestEvent();
                            });
                        }
                        else  {
                            isInit = true;
                        }
                    });
                }
            }
        };


        vm.changeStateEvents = function()  {
            cancelDiagnosticsNextLoad();
            $state.go('main.diagnostics.events');
        };



        init();

        $scope.$on('$destroy', function() {
            if(vm.enableDashboardDiagnostics)  {
                $log.debug("Dashboard scope destroyed.  Cleaning up DashboardDiagnosticsCtrl resources...");
                cancelDiagnosticsNextLoad();
                isAlive = false;    
            }
        });
    }
})();
/**
 * @author Charles Fung
 * created on 2017-06-12
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.dashboard')
        .directive('dashboardEnviron', dashboardEnviron);

    /** @ngInject */
    function dashboardEnviron() {
        return {
            restrict: 'E',
            controller: 'DashboardEnvironCtrl',
            templateUrl: 'app/pages/dashboard/dashboardEnviron/dashboardEnviron.html'
        };
    }
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 * created on 2017-06-14
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.dashboard')
        .controller('DashboardEnvironCtrl', DashboardEnvironCtrl)
        .controller('DashboardEnvironStatusCtrl', DashboardEnvironStatusCtrl);

    /** @ngInject */
    function DashboardEnvironCtrl($scope, $log, $q, $timeout, $mdDialog, 
        LumiService, AuthService, UserSettingsService, UtilService, EnvironSensorService) {
        $scope.tenant = LumiService.getTenant();
        
        $scope.isEnvironLoading = true;

        $scope.displayEnvironSensorsStatusAlert = false;

        let environPollingPromise = null;
        let environPollingInterval = 2500;
        let environPollingErrors = 0;

        let alert;

        let isInit = false;
        let displayTZ = env.defaultTZ;

        let isAlive = true;

        // Define the number of rows to limit before expand footer is enabled for table
        let numEnvironRowsToLimit = 5;
        $scope.environRowLimit = numEnvironRowsToLimit;
        $scope.isEnvironTableExpanded = false;

        let environRowLimitCounter = 0;

        // Based on the counter, determine the row limit of each type of sensor
        const determineRowLimit = function(numOfSensors) {
            let rowLimit = 0;

            for(let i = 0; i < numOfSensors; i++) {
                if($scope.environRowLimit > environRowLimitCounter) {
                    rowLimit++;
                    environRowLimitCounter++;
                }
            }

            return rowLimit;
        }

        // Save row limit values to go back to immediately when modifyEnvironRows() is called
        let environRowLimitTempSavedVal;
        let environRowLimitPressureSavedVal;
        let environRowLimitHumiditySavedVal;
        let environRowLimitDewpointSavedVal;

        // Expand/shrink rows
        $scope.modifyEnvironRows = function() {
            $scope.isEnvironTableExpanded = !$scope.isEnvironTableExpanded;

            if($scope.isEnvironTableExpanded) {
                $scope.environRowLimitTemp = undefined;
                $scope.environRowLimitPressure = undefined;
                $scope.environRowLimitHumidity = undefined;
                $scope.environRowLimitDewpoint = undefined;
            } else {
                $scope.environRowLimitTemp = environRowLimitTempSavedVal;
                $scope.environRowLimitPressure = environRowLimitPressureSavedVal;
                $scope.environRowLimitHumidity = environRowLimitHumiditySavedVal;
                $scope.environRowLimitDewpoint = environRowLimitDewpointSavedVal;
            }
        }

        const getLatestTemperatures = function () {
            $log.debug("Getting latest environ temperatures");

            let deferred = $q.defer();
            EnvironSensorService.latestTemperatures.query({ tenant: $scope.tenant }, function(res) {
                $scope.environTemperatures = res.filter(t => t.display)
                    .map(d => { 
                        d.timestamp =  UtilService.convertUTCTimestamp(d.timestamp, displayTZ);
                        return d; 
                    });

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;

                $log.debug("An error has occurred getting latest environ temperatures: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getLatestPressures = function () {
            $log.debug("Getting latest environ atm pressures");

            let deferred = $q.defer();
            EnvironSensorService.latestPressures.query({ tenant: $scope.tenant }, function(res) {
                $scope.environPressures = res.filter(t => t.display)
                    .map(d => { 
                        d.timestamp =  UtilService.convertUTCTimestamp(d.timestamp, displayTZ);
                        return d; 
                    });

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;

                $log.debug("An error has occurred getting latest environ atm pressures: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getLatestHumidities = function () {
            $log.debug("Getting latest environ humidities");

            let deferred = $q.defer();
            EnvironSensorService.latestHumidities.query({ tenant: $scope.tenant }, function(res) {
                $scope.environHumidities = res.filter(t => t.display)
                    .map(d => { 
                        d.timestamp =  UtilService.convertUTCTimestamp(d.timestamp, displayTZ);
                        return d; 
                    });

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;

                $log.debug("An error has occurred getting latest environ humidities: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getLatestDewpoints = function () {
            $log.debug("Getting latest environ dewpoints");

            let deferred = $q.defer();
            EnvironSensorService.latestDewpoints.query({ tenant: $scope.tenant }, function(res) {
                $scope.environDewpoints = res.filter(t => t.display)
                    .map(d => { 
                        d.timestamp =  UtilService.convertUTCTimestamp(d.timestamp, displayTZ);
                        return d; 
                    });

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;

                $log.debug("An error has occurred getting latest environ dewpoints: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };


        const hasEnvironSensorStatusError = function(element) {
            return (element && element.sensorStatus > 0);
        };

        const environRefresh = function()  {
            if($scope.tenant !== null)  {
                $log.debug("Refresh environ data");
                $q.all([
                    getLatestTemperatures(),
                    getLatestPressures(),
                    getLatestHumidities(),
                    getLatestDewpoints()
                ]).then(function(res) {
                    const err = (!res[0] || !res[1] || !res[2] || !res[3]);
                    if(err)  {
                        $scope.displayEnvironSensorsStatusAlert = false;
                        environNextLoad(++environPollingErrors * 2 * environPollingInterval);
                    }
                    else  {
                        $scope.displayEnvironSensorsStatusAlert = $scope.environTemperatures.some(hasEnvironSensorStatusError) ||
                            $scope.environTemperatures.some(hasEnvironSensorStatusError) ||
                            $scope.environPressures.some(hasEnvironSensorStatusError) ||
                            $scope.environHumidities.some(hasEnvironSensorStatusError) ||
                            $scope.environDewpoints.some(hasEnvironSensorStatusError);
    
                             // Total number of sensors
                            $scope.totalNumOfEnvironSensors = $scope.environTemperatures.length + $scope.environPressures.length + $scope.environHumidities.length + $scope.environDewpoints.length
    
                            // Determine the number for table rows that will appear for each type of sensor
                            if(!$scope.isEnvironTableExpanded) {
                                $scope.environRowLimitTemp = determineRowLimit($scope.environTemperatures.length);
                                $scope.environRowLimitPressure = determineRowLimit($scope.environPressures.length);
                                $scope.environRowLimitHumidity = determineRowLimit($scope.environHumidities.length);
                                $scope.environRowLimitDewpoint = determineRowLimit($scope.environDewpoints.length);
    
                                environRowLimitTempSavedVal = $scope.environRowLimitTemp;
                                environRowLimitPressureSavedVal = $scope.environRowLimitPressure;
                                environRowLimitHumiditySavedVal = $scope.environRowLimitHumidity;
                                environRowLimitDewpointSavedVal = $scope.environRowLimitDewpoint;
                            }
    
                            // Reset counter
                            environRowLimitCounter = 0;
    
                            // Add sensor status label property for each sensor of the same type
                            const addSensorStatusLabel = function(sensors) {
                                sensors.forEach(function(sensor) {
                                    const sensorStatusLabel = (sensor.sensorStatus > 0) ? 'Error' : 'Active';
                                    sensor["statusLabel"] = sensorStatusLabel;
                                });
                            }
    
                            // Add sensor status label for each type of sensor
                            addSensorStatusLabel($scope.environTemperatures)
                            addSensorStatusLabel($scope.environPressures)
                            addSensorStatusLabel($scope.environHumidities)
                            addSensorStatusLabel($scope.environDewpoints)
    
                        environPollingErrors = 0;
                        environNextLoad();
                    }
    
                    $log.debug("Done refresh environ data".concat(err ? " with error" : ""));
                    $scope.isEnvironLoading = false;
                });
            }
        };



        const cancelEnvironNextLoad = function() {
            $timeout.cancel(environPollingPromise);
        };

        const environNextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || environPollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelEnvironNextLoad();

            if(isAlive)  {
                $log.debug("Poll environ data with delay: ".concat(pollingDelay).concat( " milliseconds"));
                environPollingPromise = $timeout(environRefresh, pollingDelay);
            }
        };


        const init = function()  {
            if(!isInit && $scope.tenant !== null)  {
                $log.info("Initializing Dashboard Environ");
                const companyInfo = LumiService.companyInfo();
                const companyId = companyInfo ? companyInfo.companyId : null;

                const userInfo = AuthService.userInfo();
                if(userInfo)  {
                    UserSettingsService.settings.getUserSetting( {companyId: companyId, username: userInfo.username, userSettingType: 'enableDashboardEnvironment'}, function(res) {
                        if(res !== null)  {
                            $scope.enableDashboardEnvironment = res.val === '1';
                        }
                        else  {
                            $log.debug("Empty enableDashboardEnvironment.  Defaulting to ").concat(env.enableDashboardEnvironment);
                            $scope.enableDashboardEnvironment = env.enableDashboardEnvironment;     
                        }
                    }, function(err)  {
                        const errData = err.data;
                        $log.debug("Cannot get enableDashboardEnvironment.  Defaulting to ".concat(env.enableDashboardEnvironment).concat(": ")
                            .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));   
                        $scope.enableDashboardEnvironment = env.enableDashboardEnvironment;  
                    }).$promise.finally(function()  {
                        if($scope.enableDashboardEnvironment)  {
                            UserSettingsService.settings.getUserSetting({ companyId: companyId, username: userInfo.username, userSettingType: 'Display Time Zone' }, function(res2) {
                                if(res2 && res2.val)  {
                                    displayTZ = res2.val;
                                }
                                else  {
                                    $log.debug("Empty display time zone.  Defaulting to ").concat(displayTZ);    
                                }
                            }, function(err)  {
                                const errData = err.data;
            
                                $log.debug("An error has occurred getting display time zone.  Defaulting to ".concat(displayTZ).concat(": ")
                                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));    
                            }).$promise.finally(function()  {
                                moment.tz.setDefault(displayTZ);
                                isInit = true;
                                
                                environRefresh();
                            });
                        }
                        else  {
                            isInit = true;
                        }
                    });
                }
            }
        };


        $scope.showDashboardEnvironStatusModal = function(ev, environSensorId, environSensorType) {
            $mdDialog.show({
                controller: 'DashboardEnvironStatusCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/dashboard/dashboardEnviron/dashboardEnvironStatusModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
                locals: {
                    environSensorId: environSensorId,
                    environSensorType: environSensorType
                }
            });
        };

        const showEnvironAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: true,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        init();

        $scope.$on('$destroy', function() {
            if($scope.enableDashboardEnvironment)  {
                $log.debug("Dashboard scope destroyed.  Cleaning up DashboardEnvironCtrl resources...");
                cancelEnvironNextLoad();
                isAlive = false;
            }
        });
    }

    function DashboardEnvironStatusCtrl($scope, $log, $timeout, $mdDialog, environSensorId, environSensorType, LumiService, EnvironSensorService) {
        let vm = this;
        let tenant = LumiService.getTenant();
        let isAlive = true;

        let pollingPromise = null;
        let pollingInterval = 2500;
        let pollingErrors = 0;

        vm.environSensorId = environSensorId;
        vm.environSensorType = environSensorType;
        vm.isAlarmTriggered = null;

        vm.isEnvironStatusLoading = true;

        const getEnvironSensorStatusTypes = function(){
            $log.debug("Getting environ sensor status types for environ sensor ".concat(vm.environSensorId));

            const reqBody = {
                environSensorId: vm.environSensorId,
                environSensorType: vm.environSensorType
            };
            EnvironSensorService.environSensorStatuses.statusTypesBySensor({ tenant: tenant }, reqBody, function(res) {
                vm.environSensorStatusTypes = res.environSensorStatusTypeMessages;
                if(vm.environSensorStatusTypes.length !== 0)  {
                    vm.isAlarmTriggered = ((vm.environSensorStatusTypes.filter(function(environSensorStatusType) {
                        return environSensorStatusType.category === 'ENVIRON_SENSOR_ALARM';
                    })).length > 0);
                }
                else  {
                    vm.environSensorStatusTypes.push({description: 'OK'});
                    vm.isAlarmTriggered = false;
                }

                pollingErrors = 0;
                nextLoad();
            }, function(err)  {
                const errData = err.data;
                $log.debug("An error has occurred converting environ sensor status types by flag: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));

                nextLoad(++pollingErrors * 2 * pollingInterval);
            }).$promise.finally(function()  {
                vm.isEnvironStatusLoading = false;
            });
        };


        const cancelNextLoad = function() {
            $timeout.cancel(pollingPromise);
        };

        const nextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || pollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelNextLoad();

            if(isAlive)  {
                $log.debug("Poll environ sensor status types with delay: ".concat(pollingDelay).concat( " milliseconds"));
                pollingPromise = $timeout(getEnvironSensorStatusTypes, pollingDelay);
            }
        };


        vm.hide = function() {
            cancelNextLoad();
            $mdDialog.hide();
        };

        vm.cancel = function() {
            cancelNextLoad();
            $mdDialog.cancel();
        };


        getEnvironSensorStatusTypes();

        // vm.$onDestroy = function () {
        //     cancelNextLoad();
        //     isAlive = false;
        // };

        $scope.$on('$destroy', function() {
            cancelNextLoad();
            isAlive = false;
        });
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author Charles Fung
 * created on 2017-06-12
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.dashboard')
        .directive('dashboardStatus', dashboardStatus);

    /** @ngInject */
    function dashboardStatus() {
        return {
            restrict: 'E',
            controller: 'DashboardStatusCtrl',
            templateUrl: 'app/pages/dashboard/dashboardStatus/dashboardStatus.html'
        };
    }
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 * created on 2017-06-14
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.dashboard')
        .controller('DashboardStatusCtrl', DashboardStatusCtrl)
        .controller('DashboardStatusDetailsCtrl', DashboardStatusDetailsCtrl);

    /** @ngInject */
    function DashboardStatusCtrl($scope, $log, $timeout, $mdDialog, 
        LumiService, AuthService, UserSettingsService, UtilService, DiagnosticsService) {
        $scope.tenant = LumiService.getTenant();
        $scope.isStatusLoading = true;

        let statusPollingPromise = null;
        let statusPollingInterval = 4500;
        let statusPollingErrors = 0;

        let isInit = false;
        let displayTZ = env.defaultTZ;

        let isAlive = true;


        const getStatuses = function () {
            $log.debug("Getting statuses");
            DiagnosticsService.statuses.statusesWithPercentage({ tenant: $scope.tenant }, function(res) {
                $scope.statuses = res.statusMessages.filter(function(statusMessage)  {
                   return (statusMessage.display && !statusMessage.isAlarm);
                }).map(s => { 
                    s.lastModified = UtilService.convertUTCTimestamp(s.lastModified, displayTZ);
                    return s; 
                });

                $scope.alarmStatuses = res.statusMessages.filter(function(statusMessage)  {
                    return (statusMessage.display && statusMessage.isAlarm);
                }).map(a => { 
                    a.lastModified =  UtilService.convertUTCTimestamp(a.lastModified, displayTZ);
                    return a; 
                });

                statusPollingErrors = 0;
                statusNextLoad();
            }, function(err)  {
                const errData = err.data;
                $log.debug("An error has occurred getting statuses: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));

                statusNextLoad(++statusPollingErrors * 2 * statusPollingInterval);
            }).$promise.finally(function()  {
                $scope.isStatusLoading = false;
            });
        };

        $scope.getStatusColor = function(percentage)  {
            if(percentage === 100)  {
                return '#cddc39';
            }
            else if (percentage < 100 && percentage >= 80)  {
                return "#ffc107";
            }
            else if (percentage < 80 && percentage >= 60)  {
                return "#607d8b";
            }
            else if (percentage < 60 && percentage >= 40)  {
                return "#a8a8a8";
            }
            else if (percentage < 40 && percentage >= 20)  {
                return "#795548";
            }
            else if (percentage < 20 && percentage > 0)  {
                return "#965a38";
            }
            else  {
                return "#c62828";
            }
        };

        $scope.getAlarmColor = function(percentage)  {
            if(percentage === 100)  {
                return "#cddc39";
            }
            else if (percentage < 100 && percentage >= 80)  {
                return "#ffC107";
            }
            else if (percentage < 80 && percentage >= 60)  {
                return "#ff9800";
            }
            else if (percentage < 60 && percentage >= 40)  {
                return "#e65100";
            }
            else if (percentage < 40 && percentage >= 20)  {
                return "#f44336";
            }
            else  {
                return '#c62828';
            }
        };

        $scope.getAlarmIconDisplay = function(percentage)  {
            if (percentage < 100 && percentage >= 80)  {
                return new Array(1);
            }
            else if (percentage < 80 && percentage >= 60)  {
                return new Array(2);
            }
            else if (percentage < 60 && percentage >= 40)  {
                return new Array(3);
            }
            else if (percentage < 40 && percentage >= 20)  {
                return new Array(4);
            }
            else  {
                return new Array(5);
            }
        };


        const cancelStatusNextLoad = function() {
            $timeout.cancel(statusPollingPromise);
        };

        const statusNextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || statusPollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelStatusNextLoad();

            if(isAlive)  {
                $log.debug("Poll status data with delay: ".concat(pollingDelay).concat( " milliseconds"));
                statusPollingPromise = $timeout(getStatuses, pollingDelay);
            }
        };


        const init = function()  {
            if(!isInit)  {
                $log.info("Initializing Dashboard Status");
                const companyInfo = LumiService.companyInfo();
                const companyId = companyInfo ? companyInfo.companyId : null;

                const userInfo = AuthService.userInfo();
                if(userInfo)  {
                    UserSettingsService.settings.getUserSetting({ companyId: companyId, username: userInfo.username, userSettingType: 'Display Time Zone' }, function(res) {
                        if(res && res.val)  {
                            displayTZ = res.val;
                        }
                        else  {
                            $log.debug("Empty display time zone.  Defaulting to ").concat(displayTZ);    
                        }
                    }, function(err)  {
                        const errData = err.data;
    
                        $log.debug("An error has occurred getting display time zone.  Defaulting to ".concat(displayTZ).concat(": ")
                            .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));    
                    }).$promise.finally(function()  {
                        moment.tz.setDefault(displayTZ);
                        isInit = true;
                        
                        if($scope.tenant !== null)  {
                            getStatuses();
                        }
                    });
                }
            }
        };


        $scope.showDashboardStatusDetailsModal = function(ev, statusName, statusDescription, isAlarm) {
            $mdDialog.show({
                controller: 'DashboardStatusDetailsCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/dashboard/dashboardStatus/dashboardStatusDetailsModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
                locals: {
                    statusName: statusName,
                    statusDescription: statusDescription,
                    isAlarm: isAlarm
                }
            });
        };


        init();

        $scope.$on('$destroy', function() {
            $log.debug("Dashboard scope destroyed.  Cleaning up DashboardStatusCtrl resources...");
            cancelStatusNextLoad();
            isAlive = false;
        });
    }

    function DashboardStatusDetailsCtrl($scope, $log, $timeout, $mdDialog, statusName, statusDescription, isAlarm, LumiService, DiagnosticsService) {
        let vm = this;
        let tenant = LumiService.getTenant();
        vm.isStatusDetailsLoading = true;

        let pollingPromise = null;
        let pollingInterval = 2500;
        let pollingErrors = 0;

        vm.statusName = statusName;
        vm.statusDescription = statusDescription;
        vm.isAlarm = isAlarm;

        let isAlive = true;


        const getEventtypes = function(){
            $log.debug("Getting status types for ".concat(vm.statusName).concat(" status"));
            DiagnosticsService.statuses.statusTypesByFlags({ tenant: tenant, statusName: vm.statusName }, function(res) {
                vm.eventtypes = res.eventtypeMessages;
                if(vm.eventtypes.length === 0)  {
                    vm.eventtypes.push({description: vm.isAlarm ? 'None' : 'OK'});
                }

                pollingErrors = 0;
                nextLoad();
            }, function(err)  {
                const errData = err.data;
                $log.debug("An error has occurred converting status types by flag: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));

                nextLoad(++pollingErrors * 2 * pollingInterval);
            }).$promise.finally(function()  {
                vm.isStatusDetailsLoading = false;
            });
        };


        const cancelNextLoad = function() {
            $timeout.cancel(pollingPromise);
        };

        const nextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || pollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelNextLoad();

            if(isAlive)  {
                $log.debug("Poll status types with delay: ".concat(pollingDelay).concat( " milliseconds"));
                pollingPromise = $timeout(getEventtypes, pollingDelay);
            }
        };


        vm.hide = function() {
            cancelNextLoad();
            $mdDialog.hide();
        };

        vm.cancel = function() {
            cancelNextLoad();
            $mdDialog.cancel();
        };


        getEventtypes();

        // vm.$onDestroy = function () {
        //     cancelNextLoad();
        //     isAlive = false;
        // };

        $scope.$on('$destroy', function() {
            cancelNextLoad();
            isAlive = false;
        });
    }

})();
/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-12-14
 */
(function () {
    'use strict';
    angular.module('AomsLumi.pages.data')
        .controller('MeasurementCtrl', MeasurementCtrl)
        .run(['$anchorScroll', function($anchorScroll) {
            $anchorScroll.yOffset = 50;   // Always scroll by 50 extra pixels
        }]);


    /** @ngInject */
    function MeasurementCtrl($scope, $log, $q, $timeout, $anchorScroll, $location, $mdDialog, moment, toastr,
        LumiService, AuthService, UserSettingsService, UtilService, AdminService, GeneralSettingsService, 
        ChannelService, MeasurementData) {

/*****************************************************Shared************************************************************/
        let vm = this;
        vm.tenant = LumiService.getTenant();
        vm.readOnly = env.readOnly;

        vm.historicalChannelGranularity = env.historicalMeasurementChannelGranularity;

        vm.channel = {};
        vm.sensors = {};
        vm.selectedSensorsMessages = {};
        vm.selectedSensors = {};

        let scaleSettings = {
            temperature: {
                yMin: 0,
                yMax: 0
            },
            pressure: {
                yMin: 0,
                yMax: 0
            },
            humidity: {
                yMin: 0,
                yMax: 0
            }
        };


        let updateMasterPromise = {};

        let updateMasterInterval = {
            realtime: 1000,
            snapshot: 7500,
        };

        let updateMasterErrors = {
            realtime: 0,
            snapshot: 0,
        };

        let pruneMasterPromise = {};

        let pruneMasterInterval = {
            realtime: 30000,
            snapshot: 45000,
        };

        let alert;

        let isInit = false;
        let displayTZ = env.defaultTZ;

        let isAlive = true;


        const getScaleSettings = function () {
            $log.info("Getting chart scale settings");
            GeneralSettingsService.settings.getScaleSettings({ tenant : vm.tenant }, function(res) {
                scaleSettings.temperature.yMin = res.filter(r => r.key === 'TEMPERATURE_SCALE_YMIN').map(s => s.val)[0];
                scaleSettings.temperature.yMax = res.filter(r => r.key === 'TEMPERATURE_SCALE_YMAX').map(s => s.val)[0];
                scaleSettings.pressure.yMin = res.filter(r => r.key === 'PRESSURE_SCALE_YMIN').map(s => s.val)[0];
                scaleSettings.pressure.yMax = res.filter(r => r.key === 'PRESSURE_SCALE_YMAX').map(s => s.val)[0];
                scaleSettings.humidity.yMin = res.filter(r => r.key === 'HUMIDITY_SCALE_YMIN').map(s => s.val)[0];
                scaleSettings.humidity.yMax = res.filter(r => r.key === 'HUMIDITY_SCALE_YMAX').map(s => s.val)[0];
                $log.info("Successfully assigned scale settings: " + JSON.stringify(scaleSettings));
            }, function(err)  {
                const errData = err.data;
                showAlert("Error", "An error has occurred getting Scale Settings"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred getting scale settings: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            })
        };

        const getChannels = function () {
            $log.info("Getting channels");

            ChannelService.channels.query({ tenant: vm.tenant }, function(res) {
                vm.channels = res.channelMessages;
            }, function(err)  {
                const errData = err.data;
                showAlert("Error", "An error has occurred getting Channels"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred getting channels: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            });
        };

        const getSensors = function(datatype, channelId) {
            $log.info("Getting sensors (".concat(datatype).concat(")"));
            let deferred = $q.defer();

            ChannelService.sensors.sensorsByChannelId({ tenant: vm.tenant, channelId: channelId }, function(res) {
                vm.sensors[datatype] = res.sensorMessages;

                if(vm.channel[datatype].isActive)  {
                    if(datatype === 'realtime')  {
                        // By default, the first 16 sensors for real-time data are selected
                        vm.selectedSensorsMessages.realtime = vm.sensors[datatype].slice(0, 16);
                        if(vm.selectedSensorsMessages.realtime.length > 0)  {
                            vm.onSensorsSelected(datatype);
                        }
                    }
                    else if(datatype === 'historicalDownload' || datatype === 'historicalChart')  {
                        vm.selectedSensorsMessages[datatype] = vm.sensors[datatype];
                        if(vm.selectedSensorsMessages[datatype].length > 0)  {
                            // For now assume that the sensor type for historical sensors is uniform for a channel
                            vm.sensortype[datatype]  = vm.sensortypes[datatype].filter(t => t.name === vm.selectedSensorsMessages[datatype][0].sensorType)[0];
                            vm.onSensorsSelected(datatype);
                        }
                    }
                }

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting sensors (".concat(datatype).concat("): ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.reject(err);
            });
            return deferred.promise;
        };

        vm.toggleChannel = function(datatype)  {
            const channel = vm.channel[datatype];
            if(channel)  {
                $log.info("Toggling channel ".concat(channel.channelId));
                const isActive = !channel.isActive;

                ChannelService.channels.toggle({ tenant: vm.tenant }, {
                    channelId: channel.channelId,
                    isActive: isActive
                }, function(res) {

                    toastr.success("Channel ".concat(channel.channelId).concat(" has been ")
                        .concat(isActive ? "activated" : "deactivated").concat(" successfully!"));

                    // Toggle channel applies to all of the same selected channels across datatypes
                    Object.keys(vm.channel).forEach(k => {
                        if(vm.channel[k].channelId === channel.channelId)  {
                            vm.channel[k].isActive = isActive;
                            $log.debug("Channel ".concat(channel.channelId).concat(" has been ")
                                .concat(isActive ? "activated" : "deactivated").concat(" (").concat(k).concat(")"));

                            if(vm.channel[k].isActive)  {
                                if(k === 'realtime')  {
                                    // By default, all sensors for real-time data are selected
                                    vm.selectedSensorsMessages.realtime = vm.sensors.realtime;
                                    if(vm.selectedSensorsMessages.realtime.length > 0)  {
                                        vm.onSensorsSelected('realtime');
                                    }
                                }
                            }
                            else  {
                                clearSelectedSensors(k);
                            }
                        }
                    });
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred toggling Channel ".concat(channel.channelId)
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                    $log.error("An error has occurred toggling Channel ".concat(channel.channelId)
                        .concat(": ").concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                });
            }
        };

        vm.toggleChannelDisplay = function(datatype)  {
            return vm.channel[datatype].isActive ? "Deactivate Channel" : "Activate Channel";
        };


        vm.onChannelSelected = function(datatype)  {
            $log.info("Channel ".concat(vm.channel[datatype].channelId).concat(" selected (").concat(datatype).concat(").  Getting sensors."));

            // Clear sensors
            vm.sensors[datatype] = null;
            clearSelectedSensors(datatype);

            getSensors(datatype, vm.channel[datatype].channelId).then(function(){
                $log.info("Done getting channel sensors for channel ".concat(vm.channel[datatype].channelId)
                    .concat(" (").concat(datatype).concat(")"));
            }).catch(function()  {
                showAlert("Error", "An error has occurred getting Sensors for Channel ".concat(vm.channel[datatype].channelId));
                $log.error("Done getting channel sensors for channel ".concat(vm.channel[datatype].channelId)
                    .concat(" (").concat(datatype).concat(") with error"));
            });
        };

        vm.onSensorsSelected = function(datatype)  {
            if(datatype)  {
                if (datatype === 'snapshot')  {
                    // Snapshot: Updating selected snapshot sensor will restart all master polling tasks
                    // Clear snapshot selected sensors array
                    vm.selectedSensors[datatype] = [];

                    const selectedSensorMessage = vm.selectedSensorsMessages[datatype];
                    vm.selectedSensors[datatype].push({
                        channelId: selectedSensorMessage.channelId,
                        sensorId: selectedSensorMessage.sensorId,
                        sensorType: selectedSensorMessage.sensorType
                    });

                    // Update chart scales
                    updateChartScales('snapshot', selectedSensorMessage.sensorType);
                }
                else  {
                    // Real-Time: Updating selected real-time sensors will restart all master polling tasks
                    vm.selectedSensorsMessages[datatype] = vm.selectedSensorsMessages[datatype].sort((a,b) => {
                        if(a.channelId === b.channelId)  {
                            if(a.sensorId > b.sensorId)  {
                                return 1;
                            }
                            else  {
                                return -1;
                            }
                        }
                        else if(a.channelId > b.channelId)  {
                            return 1;
                        }
                        else  {
                            return -1;
                        }
                    });

                    vm.selectedSensors[datatype] = vm.selectedSensorsMessages[datatype].map(m => {
                        return {
                            channelId: m.channelId,
                            sensorId: m.sensorId,
                            sensorType: m.sensorType
                        };
                    });


                    // Historical: Clear data granularity and time ranges if no sensors are selected
                    if(datatype === 'historicalDownload' || datatype === 'historicalChart')  {
                        if(vm.selectedSensors[datatype].length === 0)  {
                            vm.dataGranularity[datatype] = null;
                            vm.timeRangeOption[datatype] = null;
                            clearTimeRanges(datatype);
                        }
                        else  {
                            if(datatype === 'historicalChart')  {
                                updateChartScales('historicalChart', vm.selectedSensors[datatype][0].sensorType);
                            }
                        }
                    }
                }

                $log.info("Sensors selected (".concat(datatype).concat(")").concat(": ")
                    .concat(JSON.stringify(vm.selectedSensors[datatype])));
            }
        };

        const clearSelectedSensors = function(datatype)  {
            if(datatype)  {
                vm.selectedSensorsMessages[datatype] = null;

                // Clearing selected senors will result in the restarting of polling tasks
                vm.selectedSensors[datatype] = null;
            }
        };


        const setChartTitles = function()  {
            $log.info("Setting chart titles");
            
            // Set snapshot chart titles
            Object.keys(snapshotOptions).forEach(function (i) {
                Object.keys(snapshotOptions[i]).forEach(function (j) {
                    snapshotOptions[i][j].title.text = j;
                 });
            });

            // Set historical chart title
            vm.historicalOptions.title.text = "historical";
        };

        const updateChartScales = function(datatype, sensorType)  {
            $log.info("Updating chart scales (" + datatype + ") for " + sensorType + " sensors");
            switch(datatype)  {
                case 'snapshot':
                    if(sensorType === 'Temperature') {
                        const yMin = scaleSettings.temperature.yMin ? parseInt(scaleSettings.temperature.yMin) : 0;
                        const yMax = scaleSettings.temperature.yMax ? parseInt(scaleSettings.temperature.yMax) : 0;

                        Object.keys(snapshotOptions).forEach(function (i) {
                            Object.keys(snapshotOptions[i]).forEach(function (j) {
                                snapshotOptions[i][j].scales.yAxes[0].ticks.suggestedMin = yMin;
                                snapshotOptions[i][j].scales.yAxes[0].ticks.suggestedMax = yMax;
                                snapshotOptions[i][j].scales.yAxes[0].ticks.suggestedMin = yMin;
                                snapshotOptions[i][j].scales.yAxes[0].ticks.suggestedMax = yMax;
                             });
                        });
                    }
                    else if(sensorType === 'Pressure')  {
                        const yMin = scaleSettings.pressure.yMin ? parseInt(scaleSettings.pressure.yMin) : 0;
                        const yMax = scaleSettings.pressure.yMax ? parseInt(scaleSettings.pressure.yMax) : 0;

                        Object.keys(snapshotOptions).forEach(function (i) {
                            Object.keys(snapshotOptions[i]).forEach(function (j) {
                                snapshotOptions[i][j].scales.yAxes[0].ticks.suggestedMin = yMin;
                                snapshotOptions[i][j].scales.yAxes[0].ticks.suggestedMax = yMax;
                                snapshotOptions[i][j].scales.yAxes[0].ticks.suggestedMin = yMin;
                                snapshotOptions[i][j].scales.yAxes[0].ticks.suggestedMax = yMax;
                             });
                        });
                    }
                    else if(sensorType === 'Humidity')  {
                        const yMin = scaleSettings.humidity.yMin ? parseInt(scaleSettings.humidity.yMin) : 0;
                        const yMax = scaleSettings.humidity.yMax ? parseInt(scaleSettings.humidity.yMax) : 0;

                        Object.keys(snapshotOptions).forEach(function (i) {
                            Object.keys(snapshotOptions[i]).forEach(function (j) {
                                snapshotOptions[i][j].scales.yAxes[0].ticks.suggestedMin = yMin;
                                snapshotOptions[i][j].scales.yAxes[0].ticks.suggestedMax = yMax;
                                snapshotOptions[i][j].scales.yAxes[0].ticks.suggestedMin = yMin;
                                snapshotOptions[i][j].scales.yAxes[0].ticks.suggestedMax = yMax;
                             });
                        });
                    }
                    else  {
                        $log.error("Failed to update chart scales due to invalid sensorType: " + sensorType);
                    }
                    break;
                case 'historicalChart':
                    if(sensorType === 'Temperature') {
                        vm.historicalOptions.scales.yAxes[0].ticks.suggestedMin = scaleSettings.temperature.yMin ? parseInt(scaleSettings.temperature.yMin) : 0;
                        vm.historicalOptions.scales.yAxes[0].ticks.suggestedMax = scaleSettings.temperature.yMax ? parseInt(scaleSettings.temperature.yMax) : 0;
                    }
                    else if(sensorType === 'Pressure')  {
                        vm.historicalOptions.scales.yAxes[0].ticks.suggestedMin = scaleSettings.pressure.yMin ? parseInt(scaleSettings.pressure.yMin) : 0;
                        vm.historicalOptions.scales.yAxes[0].ticks.suggestedMax = scaleSettings.pressure.yMax ? parseInt(scaleSettings.pressure.yMax) : 0;
                    }
                    else if(sensorType === 'Humidity')  {
                        vm.historicalOptions.scales.yAxes[0].ticks.suggestedMin = scaleSettings.pressure.yMin ? parseInt(scaleSettings.pressure.yMin) : 0;
                        vm.historicalOptions.scales.yAxes[0].ticks.suggestedMax = scaleSettings.pressure.yMax ? parseInt(scaleSettings.pressure.yMax) : 0;
                    }
                    else  {
                        $log.error("Failed to update chart scales due to invalid sensorType: " + sensorType);
                    }
                    break;
                default:
                    break;
            }
        };


        const pruneMaster = function(datatype)  {
            $log.debug("Start pruning master (".concat(datatype).concat(")"));
            try  {
                if(vm.selectedSensors[datatype] && vm.selectedSensors[datatype].length > 0)  {
                    // Prune master will prune all data older than 30 seconds (real-time datatype) and 12 hours (snapshot datatype) for the current channel
                    // and remove all data that does not belong to the current channel
                    if(datatype === 'realtime')  {
                        MeasurementData.pruneMaster(datatype, 30, 'seconds', vm.channel[datatype].channelId);
                    }
                    else  {
                        MeasurementData.pruneMaster(datatype, 12, 'hours', vm.channel[datatype].channelId);
                    }


                    $log.debug("Done pruning master (".concat(datatype).concat(")"));
                    pruneMasterLoad(datatype);
                }
                else  {
                    $log.debug("Did not prune master (".concat(datatype).concat(") as no sensors are selected"));
                }
            }
            catch(err)  {
                $log.debug("An error has occurred pruning master (".concat(datatype).concat("): ").concat(err));
            }
        };

        const updateMaster = function(datatype, granularity)  {
            $log.debug("Start updating master (".concat(datatype).concat(", ").concat(granularity).concat(")"));
            try  {
                if(vm.selectedSensors[datatype] && vm.selectedSensors[datatype].length > 0)  {
                    // Update master
                    const updateMasterStart = moment();
                    MeasurementData.updateMaster(vm.tenant, datatype, vm.selectedSensors[datatype], granularity, "ASC").then(function(res){
                        const duration = moment.duration(moment().diff(updateMasterStart));
                        $log.debug("Done updating master (" + datatype + ", " + granularity + ") in " + duration.asSeconds() + " seconds");
                        if(datatype === 'realtime')  {
                            // Update real-time buffer
                            if(res)  {
                                $log.debug("Update real-time buffer");
                                Object.keys(res).forEach(k => {
                                    // Update realtimeBuffer with result from updateMaster
                                    if(res[k] && res[k].length > 0)  {
                                        // Deep copy from result to realtimeBuffer so that pruning of master does not affect the realtimeBuffer
                                        // ES6
                                        //realtimeBuffer[k] = res[k].map(x => ({...x}));

                                        // ES5
                                        realtimeBuffer[k] = res[k].map(x => JSON.parse(JSON.stringify(x)));
                                    }
                                })
                            }

                            if(startRefreshRadarData)  {
                                // Start the refresh radar data task
                                $log.info("Start the refresh radar data task");
                                refreshRadarData();
                            }
                        }
                        else if (datatype === 'snapshot')  {
                            if(startRefreshAllSnapshots)  {
                                // Start the refresh snapshots data task
                                $log.info("Start the refresh snapshots data task");
                                refreshAllSnapshots();
                            }
                        }

                        updateMasterErrors[datatype] = 0;
                        updateMasterLoad(datatype, granularity);
                    }).catch(function(err)  {
                        // Error for update master
                        $log.debug("Done updating master with error (".concat(datatype).concat(", ").concat(granularity).concat("): ").concat(JSON.stringify(err)));
                        updateMasterLoad(datatype, granularity, ++updateMasterErrors[datatype] * 2 * updateMasterInterval[datatype]);
                    });

                    //testing
                    // if(!realtimeBuffer["3"])  {
                    //     realtimeBuffer["3"] = [];
                    // }
                    // if(!realtimeBuffer["5"])  {
                    //     realtimeBuffer["5"] = [];
                    // }
                    // if(!realtimeBuffer["10"])  {
                    //     realtimeBuffer["10"] = [];
                    // }
                    // if(!realtimeBuffer["17"])  {
                    //     realtimeBuffer["17"] = [];
                    // }
                    // if(!realtimeBuffer["26"])  {
                    //     realtimeBuffer["26"] = [];
                    // }
                    // if(!realtimeBuffer["37"])  {
                    //     realtimeBuffer["37"] = [];
                    // }
                    // if(!realtimeBuffer["50"])  {
                    //     realtimeBuffer["50"] = [];
                    // }
                    // if(!realtimeBuffer["65"])  {
                    //     realtimeBuffer["65"] = [];
                    // }
                    // if(!realtimeBuffer["82"])  {
                    //     realtimeBuffer["82"] = [];
                    // }
                    // if(!realtimeBuffer["101"])  {
                    //     realtimeBuffer["101"] = [];
                    // }
                    // if(!realtimeBuffer["122"])  {
                    //     realtimeBuffer["122"] = [];
                    // }
                    // if(!realtimeBuffer["145"])  {
                    //     realtimeBuffer["145"] = [];
                    // }
                    // if(!realtimeBuffer["170"])  {
                    //     realtimeBuffer["170"] = [];
                    // }
                    // if(!realtimeBuffer["197"])  {
                    //     realtimeBuffer["197"] = [];
                    // }
                    // if(!realtimeBuffer["226"])  {
                    //     realtimeBuffer["226"] = [];
                    // }
                    // if(!realtimeBuffer["257"])  {
                    //     realtimeBuffer["257"] = [];
                    // }
                    //
                    // realtimeBuffer["3"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["5"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["10"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["17"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["26"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["37"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["50"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["65"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["82"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["101"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["122"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["145"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["170"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["197"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["226"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    // realtimeBuffer["257"].push({
                    //     id: 0, channelStatus: 0, sensorStatus :0, x: Date.now().valueOf(), y: (Math.random()*10)
                    // });
                    //end testing
                }
                else  {
                    $log.debug("Did not update master as no sensors are selected (".concat(datatype).concat(", ").concat(granularity).concat(")"));
                }
            }
            catch(err)  {
                $log.debug("An error has occurred updating master (".concat(datatype).concat(", ").concat(granularity).concat("): ").concat(err));
            }
        };


        const cancelPruneMasterLoad = function(datatype) {
            $timeout.cancel(pruneMasterPromise[datatype]);
        };

        const pruneMasterLoad = function(datatype) {
            // Always make sure the last timeout is cleared before starting a new one
            cancelPruneMasterLoad(datatype);

            if(isAlive)  {
                $log.debug("Prune master with delay (".concat(datatype).concat("): ")
                    .concat(pruneMasterInterval[datatype].toString()).concat( " milliseconds"));
                pruneMasterPromise[datatype] = $timeout(pruneMaster, pruneMasterInterval[datatype], true, datatype);
            }
        };

        const cancelUpdateMasterLoad = function(datatype) {
            $timeout.cancel(updateMasterPromise[datatype]);
        };

        const updateMasterLoad = function(datatype, granularity, pollingDelay) {
            pollingDelay = pollingDelay || updateMasterInterval[datatype];

            // Always make sure the last timeout is cleared before starting a new one
            cancelUpdateMasterLoad(datatype);

            if(isAlive)  {
                $log.debug("Update master with delay (".concat(datatype).concat("): ")
                    .concat(pollingDelay).concat( " milliseconds"));
                updateMasterPromise[datatype] = $timeout(updateMaster, pollingDelay, true, datatype, granularity);
            }
        };



        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: true,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };

/*****************************************************End Shared********************************************************/

/*****************************************************Real-Time*********************************************************/
        let isRealtimeDataTabSelected = false;

        let refreshRadarDataPromise = null;
        let refreshRadarDataInterval = 3000;
        let refreshRadarDataErrors = 0;

        // Relational Radar Chart of the Latest Datapoints
        let startRefreshRadarData = false;
        vm.radarData = [[]];
        vm.radarLabels = [];
        vm.radarOptions = {
            plugins: {
                streaming: false
            },
            animation: false,
            maintainAspectRatio: true,
            responsive: true
        };

        // Real-time Data Graph
        let realtimeBuffer = {};
        const realtimeBackgroundColors = [
            'rgba(230, 25, 75, 0.2)',
            'rgba(60, 180, 75, 0.2)',
            'rgba(255, 225, 25, 0.2)',
            'rgba(0, 130, 200, 0.2)',
            'rgba(245, 130, 48, 0.2)',
            'rgba(145, 30, 180, 0.2)',
            'rgba(70, 240, 240, 0.2)',
            'rgba(145, 30, 180, 0.2)',
            'rgba(240, 50, 230, 0.2)',
            'rgba(210, 245, 60, 0.2)',
            'rgba(250, 190, 190, 0.2)',
            'rgba(0, 128, 128, 0.2)',
            'rgba(230, 190, 255, 0.2)',
            'rgba(170, 110, 40, 0.2)',
            'rgba(128, 0, 0, 0.2)',
            'rgba(170, 255, 195, 0.2)'
        ];
        const realtimeBorderColors = [
            'rgba(230, 25, 75, 0.5)',
            'rgba(60, 180, 75, 0.5)',
            'rgba(255, 225, 25, 0.5)',
            'rgba(0, 130, 200, 0.5)',
            'rgba(245, 130, 48, 0.5)',
            'rgba(145, 30, 180, 0.5)',
            'rgba(70, 240, 240, 0.5)',
            'rgba(145, 30, 180, 0.5)',
            'rgba(240, 50, 230, 0.5)',
            'rgba(210, 245, 60, 0.5)',
            'rgba(250, 190, 190, 0.5)',
            'rgba(0, 128, 128, 0.5)',
            'rgba(230, 190, 255, 0.5)',
            'rgba(170, 110, 40, 0.5)',
            'rgba(128, 0, 0, 0.5)',
            'rgba(170, 255, 195, 0.5)',
        ];

        vm.realtimeOptions = {
            plugins: {
                streaming: {
                    duration: 30000,
                    refresh: 1000,
                    delay: 2000,
                    onRefresh: function(chart) {
                        if(isAlive)  {
                            if(vm.selectedSensors.realtime && vm.selectedSensors.realtime.length > 0)  {
                                if(realtimeBuffer)  {
                                    $log.debug("Refreshing real-time graph with available real-time buffer for " + vm.selectedSensors.realtime.length + " sensors");
                                    let datasetSensors = [];
                                    let selectedSensors = vm.selectedSensors.realtime.map(ss => (UtilService.szudzikPairing(ss.channelId, ss.sensorId).toString()));

                                    // Filter out realtimeBuffer sensors that are currently not selected or are empty
                                    realtimeBuffer = Object.keys(realtimeBuffer).filter(sensor =>
                                    selectedSensors.includes(sensor) && realtimeBuffer[sensor].length > 0)
                                        .reduce((filtered, sensor) =>  {
                                            filtered[sensor] = realtimeBuffer[sensor];
                                            return filtered;
                                        }, {});


                                    // Hide chart datasets that are not selected
                                    chart.data.datasets.forEach(dataset => {
                                        dataset.hidden = !selectedSensors.includes(dataset.sensorInfo);
                                    });

                                    // Filter out chart datasets sensors that are empty
                                    // Push into chart datasets values from realtimeBuffer
                                    chart.data.datasets = chart.data.datasets.filter(dataset =>
                                        (dataset.data))
                                        .reduce((filtered, dataset, i) =>  {
                                            datasetSensors.push(dataset.sensorInfo);
                                            filtered[i] = dataset;
                                            // Deep copy from realtimeBuffer, then prune to a range of 15 seconds
                                            if(realtimeBuffer[dataset.sensorInfo])  {
                                                const maxId = filtered[i].data.length !== 0 ? filtered[i].data.map(data => data.id)
                                                    .reduce((x,y) => (x > y) ? x : y) : 0;

                                                // ES6
                                                // filtered[i].data.push(...(realtimeBuffer[dataset.sensorInfo]
                                                //     .filter(data => moment(data.x).isBetween(moment().subtract(15, 'seconds'), moment()) && data.id > maxId)));

                                                // ES5
                                                filtered[i].data.push.apply(filtered[i].data, JSON.parse(JSON.stringify(realtimeBuffer[dataset.sensorInfo]
                                                    .filter(data => moment(data.x).isBetween(moment().subtract(15, 'seconds'), moment()) && data.id > maxId))));
                                            }
                                            return filtered;
                                        }, []);

                                    // Add into chart datasets sensors from realtimeBuffer that are not in the chart dataset
                                    Object.keys(realtimeBuffer).filter(sensor => !datasetSensors.includes(sensor))
                                        .forEach(sensor => {
                                            const sensorInfo = UtilService.szudzikUnpairing(sensor);
                                            const backgroundColor = realtimeBackgroundColors[sensorInfo[1] - 1];
                                            const borderColor = realtimeBorderColors[sensorInfo[1] - 1];
                                            chart.data.datasets.push({
                                                label: 'Sensor '.concat(sensorInfo[1]),
                                                fill: false,
                                                backgroundColor: backgroundColor,
                                                borderColor: borderColor,
                                                sensorInfo: sensor,
                                                data: []
                                            });
                                        });

                                    // Clear buffer
                                    Object.keys(realtimeBuffer).forEach(k => delete realtimeBuffer[k]);
                                }
                            }
                            else  {
                                // Clear buffer if no sensors are selected
                                Object.keys(realtimeBuffer).forEach(k => delete realtimeBuffer[k]);
                                $log.debug("Did not refresh real-time graph as no sensors are selected");
                            }
                        }
                        else  {
                            // Should not happen
                            $log.warn("The destruction of the MeasurementCtrl scope failed to destroy the real-time chart object.  Attempting to destroy again...");

                            Object.keys(realtimeBuffer).forEach(k => delete realtimeBuffer[k]);
                            if(chart)  {
                                chart.clear();
                                chart.destroy();
                            }
                        }
                    }
                }
            },
            legend: {
                display: true,
                position: 'right',
                labels: {
                    generateLabels: function(chart) {
                        let data = chart.data;
                        if(vm.selectedSensors.realtime && data && data.datasets)  {
                            let selectedSensors = vm.selectedSensors.realtime.map(ss => (UtilService.szudzikPairing(ss.channelId, ss.sensorId).toString()));

                            // Filter out sensors that are not selected or without data or with data that are older than 30 seconds
                            return data.datasets.filter(dataset => selectedSensors.includes(dataset.sensorInfo) && (dataset.data && dataset.data.length > 0) &&
                                    moment(dataset.data[dataset.data.length - 1].x).diff(moment().subtract(30, 'seconds')) >= 0)
                                // Sort by sensorInfo
                                .sort(function(a, b) {
                                    return a.sensorInfo - b.sensorInfo;
                                })
                                .map(function(dataset, i) {
                                    const lastDSData = dataset.data[dataset.data.length - 1];
                                    return lastDSData ? {
                                        text: dataset.label + ":  ".concat(lastDSData.y.toFixed(2).toString()),
                                        fillStyle: dataset.backgroundColor,
                                        strokeStyle: dataset.borderColor,
                                        index: i,
                                    } : {};
                                });
                        }
                        else  {
                            return [];
                        }
                    }
                },
            },
            elements: {
                point: {
                    radius: 1,
                    pointHitRadius: 10,
                    pointHoverRadius: 5
                },
                line: {
                    borderWidth: 2,
                    tension: 0, // disables bezier curves
                    animation: {
                        duration: 0, // general animation time
                    },
                    responsiveAnimationDuration: 0, // animation duration after a resize
                }
            },
            scales: {
                xAxes: [{
                    type: 'realtime',
                    display: true,
                    ticks: {
                        minRotation: 45,
                        maxRotation: 0,
                        maxTicksLimit: 25,
                        autoSkip: true
                    },

                    time: {
                        tooltipFormat: "YYYY-MM-DD HH:mm:ss:SSS",
                        displayFormats: {
                            month: 'MMM YYYY',
                            day: 'MMM D  00:00',
                            hour: 'MMM D  HH:00',
                            minute: 'HH:mm',
                            second: 'HH:mm:ss',
                            millisecond: 'HH:mm:ss:SSS'
                        }
                    }
                }],
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        stack: false,
                        position: 'left',
                        ticks: {
                            suggestedMin: -20,
                            suggestedMax: 120,
                        }
                    }
                ]
            },
            spanGaps: false,
            maintainAspectRatio: true,
            responsive: true
        };


        vm.onRealtimeDataTabSelected = function()  {
            isRealtimeDataTabSelected = true;
            $log.info("Real-time data tab selected");

            startRealtimePolling();
        };

        vm.onRealtimeDataTabDeselected = function()  {
            isRealtimeDataTabSelected = false;
            $log.info("Real-time data tab deselected");

            cancelRealtimePolling();
        };


        const startRealtimePolling = function()  {
            if(isRealtimeDataTabSelected && vm.selectedSensors.realtime && vm.selectedSensors.realtime.length > 0)  {
                // Switch on the flag to start the refresh radar data task
                vm.radarLabels = vm.selectedSensors.realtime.map(s => "Sensor ".concat(s.sensorId.toString()));
                startRefreshRadarData = true;

                // Start the real-time master polling tasks
                pruneMaster('realtime');
                updateMaster('realtime', 'tick');
            }
        };

        const cancelRealtimePolling = function()  {
            // Cancel the real-time master polling tasks
            $log.debug("Cancel prune master polling task (realtime)");
            cancelPruneMasterLoad('realtime');

            $log.debug("Cancel update master polling task (realtime)");
            updateMasterErrors.realtime = 0;
            cancelUpdateMasterLoad('realtime');

            // Cancel the refresh radar data task
            $log.debug("Cancel refresh radar data task");
            refreshRadarDataErrors = 0;
            cancelRefreshRadarDataLoad();

            // Clear radar chart
            if(vm.radarData[0])  {
                vm.radarData[0].length = 0;
            }
            if(vm.radarLabels)  {
                vm.radarLabels.length = 0;
            }
        };


        const refreshRadarData = function() {
            $log.debug("Start refreshing radar data");
            try  {
                if(vm.selectedSensors.realtime && vm.selectedSensors.realtime.length > 0)  {
                    vm.radarData[0] = MeasurementData.latestMaster('realtime', vm.selectedSensors.realtime);

                    //testing
                    // vm.radarData[0] = [(Math.random()*10), (Math.random()*10), (Math.random()*10), (Math.random()*10), (Math.random()*10),
                    //     (Math.random()*10), (Math.random()*10), (Math.random()*10), (Math.random()*10), (Math.random()*10),
                    //     (Math.random()*10), (Math.random()*10), (Math.random()*10), (Math.random()*10), (Math.random()*10), (Math.random()*10)];
                    //end testing

                    $log.debug("Done refreshing radar data");

                    refreshRadarDataErrors = 0;
                    refreshRadarDataLoad();
                }
                else  {
                    $log.debug("Did not refresh radar data as no sensors are selected");
                }
            }
            catch(err)  {
                $log.debug("An error has occurred refreshing radar data: ".concat(err));
                refreshRadarDataLoad(++refreshRadarDataErrors * 2 * refreshRadarDataInterval);
            }
            finally {
                // The refresh radar data task is started.  Turn off flag.
                startRefreshRadarData = false;
            }
        };


        $scope.$watch('vm.selectedSensors.realtime', function() {
            // Restart the refresh radar data task and the real-time master polling tasks
            // Any existing real-time master data will remain unchanged until the next time when the selected sensors are assigned.
            // Assigning the selected sensors will result in the removal of real-time master data that does not belong to the selected channel,
            // as the master polling tasks will be restarted and pruneMaster will be executed
            cancelRealtimePolling();
            startRealtimePolling();
        });


        const cancelRefreshRadarDataLoad = function() {
            $timeout.cancel(refreshRadarDataPromise);
        };

        const refreshRadarDataLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || refreshRadarDataInterval;

            // Always make sure the last timeout is cleared before starting a new one
            cancelRefreshRadarDataLoad();

            if(isAlive)  {
                $log.debug("Refresh radar data with delay: ".concat(pollingDelay).concat( " milliseconds"));
                refreshRadarDataPromise = $timeout(refreshRadarData, pollingDelay);
            }
        };

/*************************************************End Real-Time*********************************************************/

/***************************************************Snapshot************************************************************/
        let isSnapshotDataTabSelected = false;

        let startRefreshAllSnapshots = false;

        let snapshotGraphs = {};

        vm.snapshotTypes = {
            FIVE_MIN: {
                id: 0,
                name: 'FIVE_MIN', 
                toPoll: true,
                pollingInterval: 12000,
                pollingPromise: null
            },
            FIFTEEN_MIN: {
                id: 1,
                name: 'FIFTEEN_MIN',
                toPoll: true,
                pollingInterval: 36000,
                pollingPromise: null
            },
            ONE_HOUR: {
                id: 2,
                name: 'ONE_HOUR',
                toPoll: true,
                pollingInterval: 144000,
                pollingPromise: null
            },
            TWO_HOUR: {
                id: 3,
                name: 'TWO_HOUR',
                toPoll: true,
                pollingInterval: 288000,
                pollingPromise: null
            },
            SIX_HOUR: {
                id: 4,
                name: 'SIX_HOUR',
                toPoll: true,
                pollingInterval: 864000,
                pollingPromise: null
            },
            TWELVE_HOUR: {
                id: 5,
                name: 'TWELVE_HOUR',
                toPoll: true,
                pollingInterval: 1728000,
                pollingPromise: null
            }
        };

        let snapshotSmallSeries = {};
        let snapshotLargeSeries = {};

        vm.activeSnapshotId = null;
        vm.snapshotData = {};

        const snapshotOptionsTemplate = {
            small: {
                plugins: {
                    streaming: false
                },
                title: {
                    display: false,
                    text: ''
                },
                legend: {
                    display: true,
                    labels: {
                        fontColor: 'rgb(255, 99, 132)'
                    }
                },
                elements: {
                    point: {
                        radius: 2.5,
                        pointHitRadius: 2.5,
                        pointHoverRadius: 2.5,
                    },
                    line: {
                        borderWidth: 3,
                        tension: 0, // disables bezier curves
                        animation: {
                            duration: 0, // general animation time
                        },
                        hover: {
                            animationDuration: 0, // duration of animations when hovering an item
                        },
                        responsiveAnimationDuration: 0, // animation duration after a resize
                    }
                },
                scales: {
                    xAxes: [{
                        type: 'time',
                        display: true,
                        ticks: {
                            minRotation: 30,
                            maxRotation: 0,
                            maxTicksLimit: 7,
                            autoSkip: true
                        },

                        time: {
                            tooltipFormat: "YYYY-MM-DD HH:mm:ss:SSS",
                            displayFormats: {
                                month: 'MMM YYYY',
                                day: 'MMM D  00:00',
                                hour: 'MMM D  HH:00',
                                minute: 'HH:mm',
                                second: 'HH:mm:ss',
                                millisecond: 'HH:mm:ss:SSS'
                            }
                        }
                    }],
                    yAxes: [
                        {
                            type: 'linear',
                            display: true,
                            stack: true,
                            position: 'left',
                            ticks: {
                                suggestedMin: 0,
                                suggestedMax: 0,
                            }
                        }
                    ]
                },
                pan: {
                    enabled: true,
                    mode: 'xy'
                 },
                zoom: {
                    enabled: true,
                    drag: false,
                    mode: 'xy'
                }
            },
            large: {
                plugins: {
                    streaming: false
                },
                title: {
                    display: false,
                    text: ''
                },
                legend: {
                    display: true,
                    labels: {
                        fontColor: 'rgb(255, 99, 132)'
                    }
                },
                elements: {
                    point: {
                        radius: 2.5,
                        pointHitRadius: 2.5,
                        pointHoverRadius: 2.5
                    },
                    line: {
                        borderWidth: 2,
                        tension: 0, // disables bezier curves
                        animation: {
                            duration: 0, // general animation time
                        },
                        hover: {
                            animationDuration: 0, // duration of animations when hovering an item
                        },
                        responsiveAnimationDuration: 0, // animation duration after a resize
                    }
                },
                scales: {
                    xAxes: [{
                        type: 'time',
                        display: true,
                        ticks: {
                            minRotation: 45,
                            maxRotation: 0,
                            maxTicksLimit: 25,
                            autoSkip: false
                        },

                        time: {
                            tooltipFormat: "YYYY-MM-DD HH:mm:ss:SSS",
                            displayFormats: {
                                month: 'MMM YYYY',
                                day: 'MMM D  00:00',
                                hour: 'MMM D  HH:00',
                                minute: 'HH:mm',
                                second: 'HH:mm:ss',
                                millisecond: 'HH:mm:ss:SSS'
                            }
                        }
                    }],
                    yAxes: [
                        {
                            type: 'linear',
                            display: true,
                            stack: true,
                            position: 'left',
                            ticks: {
                                suggestedMin: 0,
                                suggestedMax: 0,
                            }
                        }
                    ]
                },
                pan: {
                    enabled: true,
                    mode: 'xy'
                 },
                zoom: {
                    enabled: true,
                    drag: false,
                    mode: 'xy'
                }
            }
        };

        const snapshotOptions = {
            small: {
                FIVE_MIN: JSON.parse(JSON.stringify(snapshotOptionsTemplate.small)),
                FIFTEEN_MIN: JSON.parse(JSON.stringify(snapshotOptionsTemplate.small)),
                ONE_HOUR: JSON.parse(JSON.stringify(snapshotOptionsTemplate.small)),
                TWO_HOUR: JSON.parse(JSON.stringify(snapshotOptionsTemplate.small)),
                SIX_HOUR: JSON.parse(JSON.stringify(snapshotOptionsTemplate.small)),
                TWELVE_HOUR: JSON.parse(JSON.stringify(snapshotOptionsTemplate.small))
            },
            large: {
                FIVE_MIN: JSON.parse(JSON.stringify(snapshotOptionsTemplate.large)),
                FIFTEEN_MIN: JSON.parse(JSON.stringify(snapshotOptionsTemplate.large)),
                ONE_HOUR: JSON.parse(JSON.stringify(snapshotOptionsTemplate.large)),
                TWO_HOUR: JSON.parse(JSON.stringify(snapshotOptionsTemplate.large)),
                SIX_HOUR: JSON.parse(JSON.stringify(snapshotOptionsTemplate.large)),
                TWELVE_HOUR: JSON.parse(JSON.stringify(snapshotOptionsTemplate.large))
            }
        };


        vm.onSnapshotDataTabSelected = function()  {
            isSnapshotDataTabSelected = true;
            $log.info("Snapshot data tab selected");

            startSnapshotPolling();
        };

        vm.onSnapshotDataTabDeselected= function()  {
            isSnapshotDataTabSelected = false;
            $log.info("Snapshot data tab deselected");

            cancelSnapshotPolling();
        };


        const startSnapshotPolling = function()  {
            if(isSnapshotDataTabSelected && vm.selectedSensors.snapshot && vm.selectedSensors.snapshot.length > 0)  {
                // Switch on the flag to start the refresh all snapshot task
                startRefreshAllSnapshots = true;

                // Start the snapshot master polling tasks
                pruneMaster('snapshot');
                updateMaster('snapshot', 'tick');
            }
        };

        const cancelSnapshotPolling = function()  {
            // Cancel the snapshot master polling tasks
            $log.debug("Cancel prune master polling task (snapshot)");
            cancelPruneMasterLoad('snapshot');

            $log.debug("Cancel update master polling task (snapshot)");
            updateMasterErrors.snapshot = 0;
            cancelUpdateMasterLoad('snapshot');

            $log.debug("Cancel all refresh snapshot tasks");
            cancelAllRefreshSnapshotLoad();

            // Clear all snapshots
            clearAllSnapshots();

            vm.activeSnapshotId = null;
        };


        vm.getSnapshotSeries = function(small, snapshotId)  {
            return small ? snapshotSmallSeries[snapshotId] : snapshotLargeSeries[snapshotId];
        };

        vm.getSnapshotOptions = function(small, snapshotName)  {
            return small ? snapshotOptions.small[snapshotName] : snapshotOptions.large[snapshotName];
        };


        vm.refreshSnapshotOnClicked = function(snapshotType) {
            // Restart the refresh snapshot polling task
            cancelRefreshSnapshotLoad(snapshotType);
            refreshSnapshot(snapshotType);
        };

        vm.snapshotPollingToggled = function(snapshotType) {
            snapshotType.toPoll = !snapshotType.toPoll;
            if(snapshotType)  {
                cancelRefreshSnapshotLoad(snapshotType);
                if(snapshotType.toPoll)  {
                    refreshSnapshot(snapshotType);
                }
            }
        };

        vm.setActiveSnapshot = function(snapshotId) {
            vm.activeSnapshotId = vm.activeSnapshotId !== snapshotId ? snapshotId : null;
            $log.info("Current active snapshot: ".concat(vm.activeSnapshotId));

            let currLocationHash = 'anchor_'.concat(snapshotId);
            if ($location.hash() !== currLocationHash) {
                // Set the $location.hash to currLocationHash and $anchorScroll will automatically scroll to it
                $location.hash(currLocationHash);
            } else {
                // Call $anchorScroll() explicitly since $location.hash has not changed
                $anchorScroll();
            }
        };

        vm.resetSnapshotGraphZoom = function(snapshotName)  {
            if(snapshotGraphs[snapshotName])  {
                snapshotGraphs[snapshotName].resetZoom();
            }
        };


        vm.hasSnapshotData = function(snapshotId)  {
            return vm.snapshotData[snapshotId] && vm.snapshotData[snapshotId].length > 0 &&
                vm.snapshotData[snapshotId][0].length > 0;
        };

        const refreshAllSnapshots = function() {
            try  {
                Object.keys(vm.snapshotTypes).forEach(
                    k => {
                        let snapshotType = vm.snapshotTypes[k];
                        if(snapshotType)  {
                            refreshSnapshot(snapshotType);
                        }
                    }
                );
            }
            catch(err)  {
                $log.debug("An error has occurred refreshing all snapshots: ".concat(err));
            }
            finally  {
                // The refresh all snapshot task is started.  Turn off flag.
                startRefreshAllSnapshots = false;
            }
        };

        const refreshSnapshot = function(snapshotType) {
            let data = null;
            switch(snapshotType.id)  {
                case vm.snapshotTypes.FIVE_MIN.id:
                    $log.info("Getting 5-min measurement data snapshot");
                    data = MeasurementData.filterMaster('snapshot', vm.selectedSensors.snapshot, moment().subtract(5, 'minutes'), moment());
                    break;
                case vm.snapshotTypes.FIFTEEN_MIN.id:
                    $log.info("Getting 15-min measurement data snapshot");
                    data = MeasurementData.filterMaster('snapshot', vm.selectedSensors.snapshot, moment().subtract(15, 'minutes'), moment());
                    break;
                case vm.snapshotTypes.ONE_HOUR.id:
                    $log.info("Getting 1-hour measurement data snapshot");
                    data = MeasurementData.filterMaster('snapshot', vm.selectedSensors.snapshot, moment().subtract(1, 'hours'), moment());
                    break;
                case vm.snapshotTypes.TWO_HOUR.id:
                    $log.info("Getting 2-hour measurement data snapshot");
                    data = MeasurementData.filterMaster('snapshot', vm.selectedSensors.snapshot, moment().subtract(2, 'hours'), moment());
                    break;
                case vm.snapshotTypes.SIX_HOUR.id:
                    $log.info("Getting 6-hour measurement data snapshot");
                    data = MeasurementData.filterMaster('snapshot', vm.selectedSensors.snapshot, moment().subtract(6, 'hours'), moment());
                    break;
                case vm.snapshotTypes.TWELVE_HOUR.id:
                    $log.info("Getting 12-hour measurement data snapshot");
                    data = MeasurementData.filterMaster('snapshot', vm.selectedSensors.snapshot, moment().subtract(12, 'hours'), moment());
                    break;
                default:
                    $log.error("Cannot get any data snapshot for invalid snapshot type!");
                    break;
            }

            if(data !== null)  {
                const series = Object.keys(data);
                if(series !== null && series.length > 0)  {
                    snapshotSmallSeries[snapshotType.id] = series.map(s => {
                        const sensorInfo = UtilService.szudzikUnpairing(s);
                        return 'Channel '.concat(sensorInfo[0]).concat('  ').concat('Sensor ').concat(sensorInfo[1]);
                    });

                    snapshotLargeSeries[snapshotType.id] = series.map(s => {
                        const sensorInfo = UtilService.szudzikUnpairing(s);
                        return 'Channel '.concat(sensorInfo[0]).concat('  ').concat('Sensor ').concat(sensorInfo[1]);
                    });
                }

                vm.snapshotData[snapshotType.id] = Object.values(data);
            }

            refreshSnapshotLoad(snapshotType);
        };

        const clearAllSnapshots = function()  {
            Object.keys(vm.snapshotData)
                .forEach(function(snapshot) {
                    delete vm.snapshotData[snapshot];
                });
        };


        $scope.$watch('vm.selectedSensors.snapshot', function() {
            // Restart the refresh radar data task and the snapshot master polling tasks
            // Any existing snapshot master data will remain unchanged until the next time when the selected sensors are assigned.
            // Assigning the selected sensors will result in the removal of snapshot master data that does not belong to the selected channel,
            // as the master polling tasks will be restarted and pruneMaster will be executed
            cancelSnapshotPolling();
            startSnapshotPolling();
        });


        const cancelRefreshSnapshotLoad = function(snapshotType) {
            if(snapshotType)  {
                $timeout.cancel(snapshotType.pollingPromise);
            }
        };

        const cancelAllRefreshSnapshotLoad = function() {
            Object.keys(vm.snapshotTypes).forEach(
                k => {
                    let snapshotType = vm.snapshotTypes[k];
                    if(snapshotType)  {
                        $timeout.cancel(snapshotType.pollingPromise);
                    }
                }
            );
        };

        const refreshSnapshotLoad = function(snapshotType) {
            if(snapshotType)  {
                // Always make sure the last timeout is cleared before starting a new one
                $timeout.cancel(snapshotType.pollingPromise);

                $log.debug("Refresh snapshot ".concat(snapshotType.id).concat(" with delay: ").concat(snapshotType.pollingInterval.toString())
                    .concat( " milliseconds"));

                if(isAlive)  {
                    snapshotType.pollingPromise = $timeout(refreshSnapshot, snapshotType.pollingInterval, true, snapshotType);
                }
            }
        };

/**************************************************End Snapshot*********************************************************/

/****************************************************Historical*********************************************************/
        vm.sensortypes = {};
        vm.sensortype = {};

        vm.historicalOptions = {
            plugins: {
                streaming: false
            },
            title: {
                display: false,
                text: ''
            },
            legend: {
                display: true,
                labels: {
                    fontColor: 'rgb(255, 99, 132)'
                }
            },
            elements: {
                point: {
                    radius: 2.5,
                    pointHitRadius: 2.5,
                    pointHoverRadius: 2.5
                },
                line: {
                    borderWidth: 2,
                    tension: 0, // disables bezier curves
                    animation: {
                        duration: 0, // general animation time
                    },
                    hover: {
                        animationDuration: 0, // duration of animations when hovering an item
                    },
                    responsiveAnimationDuration: 0, // animation duration after a resize
                }
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    display: true,
                    ticks: {
                        minRotation: 45,
                        maxRotation: 0,
                        maxTicksLimit: 25,
                        autoSkip: false
                    },

                    time: {
                        tooltipFormat: "YYYY-MM-DD HH:mm:ss:SSS",
                        displayFormats: {
                            month: 'MMM YYYY',
                            day: 'MMM D  00:00',
                            hour: 'MMM D  HH:00',
                            minute: 'HH:mm',
                            second: 'HH:mm:ss',
                            millisecond: 'HH:mm:ss:SSS'
                        }
                    }
                }],
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        stack: true,
                        position: 'left',
                        ticks: {
                            suggestedMin: 0,
                            suggestedMax: 0,
                        }
                    }
                ]
            },
            pan: {
                enabled: true,
                mode: 'xy'
             },
            zoom: {
                enabled: true,
                drag: false,
                mode: 'xy'
            }
        };

        vm.filetypes = {};
        vm.filetype = {};

        vm.dataGranularities = {};
        vm.dataGranularity = {};


        vm.timeRangeOption = {
            historicalChart: null,
            historicalDownload: null
        };

        vm.historicalFromMin = {
            historicalChart: null,
            historicalDownload: null
        };

        vm.historicalFromMax = {
            historicalChart: null,
            historicalDownload: null,
        };

        vm.historicalToMin = {
            historicalChart: null,
            historicalDownload: null
        };

        vm.historicalToMax = {
            historicalChart: null,
            historicalDownload: null,
        };


        vm.historicalFrom = {
            historicalChart: null,
            historicalDownload: null,
        };

        vm.historicalTo = {
            historicalChart: null,
            historicalDownload: null,
        };

        vm.isHistoricalChartLoading = true;
        vm.historicalChartMaximized = false;

        let historicalGraph = null;


        const initHistoricalDataTab = function()  {
            getSensorTypes('historicalDownload');
            getSensorTypes('historicalChart');

            getFileTypes('historicalDownload');
            getFileTypes('historicalChart');

            getDataGranularities('historicalDownload');
            getDataGranularities('historicalChart');
        };


        // Historical Shared
        const getSensorTypes = function(datatype) {
            $log.info("Getting sensor types (".concat(datatype).concat(")"));
            ChannelService.sensors.types(function(res) {
                vm.sensortypes[datatype] = res;
            }, function(err)  {
                const errData = err.data;

                $log.error("An error has occurred getting sensor types (".concat(datatype).concat("): ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
            });
        };

        const getFileTypes = function(datatype) {
            $log.info("Getting file types (".concat(datatype).concat(")"));
            AdminService.filetypes.query(function(res) {
                vm.filetypes[datatype] = res.filter(r => r.name !== 'XLSX');
            }, function(err)  {
                const errData = err.data;

                $log.error("An error has occurred getting file types (".concat(datatype).concat("): ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
            });
        };

        const getDataGranularities = function(datatype) {
            $log.info("Getting data granularities (".concat(datatype).concat(")"));
            AdminService.granularities.query(function(res) {
                switch(env.historicalMeasurementDataGranularity)  {
                    case '1day':
                        vm.dataGranularities[datatype] = res.filter(g => g.value >= 86400);
                        break;
                    case '1hr':
                        vm.dataGranularities[datatype] = res.filter(g => g.value >= 3600);
                        break;
                    case '5min':
                        vm.dataGranularities[datatype] = res.filter(g => g.value >= 360);
                        break;
                    default:
                        vm.dataGranularities[datatype] = res;
                        break;
                }
            }, function(err)  {
                const errData = err.data;

                $log.error("An error has occurred getting data granularities (".concat(datatype).concat("): ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
            });
        };


        const getSensorsBySensorType = function(sensorTypeName) {
            $log.info("Getting sensors by ".concat(sensorTypeName).concat(" sensor type"));
            let deferred = $q.defer();

            ChannelService.sensors.sensorsBySensorType({ tenant: vm.tenant, sensorTypeName: sensorTypeName }, function(res) {
                deferred.resolve(res.sensorMessages);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting sensors by ".concat(sensorTypeName).concat("sensor type: ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.reject(err);
            });
            return deferred.promise;
        };

        const clearTimeRanges = function(datatype)  {
            vm.historicalFrom[datatype] = null;
            vm.historicalTo[datatype] = null;

            vm.historicalFromMin[datatype] = null;
            vm.historicalFromMax[datatype] = null;
            vm.historicalToMin[datatype] = null;
            vm.historicalToMax[datatype] = null;
        };


        vm.historicalSensorsGroupBy = function(sensorMessage){
            return sensorMessage ? "Channel ".concat(sensorMessage.channelId) : "NULL";
        };

        vm.orderHistoricalSensorsGroupBy = function(groups){
            return groups ? groups.sort((a,b) => {
                const aChannel = parseInt(a.name.match(/^Channel ([0-9]+)$/)[1], 10);
                const bChannel = parseInt(b.name.match(/^Channel ([0-9]+)$/)[1], 10);
                return (aChannel > bChannel) ? 1 : -1;
            }) : groups;
        };

        vm.getHistoricalTimeRangeOptions = function(datatype)  {
            const granularity = vm.dataGranularity[datatype].name;
            const res = ['Custom'];

            switch(granularity)  {
                case 'tick':
                    res.push(...['All', 'Past 1 Minute', 'Past 5 Minutes', 'Past 1 Hour', 'Past 2 Hours', 'Past 6 Hours']);
                    break;
                case '5min':
                    res.push(...['All', 'Past 1 Hour', 'Past 2 Hours', 'Past 6 Hours', 'Past 12 Hours', 'Past 1 Day', 'Past 3 Days', 'Past 1 Week']);
                    break;
                case '1hr':
                    res.push(...['All', 'Past 2 Hours', 'Past 6 Hours', 'Past 12 Hours', 'Past 1 Day', 'Past 3 Days', 'Past 1 Week', 'Past 2 Weeks', 'Past 1 Month', 'Past 3 Months']);
                    break;
                case '1day':
                    res.push(...['All', 'Past 3 Days', 'Past 1 Week', 'Past 2 Weeks', 'Past 1 Month', 'Past 3 Months', 'Past 6 Months', 'Past 1 Year']);
                    break;
                default:
                    break;
            }
            return res;
        };


        vm.onHistoricalSensorTypeSelected = function(datatype)  {
            $log.info(vm.sensortype[datatype].name + " sensor type selected (".concat(datatype).concat(").  Getting sensors."));

            // Clear sensors
            vm.sensors[datatype] = null;

            // HistoricalChart: Clearing selected sensors will also result in the clearing of historical data as the historical chart will be refreshed
            clearSelectedSensors(datatype);

            // Clear data granularity
            vm.dataGranularity[datatype] = null;

            // Clear time ranges
            vm.timeRangeOption[datatype] = null;
            clearTimeRanges(datatype);

            // Clear file type
            if(datatype === 'historicalDownload')  {
                vm.filetype = null;
            }

            // Get sensors by sensor type
            getSensorsBySensorType(vm.sensortype[datatype].name).then(function(resSensorMessages){
                vm.sensors[datatype] = resSensorMessages;
            }).catch(function()  {
                showAlert("Error", "An error has occurred getting Sensors");
                $log.error("Done getting sensors by sensor type (".concat(datatype).concat(")").concat(" with error"));
            });
        };

        vm.onHistoricalDataGranularitySelected = function(datatype)  {
            $log.debug(vm.dataGranularity[datatype].name +  " granularity selected (".concat(datatype).concat(")"));
            vm.timeRangeOption[datatype] = null;
            clearTimeRanges(datatype);

            if(datatype === 'historicalChart')  {
                refreshHistoricalChart();
            }
        };

        vm.onHistoricalTimeRangeOptionSelected = function(datatype)  {
            $log.debug(vm.timeRangeOption[datatype] +  " time range selected (".concat(datatype).concat(")"));
            // Clear existing time ranges first
            clearTimeRanges(datatype);

            if(vm.timeRangeOption[datatype] !== 'Custom')  {
                switch(vm.timeRangeOption[datatype])  {
                    case 'Past 1 Minute':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(1, 'minutes');
                        break;
                    case 'Past 5 Minutes':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(5, 'minutes');
                        break;
                    case 'Past 1 Hour':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(1, 'hours');
                        break;
                    case 'Past 2 Hours':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(2, 'hours');
                        break;
                    case 'Past 6 Hours':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(6, 'hours');
                        break;
                    case 'Past 12 Hours':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(12, 'hours');
                        break;
                    case 'Past 1 Day':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(1, 'days');
                        break;
                    case 'Past 3 Days':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(3, 'days');
                        break;
                    case 'Past 1 Week':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(1, 'weeks');
                        break;
                    case 'Past 2 Weeks':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(2, 'weeks');
                        break;
                    case 'Past 1 Month':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(1, 'months');
                        break;
                    case 'Past 3 Months':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(3, 'months');
                        break;
                    case 'Past 6 Months':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(6, 'months');
                        break;
                    case 'Past 1 Year':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment().subtract(1, 'years');
                        break;
                    case 'All':
                        vm.historicalTo[datatype] = moment();
                        vm.historicalFrom[datatype] = moment(0);
                        break;    
                }
            }

            if(datatype === 'historicalChart')  {
                refreshHistoricalChart();
            }
        };

        vm.onCustomHistoricalTimeRangeChanged = function(datatype) {
            $log.debug("New custom historical time range (".concat(datatype).concat("): from ").concat(vm.historicalFrom[datatype] ? vm.historicalFrom[datatype] : 'null')
                .concat(" to ").concat(vm.historicalTo[datatype] ? vm.historicalTo[datatype] : 'null'));

            if(vm.dataGranularity[datatype])  {
                const granularity = vm.dataGranularity[datatype].name;
                if(vm.historicalFrom[datatype])  {
                    switch(granularity)  {
                        case 'tick':
                            vm.historicalToMin[datatype] = vm.historicalFrom[datatype];
                            vm.historicalToMax[datatype] = moment(vm.historicalFrom[datatype]).add(6, 'hours');
                            break;
                        case '5min':
                            vm.historicalToMin[datatype] = vm.historicalFrom[datatype];
                            vm.historicalToMax[datatype] = moment(vm.historicalFrom[datatype]).add(1, 'weeks');
                            break;
                        case '1hr':
                            vm.historicalToMin[datatype] = vm.historicalFrom[datatype];
                            vm.historicalToMax[datatype] = moment(vm.historicalFrom[datatype]).add(3, 'months');
                            break;
                        case '1day':
                            vm.historicalToMin[datatype] = vm.historicalFrom[datatype];
                            vm.historicalToMax[datatype] = moment(vm.historicalFrom[datatype]).add(1, 'years');
                            break;
                        default:
                            break;
                    }
                }

                if (vm.historicalTo[datatype])  {
                    switch(granularity)  {
                        case 'tick':
                            vm.historicalFromMin[datatype] = moment(vm.historicalTo[datatype]).subtract(6, 'hours');
                            vm.historicalFromMax[datatype] = vm.historicalTo[datatype];
                            break;
                        case '5min':
                            vm.historicalFromMin[datatype] = moment(vm.historicalTo[datatype]).subtract(1, 'weeks');
                            vm.historicalFromMax[datatype] = vm.historicalTo[datatype];
                            break;
                        case '1hr':
                            vm.historicalFromMin[datatype] = moment(vm.historicalTo[datatype]).subtract(3, 'months');
                            vm.historicalFromMax[datatype] = vm.historicalTo[datatype];
                            break;
                        case '1day':
                            vm.historicalFromMin[datatype] = moment(vm.historicalTo[datatype]).subtract(1, 'years');
                            vm.historicalFromMax[datatype] = vm.historicalTo[datatype];
                            break;
                        default:
                            break;
                    }
                }
            }

            if(datatype === 'historicalChart')  {
                refreshHistoricalChart();
            }
        };

        vm.onDeleteCustomHistoricalTimeRange = function(datatype, isHistoricalFrom)  {
            if(isHistoricalFrom)  {
                clearTimeRanges(datatype);
            }
            else  {
                vm.historicalTo[datatype] = null;
                vm.historicalFromMin[datatype] = null;
                vm.historicalFromMax[datatype] = null;
            }

            if(datatype === 'historicalChart')  {
                refreshHistoricalChart();
            }
        };

        vm.onHistoricalFileTypeSelected = function(datatype) {
            $log.debug(vm.filetype[datatype].name + " file type selected (".concat(datatype).concat(")"));
        };


        // Historical Download
        vm.hasHistoricalDownloadInputs = function()  {
            return vm.selectedSensors.historicalDownload && vm.selectedSensors.historicalDownload.length > 0 &&
                vm.historicalFrom.historicalDownload && vm.historicalTo.historicalDownload && vm.dataGranularity.historicalDownload;
        };

        vm.getHistoricalDataFileLink = function()  {
            try  {
                const sensorTypeName = vm.sensortype.historicalDownload.name;
                const fileTypeName = vm.filetype.historicalDownload.name;
                const granularity = vm.dataGranularity.historicalDownload.name;
                $log.debug("Creating link to get historical measurement ".concat(sensorTypeName.toLowerCase())
                    .concat(" data file ").concat("(").concat(granularity).concat(")")
                    .concat(" in ").concat(fileTypeName).concat(" format"));

                const res = MeasurementData.getHistoricalDataFileLink(vm.tenant, vm.selectedSensors.historicalDownload, sensorTypeName,
                    moment(vm.historicalFrom.historicalDownload), moment(vm.historicalTo.historicalDownload),
                    fileTypeName, granularity, displayTZ, "ASC", true, null);
                $log.debug("Done getting historical data file link: ".concat(res));

                return res;
            }
            catch(err)  {
                showAlert("Error", "An error has occurred getting Historical Data File Link");
                $log.error("Done getting historical data file link with error: ".concat(err));
                return "";
            }
        };


        // Historical Chart
        vm.hasHistoricalChartInputs = function()  {
            return vm.selectedSensors.historicalChart && vm.selectedSensors.historicalChart.length > 0 &&
                vm.dataGranularity.historicalChart && vm.historicalFrom.historicalChart && vm.historicalTo.historicalChart;
        };

        vm.hasHistoricalChartData = function()  {
            return vm.historicalChartData && vm.historicalChartData.length > 0;
        };

        const refreshHistoricalChart = function() {
            $log.info("Clearing historical chart");
            vm.historicalChartData = null;

            if(vm.hasHistoricalChartInputs()) {
                $log.info("Start refreshing historical chart");
                getHistoricalChartData();
            }
        };

        const getHistoricalChartData = function()  {
            vm.isHistoricalChartLoading = true;
            const granularity = vm.dataGranularity.historicalChart.name;

            $log.info(vm.historicalFrom.historicalChart ? vm.historicalFrom.historicalChart.toString() : null);
            $log.info(vm.historicalTo.historicalChart ? vm.historicalTo.historicalChart.toString() : null);

            MeasurementData.getHistoricalData(vm.tenant, vm.selectedSensors.historicalChart,
                vm.timeRangeOption.historicalChart === 'Custom' ? moment(vm.historicalFrom.historicalChart) : vm.historicalFrom.historicalChart,
                vm.timeRangeOption.historicalChart === 'Custom' ? moment(vm.historicalTo.historicalChart) : vm.historicalTo.historicalChart,
                granularity, env.historicalMeasurementChartDataTolerance, "ASC").then(function(res){
                $log.info("Done refreshing historical chart data ".concat("(").concat(granularity).concat(")"));

                if(res !== null)  {
                    const series = Object.keys(res);
                    if(series !== null && series.length > 0)  {
                        vm.historicalChartSeries = series.map(s => {
                            const sensorInfo = UtilService.szudzikUnpairing(s);
                            return 'Channel '.concat(sensorInfo[0]).concat('  ').concat('Sensor ').concat(sensorInfo[1]);
                        });
                    }
                    vm.historicalChartData = Object.values(res);
                }

            }).catch(function()  {
                showAlert("Error", "An error has occurred getting Historical Chart");
                $log.error("Done refreshing historical chart with error");
            }).finally(function()  {
                vm.isHistoricalChartLoading = false;
            });
        };

        vm.toggleHistoricalChartSize = function()  {
            vm.historicalChartMaximized = !vm.historicalChartMaximized;
        };

        vm.historicalChartSizeDisplay = function()  {
            return vm.historicalChartMaximized ? "Minimize" : "Maximize";
        };

        vm.resetHistoricalGraphZoom = function()  {
            if(historicalGraph)  {
                historicalGraph.resetZoom();
            }
        };


        $scope.$watch('vm.selectedSensors.historicalChart', function() {
            // Refresh historical chart
            refreshHistoricalChart();
        });

/**************************************************End Historical*******************************************************/
        const getEnableRealTimeMeasurementData = function(username) {
            let deferred = $q.defer();
        	UserSettingsService.settings.getUserSetting( {companyId: vm.companyId, username: username, userSettingType: 'enableRealTimeMeasurementData'}, function(res) {
                if(res !== null)  {
                    vm.realTimeDataEnabled = res.val === '1';
                }
                else  {
                    $log.debug("Empty enableRealTimeMeasurementData.  Defaulting to ").concat(env.enableRealTimeMeasurementData);
                    vm.realTimeDataEnabled = env.enableRealTimeMeasurementData;     
                }
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.debug("Cannot get enableRealTimeMeasurementData.  Defaulting to ".concat(env.enableRealTimeMeasurementData).concat(": ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));   
                vm.realTimeDataEnabled = env.enableRealTimeMeasurementData;  
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getEnableSnapshotMeasurementData = function(username) {
            let deferred = $q.defer();
        	UserSettingsService.settings.getUserSetting( {companyId: vm.companyId, username: username, userSettingType: 'enableSnapshotMeasurementData'}, function(res) {
                if(res !== null)  {
                    vm.snapshotDataEnabled = res.val === '1';
                }
                else  {
                    $log.debug("Empty enableSnapshotMeasurementData.  Defaulting to ").concat(env.enableSnapshotMeasurementData);
                    vm.snapshotDataEnabled = env.enableSnapshotMeasurementData;     
                }
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.debug("Cannot get enableSnapshotMeasurementData.  Defaulting to ".concat(env.enableSnapshotMeasurementData).concat(": ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));   
                vm.snapshotDataEnabled = env.enableSnapshotMeasurementData;  
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getEnableHistoricalMeasurementData = function(username) {
            let deferred = $q.defer();
        	UserSettingsService.settings.getUserSetting( {companyId: vm.companyId, username: username, userSettingType: 'enableHistoricalMeasurementData'}, function(res) {
                if(res !== null)  {
                    vm.historicalDataEnabled = res.val === '1';
                }
                else  {
                    $log.debug("Empty enableHistoricalMeasurementData.  Defaulting to ").concat(env.enableHistoricalMeasurementData);
                    vm.historicalDataEnabled = env.enableHistoricalMeasurementData;     
                }
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.debug("Cannot get enableHistoricalMeasurementData.  Defaulting to ".concat(env.enableHistoricalMeasurementData).concat(": ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));   
                vm.historicalDataEnabled = env.enableHistoricalMeasurementData;  
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        
        // Initialization
        const init = function()  {
            if(!isInit)  {
                $log.info("Initializing Measurement Data");
                const companyInfo = LumiService.companyInfo();
                vm.companyId = companyInfo ? companyInfo.companyId : null;

                const userInfo = AuthService.userInfo();
                if(userInfo)  {
                    $q.all([
                        getEnableRealTimeMeasurementData(userInfo.username),
                        getEnableSnapshotMeasurementData(userInfo.username),
                        getEnableHistoricalMeasurementData(userInfo.username)
                    ]).then(function(res) {
                        UserSettingsService.settings.getUserSetting({ companyId: vm.companyId, username: userInfo.username, userSettingType: 'Display Time Zone' }, function(res2) {
                            if(res2 && res2.val)  {
                                displayTZ = res2.val;
                            }
                            else  {
                                $log.debug("Empty display time zone.  Defaulting to ").concat(displayTZ);    
                            }
                        }, function(err)  {
                            const errData = err.data;
        
                            $log.debug("An error has occurred getting display time zone.  Defaulting to ".concat(displayTZ).concat(": ")
                                .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));    
                        }).$promise.finally(function()  {
                            // Override with display timezone from session storage if applicable
                            const displayTZOverride = UtilService.getDisplayTZOverride();
                            if(displayTZOverride)  {
                                displayTZ = displayTZOverride;
                            }
                            moment.tz.setDefault(displayTZ);
    
                            isInit = true;
    
                            getChannels();
                            setChartTitles();
                            getScaleSettings();
    
                            if(vm.historicalDataEnabled)  {
                                initHistoricalDataTab();
                            }
                        });
                    });
                }
            }
        };



        init();

        $scope.$on('chart-create', function (event, chart) {
            const c = chart.options.title.text;
            if(c === 'historical')  {
                historicalGraph = chart;
            }
            else  {
                snapshotGraphs[c] = chart;
            }
        });

        $scope.$on('chart-destroy', function (event, chart) {
            const c = chart.options.title.text;
            if(c === 'historical')  {
                historicalGraph = null;
            }
            else  {
                snapshotGraphs[c] = null;
            }
        });

        

        $scope.$on('$destroy', function() {
            $log.debug("MeasurementCtrl scope destroyed. Stopping polling tasks...");
            cancelRealtimePolling();
            cancelSnapshotPolling();

            $log.debug("MeasurementCtrl scope destroyed. Clearing master...");
            MeasurementData.clearMaster('realtime');
            MeasurementData.clearMaster('snapshot');

            Object.keys(snapshotGraphs).forEach(c => {
                if(snapshotGraphs[c])  {
                    snapshotGraphs[c] = null;
                }
            });

            if(historicalGraph)  {
                historicalGraph = null;
            }

            isAlive = false;
        });
    }

})();

/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-06-12
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.data')
        .directive('measurementRealtimeChart', measurementRealtimeChart);

    /** @ngInject */
    function measurementRealtimeChart($log) {
        return {
            restrict: 'E',
            template: '<canvas></canvas>',
            replace: true,
            scope: {
                chartOptions: '<',
                width: '@width',
                height: '@height'
            },

            link: function(scope, element, attrs) {
                let canvas = element[0];
                let ctx = canvas.getContext('2d');

                canvas.height = scope.height;
                canvas.width = scope.width;

                // TODO: Control legend display based on screen size
                // $(document).ready(function() {
                //     var $window = $(window);
                //
                //     function checkWidth() {
                //         const windowsize = $window.width();
                //         if (windowsize < 690) {
                //             realtimeChart.options.legend.display = false;
                //             $log.info('Window size less than ' + scope.chartOptions.legend.display);
                //         }
                //         else {
                //             realtimeChart.options.legend.display = true;
                //             $log.log('Window size larger than ' + scope.chartOptions.legend.display)
                //         }
                //
                //         realtimeChart.update();
                //     }
                //
                //     // Execute on load
                //     checkWidth();
                //     // Bind event listener on page resizing
                //     $(window).resize(checkWidth);
                // });

                let realtimeChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        datasets: []
                    },
                    options: scope.chartOptions
                });

                element.on('$destroy', function(){
                    $log.debug("Real-time measurement chart element destroyed");
                    if(realtimeChart)  {
                        $log.debug("Destroying real-time chart object...");
                        realtimeChart.clear();
                        realtimeChart.destroy();
                    }
                    canvas.remove();
                });
            },
        };
    }
})();
/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-12-14
 */
(function () {
    'use strict';
    angular.module('AomsLumi.pages.data')
        .controller('WavelengthCtrl', WavelengthCtrl);


    /** @ngInject */
    function WavelengthCtrl($log, $q, $mdDialog, moment, LumiService, AdminService, ChannelService, WavelengthData) {
        let vm = this;
        vm.tenant = LumiService.getTenant();

        // For now, only tick data granularity is made available for wavelength
        vm.dataGranularities = [
            {
                "id": 1,
                "name": "tick"
            }
        ];

        vm.selectedSensorsMessages = null;
        vm.selectedSensors = null;

        vm.historicalFromMin = null;
        vm.historicalFromMax = null;
        vm.historicalToMin = null;
        vm.historicalToMax = null;

        vm.historicalFrom = null;
        vm.historicalTo = null;

        let alert;


        const getSensorTypes = function() {
            $log.info("Getting sensor types (".concat('wavelength').concat(")"));
            ChannelService.sensors.types(function(res) {
                vm.sensortypes = res;
            }, function(err)  {
                const errData = err.data;

                $log.error("An error has occurred getting sensor types (".concat('wavelength').concat("): ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
            });
        };

        const getFileTypes = function() {
            $log.info("Getting file types (".concat('wavelength').concat(")"));
            AdminService.filetypes.query(function(res) {
                vm.filetypes = res;
            }, function(err)  {
                const errData = err.data;

                $log.error("An error has occurred getting file types (".concat('wavelength').concat("): ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
            });
        };

        const getSensorsBySensorType = function(sensorTypeName) {
            $log.info("Getting sensors by ".concat(sensorTypeName).concat(" sensor type"));
            let deferred = $q.defer();

            ChannelService.sensors.sensorsBySensorType({ tenant: vm.tenant, sensorTypeName: sensorTypeName }, function(res) {
                deferred.resolve(res.sensorMessages);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting sensors by ".concat(sensorTypeName).concat("sensor type: ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.reject(err);
            });
            return deferred.promise;
        };

        const clearTimeRanges = function()  {
            vm.historicalFrom = null;
            vm.historicalTo = null;

            vm.historicalFromMin = null;
            vm.historicalFromMax = null;
            vm.historicalToMin = null;
            vm.historicalToMax = null;
        };


        vm.onSensorsSelected = function()  {
            vm.selectedSensors = vm.selectedSensorsMessages.map(m => {
                return {
                    channelId: m.channelId,
                    sensorId: m.sensorId,
                    sensorType: m.sensorType
                };
            });

            if(vm.selectedSensors.length === 0)  {
                vm.dataGranularity = null;
                clearTimeRanges();
            }

            $log.info("Sensors selected (".concat('wavelength').concat(")").concat(": ")
                .concat(JSON.stringify(vm.selectedSensors)));
        };

        const clearSelectedSensors = function()  {
            vm.selectedSensorsMessages = null;
            vm.selectedSensors = null;
        };

        vm.historicalSensorsGroupBy = function(sensorMessage){
            return sensorMessage ? "Channel ".concat(sensorMessage.channelId) : "NULL";
        };

        vm.onHistoricalSensorTypeSelected = function()  {
            $log.info(vm.sensortype.name + " sensor type selected.  Getting sensors.");

            // Clear sensors
            vm.sensors = null;

            clearSelectedSensors();

            // Clear data granularity
            vm.dataGranularity = null;

            // Clear time ranges
            clearTimeRanges();

            // Clear file type
            vm.filetype = null;

            // Get sensors by sensor type
            getSensorsBySensorType(vm.sensortype.name).then(function(resSensorMessages){
                vm.sensors = resSensorMessages;
            }).catch(function()  {
                showAlert("Error", "An error has occurred getting Sensors");
                $log.error("Done getting sensors by sensor type (".concat('wavelength').concat(")").concat(" with error"));
            });
        };

        vm.onHistoricalDataGranularitySelected = function()  {
            $log.debug(vm.dataGranularity.name +  " granularity selected (".concat('wavelength').concat(")"));
            clearTimeRanges();
        };

        vm.onHistoricalTimeRangeChanged = function() {
            $log.debug("New historical time range:  from ".concat(vm.historicalFrom ? vm.historicalFrom : 'null')
                .concat(" to ").concat(vm.historicalTo ? vm.historicalTo : 'null'));

            if(vm.dataGranularity)  {
                const granularity = vm.dataGranularity.name;
                if(vm.historicalFrom)  {
                    switch(granularity)  {
                        case 'tick':
                            vm.historicalToMin = vm.historicalFrom;
                            vm.historicalToMax = moment(vm.historicalFrom).add(6, 'hours');
                            break;
                        default:
                            break;
                    }
                }

                if (vm.historicalTo)  {
                    switch(granularity)  {
                        case 'tick':
                            vm.historicalFromMin = moment(vm.historicalTo).subtract(6, 'hours');
                            vm.historicalFromMax = vm.historicalTo;
                            break;
                        default:
                            break;
                    }
                }
            }
        };

        vm.onDeleteHistoricalTimeRange = function(isHistoricalFrom)  {
            if(isHistoricalFrom)  {
                clearTimeRanges();
            }
            else  {
                vm.historicalTo = null;
                vm.historicalFromMin = null;
                vm.historicalFromMax = null;
            }
        };


        vm.onHistoricalFileTypeSelected = function() {
            $log.debug(vm.filetype.name + " file type selected for historical download");
        };


        vm.hasHistoricalDownloadInputs = function()  {
            return vm.selectedSensors && vm.selectedSensors.length > 0 &&
                vm.dataGranularity && vm.historicalFrom && vm.historicalTo;
        };


        vm.getHistoricalDataFileLink = function()  {
            try  {
                const sensorTypeName = vm.sensortype.name;
                const fileTypeName = vm.filetype.name;
                $log.info("Creating link to get historical wavelength ".concat(sensorTypeName.toLowerCase())
                    .concat(" data file in ").concat(fileTypeName).concat(" format"));

                const res = WavelengthData.getHistoricalDataFileLink(vm.tenant, vm.selectedSensors, sensorTypeName,
                    moment(vm.historicalFrom), moment(vm.historicalTo), fileTypeName, "ASC", null);
                $log.debug("Done getting historical data file link: ".concat(res));

                return res;
            }
            catch(err)  {
                showAlert("Error", "An error has occurred getting Historical Data File Link");
                $log.error("Done getting historical data file link with error: ".concat(err));
                return "";
            }
        };



        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: true,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        // Initialization
        getSensorTypes();
        getFileTypes();
    }

})();
/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-06-19
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.diagnostics')
        .controller('ChannelDiagnosticsCtrl', ChannelDiagnosticsCtrl);
    
    /** @ngInject */
    function ChannelDiagnosticsCtrl($scope, $state, $log, $q, $mdDialog, $timeout, toastr, 
        LumiService, InternalSettingsService, ChannelData, ChannelService) {
        let vm = this;
        vm.tenant = LumiService.getTenant();
        vm.isLoading = true;

        vm.chDiagTimeout = null;
        vm.diagnosticsStarted = false;

        vm.isSelectingCalibrationFile = false;
        vm.isExecutingSensorsCalibration = false;

        vm.extensionCableLength = 0;
        vm.sensorsCalibrationFile = null;

        vm.sensors = null;

        const sensorConfigurationFileRegex = /^CAL_(MTS|LPS|MHS)-.*.cfg$/;

        let globalInit = null;

        let newSensorsCalibration = false;

        let channelHealthsPollingPromise = null;
        let channelHealthsPollingInterval = 2500;
        let channelHealthsPollingErrors = 0;

        let toPollSensorHealths = false;

        let alert;

        vm.isInit = false;

        let isAlive = true;


        vm.diagnosticsStateChanged = function()  {
            cancelChannelHealthsNextLoad();
            vm.isLoading = true;

            if(vm.diagnosticsStarted)  {
                $log.info("Stop diagnostics");

                // Deactivate diagnostic channel and decomissioned all diagnostic sensors 
                refresh(false);
                vm.filterSensor = null;
                toPollSensorHealths = false;
                vm.sensors = null;
                vm.diagnosticsStarted = false;
            }
            else  {
                $log.info("Start diagnostics");
                
                // Assign channel settings
                if(vm.newChannelSettings)  {
                    assignNewChannelSettings().then(function(res1)  {
                        if(res1)  {
                            if(newSensorsCalibration)  {
                                // Create sensors and assign calibratons
                                createNewSensors().then(function(res2)  {
                                    if(res2)  {
                                        startDiagnosticsHelper(true);
                                    }
                                    else  {
                                        vm.isLoading = false;
                                        showAlert("Error", "Cannot start Channel Diagnostics due to a failure to create sensors and assign calibrations");
                                    }
                                })
                            }
                            else  {
                                startDiagnosticsHelper(false);
                            }
                        }
                        else  {
                            vm.isLoading = false;
                            showAlert("Error", "Cannot start Channel Diagnostics due to a failure to assign Extension Cable Length");
                        }
                    });
                }
                else  {
                    // Should not happen.  Empty Channel Settings request.
                    vm.isLoading = false;
                    showAlert("Error", "Cannot start Channel Diagnostics due to empty Extension Cable Length");  
                }
            }
        };

        vm.pollChannelHealths = function()  {
            $q.all([
                getChannelHealths(),
                getSensorHealths()
            ]).then(function(res) {
                // Disable polling for now
                if(!res[0] || !res[1])  {
                    channelHealthsNextLoad(++channelHealthsPollingErrors * 2 * channelHealthsPollingInterval);
                }
                else  {
                    channelHealthsPollingErrors = 0;
                    channelHealthsNextLoad();
                }
            });
        };

        vm.onChDiagTimeout = function()  {
            if(globalInit !== null)  {
                if(globalInit)  {
                    $state.go('main.dashboard');
                    showAlert("Info", "Channel Diagnostics Mode has timed out.  You have been redirected to the Main page.");
                }
                else  {
                    $state.go('main.advanced.channelmanagement');
                    //showAlert("Info", "Channel Diagnostics Mode has timed out.  You have been redirected to the Channel Management Wizard.");
                }
            }
        };


        vm.onChannelSelected = function()  {
            vm.isLoading = true;
            vm.extensionCableLength = 0;
            vm.newChannelSettings = {
                channelId: vm.channel.channelId,
                isDiagnostic: true,
                channelSettingsData: {
                    LENGTH: vm.extensionCableLength
                }
            };
            resetSensorsCalibrationFile();

            // Deactivate all diagnostic channels and decommission all diagnostic sensors
            refresh(false);
        };

        vm.onExtensionCableLengthChanged = function() {
            $log.info("Extension cable length changed");
            if(!vm.extensionCableLength)  {
                vm.extensionCableLength = 0;
            }
            vm.newChannelSettings.channelSettingsData.LENGTH = vm.extensionCableLength;
        };

        vm.onSensorsCalibrationFileChanged = function() {
            vm.isSelectingCalibrationFile = true;
            if(vm.sensorsCalibrationFile)  {
                $log.info("Diagnostic sensors calibration file changed");

                // Valid sensors calibration file must match the sensor calibration file regex
                const match = vm.sensorsCalibrationFile.name.match(sensorConfigurationFileRegex);
                if(match)  {
                    const calibrationFileType = match[1];
                    const channelId = vm.channel.channelId;
                    
                    ChannelData.createSensorsCalibrationData(channelId, null, calibrationFileType, 0, vm.sensorsCalibrationFile)
                    .then(function(res) {
                        if(res)  {
                            if(res.status === 'Valid')  {
                                const calibrationFileTypes = ChannelData.getCalibrationFileTypes();
                                const calibrationFileType = res.calibrationFileType;
                                switch(calibrationFileType)  {
                                    case calibrationFileTypes.calibrationMTS:
                                        vm.calibrationMTSRequests = {
                                            channelId: channelId,
                                            isDiagnostic: true,
                                            calibrationMTSData: res.data
                                        };
                                        $log.info("New diagnostic calibration MTS requests created: " + JSON.stringify(vm.calibrationMTSRequests));
                                        newSensorsCalibration = true;
                                        vm.isSelectingCalibrationFile = false;
                                        return;
                                    case calibrationFileTypes.calibrationLPS:
                                    case calibrationFileTypes.calibrationMHS:
                                    default:
                                        showAlert("Error", "An error has occurred processing Diagnostic Sensors Calibration File.  Unsupported File.");
                                        resetSensorsCalibrationFile();
                                        break;
                                }
                            }
                            else  {
                                showAlert("Error", res.status === 'Error' ? "An error has occurred processing Diagnostic Sensors Calibration File" :
                                    "An error has occurred processing Diagnostic Sensors Calibration File.  " + res.status + " File.");
                                resetSensorsCalibrationFile();
                            }
                        }
                        else  {
                            // Should not happen
                            showAlert("Error", "An unexpected error has occurred processing Diagnostic Sensors Calibration File");
                            $log.error("An unexpected error has occurred processing diagnostic sensors calibration file");
                            resetSensorsCalibrationFile();
                        }
                    }, function(err) {
                        showAlert("Error", "An unexpected error has occurred processing Diagnostic Sensors Calibration File");
                        $log.error("An unexpected error has occurred processing diagnostic sensors calibration file: ".concat(JSON.stringify(err)));
                        resetSensorsCalibrationFile();
                    });
                    
                }
                else  {
                    showAlert("Error", "An invalid Diagnostic Sensors Calibration File has been selected");
                    resetSensorsCalibrationFile();
                }
            }
            else  {
                //showAlert("Error", "Diagnostic Sensors Calibration File is undefined");
                //$log.error("Diagnostic Sensors calibration file is undefined");
                resetSensorsCalibrationFile();
            }
        };

        vm.removeCalibrationFile = function()  {
            resetSensorsCalibrationFile();
        };


        vm.getHealthColor = function(health)  {
            if(health)  {
                if (health === 'HEALTHY')  {
                    return { color: '#009fe3' };
                }
                else if (health === 'NONE')  {
                    return { color: '#616161' };
                }
                else  {
                    return { color: '#d32f2f' };
                }
            }
        };


        const startDiagnosticsHelper = function(pollSensors)  {
            toggleDiagnosticChannel(true).then(function(res3)  {
                if(res3)  {
                    toPollSensorHealths = pollSensors;

                    vm.diagnosticsStarted = true;
                    vm.pollChannelHealths();
                    
                    vm.isLoading = false;
                    toastr.success("Channel Diagnostics has been started successfully for Diagnostic Channel " + vm.channel.channelId);
                }
                else  {
                    vm.isLoading = false;
                    showAlert("Error", "Cannot start Channel Diagnostics due to a failure to activate Diagnostic Channel " + vm.channel.channelId);
                }
            });
        };


        const resetSensorsCalibrationFile = function()  {
            $log.info("Resetting Diagnostic Sensors Calibrations states");
            if(vm.sensorsCalibrationFile)  vm.sensorsCalibrationFile = null;
            if(vm.calibrationMTSRequests)  vm.calibrationMTSRequests = undefined;

            newSensorsCalibration = false;
            vm.isSelectingCalibrationFile = false;
        };


        const toggleIsChDiag = function(isChDiag)  {
            $log.info("Toggling FLAG_IS_CH_DIAG internal setting: " + isChDiag);
            let deferred = $q.defer();
            
            InternalSettingsService.settings.updateByKey({tenant: vm.tenant, key: 'FLAG_IS_CH_DIAG'}, {
                val: isChDiag ? '1' : '0',
            }, function(res) {
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred toggling FLAG_IS_CH_DIAG internal setting: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };


        const refresh = function(updateChannels)  {
            $q.all([
                deactivateAllDiagnosticChannels(),
                decommissionAllDiagnosticSensors()
            ]).then(function(res) {
                if(!res[0] || !res[1])  {
                    vm.isLoading = false;
                    if(!res[0])  {
                        showAlert("Error", "An error has occurred dactivating all Diagnostic Channels");
                    }
                    else if(!res[1])  {
                        showAlert("Error", "An error has occurred decommissioning all Diagnostic Sensors");
                    }
                }
                else  {
                    if(updateChannels)  {
                        // Get all Diagnostic Channels
                        getDiagnosticChannels().then(function(res)   {
                            if(!res)  {
                                showAlert("Error", "An error has occurred getting all Diagnostic Channels");
                            }
                            vm.isLoading = false;
                        });
                    }
                    else  {
                        vm.isLoading = false;
                    }
                }
            });
        };


        const getGlobalInit = function()  {
            let deferred = $q.defer();
            InternalSettingsService.settings.get({ tenant: vm.tenant, key: "FLAG_IS_INIT" }, function(res)  {
                globalInit = res && res === 1;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting FLAG_IS_INIT internal setting during the initialization of the Channel Diagnostics Tool: "
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getChannelDiagnosticsTimeout = function()  {
            let deferred = $q.defer();
            InternalSettingsService.settings.get({ tenant: vm.tenant, key: "CH_DIAG_TIMEOUT" }, function(res)  {
                vm.chDiagTimeout = parseInt(res.val);
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting CH_DIAG_TIMEOUT internal setting during the initialization of the Channel Diagnostics Tool: "
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };


        const getDiagnosticChannels = function () {
            $log.info("Getting diagnostic channels");
            let deferred = $q.defer();

            ChannelService.diagnosticChannels.query({ tenant: vm.tenant }, function(res) {
                vm.channels = res.channelMessages;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting diagnostic channels: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);    
            });
            return deferred.promise;
        };

        const toggleDiagnosticChannel = function(isActive)  {
            $log.info("Toggling diagnostic channel: " + isActive);
            let deferred = $q.defer();

            if(vm.channel)  {
                ChannelService.diagnosticChannels.toggle({ tenant: vm.tenant }, {
                    channelId: vm.channel.channelId,
                    isActive: isActive
                }, function(res) {
                    $log.info("Diagnostic channel has been toggled successfully");
                    deferred.resolve(true);
                }, function(err)  {
                    const errData = err.data;
                    $log.error("An error has occurred toggling Diagnostic Channel ".concat(vm.channelId)
                        .concat(": ").concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                    deferred.resolve(false); 
                });
            }
            else  {
                $log.error("Cannot toggle empty diagnostic channel");
                deferred.resolve(false);  
            }
            return deferred.promise;
        };


        const deactivateAllDiagnosticChannels = function()  {
            $log.info("Deactivate all diagnostic channels");
            let deferred = $q.defer();

            ChannelService.diagnosticChannels.deactivateAll({ tenant: vm.tenant }, function(res) {
                $log.info("Diagnostic channels have been deactivated successfully");
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred deactivating all diagnostic channels: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);    
            });
            return deferred.promise;
        };

        const decommissionAllDiagnosticSensors = function()  {
            $log.info("Decommissioning all diagnostic sensors");
            let deferred = $q.defer();

            ChannelService.diagnosticSensors.decommissionAll({ tenant: vm.tenant }, function(res) {
                $log.info("Diagnostic sensors have been decommissioned successfully");
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred decommissioning all diagnostic sensors: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);    
            });
            return deferred.promise;
        };

        const assignNewChannelSettings = function()  {
            $log.info("Assigning new diagnostic channel settings");
            let deferred = $q.defer();

            ChannelService.settings.update({ tenant: vm.tenant }, vm.newChannelSettings, function(res) {
                $log.info("Channel Settings have been assigned successfully");
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred assigning diagnostic channel settings: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                deferred.resolve(false);  
            });
            return deferred.promise;
        };

        const createNewSensors = function()  {
            $log.info("Creating new sensors");
            let deferred = $q.defer();
            let newTemperatureSensors = [];

            if(vm.calibrationMTSRequests)  {
                const calibrationMTSData = vm.calibrationMTSRequests.calibrationMTSData;
                if(calibrationMTSData)  {
                    for(let j=0; j<calibrationMTSData.length; j++)  {
                        newTemperatureSensors.push({
                            channelId: vm.calibrationMTSRequests.channelId,
                            sensorId: calibrationMTSData[j].sensorId,
                            sensorType: 'Temperature',
                            isActive: false,
                            isDiagnostic: true
                        });
                    }

                    if(newTemperatureSensors.length > 0)  {
                        ChannelService.sensors.createSensors({ tenant: vm.tenant }, newTemperatureSensors, function(res1) {
                            $log.info(res1.total + " new sensors have been created successfully");        
                            createNewCalibrationMTS().then(function(res2)  {
                                if(res2)  {
                                    deferred.resolve(true);
                                }
                                else  {
                                    deferred.resolve(false);
                                }
                            });
                        }, function(err)  {
                            const errData = err.data;
                            $log.error("An error has occurred creating sensors: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                            deferred.resolve(false);
                        });
                    }
                    else  {
                        // Should not happen.  Empty new sensor requests.
                        $log.error("An error has occurred creating sensors: Failed to create new sensor requests");
                        deferred.resolve(false);
                    }
                }
                else  {
                    // Empty calibration MTS data
                    deferred.resolve([]);
                }
            }
            else  {
                // Should not happen.  Empty calibraton MTS requests.
                $log.error("An error has occurred creating sensors: Empty calibration MTS requests");
                deferred.resolve(false);
            }
            return deferred.promise;
        };

        const createNewCalibrationMTS = function()  {
            $log.info("Creating and assigning new calibration MTS");
            let deferred = $q.defer();
            if(vm.calibrationMTSRequests)  {
                ChannelService.sensors.updateMTSList({ tenant: vm.tenant }, vm.calibrationMTSRequests, function(res) {
                    $log.info("Calibration MTS have been created and assigned successfully");
                    deferred.resolve(true);
                }, function(err)  {
                    const errData = err.data;
                    $log.error("An error has occurred creating and assigning calibration MTS: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                    deferred.resolve(false);
                });
            }
            else  {
                // Should not happen.  Empty calibraton MTS requests.
                $log.error("An error has occurred creating and assigning calibration MTS: Empty calibration MTS requests");
                deferred.resolve(false);
            }
            return deferred.promise;
        };


        const getChannelHealths = function()  {
            $log.debug("Getting channel health");
            let deferred = $q.defer();
            ChannelService.diagnosticChannels.getHealth({ tenant: vm.tenant, channelId: vm.channel.channelId }, function(res) {
                vm.channelHealth = res.health;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting channel health: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getSensorHealths = function()  {
            $log.debug("Getting sensor healths");
            let deferred = $q.defer();
            if(toPollSensorHealths)  {
                ChannelService.diagnosticSensors.getHealthsByChannelId({ tenant: vm.tenant, channelId: vm.channel.channelId }, function(res) {
                    vm.sensors = res.sensorMessages;
                    vm.displayedDiagnosticSensors = [].concat(vm.sensors);

                    deferred.resolve(true);
                }, function(err)  {
                    const errData = err.data;
                    $log.error("An error has occurred getting sensor healths: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
    
                    deferred.resolve(false);
                });
            }
            else  {
                deferred.resolve(true);
            }
            return deferred.promise;
        };


        const cancelChannelHealthsNextLoad = function()  {
            $timeout.cancel(channelHealthsPollingPromise);
        };

        const channelHealthsNextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || channelHealthsPollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelChannelHealthsNextLoad();

            if(isAlive)  {
                $log.debug("Poll channel and sensor healths with delay: ".concat(pollingDelay).concat( " milliseconds"));
                channelHealthsPollingPromise = $timeout(vm.pollChannelHealths, pollingDelay);
            }
        };
        


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                multiple: true,
                clickOutsideToClose: false,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };

        const init = function()  {
            if(!vm.isInit)  {
                $log.info("Initializing Channel Diagnostics tool");
                vm.isLoading = true;
                toggleIsChDiag(true).then(function(res1)  {
                    if(res1)  {
                        $q.all([
                            getGlobalInit(),
                            getChannelDiagnosticsTimeout()
                        ]).then(function(res2) {
                            // Disable polling for now
                            if(!res2[0] || !res2[1])  {
                                showAlert("Error", "Failed to initialize Channel Diagnostics Tool");
                            }
                            else  {
                                refresh(true);
                                vm.isInit = true;
                            }
                        });   
                    }
                    else  {
                        showAlert("Error", "Failed to initialize Channel Diagnostics Tool");
                    }
                });
            }
        };



        init();



        $scope.$on('$destroy', function() {
            $log.debug("ChannelDiagnosticsCtrl scope destroyed. Stopping polling tasks...");
            cancelChannelHealthsNextLoad();

            // Set FLAG_IS_CH_DIAG to 0, deactivate diagnostic channels, and decommission all diagnostic sensors
            toggleIsChDiag(false).then(function(res)  {
                if(!res)  {
                    showAlert("Error", "Failed to deactivate Channel Diagnostics mode");
                }
                refresh(false);
            });
            
            isAlive = false;
        });
    }
})();

/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-06-19
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.diagnostics')
        .controller('EventsCtrl', EventsCtrl);
    
    /** @ngInject */
    function EventsCtrl($log, $mdDialog, toastr, 
        LumiService, AuthService, UserSettingsService, UtilService, EventService) {
        let vm = this;
        vm.tenant = LumiService.getTenant();
        vm.isLoading = true;

        vm.dataTotal = 0;
        vm.dataRpp = 20;

        vm.severity = "ALL";

        let alert;

        let isInit = false;
        let displayTZ = env.defaultTZ;    

        const getEventSeverities = function () {
            $log.info("Getting all event severities");

        	EventService.eventSeverities.query(function(res) {
        		vm.severities = res.map(function(s)  {
                	return s.name;
				});
                vm.severities.unshift("ALL");
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting event severities: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            }).$promise.finally(function()  {
                vm.isLoading = false;
            });
        };

        vm.serverPipe = function(tableState) {
            vm.isLoading = true;
            vm.tableState = tableState;
            
            let params = {
                tenant: vm.tenant,
                page: tableState.pagination.start ?  tableState.pagination.start/vm.dataRpp : 0,
                rpp: vm.dataRpp,
                sortdir: (typeof tableState.sort.reverse !== 'undefined') ? (tableState.sort.reverse ? 'DESC' : 'ASC') : 'DESC',
            };

        	if(vm.severity !== "ALL")  {
                params.severityNameFilter = vm.severity;
            }

            $log.info("Getting events by severity");
            EventService.eventBySeverity.query(params, function(data) {
                vm.eventsData = data.eventMessages.map(e => { 
                    e.timestamp = UtilService.convertUTCTimestamp(e.timestamp, displayTZ);
                    return e; 
                });
                vm.displayedEventsData = [].concat(vm.eventsData);

                vm.dataRpp = data.rpp;
                vm.dataTotal = data.total;

                vm.tableState.pagination.number = vm.dataRpp;
                vm.tableState.pagination.totalItemCount = vm.dataTotal;
                vm.tableState.pagination.numberOfPages = Math.ceil(vm.dataTotal / vm.dataRpp);
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred getting Events"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred getting events by severity: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            }).$promise.finally(function()  {
                vm.isLoading = false;
            });
        };

        vm.refreshServerPipe = function() {
            vm.serverPipe(vm.tableState);
        }

        vm.onSeveritySelected = function() {
            vm.tableState.pagination = { start: 0 };
            vm.serverPipe(vm.tableState);
        };


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: false,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };

        const init = function()  {
            if(!isInit)  {
                $log.info("Initializing Events page");
                const companyInfo = LumiService.companyInfo();
                const companyId = companyInfo ? companyInfo.companyId : null;

                const userInfo = AuthService.userInfo();
                if(userInfo)  {
                    UserSettingsService.settings.getUserSetting({ companyId: companyId, username: userInfo.username, userSettingType: 'Display Time Zone' }, function(res) {
                        if(res && res.val)  {
                            displayTZ = res.val;
                        }
                        else  {
                            $log.debug("Empty display time zone.  Defaulting to ").concat(displayTZ);    
                        }
                    }, function(err)  {
                        const errData = err.data;
    
                        $log.debug("An error has occurred getting display time zone.  Defaulting to ".concat(displayTZ).concat(": ")
                            .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));    
                    }).$promise.finally(function()  {
                        moment.tz.setDefault(displayTZ);
                        isInit = true;
                        
                        getEventSeverities();
                    });
                }
            }
        };



        init();
    }
})();

/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-06-19
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.lumicon')
        .controller('MaturityCtrl', MaturityCtrl)
        .controller('MaturityStrengthJobGroupCtrl', MaturityStrengthJobGroupCtrl)
        .controller('MaturityStrengthDownloadCtrl', MaturityStrengthDownloadCtrl)
        .controller('MaturityStrengthJobCtrl', MaturityStrengthJobCtrl);
    
    /** @ngInject */
    function MaturityCtrl($log, $q, $mdDialog, toastr, 
        LumiService, AuthService, UserSettingsService, UtilService, 
        ChannelService, ChannelJobService, MaturityStrengthJobService) {
        let vm = this;

        vm.tenant = LumiService.getTenant();
        vm.readOnly = env.readOnly;
        vm.isLoading = true;
        vm.isViewingDetails = false;

        vm.dataTotal = 0;
        vm.dataRpp = 20;

        vm.maturityStrengthJobFilter = {
            channelJobTypeName: 'Maturity & Strength',
            cgId: null,
            companyId: null,
            username: null,
            channelJobVisibilityName: null,
            granularityName: null,
            maturityFunctionTypeName: null,
            maturityStrengthFunctionTypeName: null,
            status: null
        }

        let msjChannelGroups = null;

        let alert;

        let isInit = false;

        let displayTZ = env.defaultTZ;


        vm.serverPipe = function(tableState) {
        	vm.isLoading = true;
        	vm.tableState = tableState;

            let params = {
                tenant: vm.tenant,
                page: tableState.pagination.start ?  tableState.pagination.start/vm.dataRpp : 0,
                rpp: vm.dataRpp,
                sortdir: (typeof tableState.sort.reverse !== 'undefined') ? (tableState.sort.reverse ? 'DESC' : 'ASC') : 'DESC',
            };

            Object.keys(vm.maturityStrengthJobFilter).forEach(function (key) {
                if(vm.maturityStrengthJobFilter[key] === 'ALL')  {
                    vm.maturityStrengthJobFilter[key] = null;
                }
             });

            $log.info("Getting maturity strength jobs");
            MaturityStrengthJobService.maturityStrengthJobs.getPagedList(params, vm.maturityStrengthJobFilter,function(data) {
                vm.maturityStrengthJobs = data.maturityStrengthJobMessages.map(msj => {
                    msj.creationDateMilliseconds = msj.creationDate;
                    msj.creationDate = UtilService.convertUTCTimestamp(msj.creationDate, displayTZ);

                    if(msj.startDate)  {
                        msj.startDateMilliseconds = msj.startDate;
                        msj.startDate = UtilService.convertUTCTimestamp(msj.startDate, displayTZ);
                    }

                    if(msj.terminationDate)  {
                        msj.terminationDateMilliseconds = msj.terminationDate;
                        msj.terminationDate = UtilService.convertUTCTimestamp(msj.terminationDate, displayTZ);
                    }

                    return msj;         
                });

                vm.displayedMaturityStrengthJobs = [].concat(vm.maturityStrengthJobs);
                
                vm.dataRpp = data.rpp;
                vm.dataTotal = data.total;

                vm.tableState.pagination.number = vm.dataRpp;
                vm.tableState.pagination.totalItemCount = vm.dataTotal;
                vm.tableState.pagination.numberOfPages = Math.ceil(vm.dataTotal / vm.dataRpp);
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred getting Maturity Strength Jobs"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred getting maturity strength jobs: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            }).$promise.finally(function()  {
                vm.isLoading = false;
            });
        };

        
        vm.stopMaturityStrengthJob = function(maturityStrengthJobId, channelJobId, maturityStrengthJobStatus)  {
            if(maturityStrengthJobStatus === 'RUNNING')  {
                terminateMaturityStrengthJob(maturityStrengthJobId);
            }
            else  {
                deleteMaturityStrengthJob(maturityStrengthJobId, channelJobId);
            }
        };

        vm.refreshData = function() {
            vm.tableState.pagination = { start: 0 };
            vm.serverPipe(vm.tableState);
        };

        vm.onJobGroupFilterSelected = function(channelJobGroupMessage)  {
            vm.maturityStrengthJobFilter.channelJobGroupId =
                channelJobGroupMessage.name !== 'ALL' ? channelJobGroupMessage.id : null;
             
             if(isInit)  {
                vm.refreshData();
             }
        };

        vm.onCableFilterSelected = function(channelGroupMessage)  {
            vm.maturityStrengthJobFilter.cgId =
             channelGroupMessage.channelGroupId !== 'ALL' ? channelGroupMessage.id : null;
             
             if(isInit)  {
                vm.refreshData();
             }
        };

        vm.getStatusColor = function(status)  {
            if (status === 'RUNNING')  {
                return { color: '#388e3c' };
            }
            else if (status === 'TERMINATED')  {
                return { color: '#616161' };
            }
            else if (status === 'ERROR')  {
                return { color: '#d32f2f' };
            }
            else  {
                return { color: '#009fe3' };
            }
        }


        const getChannelJobStatusTypes = function () {
            $log.info("Getting all channel job statuses");
            let deferred = $q.defer();
        	ChannelJobService.channelJobStatusTypes.query(function(res) {
        		vm.channelJobStatusTypes = res.map(function(t)  {
                	return t.name;
				});
                vm.channelJobStatusTypes.unshift("ALL");

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting channel job statsues: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getChannelJobGroups = function () {
            $log.info("Getting all channel job groups");
            let deferred = $q.defer();
        	ChannelJobService.channelJobGroups.query({ tenant: vm.tenant }, function(res) {
                vm.jobGroups = res;
                vm.jobGroups.unshift( { name: "ALL" } );

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting channel job groups: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        }

        const getChannelGroups = function () {
            $log.info("Getting all channel groups of Cable type");
            let deferred = $q.defer();
        	ChannelService.channelGroups.getChannelGroupsByType({ tenant: vm.tenant, channelGroupTypeName: 'Cable' }, function(res) {
                msjChannelGroups = JSON.parse(JSON.stringify(res.channelGroupMessages));
                vm.channelGroups = res.channelGroupMessages.filter((e, i) => res.channelGroupMessages.findIndex(a => a.channelGroupId === e.channelGroupId) === i);
                vm.channelGroups.unshift( { channelGroupId: "ALL" } );
                
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting channel groups of cable type: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const terminateMaturityStrengthJob = function(maturityStrengthJobId)  {
            let confirm = $mdDialog.confirm()
            .title("Confirmation")
            .textContent("Are you sure you want to terminate Maturity Strength Job " + maturityStrengthJobId + "?")
            .targetEvent(event)
            .multiple(true)
            .ok('Yes')
            .cancel('No');

            $mdDialog.show(confirm).then(function() {
                $log.info("Terminate Maturity Strength Job ".concat(maturityStrengthJobId));
            
                MaturityStrengthJobService.maturityStrengthJobs.terminate({ tenant: vm.tenant }, { id: maturityStrengthJobId }, function(res) {                
                    $log.info("Maturity strength job " + maturityStrengthJobId + " has been terminated successfully");
                    toastr.success("Maturity Strength Job " + maturityStrengthJobId + " has been terminated successfully!");
                    vm.refreshData();
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred terminating Maturity Strength Job ".concat(maturityStrengthJobId)
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                    $log.error("An error has occurred terminating maturity strength job ".concat(maturityStrengthJobId)
                        .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                });
            });
        };

        const deleteMaturityStrengthJob = function(maturityStrengthJobId, channelJobId)  {
            let confirm = $mdDialog.confirm()
            .title("Confirmation")
            .textContent("Removing Maturity Strength Job will also erase all of its associated data.  Proceed?")
            .targetEvent(event)
            .ok('Yes')
            .cancel('No');

            $mdDialog.show(confirm).then(function() {
                $log.info("Remove Maturity Strength Job ".concat(maturityStrengthJobId));
                
                ChannelJobService.channelJobs.delete({ id: channelJobId, tenant: vm.tenant }, function(res) {
                    $log.info("Maturity strength job " + maturityStrengthJobId + " has been removed successfully");
                    toastr.success("Maturity Strength Job " + maturityStrengthJobId + " has been removed successfully!");
                    if(vm.maturityStrengthJobs)  {
                        vm.maturityStrengthJobs = vm.maturityStrengthJobs.filter(msj => msj.id !== maturityStrengthJobId);
                        vm.displayedMaturityStrengthJobs = [].concat(vm.maturityStrengthJobs);
                    }
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred removing Maturity Strength Job ".concat(maturityStrengthJobId)
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
    
                    $log.error("An error has occurred removing maturity strength job ".concat(maturityStrengthJobId).concat(": ") 
                        .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                });
            });
        };

        const refreshMaturityStrengthJobFilters = function()  {
            $log.info("Refresh maturity strength job filters");
            vm.isLoading = true;
            $q.all([
                getChannelJobStatusTypes(),
                getChannelJobGroups(),
                getChannelGroups(),
            ]).then(function(res) {
                if(!res[0] && !res[1] && !res[2])  {
                    showAlert("Error", "An error has occurred getting Channel Job Status Types, Channel Job Groups, and Channel Groups");
                }
                else if(!res[0])  {
                    showAlert("Error", "An error has occurred getting Channel Job Status Types");
                }
                else if (!res[1])  {
                    showAlert("Error", "An error has occurred getting Channel Job Groups");
                }
                else if (!res[2])  {
                    showAlert("Error", "An error has occurred getting Channel Groups");
                }

                $log.info("Done refresh maturity strength job filters".concat((!res[0] || !res[1] || !res[2]) ? " with error" : ""));
                vm.isLoading = false;
            });
        };

        
        vm.showMaturityStrengthJobGroupModal = function(ev) {
            vm.isViewingDetails = true;
            $mdDialog.show({
                controller: 'MaturityStrengthJobGroupCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/lumicon/maturity/maturityStrengthJobGroupModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                multiple : true,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
            }).then(function(res) {
                if(res)  {
                    $log.info("Channel job group dialog closed upon successful job group creation");
                    toastr.success("Channel Job Group " + res.name + " has been created successfully");
                    getChannelJobGroups();
                }
            }, function(err)  {
                if(err)  {
                    $log.info("Channel job group dialog closed upon error");
                }
            });
        };

        vm.showMaturityStrengthDownloadModal = function(ev, msj) {
            vm.isViewingDetails = true;
            $mdDialog.show({
                controller: 'MaturityStrengthDownloadCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/lumicon/maturity/maturityStrengthDownloadModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                multiple : true,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
                locals: {
                    msj: msj,
                    displayTZ                
                }
            }).then(function() {
                $log.info("Maturity strength download dialog closed upon successful job creation");
                vm.isViewingDetails = false;
            }, function(err)  {
                if(err)  {
                    $log.info("Maturity strength download dialog closed upon error");
                    vm.refreshData();
                }
                vm.isViewingDetails = false;
            });
        };

        vm.showMaturityStrengthJobModal = function(ev, msj) {
            vm.isViewingDetails = true;
            $mdDialog.show({
                controller: 'MaturityStrengthJobCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/lumicon/maturity/maturityStrengthJobModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                multiple : true,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
                locals: {
                    msj: msj,
                    channelGroups: msjChannelGroups,
                    companyId: vm.companyId,
                    username: vm.username,
                    displayTZ                
                }
            }).then(function() {
                $log.info("Maturity strength job dialog closed upon successful job creation");
                vm.refreshData();
                vm.isViewingDetails = false;
            }, function(err)  {
                // Refresh upon server error to ensure we are up-to-date with data
                if(err)  {
                    $log.info("Maturity strength job dialog closed upon error");
                    vm.refreshData();
                }
                vm.isViewingDetails = false;
            });
        };


        
        const init = function()  {
            if(!isInit)  {
                $log.info("Initializing Maturity Strength Jobs page");
                const companyInfo = LumiService.companyInfo();
                vm.companyId = companyInfo ? companyInfo.companyId : null;

                const userInfo = AuthService.userInfo();
                    if(userInfo)  {
                        vm.username = userInfo.username;
                        UserSettingsService.settings.getUserSetting({ companyId: vm.companyId, username: vm.username, userSettingType: 'Display Time Zone' }, function(res) {
                            if(res && res.val)  {
                                displayTZ = res.val;
                            }
                            else  {
                                $log.debug("Empty display time zone.  Defaulting to ").concat(displayTZ);    
                            }
                        }, function(err)  {
                            const errData = err.data;
        
                            $log.debug("An error has occurred getting display time zone.  Defaulting to ".concat(displayTZ).concat(": ")
                                .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));    
                        }).$promise.finally(function()  {
                            moment.tz.setDefault(displayTZ);
                            isInit = true;
                            
                            refreshMaturityStrengthJobFilters();
                        });
                    }
            }
        };



        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: true,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        init();
    }

    function MaturityStrengthJobGroupCtrl($log, $timeout, $mdDialog, toastr, LumiService, ChannelJobService) {
        let vm = this;
        let tenant = LumiService.getTenant();
        vm.jobGroup = {};

        vm.createJobGroup = function() {
            return $timeout(1000)
                .then(function()  {
                    $log.info("Creating Job Group");
                    if(vm.jobGroup)  {
                        ChannelJobService.channelJobGroups.save({ tenant: tenant }, vm.jobGroup, function(res)  {
                            $log.info("Channel Job Group " + res.id + " created");
                            vm.hide();
                        }, function(err)  {
                            const errData = err.data;
                            $log.error("Failed to create Channel Job Group: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                            toastr.error("Failed to create Channel Job Group: ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                        });
                    }
                    else  {
                        // Should not happen
                        toastr.error("An error has occurred creating Job Group (null job group)");
                        vm.cancel();
                    }
                });
        };


        vm.hide = function() {
            $mdDialog.hide(vm.jobGroup);
        };

        vm.cancel = function() {
            $mdDialog.cancel();
        };
    }


    function MaturityStrengthDownloadCtrl($q, $log, $mdDialog, LumiService, MaturityStrengthJobData, MaturityStrengthJobService,
        MaturityStrengthData, MeasurementData, msj,  displayTZ) {
        let vm = this;
        let tenant = LumiService.getTenant();
        const currTimeInMilliseconds = moment().valueOf();

        vm.msj = msj;
        vm.selectedSensors = {};

        vm.fileCats = [
            {
                name: 'meta',
                display: 'Job Metadata',
                fileTypes: ['JSON']
            },
            {
                name: 'temperature',
                display: 'Raw Measurement Temperature ('.concat(vm.msj.granularityName).concat(')'),
                fileTypes: ['CSV', 'JSON']
            },
            {
                name: 'maturity',
                display: 'Maturity & Strength',
                fileTypes: ['CSV', 'JSON', 'XLSX']
            }
        ];


        vm.getDownloadFileLink = function(cat, fileType)  {
            if(vm.msj)  {
                if(cat === 'meta')  {
                    return MaturityStrengthJobData.getJobDetailsFileLink(tenant, vm.msj.id, displayTZ, null);
                }

                if(vm.selectedSensors['Temperature'] && vm.selectedSensors['Temperature'].length > 0)  {
                    if(cat === 'temperature')  {
                        return getMeasurementDataFileLink('Temperature', fileType);
                    }
                    else if(cat === 'maturity')  {
                        return getMaturityDataFileLink(fileType);
                    }
                }
            }
            return "";
        };

        const getMeasurementDataFileLink = function(sensorType, fileType)  {
            try  {
                const granularity = vm.msj.granularityName;
                $log.debug("Creating link to get measurement ".concat(sensorType.toLowerCase())
                    .concat(" data file ").concat("(").concat(granularity).concat(")")
                    .concat(" in ").concat(fileType).concat(" format"));

                const customName = 'Measurement' + sensorType + granularity + '_' + vm.msj.channelJobName + '_' + tenant + '_' + 
                    vm.msj.startDateMilliseconds + '_' + (vm.msj.terminationDateMilliseconds ? vm.msj.terminationDateMilliseconds : currTimeInMilliseconds) +
                    '__' + currTimeInMilliseconds;
                const res = MeasurementData.getHistoricalDataFileLink(tenant, vm.selectedSensors[sensorType], sensorType,
                    moment(vm.msj.startDateMilliseconds), vm.msj.terminationDateMilliseconds ? moment(vm.msj.terminationDateMilliseconds) : currTimeInMilliseconds,
                    fileType, granularity, displayTZ, "ASC", false, customName);
                
                $log.debug("Done getting measurement data file link: ".concat(res));
                return res;
            }
            catch(err)  {
                $log.error("Done getting measurement data file link with error: ".concat(err));
                return "";
            }
        };

        const getMaturityDataFileLink = function(fileType)  {
            try  {
                $log.debug("Creating link to get maturity data file in ".concat(fileType).concat(" format"));
                const res = MaturityStrengthData.getHistoricalDataFileLink(tenant, vm.msj.id,
                    moment(vm.msj.startDateMilliseconds), vm.msj.terminationDateMilliseconds ? moment(vm.msj.terminationDateMilliseconds) : currTimeInMilliseconds,
                    fileType, displayTZ, "ASC", null);
                
                $log.debug("Done getting maturity data file link: ".concat(res));
                return res;
            }
            catch(err)  {
                $log.error("Done getting maturity data file link with error: ".concat(err));
                return "";
            }
        };


        const getMaturityStrengthJobSensors = function(id, sensorType) {
            $log.info("Getting maturity strength job sensors (" + sensorType + ") for maturity strength job " + id);
            let deferred = $q.defer();

            const reqBody = {
                id: id,
                sensorType: sensorType
            };

            MaturityStrengthJobService.maturityStrengthJobs.sensors({ tenant: tenant, allowDecommissioned: true }, reqBody, function(res) {
                vm.selectedSensors[sensorType] = res.sensorMessages.sort((a,b) => {
                    if(a.channelId === b.channelId)  {
                        if(a.sensorId > b.sensorId)  {
                            return 1;
                        }
                        else  {
                            return -1;
                        }
                    }
                    else if(a.channelId > b.channelId)  {
                        return 1;
                    }
                    else  {
                        return -1;
                    }
                });

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting maturity strength job sensors (" + sensorType + ") for maturity strength job ".concat(id)
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };


        vm.hide = function() {
            $mdDialog.hide();
        };

        vm.cancel = function(errData) {
            if(errData)  {
                $mdDialog.cancel(errData);
            }
            else  {
                $mdDialog.cancel();
            }
        };


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: true,
                multiple: true
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };


        getMaturityStrengthJobSensors(vm.msj.id, 'Temperature');
    }

    function MaturityStrengthJobCtrl($scope, $q, $log, $timeout, $mdDialog, $anchorScroll, $location, toastr,
            LumiService, AdminService, GeneralSettingsService, ChannelService, AlarmSettingsService, UtilService,
            ChannelJobService, MaturityStrengthJobService, MaturityStrengthDataService,
            MeasurementDataService, msj, channelGroups, companyId, username, displayTZ) {
        let vm = this;
        let tenant = LumiService.getTenant();

        vm.isCreate = true;

        vm.msj = msj;
        vm.jobGroup = null;
        vm.channelGroups = (vm.isCreate && env.cableType === 'electronic') ? channelGroups.filter(cg => cg.isNodeAssociated) : channelGroups;
        vm.companyId = companyId;
        vm.username = username;
        vm.singularAlarmThreshold = null;

        vm.hasJobDuration = false;

        vm.selectedDataSensor = null;

        const dataCategories = ['temperature', 'humidity', 'maturity'];
        const dataSubCategories = {
            'maturity' : ['maturityIndex', 'strength']
        };

        let masterData = {
            temperature: {},
            humidity: {},
            maturityIndex: {},
            strength: {}
        };

        vm.graphData = {
            temperature: {},
            humidity: {},
            maturityIndex: {},
            strength: {}
        }

        let maturityStrengthJobSensorMessages = {};
        vm.maturityStrengthJobSensors = {};
        let selectedMaturityStrengthJobSensors = {};

        let maturityStrengthJobFrom = {};

        vm.readOnly = env.readOnly;
        vm.isLoading = false;

        let msjStatusAlarmPollingPromise = null;
        let msjStatusAlarmPollingInterval = 5000;
        let msjStatusAlarmPollingErrors = 0;

        let sensorsDataPollingPromise = null;
        let sensorsDataPollingInterval = 5000;
        let sensorsDataPollingErrors = 0;

        let refreshMasterDataPromise = {};
        let refreshMasterDataPollingInterval = 60000;
        let refreshMasterDataPollingErrors = {
            temperature: 0,
            humidity: 0,
            maturity: 0,
        };

        let alert;

        let isAlive = true;



        let maturityStrengthGraphs = {};

        const maturityStrengthGraphOptionsTemplate = {
            plugins: {
                streaming: false
            },
            title: {
                display: false,
                text: ''
            },
            legend: {
                display: true,
                labels: {
                    fontColor: 'rgb(255, 99, 132)'
                }
            },
            elements: {
                point: {
                    radius: 2.5,
                    pointHitRadius: 2.5,
                    pointHoverRadius: 2.5,
                },
                line: {
                    borderWidth: 3,
                    tension: 0, // disables bezier curves
                    animation: {
                        duration: 0, // general animation time
                    },
                    hover: {
                        animationDuration: 0, // duration of animations when hovering an item
                    },
                    responsiveAnimationDuration: 0, // animation duration after a resize
                }
            },
            responsive: true,
            animation: {
                duration: 0, // general animation time
            },
            hover: {
                animationDuration: 0, // duration of animations when hovering an item
            },
            responsiveAnimationDuration: 0, // animation duration after a resize
            scales: {
                xAxes: [{
                    type: 'time',
                    display: true,
                    ticks: {
                        minRotation: 30,
                        maxRotation: 0,
                        maxTicksLimit: 7,
                        autoSkip: true
                    },

                    time: {
                        tooltipFormat: "YYYY-MM-DD HH:mm:ss:SSS",
                        displayFormats: {
                            month: 'MMM YYYY',
                            day: 'MMM D  00:00',
                            hour: 'MMM D  HH:00',
                            minute: 'HH:mm',
                            second: 'HH:mm:ss',
                            millisecond: 'HH:mm:ss:SSS'
                        }
                    },
                }],
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        stack: true,
                        position: 'left',
                        ticks: {
                            suggestedMin: -20,
                            suggestedMax: 120,
                        }
                    }
                ]
            },
            pan: {
                enabled: true,
                mode: 'xy'
             },
            zoom: {
                enabled: true,
                drag: false,
                mode: 'xy',
                rangeMin: {
                    y: -10
                },
                rangeMax: {
                    y: 25000
                }
            }
        };

        vm.maturityStrengthGraphOptions = {
            temperature: JSON.parse(JSON.stringify(maturityStrengthGraphOptionsTemplate)),
            humidity: JSON.parse(JSON.stringify(maturityStrengthGraphOptionsTemplate)),
            maturityIndex: JSON.parse(JSON.stringify(maturityStrengthGraphOptionsTemplate)),
            strength: JSON.parse(JSON.stringify(maturityStrengthGraphOptionsTemplate))
        };

        vm.maturityStrengthGraphSeries = {};



        vm.createMaturityStrengthJob = function()  {
            vm.isLoading = true;
            if(validateMaturityStrengthJobInputs())  {
                createMaturityStrengthJobHelper().then(function(resIds) {
                    if(resIds)  {
                        $q.all([
                            assignMaturityStrengthJobGroup(resIds.channelJobId),
                            createMaturityStrengthBlacklistedSensors(resIds.id),
                            createMaturityStrengthFunctionParams(resIds.id),
                            createMaturityStrengthJobAlarm(resIds.id, resIds.channelJobId)
                        ]).then(function(res) {
                            if(!res[0] || !res[1] || !res[2] || !res[3])  {
                                $log.info("Creating maturity strength job but auxiliary tasks failed");
                                vm.isLoading = false;
                                vm.cancel(true);
                            }
                            else {
                                $log.info("Creating maturity strength job and auxiliary tasks completed");
                                updateMaturityStrengthJobStatus(resIds.id, 'NEW').then(function(res2)  {
                                    if(res2)  {
                                        // Maturity strength job status updated to NEW.  Proceed to start job.
                                        startMaturityStrengthJob(resIds.id, false).then(function(res3)  {
                                            if(res3)  {
                                                if(res3.sensorMessages)  {
                                                    const smm = res3.sensorMessages.map(rsm => {
                                                        return "Sensor " + rsm.sensorId + "&nbsp;&nbsp;&nbsp;&nbsp;" + (rsm.latestValueTimestamp ? (rsm.latestValue + " °C") : 'NONE');
                                                    });

                                                    let confirmMessage = "<div><p>The Temperature Sensors listed below are currently not reporting temperatures or are reporting temperatures lower than the Datum Temperature.<p></div><br><div><p>Proceed with starting the job?</p></div>"; 
                                                    smm.forEach(m => confirmMessage = confirmMessage.concat("<br><div><p>").concat(m).concat("</p></div>"));
                                                    
                                                    let confirm = $mdDialog.confirm()
                                                        .title("Warning")
                                                        .htmlContent(confirmMessage)
                                                        .targetEvent(event)
                                                        .multiple(true)
                                                        .ok('Yes')
                                                        .cancel('No');

                                                        $mdDialog.show(confirm).then(function() {
                                                            // Proceed with starting the maturity strength job with the forced flag set
                                                            startMaturityStrengthJob(resIds.id, true).then(function(res4)  {
                                                                if(res4)  {
                                                                    vm.hide();
                                                                }
                                                                else  {
                                                                    vm.cancel(true);
                                                                }
                                                            });
                                                        }, function()  {
                                                            $log.info("User abandoned starting maturity strength job " + resIds.id + ".  Removing maturity strength job.")
                                                            deleteMaturityStrengthJob(resIds.id, resIds.channelJobId).then(function(res5)  {
                                                                if(!res5)  {
                                                                    vm.isLoading = false;
                                                                    vm.cancel(true);
                                                                }
                                                            });
                                                        });
                                                }
                                                else  {
                                                   // Maturity Strength Job started
                                                   vm.hide(res3);
                                                }
                                            }
                                            else  {
                                                // Failed to start maturity strength job
                                                vm.cancel(true);     
                                            }
                                        });
                                    }
                                    else  {
                                        // Failed to update maturity strength job status to NEW
                                        vm.isLoading = false;
                                        vm.cancel(true);  
                                    }
                                });
                            }
                        });
                    }
                    else  {
                        // Failed to maturity strength job
                        vm.isLoading = false;
                    }
                });
            }
            else  {
                // Failed to validate input
                vm.isLoading = false;
            }  
        };

        vm.terminateMaturityStrengthJob = function(maturityStrengthJobId)  {
            let confirm = $mdDialog.confirm()
            .title("Confirmation")
            .textContent("Are you sure you want to terminate Maturity Strength Job " + maturityStrengthJobId + "?")
            .targetEvent(event)
            .multiple(true)
            .ok('Yes')
            .cancel('No');

            $mdDialog.show(confirm).then(function() {
                $log.info("Terminate Maturity Strength Job ".concat(maturityStrengthJobId));
            
                MaturityStrengthJobService.maturityStrengthJobs.terminate({ tenant: tenant }, { id: maturityStrengthJobId }, function(res) {                
                    $log.info("Maturity strength job " + maturityStrengthJobId + " has been terminated successfully");
                    toastr.success("Maturity Strength Job " + maturityStrengthJobId + " has been terminated successfully!");
                    
                    // Cancel polling tasks
                    cancelJobUpdatesPolling();
                    cancelMasterPolling(false);

                    // Update status
                    getMaturityStrengthJobStatusAlarm();
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred terminating Maturity Strength Job ".concat(maturityStrengthJobId)
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                    $log.error("An error has occurred terminating maturity strength job ".concat(maturityStrengthJobId)
                        .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                });
            });
        };

        vm.getSensorsFromTemperatureChannel = function () {
            if(vm.msj.cgId)  {
                $log.info("Getting all sensors from temperature channel from channel group " + vm.msj.cgId);
                //vm.isLoading = true;
                vm.sensors = null;
                vm.selectedSensorsMessages = null;

                ChannelService.channels.channelsByGroup({ tenant: tenant, cgId: vm.msj.cgId }, function(res) {
                    const channelIds = res.channelMessages.map(c => c.channelId);
                    if(channelIds && channelIds.length > 0)  {
                        let sensorFutures = [];
                        channelIds.forEach(cid => sensorFutures.push(findTemperatureChannel(cid)));
                        
                        $q.all(sensorFutures).then(function(ss) {
                            vm.sensors = ss.find(s => s !== null);
                            if(vm.sensors && vm.sensors.length > 0)  {
                                $log.info("Temperature channel has been successfully found from channel group ".concat(vm.msj.cgId));
                                vm.selectedSensorsMessages = [].concat(vm.sensors);
                            }
                            else  {
                                showAlert("Error", "Failed to find Temperature Channel from Channel Group ".concat(vm.msj.cgId));
                                $log.info("Failed to find temperature channel from channel group ".concat(vm.msj.cgId));
                            }    
                            //vm.isLoading = false;
                        }); 
                    }
                    else  {
                        showAlert("Error", "Failed to find Channels from Channel Group ".concat(vm.msj.cgId));
                        $log.info("Failed to get channels from channel group ".concat(vm.msj.cgId));
                        //vm.isLoading = false;
                    }
                }, function(err)  {
                    const errData = err.data;
                    showAlert("Error", "An error has occurred getting all sensors from Temperature Channel from Channel Group ".concat(vm.msj.cgId)
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
                    $log.info("An error has occurred getting all sensors from temperature channel from channel group ".concat(vm.msj.cgId)
                        .concat(": ").concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                    //vm.isLoading = false;    
                });
            }
        };


        vm.resetMaturityStrengthGraphZoom = function(graphType)  {
            if(maturityStrengthGraphs[graphType])  {
                maturityStrengthGraphs[graphType].resetZoom();
            }
        }; 

        
        vm.onDataSensorSelected = function()  {
            // Updating selected maturity strength job sensors and restart all master polling tasks
            $log.info("Data sensor " + vm.selectedDataSensor.sensorId + " selected");
            selectedMaturityStrengthJobSensors.temperature = vm.maturityStrengthJobSensors.temperature.filter(s => s.sensorId === vm.selectedDataSensor.sensorId);
            selectedMaturityStrengthJobSensors.humidity = vm.maturityStrengthJobSensors.humidity.filter(s => s.sensorId === vm.selectedDataSensor.sensorId);

            selectedMaturityStrengthJobSensors.maturity = [].concat(selectedMaturityStrengthJobSensors.temperature);

            cancelMasterPolling(true);
            startMasterPolling();
        };

        vm.getDataAvailability = function(dc)  {
            return vm.graphData[dc] != null && vm.graphData[dc].length > 0;
        }


        vm.onMaturityStrengthFunctionSelected = function()  {
            if(vm.msj.maturityStrengthFunctionTypeName === 'Plowman' || vm.msj.maturityStrengthFunctionTypeName === 'Modified Plowman')  {
                vm.maturityStrengthFunctionParams = [
                    {
                        name: 'a',
                        val: null 
                    },
                    {
                        name: 'b',
                        val: null
                    }
                ];
            }
            else  {
                vm.maturityStrengthFunctionParams = null;
            }
        };

        vm.displayMaturityStrengthFunctionParamField = function(paramIndex)  {
            if(vm.msj.maturityStrengthFunctionTypeName === 'Plowman' || vm.msj.maturityStrengthFunctionTypeName === 'Modified Plowman')  {
                return paramIndex < 2; 
            }
            else  {
                return paramIndex < 0;
            }
        };

        vm.getStatusColor = function(status)  {
            if (status === 'RUNNING')  {
                return { color: '#388e3c' };
            }
            else if (status === 'TERMINATED')  {
                return { color: '#616161' };
            }
            else if (status === 'ERROR')  {
                return { color: '#d32f2f' };
            }
            else  {
                return { color: '#009fe3' };
            }
        };

        vm.gotoAnchor = function(graphName)  {
            const newHash = "anchor_" + graphName;
            if($location.hash() !== newHash) {
              $location.hash("anchor_" + graphName);
            } 
            else {
              $anchorScroll();
            }
        };


        const refreshMasterData = function(dc, granularity)  {
            const isTerminated = vm.msj.status === 'TERMINATED' && vm.msj.terminationDateMilliseconds;
            $log.debug("Start refreshing master data for ".concat(vm.msj.status).concat(" job (").concat(dc).concat(", ").concat(granularity).concat(") for sensors: "
                .concat(JSON.stringify(selectedMaturityStrengthJobSensors[dc]))));
            
                try  {                
                // Determine 'to' as terminationDate if the job has been terminated or otherwise the current time 
                const to = isTerminated ? moment(vm.msj.terminationDateMilliseconds) : moment();

                // Trigger next load only if the job has not been terminated
                if(dc === 'maturity')  {
                    refreshMaturityData(dc, granularity, to, !isTerminated);
                }
                else  {
                    refreshMeasurementData(dc, granularity, to, !isTerminated);
                }
            }
            catch(err)  {
                $log.debug("An error has occurred refreshing master data (".concat(dc).concat(", ").concat(granularity).concat("): ").concat(err));
            }
        };

        const refreshMeasurementData = function(dc, granularity, to, refreshNextLoad)  {
            // Build measurement data request
            const from = maturityStrengthJobFrom[dc];
            const sensorInfos = selectedMaturityStrengthJobSensors[dc].map(ss => UtilService.szudzikPairing(ss.channelId, ss.sensorId).toString());
            let requests = selectedMaturityStrengthJobSensors[dc].reduce((reduced, sensor) =>  {
                let si = UtilService.szudzikPairing(sensor.channelId, sensor.sensorId);
                reduced.push({
                    sensorInfo: si,
                    sensorType: sensor.sensorType,
                    cutoffId: (masterData[dc][si] && masterData[dc][si].length > 0) ? (masterData[dc][si].reduce((max, s) => s.id > max ? s.id : max, masterData[dc][si][0].id)) : 0,
                    from: from.valueOf(),
                    to: to.valueOf()
                });
                return reduced;
            }, []);

            let params = {
                tenant: tenant,
                granularity: granularity,
                sortdir: "ASC"
            };

            $log.debug("Measurement data request for maturity strength job (".concat(dc).concat("): ")
                .concat(JSON.stringify(requests)));
            getMeasurementData(dc, params, requests).then(function(res)  {
                if(res)  {
                    // Update existing measurement data and cutoff id
                    Object.keys(masterData[dc]).forEach(k => {
                        if(sensorInfos.includes(k) && res[k]) {
                            masterData[dc][k].push(...res[k]);
                        }
                    });

                    // Add new measurement data if there are no existing data
                    sensorInfos.filter(sensorInfo => !(Object.keys(masterData[dc]).some(k => k === sensorInfo)))
                        .forEach(a => {
                            if(res[a])  {
                                masterData[dc][a] = res[a];
                            }
                        });

                    // Update series
                    const series = Object.keys(masterData[dc]);
                    if(series !== null && series.length > 0)  {
                        vm.maturityStrengthGraphSeries[dc] = series.map(s => {
                            const sensorInfo = UtilService.szudzikUnpairing(s);
                            return 'Sensor '.concat(sensorInfo[1]);
                        });        
                    }
                    
                    // Update data
                    vm.graphData[dc] = Object.values(masterData[dc]);

                    // Update from
                    maturityStrengthJobFrom[dc] = to; 
                    
                    refreshMasterDataPollingErrors[dc] = 0;

                    if(refreshNextLoad)  {
                        refreshMasterDataNextLoad(dc);
                    }
                    else  {
                        cancelRefreshMasterDataNextLoad(dc);
                        $log.info("Do not refresh next load for measurement data");
                    }
                }
            }).catch(function(err)  {
                // Error for getting measurement data
                $log.error("Done refreshing master data with error (".concat(dc).concat(", ").concat(granularity).concat("): ").concat(err));
                refreshMasterDataNextLoad(dc, ++refreshMasterDataPollingErrors[dc] * 2 * refreshMasterDataPollingInterval[dc]);
            });    
        };

        const refreshMaturityData = function(dc, granularity, to, refreshNextLoad)  {
            // Build maturity data request
            // Determine cutoffId with maturity index data
            const from = maturityStrengthJobFrom[dc];
            const sensorInfos = selectedMaturityStrengthJobSensors[dc].map(ss => UtilService.szudzikPairing(ss.channelId, ss.sensorId).toString());
            let requests = selectedMaturityStrengthJobSensors[dc].reduce((reduced, sensor) =>  {
                let si = UtilService.szudzikPairing(sensor.channelId, sensor.sensorId);
                reduced.push({
                    id: vm.msj.id,
                    sensorInfo: si,
                    cutoffId: (masterData['maturityIndex'][si] && masterData['maturityIndex'][si].length > 0) ? (masterData['maturityIndex'][si].reduce((max, s) => s.id > max ? s.id : max, masterData['maturityIndex'][si][0].id)) : 0,
                    from: from.valueOf(),
                    to: to.valueOf()
                });
                return reduced;
            }, []);

            let params = {
                tenant: tenant,
                maturity_tolerance: env.lumiconMaturityChartDataTolerance,
                strength_tolerance: env.lumiconStrengthChartDataTolerance,
                sortdir: "ASC"
            };

            $log.debug("Maturity data request for maturity strength job: ".concat(JSON.stringify(requests)));
            getMaturityData(params, requests).then(function(res)  {
                if(res)  {
                    // Sensor to maturity data object map (with maturity index data) is the first item of the list
                    // Sensor to maturity data object map (with strength data) is the second item of the list
                    updateMaturityMasterData('maturityIndex', sensorInfos, res[0]);
                    updateMaturityMasterData('strength', sensorInfos, res[1]);

                    // Update from
                    maturityStrengthJobFrom.maturity = to;

                    refreshMasterDataPollingErrors[dc] = 0;

                    if(refreshNextLoad)  {
                        refreshMasterDataNextLoad(dc);
                    }
                    else  {
                        cancelRefreshMasterDataNextLoad(dc);
                        $log.info("Do not refresh next load for maturity data");
                    }
                }
            }).catch(function(err)  {
                // Error for getting maturity data
                $log.error("Done refreshing master data with error (".concat(dc).concat(", ").concat(granularity).concat("): ").concat(JSON.stringify(err)));
                refreshMasterDataNextLoad(dc, ++refreshMasterDataPollingErrors[dc] * 2 * refreshMasterDataPollingInterval[dc]);
            });    
        };
        

        const clearMasterData = function(clearGraph, dc)  {
            $log.info("Clearing master data (" + dc + ")" + (clearGraph ? " and graphs" : ""));

            if(dataSubCategories[dc])  {
                dataSubCategories[dc].forEach(dsc => {
                    Object.keys(masterData[dsc]).forEach(k => delete masterData[dsc][k]);
                    if(clearGraph)  {
                        vm.graphData[dsc] = [];
                    } 
                });
            }
            else  {
                Object.keys(masterData[dc]).forEach(k => delete masterData[dc][k]);
                if(clearGraph)  {
                    vm.graphData[dc] = [];
                }
            }
        };

        const resetMasterMetadata = function(dc)  {
            $log.info("Reset master metadata (" + dc + ")");
            maturityStrengthJobFrom[dc] = moment(vm.msj.startDateMilliseconds);
        };

        const updateMaturityMasterData = function(dsc, sensorInfos, dataMap)  {
           // Update existing maturity data and cutoff id
            Object.keys(masterData[dsc]).forEach(k => {
                if(sensorInfos.includes(k) && dataMap[k]) {
                    masterData[dsc][k].push(...dataMap[k]);
                }
            });

            // Add new maturity data if there are no existing data
            sensorInfos.filter(sensorInfo => !(Object.keys(masterData[dsc]).some(k => k === sensorInfo)))
                .forEach(a => {
                    if(dataMap[a])  {
                        masterData[dsc][a] = dataMap[a];
                    }
                });
            
            // Update series
            const series = Object.keys(masterData[dsc]);
            if(series !== null && series.length > 0)  {
                vm.maturityStrengthGraphSeries[dsc] = series.map(s => {
                    const sensorInfo = UtilService.szudzikUnpairing(s);
                    return 'Sensor '.concat(sensorInfo[1]);
                });        
            }

            // Update data
            vm.graphData[dsc] = Object.values(masterData[dsc]);
        };

        const getMeasurementData = function(dc, params, requests)  {
            let deferred = $q.defer();
            const measurementDataReqStart = moment();
            MeasurementDataService.measurementDataByTimeRange(env.msjMeasurementDataTimeout, env.lumiconMeasurementChartDataTolerance, true)
                .data(params, requests, function(res) {
                    const duration = moment.duration(moment().diff(measurementDataReqStart));
                    $log.debug("Done measurement data request for maturity strength job (" + dc + ") in " + duration.asSeconds() + " seconds");
                    deferred.resolve(res);
                }, function(err)  {
                    const errData = err.data;
                    $log.error("Measurement data request for maturity strength job (" + dc + ") has encountered an error or has timed out: "
                        .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                    const duration = moment.duration(moment().diff(measurementDataReqStart));
                    $log.error("Abandoned or completed measurement data request for maturity strength job (" + dc + ") with error after " + duration.asSeconds() + " seconds.  " +
                        "Timeout for getting measurement data is " + (env.msjMeasurementDataTimeout)/1000 + " seconds.");
                    deferred.reject(err);
                });
            return deferred.promise;
        };

        const getMaturityData = function(params, requests)  {
            let deferred = $q.defer();
            const maturityDataReqStart = moment();
            MaturityStrengthDataService.maturityStrengthData.maturityDataByTimeRange(params, requests, function(res) {
                    const duration = moment.duration(moment().diff(maturityDataReqStart));
                    $log.debug("Done maturity strength data request for maturity strength job in " + duration.asSeconds() + " seconds");

                    deferred.resolve(res);
                }, function(err)  {
                    const errData = err.data;
                    $log.error("Maturity strength data request for maturity strength job has encountered an error or has timed out: "
                        .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                    const duration = moment.duration(moment().diff(maturityDataReqStart));
                    $log.error("Abandoned or completed maturity strength data request for maturity strength job with error after " + duration.asSeconds() + " seconds.  ");
                    deferred.reject(err);
                });
            return deferred.promise;
        };

        const getDataExtremities = function(dc, parentDc)  {
            const extremities = selectedMaturityStrengthJobSensors[parentDc ? parentDc : dc].reduce((reduced, sensor) =>  {
                let si = UtilService.szudzikPairing(sensor.channelId, sensor.sensorId);
                reduced.push({
                    sensorInfo: si,
                    minY: (masterData[dc][si] && masterData[dc][si].length > 0) ? (masterData[dc][si].reduce((min, s) => s.y < min ? s.y : min, masterData[dc][si][0].y)) : 0,
                    maxY: (masterData[dc][si] && masterData[dc][si].length > 0) ? (masterData[dc][si].reduce((max, s) => s.y > max ? s.y : max, masterData[dc][si][0].y)) : 0,
                });
                return reduced;
            }, []);

            return { 
                minY: Math.min(...extremities.map(d => d.minY), 25000),
                maxY: Math.max(...extremities.map(d => d.maxY), -10)
            };
        };


        const pollMaturityStrengthJobStatusAlarm = function() {
            $log.debug("Polling status and alarm for maturity strength job " + vm.msj.id);
            getMaturityStrengthJobStatusAlarm().then(function(res)  {
                if(res)  {
                    msjStatusAlarmPollingErrors = 0;
                    msjStatusAlarmNextLoad();
                }
                else  {
                    showAlert("Error", "Operational error as Maturity Strength Job ".concat(vm.msj.id).concat(" may possibly have been removed.  Try again later or contact your system administrator."));
                    vm.cancel(true);

                    //msjStatusAlarmNextLoad(++msjStatusAlarmPollingErrors * 2 * msjStatusAlarmPollingInterval);
                }
            });
        };

        const pollSensorsWithMaturityStrengthData = function() {
            $log.debug("Polling sensors with latest maturity strength data for maturity strength job " + vm.msj.id);
            MaturityStrengthDataService.maturityStrengthData.sensorsWithMaturityStrengthData({ tenant: tenant, msjId: vm.msj.id }, function(res) {
                vm.latestSensorsMsjData = res.map(s => {
                    s.latestValueTimestamp = UtilService.convertUTCTimestamp(s.latestValueTimestamp, displayTZ);
                    return s;         
                });

                sensorsDataPollingErrors = 0;
                sensorsDataNextLoad();
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred polling sensors with latest maturity strength data for maturity strength job ".concat(vm.msj.id)
                    .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                    
                showAlert("Error", "Operational error as Maturity Strength Job ".concat(vm.msj.id).concat(" may possibly have been removed.  Try again later or contact your system administrator."));
                vm.cancel(true);

                //sensorsDataNextLoad(++sensorsDataPollingErrors * 2 * sensorsDataPollingInterval);
            });
        };

        const getMaturityStrengthJobStatusAlarm = function()  {
            $log.debug("Getting status and alarm for maturity strength job " + vm.msj.id);
            let deferred = $q.defer();
            MaturityStrengthJobService.maturityStrengthJobs.get({ id: vm.msj.id, tenant: tenant }, function(res) {
                vm.msj.status = res.status;
                vm.msj.alarmSensors1 = res.alarmSensors1;
                vm.msj.alarmSensors2 = res.alarmSensors2;

                // If job has been terminated when dialog is open, update termination date
                if(!vm.msj.terminationDate && res.terminationDate)  {
                    vm.msj.terminationDateMilliseconds = res.terminationDate;
                    vm.msj.terminationDate = UtilService.convertUTCTimestamp(res.terminationDate, displayTZ);
                }

                // Get job duration information
                if(vm.msj.terminationDateMilliseconds && vm.msj.startDateMilliseconds && !vm.hasJobDuration)  {
                    const startMoment = moment(vm.msj.startDateMilliseconds);
                    const terminationMoment = moment(vm.msj.terminationDateMilliseconds);
                    const jobDuration = moment.duration(terminationMoment.diff(startMoment));
                    
                    //Get hours and subtract from duration
                    vm.jobDurationHours = Math.floor(jobDuration.asHours());
                    jobDuration.subtract(moment.duration(vm.jobDurationHours, 'hours'));
                    vm.jobDurationHours = vm.jobDurationHours.toString().padStart(2, '0');

                    //Get minutes and subtract from duration
                    vm.jobDurationMinutes = Math.floor(jobDuration.asMinutes());
                    jobDuration.subtract(moment.duration(vm.jobDurationMinutes, 'minutes'));
                    vm.jobDurationMinutes = vm.jobDurationMinutes.toString().padStart(2, '0');

                    //Get seconds and subtract from duration
                    vm.jobDurationSeconds = Math.floor(jobDuration.asSeconds());
                    jobDuration.subtract(moment.duration(vm.jobDurationSeconds, 'seconds'));
                    vm.jobDurationSeconds = vm.jobDurationSeconds.toString().padStart(2, '0');

                    vm.hasJobDuration = true;
                }                               

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred polling status and alarm for maturity strength job ".concat(vm.msj.id)
                    .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                deferred.resolve(false);
            });
            return deferred.promise;
        }


        const validateMaturityStrengthJobInputs = function()  {
            // Set TSPEC to be the same as the datum temperature
            vm.msj.specTemperature = vm.msj.datumTemperature;

            // Validate Granularity and Refresh Rate
            if(vm.msj.granularityName === 'ticks' ||
                (vm.msj.granularityName === '5min' && vm.msj.refreshRate >= 300) ||
                (vm.msj.granularityName === '1hr' && vm.msj.refreshRate >= 3600) ||
                (vm.msj.granularityName === '1day' && vm.msj.refreshRate >= 86400))  {
                
                // Validate that sensors are not empty    
                if(vm.selectedSensorsMessages && vm.selectedSensorsMessages.length > 0)  {
                    // Determine whether Maturity Function Type and Maturity Strength Function Type are supported
                    if(vm.msj.maturityFunctionTypeName === 'Nurse-Saul' &&
                        (vm.msj.maturityStrengthFunctionTypeName === 'Plowman' || vm.msj.maturityStrengthFunctionTypeName === 'Modified Plowman'))  {
                        $log.info("Maturity Strength Job Inputs have been validated");
                        // Validate that Maturity Strength Function Params are not null
                        if(!vm.maturityStrengthFunctionParams || vm.maturityStrengthFunctionParams.every(p => p.val !== null))  {
                            return true;
                        }
                        else  {
                            showAlert("Warning", "One or more Maturity Strength Function Parameter Values are empty.  Please modify your input and try again.");
                            return false;
                        }
                    }
                    else  {
                        if(vm.msj.maturityFunctionTypeName !== 'Nurse-Saul')  {
                            showAlert("Warning", "The selected Maturity Function Type is currently not supported.  Please modify your input and try again.");
                        }
                        else if(vm.msj.maturityStrengthFunctionTypeName !== 'Plowman' && vm.msj.maturityStrengthFunctionTypeName !== 'Modified Plowman')  {
                            showAlert("Warning", "The selected Maturity Strength Function Type is currently not supported.  Please modify your input and try again.");
                        }
                        return false;
                    }
                }
                else  {
                    showAlert("Warning", "Sensors cannot be empty.  Please modify your input and try again.");
                    return false;
                }
            }
            else  {
                showAlert("Warning", "Refresh Rate must be greater than or equal to Data Granularity.  Please modify your input and try again.");
                return false;

            }                    
        };
        
        const getMaturityStrengthJobSensors = function(id, sensorType) {
            $log.info("Getting maturity strength job sensors (" + sensorType + ") for maturity strength job " + id);
            let deferred = $q.defer();

            const reqBody = {
                id: id,
                sensorType: sensorType
            };

            MaturityStrengthJobService.maturityStrengthJobs.sensors({ tenant: tenant, allowDecommissioned: true }, reqBody, function(res) {
                maturityStrengthJobSensorMessages[sensorType] = res.sensorMessages.sort((a,b) => {
                    if(a.channelId === b.channelId)  {
                        if(a.sensorId > b.sensorId)  {
                            return 1;
                        }
                        else  {
                            return -1;
                        }
                    }
                    else if(a.channelId > b.channelId)  {
                        return 1;
                    }
                    else  {
                        return -1;
                    }
                });
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting maturity strength job sensors (" + sensorType + ") for maturity strength job ".concat(id)
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };


        const getChannelJobGroups = function () {
            $log.info("Getting all channel job groups");
            let deferred = $q.defer();
        	ChannelJobService.channelJobGroups.query({ tenant: tenant }, function(res) {
                vm.jobGroups = res;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting channel job groups: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getChannelJobVisibilities = function () {
            $log.info("Getting all channel job visibilities");
            let deferred = $q.defer();
        	ChannelJobService.channelJobVisibilities.query(function(res) {
                vm.channelJobVisibilities = res;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting channel job visibilities: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getDataGranularities = function() {
            $log.info("Getting all data granularities");
            let deferred = $q.defer();
            AdminService.granularities.query(function(res) {
                vm.dataGranularities = res.filter(g => g.name !== 'tick');
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting data granularities (".concat(errData ? JSON.stringify(errData) : 
                JSON.stringify(err)));
            });
            return deferred.promise;
        };

        const getMaturityFunctionTypes = function () {
            $log.info("Getting all maturity function types");
            let deferred = $q.defer();
        	MaturityStrengthJobService.maturityFunctionTypes.query(function(res) {
                vm.maturityFunctionTypes = res;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting maturity function types: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getMaturityStrengthFunctionTypes = function () {
            $log.info("Getting all maturity strength function types");
            let deferred = $q.defer();
        	MaturityStrengthJobService.maturityStrengthFunctionTypes.query(function(res) {
                vm.maturityStrengthFunctionTypes = res;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred getting maturity strength function types: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const createMaturityStrengthJobHelper = function(){
            $log.info("Creating Maturity Strength Job");
            let deferred = $q.defer();
        	MaturityStrengthJobService.maturityStrengthJobs.save({ tenant: tenant }, vm.msj, function(res) {
                deferred.resolve({ 
                    id: res.id,
                    channelJobId: res.channelJobId 
                 });
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred creating Maturity Strength Job"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred creating maturity strength job: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                deferred.resolve(false);
            });
            return deferred.promise;       
        };

        const assignMaturityStrengthJobGroup = function(channelJobId){
            let deferred = $q.defer();
            if(vm.jobGroup)  {
                $log.info("Assign Maturity Strength Job to Channel Job Group");
                ChannelJobService.channelJobGroups.assignChannelJobGroup({ tenant: tenant }, {
                    channelJobId: channelJobId,
                    channelJobGroupId: vm.jobGroup
                }, function(res) {
                    $log.info("Maturity strength job assigned to channel job group");
                    deferred.resolve(true);
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred assigning Maturity Strength Job to Channel Job Group"
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                    $log.error("An error has occurred assigning maturity strength job to channel job group: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                    deferred.resolve(false);
                });
            }
            else  {
                deferred.resolve(true);
            }
            
            return deferred.promise;       
        };

        const createMaturityStrengthBlacklistedSensors = function(maturityStrengthJobId){
            $log.info("Creating maturity strength blacklisted sensors for maturity strength job " + maturityStrengthJobId);
            let deferred = $q.defer();
            let maturityStrengthBlacklistedSensors =
                        vm.sensors.filter(s => !vm.selectedSensorsMessages.includes(s))
                                    .map(fs => {
                                        return {
                                            sid: fs.id
                                        }
                                    });
                                    
            if(maturityStrengthBlacklistedSensors && maturityStrengthBlacklistedSensors.length > 0)  {
                const reqBody = {
                    id: maturityStrengthJobId,
                    maturityStrengthBlacklistedSensors: maturityStrengthBlacklistedSensors
                };
    
                MaturityStrengthJobService.maturityStrengthBlacklistedSensors.save({ tenant: tenant }, 
                    reqBody, function(res) {
                        $log.info("Maturity strength blacklisted sensors created for maturity strength job " + maturityStrengthJobId);
                        deferred.resolve(true);
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred creating Maturity Strength Blacklisted Sensors"
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
    
                    $log.error("An error has occurred creating maturity strength blacklisted sensors: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                    deferred.resolve(false);
                });                
            }
            else  {
                // No blacklisted sensors.  Do not create.
                deferred.resolve(true);
            }

            return deferred.promise;       
        };

        const createMaturityStrengthFunctionParams = function(maturityStrengthJobId){
            $log.info("Creating maturity strength function params for maturity strength job " + maturityStrengthJobId);
            let deferred = $q.defer();
                                    
            if(vm.maturityStrengthFunctionParams && vm.maturityStrengthFunctionParams.length > 0)  {
                const reqBody = {
                    id: maturityStrengthJobId,
                    maturityStrengthFunctionParams: vm.maturityStrengthFunctionParams
                };
    
                MaturityStrengthJobService.maturityStrengthFunctionParams.save({ tenant: tenant }, 
                    reqBody, function(res) {
                        $log.info("Maturity strength function params created for maturity strength job " + maturityStrengthJobId);
                        deferred.resolve(true);
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred creating Maturity Strength Function Params"
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
    
                    $log.error("An error has occurred creating maturity strength function params: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                    deferred.resolve(false);
                });                
            }
            else  {
                // No maturity strength function params.  Do not create.
                deferred.resolve(true);
            }

            return deferred.promise;       
        };

        const createMaturityStrengthJobAlarm = function(maturityStrengthJobId, channelJobId){
            $log.info("Creating and assigning maturity strength job alarm for maturity strength job " + maturityStrengthJobId);
            let deferred = $q.defer();
                                    
            if(vm.singularAlarmThreshold)  {
                const reqBody = {
                    alarmData: {
                        alarmType: 'LUMICON_MATURITY_STRENGTH_THRESHOLD',
                        singularThreshold: vm.singularAlarmThreshold 
                    }
                };

                AlarmSettingsService.alarms.save({ tenant: tenant }, reqBody, function(resAlarm) {
                    $log.info("Maturity strength job alarm created for maturity strength job " + maturityStrengthJobId);
                    const alarmId = resAlarm.alarmData.id;

                    ChannelJobService.channelJobs.assignAlarm({ tenant: tenant }, { channelJobId: channelJobId, alarmId: alarmId}, function(res) {
                        $log.info("Maturity strength job alarm assigned for maturity strength job " + maturityStrengthJobId);
                        deferred.resolve(true);
                    }, function(err)  {
                        const errData = err.data;
                        toastr.error("An error has occurred assigning Maturity Strength Job Alarm"
                            .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
    
                        $log.error("An error has occurred assigning maturity strength job alarm: ".concat(errData ? JSON.stringify(errData) :
                            JSON.stringify(err)));
                            deferred.resolve(false);
                    });
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred creating Maturity Strength Job Alarm"
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                    $log.error("An error has occurred creating maturity strength job alarm: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                        deferred.resolve(false);
                });
            }
            else  {
                // No maturity strength job alarm.  Do not create.
                deferred.resolve(true);
            }

            return deferred.promise;       
        };

        const startMaturityStrengthJob = function(maturityStrengthJobId, forced)  {
            $log.info("Start Maturity Strength Job ".concat(maturityStrengthJobId).concat(" (forced = ".concat(forced).concat(")")));
            let deferred = $q.defer();

            const reqBody = {
                id: maturityStrengthJobId,
                forced: forced
            };

        	MaturityStrengthJobService.maturityStrengthJobs.start({ tenant: tenant }, reqBody, function(res) {
                if(res.sensorMessages)  {
                    $log.info("Maturity strength job " + maturityStrengthJobId + " failed to start as there are sensor temperatures lower than TSPEC");
                }
                else  {
                    $log.info("Maturity strength job " + maturityStrengthJobId + " has started successfully");
                    toastr.success("Maturity Strength Job " + maturityStrengthJobId + " has started successfully!");
                }
                
                vm.isLoading = false;
                deferred.resolve(res);
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred starting Maturity Strength Job ".concat(maturityStrengthJobId)
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred starting maturity strength job ".concat(maturityStrengthJobId)
                    .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                
                vm.isLoading = false;
                deferred.resolve(false);
            });
            return deferred.promise;       
        };

        const deleteMaturityStrengthJob = function(maturityStrengthJobId, channelJobId)  {
            $log.info("Remove Maturity Strength Job ".concat(maturityStrengthJobId));
            let deferred = $q.defer();
            
            ChannelJobService.channelJobs.delete({ id: channelJobId, tenant: tenant }, function(res) {                
                $log.info("Maturity strength job " + maturityStrengthJobId + " has been removed successfully");
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred removing Maturity Strength Job ".concat(maturityStrengthJobId)
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred removing maturity strength job ".concat(maturityStrengthJobId)
                    .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                deferred.resolve(false);    
            });
            return deferred.promise;
        };

        const updateMaturityStrengthJobStatus = function(maturityStrengthJobId, channelJobStatus)  {
            $log.info("Updating Maturity Strength Job Status to ".concat(channelJobStatus));
            let deferred = $q.defer();

            const reqBody = {
                id: maturityStrengthJobId,
                channelJobStatus: channelJobStatus
            };

        	MaturityStrengthJobService.maturityStrengthJobStatuses.update({ tenant: tenant }, reqBody, function(res) {
                $log.info("Maturity Strength Job Status successfully updated to ".concat(channelJobStatus));
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred updating Maturity Strength Job Status to ".concat(channelJobStatus)
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred updating maturity strength job status to ".concat(channelJobStatus)
                    .concat(": ".concat(errData ? JSON.stringify(errData) : JSON.stringify(err))));
                deferred.resolve(false);
            });
            return deferred.promise;       
        };
        

        const findTemperatureChannel = function(channelId)  {
            $log.info("Determining temperature channel for channel " + channelId);
            let deferred = $q.defer();
        	ChannelService.sensors.sensorsByChannelId({ tenant: tenant, channelId: channelId }, function(res) {
                const sensorMessages = res.sensorMessages;
                const ss = (sensorMessages && sensorMessages.every(s => s.isActive && s.sensorType === 'Temperature')) ?
                    sensorMessages : null;

                deferred.resolve(ss);
            }, function(err)  {
                const errData = err.data;
                $log.info("An error has occurred determining temperature channel for channel ".concat(channelId).concat(": ")
                .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                deferred.resolve(null);
            }); 
            return deferred.promise;
        }


        const startJobUpdatesPolling = function()  {
            $log.debug("Start maturity strength job updates polling tasks");
            if(vm.msj)  {
                pollMaturityStrengthJobStatusAlarm()
                pollSensorsWithMaturityStrengthData()
            }
        };

        const cancelJobUpdatesPolling = function()  {
            $log.info("Cancel maturity strength job updates polling tasks");
            msjStatusAlarmPollingErrors = 0;
            cancelMsjStatusAlarmNextLoad();

            sensorsDataPollingErrors = 0;
            cancelSensorsDataNextLoad();
        };


        vm.restartMasterPolling = function(clearGraph, dc)  {
            cancelMasterPolling(clearGraph, dc);
            startMasterPolling(dc);
        };

        const startMasterPolling = function(dc)  {
            if(dc)  {
                if(selectedMaturityStrengthJobSensors[dc] && selectedMaturityStrengthJobSensors[dc].length > 0)  {
                    $log.info("Start master polling tasks".concat(dc ? (" (" + dc + ")") : ""));
                    refreshMasterData(dc, vm.msj.granularityName);
                }
            }
            else  {
                dataCategories.forEach(dataCategory => {
                    startMasterPolling(dataCategory);
                });
            }
        };

        const cancelMasterPolling = function(clearGraph, dc)  {
            $log.info("Cancel master polling tasks".concat(dc ? (" (" + dc + ")") : ""));
            if(dc)  {
                refreshMasterDataPollingErrors[dc] = 0;
                cancelRefreshMasterDataNextLoad(dc);
                
                clearMasterData(clearGraph, dc);
                resetMasterMetadata(dc);
            }
            else  {
                dataCategories.forEach(dataCategory => {
                    cancelMasterPolling(clearGraph, dataCategory);
                });
            }
        };


        vm.hide = function(res) {
            $mdDialog.hide(res);
        };

        vm.cancel = function(errData) {
            if(errData)  {
                $mdDialog.cancel(errData);
            }
            else  {
                $mdDialog.cancel();
            }
        };



        const init = function()  {
            vm.isLoading = true;
            vm.isCreate = vm.msj ? false : true;
            $q.all([
                getChannelJobGroups(),
                getDataGranularities(),
                getChannelJobVisibilities(),
                getMaturityFunctionTypes(),
                getMaturityStrengthFunctionTypes()
            ]).then(function(res) {
                if(!res[0] || !res[1] || !res[2] || !res[3], !res[4])  {
                    vm.isLoading = false;
                    $log.error("An error has occurred getting parameter options");
                    showAlert("Error", "An error has occurred getting parameter options for creating Maturity Strength Job");
                }
                else  {
                    // Create new Maturity Strength Job
                    if(vm.isCreate)  {
                        vm.msj = {
                            channelJobTypeName: 'Maturity & Strength',
                            companyId: vm.companyId,
                            username: vm.username,
                            channelJobVisibilityName: 'UNRESTRICTED',
                            refreshRate: 300,
                            granularityName: '5min',
                            maturityFunctionTypeName: 'Nurse-Saul',
                            maturityStrengthFunctionTypeName: 'Plowman',
                        };

                        vm.onMaturityStrengthFunctionSelected();
                        vm.isLoading = false;
                    }
                    // View existing Maturity Strength Job
                    else  {
                        // Get maturity strength job sensors
                        $q.all([
                            getMaturityStrengthJobSensors(vm.msj.id, 'temperature'),
                            getMaturityStrengthJobSensors(vm.msj.id, 'humidity')
                        ]).then(function(res2)  {
                            if(res2[0])  {
                                if(maturityStrengthJobSensorMessages.temperature && 
                                    maturityStrengthJobSensorMessages.humidity &&
                                    maturityStrengthJobSensorMessages.temperature.length > 0)  {
                                    vm.maturityStrengthJobSensors.temperature = maturityStrengthJobSensorMessages['temperature'].map(ss => {
                                        return  {
                                            id: ss.id,
                                            channelId: ss.channelId,
                                            sensorId: ss.sensorId,
                                            sensorType: ss.sensorType
                                        };
                                    });

                                    vm.maturityStrengthJobSensors.humidity = maturityStrengthJobSensorMessages['humidity'].map(ss => {
                                        return  {
                                            id: ss.id,
                                            channelId: ss.channelId,
                                            sensorId: ss.sensorId,
                                            sensorType: ss.sensorType
                                        };
                                    });
                                    
                                    // Set channel job group
                                    if(vm.msj.channelJobGroupId && vm.msj.channelJobGroupName)  {
                                        vm.jobGroup = vm.msj.channelJobGroupId;
                                    }

                                    // Set singular alarm threshold
                                    if(vm.msj.alarmData && vm.msj.alarmData.singularThreshold)  {
                                        vm.singularAlarmThreshold = vm.msj.alarmData.singularThreshold;
                                    }

                                    // Set chart titles
                                    setChartTitles();

                                    // Get scale settings
                                    getScaleSettings();
            
                                    // Start polling for job updates 
                                    startJobUpdatesPolling();
                                    vm.isLoading = false;
                                }
                                else  {
                                    // Empty maturity strength job sensors.  Should not happen.
                                    toastr.error("No sensors are found for Maturity Strength Job ".concat(vm.msj.id));
                                    $log.error("Empty maturity strength sensors for maturity strength job " + vm.msj.id);
                                    vm.cancel(true);
                                }
                            }
                            else  {
                                $log.error("Failed to get temperature maturity strength job sensors");
                                showAlert("Error", "Operational error as Maturity Strength Job ".concat(vm.msj.id).concat(" may possibly have been removed.  Try again later or contact your system administrator."));
                                
                                vm.isLoading = false;
                                vm.cancel(true);                                 
                            }
                        });
                    }  
                }
            });
        };

        const setChartTitles = function()  {
            $log.info("Setting chart titles");
            vm.maturityStrengthGraphOptions.temperature.title.text = "temperature";
            vm.maturityStrengthGraphOptions.humidity.title.text = "humidity";
            vm.maturityStrengthGraphOptions.maturityIndex.title.text = "maturityIndex";
            vm.maturityStrengthGraphOptions.strength.title.text = "strength";
        };

        const getScaleSettings = function () {
            $log.info("Getting chart scale settings");
            GeneralSettingsService.settings.getScaleSettings({ tenant : tenant }, function(res) {
                const scaleSettings = {
                    temperature: {
                        yMin: null,
                        yMax: null
                    },
                    humidity: {
                        yMin: null,
                        yMax: null
                    },
                    maturityIndex: {
                        yMin: null,
                        yMax: null
                    },
                    strength: {
                        yMin: null,
                        yMax: null
                    }
                };

                scaleSettings.temperature.yMin = res.filter(r => r.key === 'TEMPERATURE_SCALE_YMIN').map(s => s.val)[0];
                scaleSettings.temperature.yMax = res.filter(r => r.key === 'TEMPERATURE_SCALE_YMAX').map(s => s.val)[0];
                scaleSettings.humidity.yMin = res.filter(r => r.key === 'HUMIDITY_SCALE_YMIN').map(s => s.val)[0];
                scaleSettings.humidity.yMax = res.filter(r => r.key === 'HUMIDITY_SCALE_YMAX').map(s => s.val)[0];
                scaleSettings.maturityIndex.yMin = res.filter(r => r.key === 'MATURITY_INDEX_SCALE_YMIN').map(s => s.val)[0];
                scaleSettings.strength.yMin = res.filter(r => r.key === 'MATURITY_STRENGTH_SCALE_YMIN').map(s => s.val)[0];
                $log.info("Successfully assigned scale settings: " + JSON.stringify(scaleSettings));
              
                updateChartScales(scaleSettings);
            }, function(err)  {
                const errData = err.data;
                showAlert("Error", "An error has occurred getting Scale Settings"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred getting scale settings: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            })
        };

        const updateChartScales = function(scaleSettings)  {
            if(scaleSettings)  {
                $log.info("Updating chart scales");
                vm.maturityStrengthGraphOptions.temperature.scales.yAxes[0].ticks.suggestedMin = scaleSettings.temperature.yMin ? parseInt(scaleSettings.temperature.yMin) : 0;
                vm.maturityStrengthGraphOptions.temperature.scales.yAxes[0].ticks.suggestedMax = scaleSettings.temperature.yMax ? parseInt(scaleSettings.temperature.yMax) : 0;
                vm.maturityStrengthGraphOptions.humidity.scales.yAxes[0].ticks.suggestedMin = scaleSettings.humidity.yMin ? parseInt(scaleSettings.humidity.yMin) : 0;
                vm.maturityStrengthGraphOptions.humidity.scales.yAxes[0].ticks.suggestedMax = scaleSettings.humidity.yMax ? parseInt(scaleSettings.humidity.yMax) : 0;

                vm.maturityStrengthGraphOptions.maturityIndex.scales.yAxes[0].ticks.suggestedMin = scaleSettings.maturityIndex.yMin ? parseInt(scaleSettings.maturityIndex.yMin) : 0;
                vm.maturityStrengthGraphOptions.maturityIndex.scales.yAxes[0].ticks.suggestedMax = scaleSettings.maturityIndex.yMax ? parseInt(scaleSettings.maturityIndex.yMax) : 0;
                vm.maturityStrengthGraphOptions.strength.scales.yAxes[0].ticks.suggestedMin = scaleSettings.strength.yMin ? parseInt(scaleSettings.strength.yMin) : 0;
                vm.maturityStrengthGraphOptions.strength.scales.yAxes[0].ticks.suggestedMax = scaleSettings.strength.yMax ? parseInt(scaleSettings.strength.yMax) : 0;
            }
        }
        

        const cancelMsjStatusAlarmNextLoad = function() {
            $timeout.cancel(msjStatusAlarmPollingPromise);
        };

        const msjStatusAlarmNextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || msjStatusAlarmPollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelMsjStatusAlarmNextLoad();

            if(isAlive)  {
                $log.debug("Poll maturity strength job status and alarm with delay: ".concat(pollingDelay).concat( " milliseconds"));
                msjStatusAlarmPollingPromise = $timeout(pollMaturityStrengthJobStatusAlarm, pollingDelay);
            }
        };

        const cancelSensorsDataNextLoad = function() {
            $timeout.cancel(sensorsDataPollingPromise);
        };

        const sensorsDataNextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || sensorsDataPollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelSensorsDataNextLoad();

            if(isAlive)  {
                $log.debug("Poll sensors with maturity strength data with delay: ".concat(pollingDelay).concat( " milliseconds"));
                sensorsDataPollingPromise = $timeout(pollSensorsWithMaturityStrengthData, pollingDelay);
            }
        };

        const cancelRefreshMasterDataNextLoad = function(dc) {
            $timeout.cancel(refreshMasterDataPromise[dc]);
        };

        const refreshMasterDataNextLoad = function(dc, pollingDelay) {
            pollingDelay = pollingDelay || refreshMasterDataPollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelRefreshMasterDataNextLoad(dc);

            if(isAlive)  {
                $log.debug("Refresh master data with delay (".concat(dc).concat("): ")
                    .concat(pollingDelay).concat( " milliseconds"));
                refreshMasterDataPromise[dc] = $timeout(refreshMasterData, pollingDelay, true, dc, vm.msj.granularityName);
            }
        };


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: true,
                multiple: true
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        init();



        $scope.$on('chart-create', function (event, chart) {
            const dc = chart.options.title.text;
            const parentDc = Object.keys(dataSubCategories).find(k => dataSubCategories[k] && dataSubCategories[k].length > 0 && dataSubCategories[k].includes(dc));
            if(!maturityStrengthGraphs[dc])  {
                
                maturityStrengthGraphs[dc] = chart;

                const extremities = getDataExtremities(dc, parentDc);
                
                chart.options.zoom.rangeMin.y = extremities.minY;
                chart.options.zoom.rangeMax.y = extremities.maxY * 1.5;
                chart.update();
            }
        });

        $scope.$on('chart-update', function (event, chart) {
            const dc = chart.options.title.text;
            const parentDc = Object.keys(dataSubCategories).find(k => dataSubCategories[k] && dataSubCategories[k].length > 0 && dataSubCategories[k].includes(dc));
        
            const extremities = getDataExtremities(dc, parentDc);
            
            chart.options.zoom.rangeMin.y = extremities.minY;
            chart.options.zoom.rangeMax.y = extremities.maxY * 1.5;
            chart.update();
        });

        $scope.$on('chart-destroy', function (event, chart) {
            const dc = chart.options.title.text;
            if(maturityStrengthGraphs[dc])  {
                maturityStrengthGraphs[dc] = null;
            }  
        });

          

        $scope.$on('$destroy', function() {
            $log.debug("MaturityStrengthJobCtrl scope destroyed. Stopping polling tasks...");
            cancelJobUpdatesPolling();
            cancelMasterPolling(true);

            Object.keys(maturityStrengthGraphs).forEach(c => {
                if(maturityStrengthGraphs[c])  {
                    maturityStrengthGraphs[c] = null;
                }
            });
            
            isAlive = false;
        });

    }

})();

/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-06-19
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.settings')
        .controller('AlarmCtrl', AlarmCtrl)
        .controller('NewEnvironSensorAlarmCtrl', NewEnvironSensorAlarmCtrl)
        .controller('NewChannelAlarmCtrl', NewChannelAlarmCtrl);

    /** @ngInject */
    function AlarmCtrl($log, $q, $mdDialog, toastr, LumiService, ChannelService, EnvironSensorService, EnvironSensorSettingsService, AlarmSettingsService) {
        let vm = this;
        vm.tenant = LumiService.getTenant();
        vm.readOnly = env.readOnly;
        vm.isEnvironSensorAlarmsLoading = true;
        vm.isChannelAlarmsLoading = true;
        vm.isEditingAlarm = false;

        let alert;


        const getEnvironSensors = function () {
            $log.info("Getting environ sensors");
            let deferred = $q.defer();
            EnvironSensorService.sensors.query({ tenant: vm.tenant }, function(res) {
                vm.environSensors = res.environSensorMessages.filter(e => e.display);
                vm.displayedEnvironSensors = [].concat(vm.environSensors);

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting environ sensors: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getChannelsWithAlarmData = function () {
            $log.info("Getting channels with alarm data");
            let deferred = $q.defer();
            ChannelService.channels.channelsWithAlarmData({ tenant: vm.tenant }, function(res) {
                vm.channels = res.channelMessages;
                vm.displayedChannels = [].concat(vm.channels);

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting channels with alarm data: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getAlarmsByAlarmType = function(alarmTypeName) {
            $log.info("Getting alarms by ".concat(alarmTypeName).concat(" alarm type"));
            let deferred = $q.defer();

            AlarmSettingsService.alarms.alarmsByAlarmType({ tenant: vm.tenant }, { alarmTypeName: alarmTypeName }, function(res) {
                switch(alarmTypeName)  {
                    case 'ENVIRON_SENSOR_THRESHOLD':
                        vm.environSensorAlarms = res.alarmMessages;
                        break;
                    case 'SENSOR_THRESHOLD':
                        vm.channelAlarms = res.alarmMessages;
                        break;
                    default:
                        // Should not happen
                        $log.error("Failed to get alarms by invalid alarm type ".concat(alarmTypeName));
                        deferred.resolve(false);
                        return;
                }
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting alarms by ".concat(alarmTypeName).concat(" alarm type: ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };


        vm.refreshEnvironSensorAlarms = function()  {
            $log.info("Refresh environ sensors and alarms");
            vm.isEnvironSensorAlarmsLoading = true;
            $q.all([
                getEnvironSensors(),
                getAlarmsByAlarmType("ENVIRON_SENSOR_THRESHOLD"),
            ]).then(function(res) {
                if(!res[0] && !res[1])  {
                    showAlert("Error", "An error has occurred getting Environment Sensors and Alarms");
                }
                else if(!res[0])  {
                    showAlert("Error", "An error has occurred getting Environment Sensors");
                }
                else if (!res[1])  {
                    showAlert("Error", "An error has occurred getting Alarms");
                }

                $log.info("Done refresh environ sensors and alarms".concat((!res[0] || !res[1]) ? " with error" : ""));
                vm.isEnvironSensorAlarmsLoading = false;
            });
        };

        vm.refreshChannelAlarms = function()  {
            $log.info("Refresh channels and alarms");
            vm.isChannelAlarmsLoading = true;
            $q.all([
                getChannelsWithAlarmData(),
                getAlarmsByAlarmType("SENSOR_THRESHOLD"),
            ]).then(function(res) {
                if(!res[0] && !res[1])  {
                    showAlert("Error", "An error has occurred getting Channels and Alarms");
                }
                else if(!res[0])  {
                    showAlert("Error", "An error has occurred getting Channels");
                }
                else if (!res[1])  {
                    showAlert("Error", "An error has occurred getting Alarms");
                }

                $log.info("Done refresh channels and alarms".concat((!res[0] || !res[1]) ? " with error" : ""));
                vm.isChannelAlarmsLoading = false;
            });
        };


        vm.onEnvironSensorAlarmChanged = function(environSensor, alarmMessage)  {
            let confirm = $mdDialog.confirm()
                .title("Confirmation")
                .textContent(alarmMessage ? "Are you sure you want to assign Alarm "
                    .concat(alarmMessage.alarmData.id).concat(" to Environment Sensor ").concat(environSensor.sensorId).concat("?") :
                    "Are you sure you want to unassign Alarm from Environment Sensor ".concat(environSensor.sensorId).concat("?"))
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
                // Assign environ sensor to local alarm data first, or null if alarm has been cleared
                if(alarmMessage)  {
                    environSensor.alarmData = alarmMessage.alarmData;
                }
                else  {
                    environSensor.alarmData = null;
                }

                // Perform server-side assignment of alarm
                assignEnvironSensorAlarm(environSensor.sensorId, environSensor.environSensorType, alarmMessage ? alarmMessage.alarmData.id : null);
            }, function()  {
                vm.refreshEnvironSensorAlarms();
            });
        };

        const assignEnvironSensorAlarm = function(environSensorId, environSensorType, alarmId)  {
            const reqBody = {
                environSensorId: environSensorId,
                environSensorType: environSensorType,
                alarmId: alarmId
            };

            EnvironSensorSettingsService.assignAlarm({ tenant: vm.tenant }, reqBody, function(res) {
                toastr.success(alarmId ? "Alarm ".concat(alarmId)
                    .concat(" has been assigned to Environment Sensor ")
                    .concat(environSensorId) :
                    "Alarm has been unassigned from Environment Sensor "
                        .concat(environSensorId));

                // Refresh environ sensors and alarms
                vm.refreshEnvironSensorAlarms();
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred ".concat(alarmId ? "assigning" : "unassigning")
                    .concat(" alarm ").concat(alarmId ? "to" : "from")
                    .concat(" Environment Sensor ").concat(environSensorId)
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred performing assignment of alarm to environ sensor with id "
                    .concat(environSensorId)
                    .concat(": ").concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));

                // Refresh environ sensors and alarms upon server error to ensure we are up-to-date with data
                if(errData)  {
                    vm.refreshEnvironSensorAlarms();
                }
            });
        };

        vm.onChannelAlarmChanged = function(channel, alarmMessage)  {
            let confirm = $mdDialog.confirm()
                .title("Confirmation")
                .textContent(alarmMessage ? "Are you sure you want to assign Alarm "
                    .concat(alarmMessage.alarmData.id).concat(" to all Sensors of Channel ").concat(channel.channelId)
                    .concat("?  This will override all existing Alarms in the Channel.") :
                    "Are you sure you want to unassign Alarm from all Sensors of Channel ".concat(channel.channelId)
                    .concat("?  This will override all existing Alarms in the Channel."))
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
                // Assign channel to local alarm data first, or null if alarm has been cleared
                if(alarmMessage)  {
                    channel.alarmData = alarmMessage.alarmData;
                }
                else  {
                    channel.alarmData = null;
                }

                // Perform server-side assignment of alarm
                assignChannelAlarm(channel.channelId, alarmMessage ? alarmMessage.alarmData.id : null);
            }, function()  {
                vm.refreshChannelAlarms();
            });
        };

        const assignChannelAlarm = function(channelId, alarmId)  {
            const reqBody = {
                channelId: channelId,
                alarmId: alarmId
            };

            ChannelService.channels.assignAlarm({ tenant: vm.tenant }, reqBody, function(res) {
                toastr.success(alarmId ? "Alarm ".concat(alarmId)
                    .concat(" has been assigned to Channel ")
                    .concat(channelId) :
                    "Alarm has been unassigned from Channel "
                        .concat(channelId));

                // Refresh channel and alarms
                vm.refreshChannelAlarms();
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred ".concat(alarmId ? "assigning" : "unassigning")
                    .concat(" alarm ").concat(alarmId ? "to" : "from")
                    .concat(" Channel ").concat(channelId)
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred performing assignment of alarm to Channel "
                    .concat(channelId)
                    .concat(": ").concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));

                // Refresh channels and alarms upon server error to ensure we are up-to-date with data
                if(errData)  {
                    vm.refreshChannelAlarms();
                }
            });
        };


        vm.setAlarmThresholds = function(oldAlarmData, newAlarmData, alarmTypeName)  {
            vm.isEditingAlarm = true;

            if(oldAlarmData.id)  {
                newAlarmData.id = oldAlarmData.id;
                Object.keys(newAlarmData).forEach(key => (!newAlarmData[key] && newAlarmData[key] !== undefined) && delete newAlarmData[key]);

                const reqBody = {alarmData: newAlarmData};
                AlarmSettingsService.alarms.update({ tenant: vm.tenant }, reqBody, function(res) {
                    toastr.success("Alarm ".concat(newAlarmData.id).concat(" has been updated successfully!"));

                    // Refresh so that all environ sensors or channels with the same alarm will have the updated values in the table
                    if(alarmTypeName === 'ENVIRON_SENSOR_THRESHOLD')  {
                        vm.refreshEnvironSensorAlarms();
                    }
                    else if(alarmTypeName === 'SENSOR_THRESHOLD')  {
                        vm.refreshChannelAlarms();
                    }
                }, function(err)  {
                    const errData = err.data;
                    toastr.error("An error has occurred updating Alarm"
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
                    $log.error("An error has occurred updating alarm: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));

                    // Refresh upon server error to ensure we are up-to-date with data
                    if(errData)  {
                        if(alarmTypeName === 'ENVIRON_SENSOR_THRESHOLD')  {
                            vm.refreshEnvironSensorAlarms();
                        }
                        else if(alarmTypeName === 'SENSOR_THRESHOLD')  {
                            vm.refreshChannelAlarms();
                        }
                    }
                }).$promise.finally(function()  {
                    vm.isEditingAlarm = false;
                });
            }
            else  {
                // Should not happen
                showAlert("Error", "This component has not been assigned an Alarm");
                $log.info("An error has occurred updating alarm with empty alarm data.  Old: "
                    .concat(JSON.stringify(oldAlarmData))
                    .concat(  "New: ").concat(JSON.stringify(newAlarmData)));

                vm.isEditingAlarm = false;
            }
        };


        vm.showNewEnvironSensorAlarmModal = function(ev, environSensorId, environSensorType) {
            $mdDialog.show({
                controller: 'NewEnvironSensorAlarmCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/settings/alarm/newEnvironSensorAlarmModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
                locals: {
                    environSensorId: environSensorId,
                    environSensorType: environSensorType,
                }
            }).then(function(response) {
                const newAlarmId = response.alarmData.id;
                $log.info("New alarm ".concat(newAlarmId).concat(" has been created successfully: ").concat(JSON.stringify(response)));
                toastr.success("New Environment Sensor Alarm ".concat(newAlarmId).concat(" has been created successfully!"));

                assignEnvironSensorAlarm(environSensorId, environSensorType, response.alarmData.id);
            }, function(errData)  {
                // Refresh environ sensors and alarms upon server error to ensure we are up-to-date with data
                if(errData)  {
                    vm.refreshEnvironSensorAlarms();
                }
            });
        };

        vm.showNewChannelAlarmModal = function(ev, channelId) {
            $mdDialog.show({
                controller: 'NewChannelAlarmCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/settings/alarm/newChannelAlarmModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
                locals: {
                    channelId: channelId,
                }
            }).then(function(response) {
                const newAlarmId = response.alarmData.id;
                $log.info("New alarm ".concat(newAlarmId).concat(" has been created successfully: ").concat(JSON.stringify(response)));
                toastr.success("New Channel Alarm ".concat(newAlarmId).concat(" has been created successfully!"));

                assignChannelAlarm(channelId, response.alarmData.id);
            }, function(errData)  {
                // Refresh channels and alarms upon server error to ensure we are up-to-date with data
                if(errData)  {
                    vm.refreshChannelAlarms();
                }
            });
        };

        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: false,
                skipHide: true,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };

    }

    function NewEnvironSensorAlarmCtrl($log, $timeout, $mdDialog, toastr, environSensorId, environSensorType, LumiService, AlarmSettingsService) {
        let vm = this;
        let tenant = LumiService.getTenant();

        vm.environSensorId = environSensorId;
        vm.environSensorType = environSensorType;
        vm.alarmData = {};


        vm.createAlarm = function(){
            return $timeout(1000)
                .then(function()  {
                    if(vm.alarmData)  {
                        vm.alarmData.alarmType = 'ENVIRON_SENSOR_THRESHOLD';
                        const reqBody = {alarmData: vm.alarmData};

                        AlarmSettingsService.alarms.save({ tenant: tenant }, reqBody, function(res) {
                            $mdDialog.hide(res);
                        }, function(err)  {
                            const errData = err.data;
                            toastr.error("An error has occurred creating Environment Sensor Alarm"
                                .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                            $log.error("An error has occurred creating environ sensor alarm: ".concat(errData ? JSON.stringify(errData) :
                                JSON.stringify(err)));
                            vm.cancel(errData);
                        });
                    }
                    else  {
                        // Should not happen
                        toastr.error("An error has occurred creating Environment Sensor Alarm (null alarm)");
                        vm.cancel();
                    }
                });
        };

        vm.cancel = function(errData) {
            if(errData)  {
                $mdDialog.cancel(errData);
            }
            else  {
                $mdDialog.cancel();
            }
        };
    }

    function NewChannelAlarmCtrl($log, $timeout, $mdDialog, toastr, channelId, LumiService, AlarmSettingsService) {
        let vm = this;
        let tenant = LumiService.getTenant();

        vm.channelId = channelId;
        vm.alarmData = {};

        
        vm.createAlarm = function(){
            return $timeout(1000)
                .then(function()  {
                    if(vm.alarmData)  {
                        vm.alarmData.alarmType =  'SENSOR_THRESHOLD';
                        const reqBody = {alarmData: vm.alarmData};

                        AlarmSettingsService.alarms.save({ tenant: tenant }, reqBody, function(res) {
                            $mdDialog.hide(res);
                        }, function(err)  {
                            const errData = err.data;
                            toastr.error("An error has occurred creating Channel Alarm"
                                .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                            $log.error("An error has occurred creating channel alarm: ".concat(errData ? JSON.stringify(errData) :
                                JSON.stringify(err)));
                            vm.cancel(errData);
                        });
                    }
                    else  {
                        // Should not happen
                        toastr.error("An error has occurred creating Channel Alarm (null alarm)");
                        vm.cancel();
                    }
                });
        };

        vm.cancel = function(errData) {
            if(errData)  {
                $mdDialog.cancel(errData);
            }
            else  {
                $mdDialog.cancel();
            }
        };
    }

})();
/**
 * Created by Charles Fung on 2017-06-19.
 */
/*jslint bitwise: true */
/*jshint esversion: 6 */
/*eslint-env es6 */


/**
 * @author Charles Fung
 * created on 2017-06-27
 */
(function () {
    'use strict';
    angular.module('AomsLumi.pages.settings')
        .controller('ChannelCtrl', ChannelCtrl)
        .controller('SensorConfigCtrl', SensorConfigCtrl);

    /** @ngInject */
    function ChannelCtrl($log, $q, $timeout, $mdDialog, toastr, env, LumiService, InternalSettingsService, ChannelData, ChannelService) {
        // TODO: Change deferred.resolve(false) to deferred.reject()
        let vm = this;
        vm.tenant = LumiService.getTenant();
        vm.readOnly = env.readOnly;
        vm.isLoading = false;
        vm.isChannelsLoading = false;

        vm.enableFileBasedChannelSettings = env.enableFileBasedChannelSettings;
        vm.enableFileBasedSensorsCalibrations = env.enableFileBasedSensorsCalibrations;
        let numSensors = 0;

        vm.isSelectingChannelSettingsFile = false;
        vm.isSelectingCalibrationFile = false;
        vm.isExecutingChannelSettingsRequests = false;
        vm.isExecutingSensorsCalibration = false;

        vm.hasChannelSettingsRequests = false;
        // TODO: define channel settings file regex
        const channelSettingsFileRegex = /^.*.cfg$/;

        vm.hasSensorsCalibration = false;
        const sensorConfigurationFileRegex = /^CAL_(MTS|LPS|MHS)-(\d+).cfg$/;

        vm.selectedChannelIndex = null;

        vm.isInit = false;

        let alert;


        vm.init = function()  {
            if(!vm.isInit)  {
                $log.info("Initializing Channel Settings page");
                vm.isLoading = true;
                $q.all([
                    getNumSensors(),
                    vm.getChannels(),
                ]).then(function(res) {
                    if(!res[0] || !res[1])  {
                        showAlert("Error", "An error has occurred initializing the Channel Settings page");
                    }
                    else  {
                        $log.info("Channel Settings page initialized: numChannels %d, numSensors %s", vm.channels ? vm.channels.length : 0, numSensors);
                        vm.isInit = true;
                    }
                    vm.isLoading = false;
                });
            }
        };

        const getNumSensors = function()  {
            let deferred = $q.defer();
            InternalSettingsService.settings.get({ tenant: vm.tenant, key: "ENFORCED_NUM_SENSORS" }, function(res)  {
                numSensors = parseInt(res.val);
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting ENFORCED_NUM_SENSORS internal setting: "
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };

/******************************************** File-Based Configuration *************************************************/
        vm.onChannelSettingsFileChanged = function() {
            vm.isSelectingChannelSettingsFile = true;
            if(vm.channelSettingsFile)  {
                $log.info("Channel settings file changed");

                // Valid channel settings file must match the channel settings file regex
                const match = vm.channelSettingsFile.name.match(channelSettingsFileRegex);
                if(match)  {
                    const numChannels = vm.channels ? vm.channels.length : 0;

                    if(vm.channels && numChannels > 0)  {
                        ChannelData.createChannelSettingsData(numChannels, vm.channelSettingsFile)
                            .then(function(res) {
                                if(res)  {
                                    if(res.status === 'Valid')  {
                                        vm.channelSettingsRequests = res.data.map(cs => {
                                            cs.isDiagnostic = false;
                                            return cs;
                                        });

                                        $log.info("New Channel Settings requests created: " + JSON.stringify(vm.channelSettingsRequests));
                                        vm.hasChannelSettingsRequests = true;
                                        vm.isSelectingChannelSettingsFile = false;
                                    }
                                    else  {
                                        showAlert("Error", res.status === 'Error' ? "An error has occurred processing Channel Settings File" :
                                            "An error has occurred processing Channel Settings File.  " + res.status + " File.");
                                        resetChannelSettingsFile();
                                    }
                                }
                                else  {
                                    // Should not happen
                                    showAlert("Error", "An unexpected error has occurred processing Channel Settings File");
                                    $log.error("An unexpected error has occurred processing channel settings file");
                                    resetChannelSettingsFile();
                                }
                            }, function(err) {
                                showAlert("Error", "An unexpected error has occurred processing Channel Settings File");
                                $log.error("An unexpected error has occurred processing channel settings file: ".concat(JSON.stringify(err)));
                                resetChannelSettingsFile();
                            });
                    }
                    else  {
                        showAlert("Error", "Cannot process Channel Settings File as no Channels are available");
                        resetChannelSettingsFile();
                    }
                }
                else  {
                    showAlert("Error", "An invalid Channel Settings File has been selected");
                    resetChannelSettingsFile();
                }
            }
            else  {
                //showAlert("Error", "Channel Settings File is undefined");
                //$log.error("Channel settings file is undefined");
                resetChannelSettingsFile();
            }
        };

        vm.onSensorsCalibrationFileChanged = function() {
            vm.isSelectingCalibrationFile = true;
            if(vm.sensorsCalibrationFile)  {
                $log.info("Sensors calibration file changed");

                // Valid sensors calibration file must match the sensor calibration file regex
                const match = vm.sensorsCalibrationFile.name.match(sensorConfigurationFileRegex);
                if(match)  {
                    const calibrationFileType = match[1];
                    const serialNumber = calibrationFileType + '-' + match[2];
                    const channelId = vm.channels.filter(c => c.serialNumber === serialNumber).map(c => c.channelId)[0];

                    if(channelId)  {
                        ChannelData.createSensorsCalibrationData(channelId, serialNumber, calibrationFileType, numSensors, vm.sensorsCalibrationFile)
                            .then(function(res) {
                                if(res)  {
                                    if(res.status === 'Valid')  {
                                        const calibrationFileTypes = ChannelData.getCalibrationFileTypes();
                                        const calibrationFileType = res.calibrationFileType;
                                        switch(calibrationFileType)  {
                                            case calibrationFileTypes.calibrationMTS:
                                                vm.calibrationMTSRequests = {
                                                    channelId: channelId,
                                                    serialNumber: serialNumber,
                                                    isDiagnostic: false,
                                                    calibrationMTSData: res.data
                                                };
                                                $log.info("New Calibration MTS requests created: " + JSON.stringify(vm.calibrationMTSRequests));
                                                vm.hasSensorsCalibration = true;
                                                vm.isSelectingCalibrationFile = false;
                                                return;
                                            case calibrationFileTypes.calibrationLPS:
                                            case calibrationFileTypes.calibrationMHS:
                                            default:
                                                showAlert("An error has occurred processing Sensors Calibration File.  Unsupported File.");
                                                resetSensorsCalibrationFile();
                                                break;
                                        }
                                    }
                                    else  {
                                        showAlert("Error", res.status === 'Error' ? "An error has occurred processing Sensors Calibration File" :
                                            "An error has occurred processing Sensors Calibration File.  " + res.status + " File.");
                                        resetSensorsCalibrationFile();
                                    }
                                }
                                else  {
                                    // Should not happen
                                    showAlert("Error", "An unexpected error has occurred processing Sensors Calibration File");
                                    $log.error("An unexpected error has occurred processing sensors calibration file");
                                    resetSensorsCalibrationFile();
                                }
                            }, function(err) {
                                showAlert("Error", "An unexpected error has occurred processing Sensors Calibration File");
                                $log.error("An unexpected error has occurred processing sensors calibration file: ".concat(JSON.stringify(err)));
                                resetSensorsCalibrationFile();
                            });
                    }
                    else  {
                        showAlert("Error", "The Sensors Calibration File selected does not correspond to any existing Channels");
                        resetSensorsCalibrationFile();
                    }
                }
                else  {
                    showAlert("Error", "An invalid Sensors Calibration File has been selected");
                    resetSensorsCalibrationFile();
                }
            }
            else  {
                // Should not happen
                showAlert("Error", "Sensors Calibration File is undefined");
                $log.error("Sensors calibration file is undefined");
                resetSensorsCalibrationFile();
            }
        };


        vm.executeChannelSettingsRequests = function()  {
            // TODO: Execute Channel Settings Requests
            vm.isExecutingChannelSettingsRequests = true;
            return $timeout(1000)
                .then(function()  {
                    vm.isExecutingChannelSettingsRequests = false;
                });
        };


        vm.executeSensorsCalibration = function()  {
            return $timeout(1000)
                .then(function()  {
                    if(vm.calibrationMTSRequests)  {
                        executeCalibrationMTS();
                    }
                    else if (vm.calibrationLPSRequests)  {
                        executeCalibrationLPS();
                    }
                    else if (vm.calibrationMHSRequests)  {
                        executeCalibrationMHS();
                    } 
                });
        };

        const executeCalibrationMTS = function()  {
            $log.info("Creating and assigning from calibration MTS data");
            vm.isExecutingSensorsCalibration = true;
            ChannelService.sensors.updateMTSList({ tenant: vm.tenant }, vm.calibrationMTSRequests, function(res) {
                toastr.success("Temperature Sensors have been calibrated successfully!");
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred calibrating Temperature Sensors"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred calibrating Temperature Sensors"
                    .concat(": ").concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
            }).$promise.finally(function()  {
                vm.isExecutingSensorsCalibration = false;
                resetSensorsCalibrationFile();
            });
        };

        const executeCalibrationLPS = function()  {
            // TODO: Execute Calibration LPS
        };

        const executeCalibrationMHS = function()  {
            // TODO: Execute Calibration MHS
        };


        const resetChannelSettingsFile = function()  {
            $log.info("Resetting Channel Settings states");
            if(vm.channelSettingsFile)  vm.channelSettingsFile = null;
            if(vm.channelSettingsRequests)  vm.channelSettingsRequests = undefined;

            vm.hasChannelSettingsRequests = false;
            vm.isSelectingChannelSettingsFile = false;
        };

        const resetSensorsCalibrationFile = function()  {
            $log.info("Resetting Sensors Calibrations states");
            if(vm.sensorsCalibrationFile)  vm.sensorsCalibrationFile = null;
            if(vm.calibrationMTSRequests)  vm.calibrationMTSRequests = undefined;

            vm.hasSensorsCalibration = false;
            vm.isSelectingCalibrationFile = false;
        };
/************************************************ End File-Based Configuration******************************************/

/****************************************************** User Configuration**********************************************/
        vm.getChannels = function () {
            $log.info("Getting channels");
            vm.isChannelsLoading = true;
            let deferred = $q.defer();

            ChannelService.channels.query({ tenant: vm.tenant }, function(res) {
                vm.channels = res.channelMessages;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting channels: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));

                deferred.resolve(false);
            }).$promise.finally(function()  {
                vm.isChannelsLoading = false;
            });
            return deferred.promise;
        };

        vm.getSensors = function(channelId) {
            $log.info("Getting sensors");
            let deferred = $q.defer();

            ChannelService.sensors.sensorsByChannelId({ tenant: vm.tenant, channelId: channelId }, function(res) {
                vm.sensors = res.sensorMessages;

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting sensors: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));

                deferred.resolve(false);
            });
            return deferred.promise;
        };

        vm.getChannelSettings = function(channelId) {
            $log.info("Getting channel settings for channel ".concat(channelId));
            let deferred = $q.defer();

            ChannelService.settings.query({ tenant: vm.tenant, channelId: channelId }, function(res) {
                vm.channelsettings = res;
                if(!vm.channelsettings || !vm.channelsettings.channelId)  {
                    vm.channelsettings.channelId = channelId;
                }
                
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting channel settings for channel ".concat(channelId)
                    .concat(": ").concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.resolve(false);
            });

            return deferred.promise;
        };


        vm.onChannelSelected = function(index, channelId, serialNumber)  {
            $log.info("Channel ".concat(channelId).concat(" selected.  Getting sensors and settings."));
            vm.isChannelsLoading = true;
            vm.selectedChannelId = channelId;
            vm.selectedSerialNumber = serialNumber;

            $q.all([
                vm.getSensors(channelId),
                vm.getChannelSettings(channelId)
            ]).then(function(res) {
                if(!res[0] || !res[1])  {
                    if(!res[0] && !res[1])  {
                        showAlert("Error", "An error has occurred getting Sensors and Settings for Channel ".concat(channelId));
                    }
                    else if(!res[0])  {
                        showAlert("Error", "An error has occurred getting Sensors for Channel ".concat(channelId));
                    }
                    else if (!res[1])  {
                        showAlert("Error", "An error has occurred getting Settings for Channel ".concat(channelId));
                    }
                    vm.selectedChannelIndex = null;
                }
                else  {
                    if (vm.selectedChannelIndex === null) {
                        vm.selectedChannelIndex = index;
                    }
                    else {
                        vm.selectedChannelIndex = (vm.selectedChannelIndex === index) ? null : index;
                    }
                }

                vm.selectedSensor = null;
                vm.isChannelsLoading = false;
                $log.log("Done getting channel sensors and settings for channel ".concat(channelId)
                    .concat((!res[0] || !res[1]) ? " with error" : ""));
            }).finally(function()  {
            	vm.isChannelsLoading = false;
            });
        };

        vm.updateChannelSettings = function(){
            $log.info("Update channel settings for channel ".concat(vm.selectedChannelId));
            return $timeout(1000)
                .then(function() {
                    const reqBody = vm.channelsettings;

                    ChannelService.settings.update({ tenant: vm.tenant }, reqBody, function(res) {
                        toastr.success("Channel Settings has been saved successfully!");
                    }, function(err)  {
                        const errData = err.data;
                        toastr.error("An error has occurred saving Channel Settings for Channel ".concat(vm.selectedChannelId)
                            .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                        $log.error("An error has occurred saving channel settings for channel ".concat(vm.selectedChannelId)
                            .concat(": ").concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                    });
                });
        };


        vm.showSensorConfigModal = function(ev) {
            $mdDialog.show({
                controller: 'SensorConfigCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/settings/channel/sensorConfigModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
                locals: {
                    selectedChannelId: vm.selectedChannelId,
                    selectedSensorId: vm.selectedSensor.sensorId,
                    selectedSensorType: vm.selectedSensor.sensorType
                }
            }).then(function(response) {
                $log.info("Configuration has been saved successfully for Channel ".concat(vm.selectedChannelId).concat(" Sensor ")
                    .concat(vm.selectedSensor.sensorId).concat(": ").concat(JSON.stringify(response)));
                toastr.success("Configuration has been saved successfully!");
            }, function(errData)  {
                // Refresh channels upon server error to ensure we are up-to-date with data
                if(errData)  {
                    vm.getChannels();
                    vm.selectedSensor = null;
                    vm.selectedChannelIndex = null;
                }
            });
        };
/************************************************** End User Configuration**********************************************/


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: true,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        vm.init();
    }

    function SensorConfigCtrl($log, $timeout, $mdDialog, toastr, selectedChannelId, selectedSensorId, selectedSensorType, 
        LumiService, ChannelService) {
        let vm = this;
        let tenant = LumiService.getTenant();

        vm.readOnly = env.readOnly;
        
        vm.channelId = selectedChannelId;
        vm.sensorId = selectedSensorId;
        vm.sensorType = selectedSensorType;


        vm.getConfiguration = function() {
            switch (vm.sensorType.toUpperCase()) {
                case 'TEMPERATURE':
                    vm.getCalibrationMTS();
                    break;
                case 'PRESSURE':
                    vm.getCalibrationLPS();
                    break;
                case 'HUMIDITY':
                    vm.getCalibrationMHS();
                    break;
                default:
                    const errData = "An error has occurred getting configuration for Channel ".concat(vm.channelId)
                        .concat(" Sensor ").concat(vm.sensorId)
                        .concat(": Invalid Sensor Type");

                    toastr.error(errData);
                    $log.error("Failed to get configuration for Channel ".concat(vm.channelId).concat(" Sensor ")
                        .concat(vm.sensorId).concat(" due to invalid sensor type ").concat(vm.sensorType));

                    vm.cancel(errData);
                    break;
            }
        };

        vm.getCalibrationMTS = function()  {
            $log.info("Getting calibrationMTS");
            const reqBody = {
                channelId: vm.channelId,
                sensorId: vm.sensorId
            };

            ChannelService.sensors.getMTS({ tenant: tenant }, reqBody, function(res) {
                vm.calibrationMTSData = res.calibrationMTSData[0];
                if(!vm.calibrationMTSData)  {
                    vm.calibrationMTSData = {
                        sensorId: vm.sensorId
                    }
                }
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred getting Calibration MTS for Channel ".concat(vm.channelId)
                    .concat(" Sensor ").concat(vm.sensorId)
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred getting calibration MTS for Channel ".concat(vm.channelId)
                    .concat(" Sensor ").concat(vm.sensorId)
                    .concat(": ").concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                vm.cancel(errData);
            });
        };

        vm.getCalibrationLPS = function()  {
            $log.info("Getting calibrationLPS");
            const reqBody = {
                channelId: vm.channelId,
                sensorId: vm.sensorId
            };

            ChannelService.sensors.getLPS({ tenant: tenant }, reqBody, function(res) {
                vm.calibrationLPSData = res.calibrationLPSData[0];
                if(!vm.calibrationLPSData)  {
                    vm.calibrationLPSData = {
                        sensorId: vm.sensorId
                    }
                }
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred getting Calibration LPS for Channel ".concat(vm.channelId)
                    .concat(" Sensor ").concat(vm.sensorId)
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred getting calibration LPS for Channel ".concat(vm.channelId)
                    .concat(" Sensor ").concat(vm.sensorId)
                    .concat(": ").concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                vm.cancel(errData);
            });
        };

        vm.getCalibrationMHS = function()  {
            $log.info("Getting calibrationMHS");
            const reqBody = {
                channelId: vm.channelId,
                sensorId: vm.sensorId
            };

            ChannelService.sensors.getMHS({ tenant: tenant }, reqBody, function(res) {
                vm.calibrationMHSData = res.calibrationMHSData[0];
                if(!vm.calibrationMHSData)  {
                    vm.calibrationMHSData = {
                        sensorId: vm.sensorId
                    }
                }
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred getting Calibration MHS for Channel ".concat(vm.channelId)
                    .concat(" Sensor ").concat(vm.sensorId)
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred getting calibration MHS for Channel ".concat(vm.channelId)
                    .concat(" Sensor ").concat(vm.sensorId)
                    .concat(": ").concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                vm.cancel(errData);
            });
        };


        vm.updateCalibrationMTS = function(){
            return $timeout(1000)
                .then(function()  {
                    if(vm.calibrationMTSData)  {
                        const reqBody = {
                            channelId: vm.channelId,
                            isDiagnostic: false,
                            calibrationMTSData: vm.calibrationMTSData
                        };

                        ChannelService.sensors.updateMTS({ tenant: tenant }, reqBody, function(res) {
                            $mdDialog.hide(res);
                        }, function(err)  {
                            const errData = err.data;
                            toastr.error("An error has occurred saving Calibration MTS for Channel ".concat(vm.channelId)
                                .concat(" Sensor ").concat(vm.sensorId)
                                .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                            $log.error("An error has occurred saving CalibrationMTS for Channel ".concat(vm.channelId)
                                .concat(" Sensor ").concat(vm.sensorId).concat(": ").concat(errData ? JSON.stringify(errData) :
                                JSON.stringify(err)));
                            vm.cancel(errData);
                        });
                    }
                    else  {
                        // Should not happen
                        toastr.error("An error has occurred saving Calibration MTS for Channel ".concat(vm.channelId)
                            .concat(" Sensor ").concat(vm.sensorId).concat(" (null Calibration MTS)"));
                        vm.cancel();
                    }
                });
        };

        vm.updateCalibrationLPS = function(){
            return $timeout(1000)
                .then(function()  {
                    if(vm.calibrationLPSData)  {
                        const reqBody = {
                            channelId: vm.channelId,
                            isDiagnostic: false,
                            calibrationLPSData: vm.calibrationLPSData
                        };

                        ChannelService.sensors.updateLPS({ tenant: tenant }, reqBody, function(res) {
                            $mdDialog.hide(res);
                        }, function(err)  {
                            const errData = err.data;
                            toastr.error("An error has occurred saving Calibration LPS for Channel ".concat(vm.channelId)
                                .concat(" Sensor ").concat(vm.sensorId)
                                .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                            $log.error("An error has occurred saving CalibrationLPS for Channel ".concat(vm.channelId)
                                .concat(" Sensor ").concat(vm.sensorId).concat(": ").concat(errData ? JSON.stringify(errData) :
                                    JSON.stringify(err)));
                            vm.cancel(errData);
                        });
                    }
                    else  {
                        // Should not happen
                        toastr.error("An error has occurred saving Calibration LPS for Channel ".concat(vm.channelId)
                            .concat(" Sensor ").concat(vm.sensorId).concat(" (null Calibration LPS)"));
                        vm.cancel();
                    }
                });
        };

        vm.updateCalibrationMHS = function(){
            return $timeout(1000)
                .then(function()  {
                    if(vm.calibrationMHSData)  {
                        const reqBody = {
                            channelId: vm.channelId,
                            isDiagnostic: false,
                            calibrationMHSData: vm.calibrationMHSData
                        };

                        ChannelService.sensors.updateMHS({ tenant: tenant }, reqBody, function(res) {
                            $mdDialog.hide(res);
                        }, function(err)  {
                            const errData = err.data;
                            toastr.error("An error has occurred saving Calibration MHS for Channel ".concat(vm.channelId)
                                .concat(" Sensor ").concat(vm.sensorId)
                                .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                            $log.error("An error has occurred saving CalibrationMHS for Channel ".concat(vm.channelId)
                                .concat(" Sensor ").concat(vm.sensorId).concat(": ").concat(errData ? JSON.stringify(errData) :
                                JSON.stringify(err)));
                            vm.cancel(errData);
                        });
                    }
                    else  {
                        // Should not happen
                        toastr.error("An error has occurred saving Calibration MHS for Channel ".concat(vm.channelId)
                            .concat(" Sensor ").concat(vm.sensorId).concat(" (null Calibration MHS)"));
                        vm.cancel();
                    }
                });
        };


        vm.cancel = function() {
            $mdDialog.cancel();
        };



        vm.getConfiguration();
    }
})();
/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-06-27
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.settings')
        .controller('EmailNotificationCtrl', EmailNotificationCtrl)
        .controller('NewEmailCtrl', NewEmailCtrl);

    /** @ngInject */
    function EmailNotificationCtrl($log, $mdDialog, toastr, LumiService, EmailNotificationSettingsService) {
        let vm = this;
        vm.readOnly = env.readOnly;
        vm.isLoading = true;
        vm.isToggling = false;

        let alert;

        vm.tenant = LumiService.getTenant();


        const getNotificationEmails = function () {
            $log.info("Getting all notification emails");

            EmailNotificationSettingsService.emailNotifications.query({ tenant: vm.tenant }, function(res) {
                vm.emails = res.emailNotificationMessages;
            }, function(err)  {
                const errData = err.data;
                showAlert("Error", "An error has occurred getting Notification Emails"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred getting notification emails: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            }).$promise.finally(function()  {
                vm.isLoading = false;
            });
        };

        vm.deleteNotificationEmail = function(emailNotificationMessage) {
            const id = emailNotificationMessage.id;
            const email = emailNotificationMessage.email;

            EmailNotificationSettingsService.emailNotifications.delete({ id: id, tenant: vm.tenant }, function(res) {
                toastr.success(email.concat(" has been removed successfully!"));
                if(vm.emails)  {
                    vm.emails = vm.emails.filter(e => e.id !== id);
                }
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred removing Notification Email"
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred removing notification email: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
            });
        };

        vm.toggleEmailNotification = function(emailNotificationMessage)  {
            vm.isToggling = true;
            const id = emailNotificationMessage.id;
            const email = emailNotificationMessage.email;
            const isActive = emailNotificationMessage.isActive;

            const reqBody = {
                "id": id,
                "isActive": isActive
            };

            EmailNotificationSettingsService.emailNotifications.toggle({ tenant: vm.tenant }, reqBody, function(res) {
                $log.info(JSON.stringify(res));
                toastr.success("Email Notification for "
                    .concat(email)
                    .concat(" has been ")
                    .concat(isActive ? "activated" : "deactivated"));
            }, function(err)  {
                emailNotificationMessage.isActive = !emailNotificationMessage.isActive;

                const errData = err.data;
                let errMessage = "An error has occurred "
                    .concat(isActive ? "activating " : "deactivating ")
                    .concat("Email Notification for ")
                    .concat(email);

                toastr.error(errMessage.concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error(errMessage.concat(": ")
                    .concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
            }).$promise.finally(function()  {
                vm.isToggling = false;
            });
        };



        vm.showNewEmailModal = function(ev) {
            $mdDialog.show({
                controller: 'NewEmailCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/settings/email/newEmailModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
            }).then(function(response) {
                $log.info("New notification email has been created successfully: ".concat(JSON.stringify(response)));
                toastr.success(response.email.concat(" has been added successfully!"));
                vm.emails.push(response);
            }, function(errData)  {
            });
        };

        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: false,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        getNotificationEmails();
    }



    function NewEmailCtrl($log, $timeout, $mdDialog, toastr, LumiService, EmailNotificationSettingsService) {
        let vm = this;
        let tenant = LumiService.getTenant();

        vm.newEmail = null;

        
        vm.addNotificationEmail = function(){
            return $timeout(1000)
                .then(function()  {
                    if(vm.newEmail)  {
                        const reqBody = {
                            email: vm.newEmail,
                            isActive: true
                        };

                        EmailNotificationSettingsService.emailNotifications.save({ tenant : tenant }, reqBody, function(res) {
                            $mdDialog.hide(res);
                        }, function(err)  {
                            const errData = err.data;
                            toastr.error("An error has occurred adding Notification Email"
                                .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                            $log.error("An error has occurred creating notification email: ".concat(errData ? JSON.stringify(errData) :
                                JSON.stringify(err)));
                            vm.cancel();
                        });
                    }
                    else  {
                        // Should not happen
                        toastr.error("An error has occurred adding Notification Email (null email)");
                        vm.cancel();
                    }
                });
        };

        vm.cancel = function() {
            $mdDialog.cancel();
        };
    }

})();
/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2017-06-27
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.settings')
        .controller('GeneralCtrl', GeneralCtrl);

    /** @ngInject */
    function GeneralCtrl($log, $timeout, $mdDialog, toastr, LumiService, GeneralSettingsService) {
        let vm = this;
        vm.tenant = LumiService.getTenant();
        vm.readOnly = env.readOnly;
        vm.isLoading = true;

        let alert;
        

        const getGeneralSettings = function () {
            $log.info("Getting general settings");
            GeneralSettingsService.settings.query({ tenant : vm.tenant }, function(res) {
                    vm.generalsettings = res.filter(g => g.isDisplay);
                }, function(err)  {
                    const errData = err.data;
                    showAlert("Error", "An error has occurred getting General Settings"
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                    $log.error("An error has occurred getting general settings: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                }).$promise.finally(function()  {
                    vm.isLoading = false;
                });
        };

        vm.updateGeneralSettings = function(){
            return $timeout(1000)
                .then(function() {
                    $log.info("Update general settings");
                    const reqBody = vm.generalsettings.reduce(function(map, setting) {
                        map[setting.key] = setting.val;
                        return map;
                    }, {});

                    GeneralSettingsService.settings.updateAll({ tenant : vm.tenant }, reqBody, function(res) {
                        toastr.success("General Settings has been saved successfully!");
                    }, function(err)  {
                        const errData = err.data;
                        toastr.error("An error has occurred saving General Settings"
                            .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                        $log.error("An error has occurred saving general settings: ".concat(errData ? JSON.stringify(errData) :
                            JSON.stringify(err)));
                    });
                });
        };


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: false,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        getGeneralSettings();
    }

})();

/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 2018-05-10
 */
(function () {
    'use strict';

    angular.module('AomsLumi.pages.settings')
        .controller('UserCtrl', UserCtrl);

    /** @ngInject */
    function UserCtrl($log, $timeout, $q, $mdDialog, $window, toastr, 
        LumiService, AuthService, UserSettingsService) {
        let vm = this;
        vm.readOnly = env.readOnly;
        vm.isLoading = true;

        let alert;

        let isInit = false;
        let companyId = null;
        let username;


        const getUserSettings = function () {
            $log.info("Getting user settings");
            let deferred = $q.defer();

            let params = {
                username: username,
                companyId: companyId
            };

            UserSettingsService.settings.getUserSettings(params, function(res) {
                vm.usersettings = res.filter(u => u.isDisplay);
                
                // Partially replace the user settings with the ones from session storage if applicable
                if(env.readOnly)  {
                    const usersettings = sessionStorage.getItem('key_AOMS_LUMI_USERSETTINGS');
                    if(usersettings)  {
                        const usersettingsJson = JSON.parse(usersettings);
                        if(usersettingsJson && usersettingsJson.length > 0)  {
                            const usersettingsIds = usersettingsJson.map(s => s.id);
                            vm.usersettings = vm.usersettings.filter(s => !usersettingsIds.includes(s.id))
                                .concat(usersettingsJson)
                                .sort((a, b) => a.id - b.id);
                        }
                    }
                }

                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;

                $log.error("An error has occurred getting user settings: ".concat(errData ? JSON.stringify(errData) :
                    JSON.stringify(err)));
                    deferred.resolve(false);
            });
            return deferred.promise;
        };

        const getUserSettingOptions = function () {
            $log.info("Getting user setting options");
            let deferred = $q.defer();
            UserSettingsService.settings.getUserSettingOptions(function(res) {
                    vm.usersettingOptions = res;
                    deferred.resolve(true);
                }, function(err)  {
                    const errData = err.data;

                    $log.error("An error has occurred getting user setting options: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                        deferred.resolve(false);
                });
                return deferred.promise;
        };

        const refresh = function()  {
            $log.info("Refresh user settings");
            
            $q.all([
                getUserSettings(),
                getUserSettingOptions()
            ]).then(function(res) {
                const err = (!res[0] || !res[1]);
                
                vm.isLoading = false;
                $log.info("Done refresh user settings".concat(err ? " with error" : ""));
            });
        };

        const init = function()  {
            if(!isInit)  {
                const companyInfo = LumiService.companyInfo();
                companyId = companyInfo ? companyInfo.companyId : null;

                $log.info("Initializing User Settings page");
                const userInfo = AuthService.userInfo();
                if(userInfo)  {
                    username = userInfo.username;
                    isInit = true;

                    refresh();
                }
            }
        };


        vm.filterUserSettingOptions = function(userSettingType)  {
            if(vm.usersettingOptions[userSettingType])  {
                return vm.usersettingOptions[userSettingType].map(o => o.val);
            }
            return [];
        };

        vm.updateUserSettings = function(){
            return $timeout(1000)
                .then(function() {
                    $log.info("Update user settings");
                    if(vm.readOnly)  {
                        let confirm = $mdDialog.confirm()
                        .title("Warning")
                        .textContent("The system is currently not in a mode that supports write operations.  Update selected user settings temporarily for this session only?")
                        .targetEvent(event)
                        .ok('Yes')
                        .cancel('Cancel');
    
                        $mdDialog.show(confirm).then(function() {
                            // If in read-only mode, put into sessionStorage the user settings that support read-only mode
                            $log.info("Put user settings that support read-only mode into session storage");
                            const filteredUserSettings = vm.usersettings.filter(s => s.supportReadOnly);
                            if(filteredUserSettings && filteredUserSettings.length > 0)  {
                                sessionStorage.setItem('key_AOMS_LUMI_USERSETTINGS', JSON.stringify(filteredUserSettings));
                                toastr.success("Selected User Settings has been temporarily updated for this session");
                            }
                            else  {
                                // Should not happen
                                toastr.error("Failed to update selected User Settings temporarily");
                            }
                        }, function()  {
                            refresh();
                        });       
                    }   
                    else  {
                        let params = {
                            companyId: companyId,
                            username: username
                        };

                        UserSettingsService.settings.updateUserSettings(params, vm.usersettings, function(res) {
                            toastr.success("User Settings has been saved successfully!");
                        }, function(err)  {
                            const errData = err.data;
                            toastr.error("An error has occurred saving General Settings"
                                .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                            $log.error("An error has occurred saving general settings: ".concat(errData ? JSON.stringify(errData) :
                                JSON.stringify(err)));
                        });
                    } 
                });
        };


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                ok: 'Close',
                clickOutsideToClose: false,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };



        init();
    }

})();

/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('MaturityStrengthData', function (LumiService) {
            const serverUrl = LumiService.getServerUrl();

            if(serverUrl)  {
                return {
                    getHistoricalDataFileLink: function(tenant, msjId, from, to, fileTypeName, displayTZ, sortdir, customFilename)  {
                        const userInfo = JSON.parse(localStorage.getItem('key_AOMS_LUMI_USERINFO'));
                        if(userInfo && userInfo.token)  {
                            try {
                                const authTokenParam = "&auth_token=" + userInfo.token;
                                
                                return serverUrl + "/analytics/lumicon/data/maturity/file?tenant=" + tenant + 
                                    "&msjId=" + msjId + 
                                    (customFilename ? ('&customFilename=' + customFilename) : '') +
                                    "&from=" + from.valueOf() + "&to=" + to.valueOf() +
                                    "&format=" + fileTypeName + "&timezone=" + displayTZ + 
                                    "&sortdir=" + sortdir + authTokenParam;
                            }
                            catch(err)  {
                                throw err;
                            }
                        }
                        else  {
                            throw "User may not be authenticated";
                        }
                    }
                };
            }   
            else  {
                return null;
            } 
        })
        .factory('MaturityStrengthDataService', function ($resource, $filter, LumiService) {
            const serverUrl = LumiService.getServerUrl();

            if(serverUrl)  {
                return {
                    maturityStrengthData: $resource(serverUrl.concat("/analytics/lumicon/maturity/data"), {},
                        {
                            // Polling service
                            'sensorsWithMaturityStrengthData': {
                                url: serverUrl.concat("/channels/sensors/list/with_msj_data/:msjId"),
                                method: 'GET',
                                isArray: true,
                                params: {
                                    tenant: "@tenant",
                                    msjId: "@msjId"
                                }},
    
                            'maturityDataByTimeRange': {
                                url: serverUrl.concat("/data/analytics/lumicon/maturity/time"),
                                method: 'POST',
                                isArray: true,
                                params: {
                                    tenant: "@tenant",
                                    maturity_tolerance: "@maturity_tolerance",
                                    strength_tolerance: "@strength_tolerance",
                                    // Always true for maturity strength data
                                    allowDecommissioned: true,
                                    sortdir: "@sortdir"
                                }}       
                        }),
                };
            }   
            else  {
                return null;
            }
        })
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('MaturityStrengthJobData', function (LumiService) {
            const serverUrl = LumiService.getServerUrl();

            if(serverUrl)  {
                return {
                    getJobDetailsFileLink: function(tenant, msjId, displayTZ, customFilename)  {
                        const userInfo = JSON.parse(localStorage.getItem('key_AOMS_LUMI_USERINFO'));
                        if(userInfo && userInfo.token)  {
                            try {
                                const authTokenParam = "&auth_token=" + userInfo.token;
                                
                                return serverUrl + "/analytics/lumicon/metadata/msj/file?tenant=" + tenant + "&msjId=" + 
                                        msjId + (customFilename ? ('&customFilename=' + customFilename) : '') +
                                        "&timezone=" + displayTZ + authTokenParam;
                            }
                            catch(err)  {
                                throw err;
                            }
                        }
                        else  {
                            throw "User may not be authenticated";
                        }
                    }
                };
            }
            else  {
                return null;
            }
        })
        .factory('MaturityStrengthJobService', function ($resource, $filter, LumiService) {
            const serverUrl = LumiService.getServerUrl();

            if(serverUrl)  {
                return {
                    maturityStrengthJobs: $resource(serverUrl.concat("/analytics/lumicon/maturity/jobs/:id"), { id: "@id" },
                        {
                            // Polling service
                            'getPagedList': {
                                url: serverUrl.concat('/analytics/lumicon/maturity/jobs/paged'),
                                method: 'POST',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }
                            },
                            'getActiveCountByChannelGroup': {
                                url: serverUrl.concat('/analytics/lumicon/maturity/jobs/cmd/get_active_count/:cgId'),
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant",
                                    cgId: "@cgId"
                                }
                            },
                            'sensors': {
                                url: serverUrl.concat('/analytics/lumicon/maturity/jobs/sensors'),
                                method: 'POST',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant",
                                    allowDecommissioned: "@allowDecommissioned"
                                }
                            },
                            'start': {
                                url: serverUrl.concat('/analytics/lumicon/maturity/jobs/cmd/start'),
                                method: 'POST',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }
                            },
                            'terminate': {
                                url: serverUrl.concat('/analytics/lumicon/maturity/jobs/cmd/terminate'),
                                method: 'POST',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }
                            },
                            params: {
                                tenant: "@tenant"
                            }
                        }),
    
                    maturityStrengthJobStatuses: $resource(serverUrl.concat("/analytics/lumicon/maturity/jobs/statuses"), {},
                        {
                            'update': {
                                url: serverUrl.concat("/analytics/lumicon/maturity/jobs/cmd/update_status"),
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }
                            }
                        }),    
    
                    maturityFunctionTypes: $resource(serverUrl.concat("/analytics/lumicon/maturity/function/types"), {},
                        {
                            'query': {
                                method: 'GET',
                                isArray: true,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }}
                        }),
    
                    maturityStrengthFunctionTypes: $resource(serverUrl.concat("/analytics/lumicon/maturity/strength/function/types"), {},
                        {
                            'query': {
                                method: 'GET',
                                isArray: true,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }}
                        }),
                        
                    maturityStrengthBlacklistedSensors: $resource(serverUrl.concat("/analytics/lumicon/maturity/jobs/blacklist/sensors"), {},
                    {
                        'query': {
                            method: 'GET',
                            isArray: true,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }},
                        params: {
                            tenant: "@tenant"
                        }    
                    }),
                    maturityStrengthFunctionParams: $resource(serverUrl.concat("/analytics/lumicon/maturity/jobs/function/params"), {},
                    {
                        'query': {
                            method: 'GET',
                            isArray: true,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }},
                        params: {
                            tenant: "@tenant"
                        }
                    }),
                };
            }   
            else  {
                return null;
            } 
        });
})();
/*jshint esversion: 6 */
/*eslint-env es6 */
/**
 * @author Charles Fung
 */

(function () {
    'use strict';

    angular.module('AomsLumi')
        .factory('OutlierDetectionJobService', function ($resource, $filter, LumiService) {
            const serverUrl = LumiService.getServerUrl();

            if(serverUrl)  {
                return {
                    outlierDetectionJobs: $resource(serverUrl.concat("/analytics/outlier/jobs/:id"), { id: "@id" },
                        {
                            // Polling service
                            'getPagedList': {
                                url: serverUrl.concat('/analytics/outlier/jobs/paged'),
                                method: 'POST',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }
                            },
                            'getActiveCountByChannelGroup': {
                                url: serverUrl.concat('/analytics/outlier/jobs/cmd/get_active_count/:cgId'),
                                method: 'GET',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant",
                                    cgId: "@cgId"
                                }
                            },
                            'sensors': {
                                url: serverUrl.concat('/analytics/outlier/jobs/sensors'),
                                method: 'POST',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }
                            },
                            'start': {
                                url: serverUrl.concat('/analytics/outlier/jobs/cmd/start'),
                                method: 'POST',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }
                            },
                            'terminate': {
                                url: serverUrl.concat('/analytics/outlier/jobs/cmd/terminate'),
                                method: 'POST',
                                isArray: false,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }
                            },
                            'sensorStatuses': {
                                url: serverUrl.concat('/analytics/outlier/jobs/sensors/statuses/:odjId'),
                                method: 'GET',
                                isArray: true,
                                params: {
                                    odjId: "@odjId",
                                    tenant: "@tenant"
                                },
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                            },
                            params: {
                                tenant: "@tenant"
                            }
                        }),
    
                    outlierDetectionJobStatuses: $resource(serverUrl.concat("/analytics/outlier/jobs/statuses"), {},
                        {
                            'update': {
                                url: serverUrl.concat("/analytics/outlier/jobs/cmd/update_status"),
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                params: {
                                    tenant: "@tenant"
                                }
                            }
                        }),    
                };
            }   
            else  {
                return null;
            } 
        });
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('AomsLumi.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('AomsLumi.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
/*jshint esversion: 6 */
/*eslint-env es6 */

(function() {
  'use strict';

  angular.module('AomsLumi.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        let isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function(globalInit) {
            const userInfo = JSON.parse(localStorage.getItem('key_AOMS_LUMI_USERINFO'));
            if(userInfo)  {
              let states = defineMenuItemStates();
              let menuItems = states.filter(function(item) {
                  // If globalInit is false, return only menu items that do not require app to be initialized
                  // Filter out menu items that are marked as hidden
                  // If menu items are restricted to certain user roles, then filter out items that the current user does not have permissions to view
                  return item.level === 0 &&
                        (globalInit || !item.requiresInit) &&
                        (!item.hidden) &&  
                        (!item.roles || item.roles.filter(r => userInfo.roles.indexOf(r) > -1).length > 0)

              });

              menuItems.forEach(function(item) {
                  let children = states.filter(function(child) {
                      return child.level === 1 && child.name.indexOf(item.name) === 0 &&
                          (globalInit || !child.requiresInit) &&
                          (!child.hidden) &&
                          (!child.roles || child.roles.filter(r => userInfo.roles.indexOf(r) > -1).length > 0);
                  });
                  item.subMenu = children.length ? children : null;
              });

              return menuItems.concat(staticMenuItems);
            }
            else  {
              // User is not authenticated.  Should not happen
              return null;
            }
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          let result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta
              })
              .map(function(s) {
                let meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: ((s.name.match(/\./g) || []).length - 1),
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                  requiresInit: s.requiresInit,
                  hidden: s.hidden,
                  roles: s.roles
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 16.04.2017
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme.components')
  .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, $state, $q, $log, $window, toastr, baSidebarService, LumiService, AuthService, UserSettingsService, InternalSettingsService) {
      $scope.isInit = false;
      
      let tenant = LumiService.getTenant();
      let globalInit = false;


      const getUserSettingsType = function(companyId, username, userSettingsType) {
        let deferred = $q.defer();

        UserSettingsService.settings.getUserSetting( {companyId: companyId, username: username, userSettingType: userSettingsType}, function(res) {
            if(res !== null)  {
                deferred.resolve(res.val === '1');
            }
            else  {
                $log.debug("Empty " + userSettingsType + ".  Defaulting to ").concat(env[userSettingsType]);
                deferred.resolve(env[userSettingsType]);     
            }
        }, function(err)  {
            const errData = err.data;
            $log.debug("Cannot get " + userSettingsType + ".  Defaulting to ".concat(env[userSettingsType]).concat(": ")
                .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));   
            deferred.resolve(env[userSettingsType]);  
        });
        return deferred.promise;
      };


      const init = function()  {
          if(!$scope.isInit)  {
              $log.info("Initializing Side Bar");
              
              if(!env.standalone && tenant === null)  {
                $scope.menuItems = [];
                $scope.defaultSidebarState = null;
                $scope.isInit = true;
              }
              else  {
                getGlobalInit().then(function(res) {
                  if(!res)  {
                    toastr.error("An error has occurred initializing the Side Bar");

                    // Go back to the Login page
                    $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                    $window.localStorage.removeItem('key_AOMS_LUMI_TENANT');
                    $state.go('login');
                  }
                  else  {
                      $log.info("globalInit obtained: " + globalInit + ".  Initializing Side Bar menu items.");
                      $scope.menuItems = baSidebarService.getMenuItems(globalInit);
                      if($scope.menuItems)  {
                          if($scope.menuItems.length > 0)  {
                            const companyInfo = LumiService.companyInfo();
                            const companyId = companyInfo ? companyInfo.companyId : null;

                            const userInfo = AuthService.userInfo();
                            if(userInfo)  {
                                filterMenuItems(companyId, userInfo.username);
                              }
                              else  {
                                $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
                                $scope.isInit = true;
                              }
                          }
                          else  {
                              // No items in the menu.  Should not happen
                              $log.error("Cannot find items in the Side Bar menu");
                          }
                      }
                      else  {
                          // User is not authenticated.  Should not happen
                          $log.error("Failed to get Side Bar menu items as user has not been authenticated");
                      }
                  }
                });
              }
          }
      };


      const getGlobalInit = function()  {
        let deferred = $q.defer();
        if(tenant != null)  {
          InternalSettingsService.settings.get({ tenant: tenant, key: "FLAG_IS_INIT" }, function(res)  {
              globalInit = res.val ? (res.val === "1") : false;
              deferred.resolve(true);
          }, function(err)  {
              const errData = err.data;
              $log.error("An error has occurred getting FLAG_IS_INIT internal setting during the initialization of the Side Bar: "
                  .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

              deferred.resolve(false);
          });
        }
        else  {
          globalInit = false;
          deferred.resolve(true);
        }
        return deferred.promise;
      };

      const filterMenuItems = function(companyId, username)  {
        $q.all([
          getUserSettingsType(companyId, username, 'enableData'),
          getUserSettingsType(companyId, username, 'enableDiagnostics'),
          getUserSettingsType(companyId, username, 'enableAnalysis'),
          getUserSettingsType(companyId, username, 'enableLumiCon'),
          getUserSettingsType(companyId, username, 'enableSettings'),
          getUserSettingsType(companyId, username, 'enableAdvancedSettings'),
        ]).then(function(res2) {
            // Filter top level items
            $scope.menuItems = $scope.menuItems.filter(m => {
              return m.name === 'main.dashboard' || 
                (res2[0] && m.name === 'main.data') ||
                (res2[1] && m.name === 'main.diagnostics') ||
                (res2[2] && m.name === 'main.analysis') ||
                (res2[3] && m.name === 'main.lumicon') ||
                (res2[4] && m.name === 'main.settings') ||
                (res2[5] && m.name === 'main.advanced'); 
            });

            const hasData = $scope.menuItems.some(m => m.name == 'main.data');
            const hasDiagnostics = $scope.menuItems.some(m => m.name === 'main.diagnostics');
            const hasAnalysis = $scope.menuItems.some(m => m.name === 'main.analysis');
            const hasLumicon = $scope.menuItems.some(m => m.name === 'main.lumicon');
            const hasSettings = $scope.menuItems.some(m => m.name === 'main.settings');
            const hasAdvanced = $scope.menuItems.some(m => m.name === 'main.advanced');

            let filterSecondLevel = [];
            if(hasData)  {
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableMeasurementData'));
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableWavelengthData'));
            }

            if(hasDiagnostics)  {
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableEvents'));
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableChannelDiagnostics'));
            }

            if(hasAnalysis)  {
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableAnalysisOutlier'));
            }

            if(hasSettings)  {
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableGeneralSettings'));
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableChannelSettings'));
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableAlarmSettings'));
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableEmailNotificationSettings'));
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableUserSettings'));
            }

            if(hasAdvanced)  {
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableAdminSettings'));
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableInternalSettings'));
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableNetworkSettings'));
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableChannelManager'));
              filterSecondLevel.push(getUserSettingsType(companyId, username, 'enableCableManager'));
            }

            $q.all(filterSecondLevel).then(function(res3) {
              if(hasData)  {
                let subMenu = $scope.menuItems.find(m => m.name === 'main.data').subMenu;
                if(subMenu)  {
                  $scope.menuItems.find(m => m.name === 'main.data').subMenu = subMenu.filter(m => {
                    return (res3[0] && m.name === 'main.data.measurement') ||
                      (res3[1] && m.name === 'main.data.wavelength'); 
                  });
                }  
              }

              if(hasDiagnostics)  {
                let i = 0;
                if(hasData)  {
                  i+=2;
                }

                let subMenu = $scope.menuItems.find(m => m.name === 'main.diagnostics').subMenu;
                if(subMenu)  {
                  $scope.menuItems.find(m => m.name === 'main.diagnostics').subMenu = subMenu.filter(m => {
                    return (res3[i] && m.name === 'main.diagnostics.events') ||
                      (res3[i+1] && m.name === 'main.diagnostics.channel');
                  });
                }  
              }

              if(hasAnalysis)  {
                let i = 0;
                if(hasData)  {
                  i+=2;
                }
                if(hasDiagnostics)  {
                  i+=2;
                }

                let subMenu = $scope.menuItems.find(m => m.name === 'main.analysis').subMenu;
                if(subMenu)  {
                  $scope.menuItems.find(m => m.name === 'main.analysis').subMenu = subMenu.filter(m => {
                    return (res3[i] && m.name === 'main.analysis.outlier');
                  });
                } 
              }

              if(hasLumicon)  {
                $scope.menuItems.find(m => m.name === 'main.lumicon').subMenu = $scope.menuItems.find(m => m.name === 'main.lumicon').subMenu;
              }

              if(hasSettings)  {
                let i = 0;
                if(hasData)  {
                  i+=2;
                }
                if(hasDiagnostics)  {
                  i+=2;
                }
                if(hasAnalysis)  {
                  i+=1;
                }
                
                let subMenu = $scope.menuItems.find(m => m.name === 'main.settings').subMenu;
                if(subMenu)  {
                  $scope.menuItems.find(m => m.name === 'main.settings').subMenu = subMenu.filter(m => {
                    return (res3[i] && m.name === 'main.settings.general') ||
                      (res3[i+1] && m.name === 'main.settings.channel') ||
                      (res3[i+2] && m.name === 'main.settings.alarm') ||
                      (res3[i+3] && m.name === 'main.settings.emailnotification') ||
                      (res3[i+4] && m.name === 'main.settings.user');
                  });
                }  
              }

              if(hasAdvanced)  {
                let i = 0;
                if(hasData)  {
                  i+=2;
                }
                if(hasDiagnostics)  {
                  i+=2;
                }
                if(hasAnalysis)  {
                  i+=1;
                }
                if(hasSettings)  {
                  i+=5;
                }

                let subMenu = $scope.menuItems.find(m => m.name === 'main.advanced').subMenu;
                if(subMenu)  {
                  $scope.menuItems.find(m => m.name === 'main.advanced').subMenu = subMenu.filter(m => {
                    return (res3[i] && m.name === 'main.advanced.admin') ||
                      (res3[i+1] && m.name === 'main.advanced.internalsettings') ||
                      (res3[i+2] && m.name === 'main.advanced.networking') ||
                      (res3[i+3] && m.name === 'main.advanced.channelmanagement') ||
                      (res3[i+4] && m.name === 'main.advanced.cablemanagement');
                  });
                }  
              }

              $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
              $scope.isInit = true;
            });
        }); 
      };


      $scope.hoverItem = function ($event) {
        $scope.showHoverElem = true;
        $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
        const menuTopValue = 66;
        $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
      };

      $scope.$on('$stateChangeSuccess', function () {
        if (baSidebarService.canSidebarBeHidden()) {
          baSidebarService.setMenuCollapsed(true);
        }
      });


      init();

  }
  })();
  
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('AomsLumi.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    };
  }
})();

(function() {
  'use strict';

  angular.module('AomsLumi.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope, $mdDialog) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum === 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum === vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1);
    };

    vm.previousTab = function () {
        var confirm = $mdDialog.confirm()
            .title("Confirmation")
            .textContent("Unsaved data may be lost if you navigate back to the previous step.  Proceed?")
            .targetEvent(event)
            .ok('Yes')
            .cancel('No');

        $mdDialog.show(confirm).then(function() {
            vm.selectTab(vm.tabNum - 1);
        }, function()  {
            vm.selectTab(vm.tabNum);
        });
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('AomsLumi.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 16.12.2017
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter($window, env) {
    return {
        restrict: 'E',
        templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
        controller: 'MsgCenterCtrl',
        link: function($scope) {
            $scope.$watch(function () {
                return angular.element('div.toast-message').length;
            }, function(newVal, oldVal, scope) {
                if (newVal > oldVal) {
                    const toasters = angular.element('div.toast-message');
                    let unread = 0;

                    if(toasters)  {
                        angular.forEach(toasters, function(toaster) {
                            const currentTime = moment();
                            const notification = {
                                template: toaster.textContent,
                                time : currentTime.calendar(),
                                isRead : false,
                                messageTimestamp : currentTime
                            };

                            $scope.notifications.push(notification);
                            if($scope.notifications.length > env.maxNotifications)  {
                                $scope.notifications.shift();
                            }

                            ++unread;
                        });

                        $scope.unreadNotifications += unread;

                        if($scope.notifications)  {
                            $window.sessionStorage.notifications = JSON.stringify($scope.notifications);
                        }
                    }
                }
            });
        }
    };
  }
})();
/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 16.12.2017
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $window, $sce, $timeout) {

/*****************************************************Notifications*****************************************************/
      $scope.unreadNotifications = 0;
      $scope.notifications = $window.sessionStorage.notifications ? JSON.parse($window.sessionStorage.notifications) : [];
      $scope.notifications.forEach(function(notification) {
          if (!notification.isRead) {
              ++$scope.unreadNotifications;
          }
      });


      $scope.getNotification = function(notification) {
          return notification ? $sce.trustAsHtml(notification.template) : $sce.trustAsHtml("");
      };

      $scope.markNotificationAsRead = function(index) {
          if($scope.notifications)  {
              $timeout( function(){
                  const idx = $scope.notifications.length - 1 - index;
                  if ($scope.notifications[idx] && !$scope.notifications[idx].isRead) {
                      $scope.notifications[idx].isRead = true;
                  }

                  --$scope.unreadNotifications;
                  $window.sessionStorage.notifications = JSON.stringify($scope.notifications);
              }, 1000);
          }
      };

      $scope.markNotificationsAsRead = function() {
          if($scope.notifications)  {
              $scope.notifications.forEach(function(notification) {
                  if (!notification.isRead) {
                      notification.isRead = true;
                  }
              });

              $scope.unreadNotifications = 0;
              $window.sessionStorage.notifications = JSON.stringify($scope.notifications);
          }
      };

/*************************************************End Notifications*****************************************************/

/******************************************************Messages*********************************************************/
      $scope.messages = [
          //   {
          //     userId: 3,
          //     text: 'After you get up and running, you can place Font Awesome icons just about...',
          //     time: '1 min ago'
          //   },
          //   {
          //     userId: 0,
          //     text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
          //     time: '2 hrs ago'
          //   },
      ];

      // $scope.getMessage = function(msg) {
      //     let text = msg.template;
      //     if (msg.userId || msg.userId === 0) {
      //         text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      //     }
      //     return $sce.trustAsHtml(text);
      // };
/**************************************************End Messages*********************************************************/

/*********************************************************Users*********************************************************/
      $scope.users = {
          //   0: {
          //     name: 'Vlad',
          //   },
          //   1: {
          //     name: 'Kostya',
          //   },
          //   2: {
          //     name: 'Andrey',
          //   },
          //   3: {
          //     name: 'Nasta',
          //   }
      };
/*****************************************************End Users*********************************************************/
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
        restrict: 'E',
        templateUrl: 'app/theme/components/pageTop/pageTop.html',
        controller: 'PageTopCtrl',
        controllerAs: 'vm',
    };
  }

})();
/*jshint esversion: 6 */
/*eslint-env es6 */

/**
 * @author Charles Fung
 * created on 16.12.2017
 */
(function () {
    'use strict';

    angular.module('AomsLumi.theme.components')
        .controller('PageTopCtrl', PageTopCtrl)
        .controller('ProjectsCtrl', ProjectsCtrl)
        .controller('NewProjectModalCtrl', NewProjectModalCtrl)
        .controller('UserDetailsCtrl', UserDetailsCtrl);
        

    /** @ngInject */
    function PageTopCtrl($scope, $state, $log, $window, $q, $timeout, $mdDialog, env, toastr, baConfig, baUtil,
                         LumiService, AlvinAuthService, AuthService, AdminService) {
        let vm = this;
        
        let isAlive = true;

        vm.standalone = env.standalone;
        vm.enableSystemStatistics = env.enableSystemStatistics;
        vm.isAdmin = false;


        const userRoleColor = {
            AOMS_ADMIN : '#c62828',
            AOMS_SUPPORT : '#4527a0',
            ADMIN: '#ef6c00',
            DEFAULT: '#00695c',
            NONE: '#37474f',
        };


        vm.isLoading = true;

        vm.cpuStat = 0;
        vm.memoryStat = 0;
        vm.systemTime = "";

        vm.cpuStatColor = "#E0E0E0";
        vm.memoryStatColor = "#E0E0E0";

        let systemStatisticsPollingPromise = null;
        let systemStatisticsPollingInterval = 3000;
        let systemStatisticsPollingErrors = 0;


        vm.getProjectTitle = function()  {
            if(env.tenant !== null)  {
                return 'Projects (Current id: ' + env.tenant + ')';
            }
            else  {
                const t = localStorage.getItem('key_AOMS_LUMI_TENANT');
                return t !== null && t !== undefined ? 'Projects (Current id: ' + t + ')' : 'Projects (Current id: None)';  
            }
        };
        
        vm.getUsername = function()  {
            const userInfo = JSON.parse(localStorage.getItem('key_AOMS_LUMI_USERINFO'));
            if(userInfo && userInfo.username)  {
                return userInfo.username;
            }
            return '';
        };

        vm.logout = function()  {
            $log.info("Logging out");
            AuthService.logout.query(function(res) {
                $log.info("Logged out successfully");

                //$window.localStorage.clear();
                $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                $state.go('login');
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred logging out".concat(": ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
            });
        };

        vm.fullLogout = function()  {
            $log.info("Full logout");
            AuthService.logout.query(function(res1) {
                $log.info("Logout (Alfred) successful");
                $window.localStorage.removeItem('key_AOMS_LUMI_USERINFO');
                
                AlvinAuthService.logout.query(function(res2) {
                    $log.info("Logout (Alvin) successful");
                    $window.localStorage.clear();
                    $state.go('login');
                }, function(err)  {
                    const errData = err.data;
                    $log.error("An error has occurred logging out (Alvin)".concat(": ")
                        .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                });
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred logging out (Alfred)".concat(": ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
            });
        };


        vm.showProjectsModal = function(ev) 
        {
            if(!env.standalone && (env.tenant === null || env.tenant === undefined))  {                    
                $mdDialog.show({
                    controller: 'ProjectsCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'app/theme/components/pageTop/projectsModal.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:false,
                    openFrom: {left: 1500},
                    closeTo: {left: 1500}
                }).then(function(res) {
                    localStorage.setItem('key_AOMS_LUMI_TENANT', res)
                    $state.reload();
                    toastr.success("Switched to Project #".concat(res).concat(" successfully"));
                }, function(errData)  {
                });
            }
        };

        vm.showUserDetailsModal = function(ev) {
            $mdDialog.show({
                controller: 'UserDetailsCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/theme/components/pageTop/userDetailsModal.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                openFrom: {left: 1500},
                closeTo: {left: 1500},
            });
        };


        function loadSystemStatistics() {
            $('.server-system-statistics .chart').each(function () {
                let chart = $(this);
                chart.easyPieChart({
                    onStep: function (from, to, percent) {
                        $(this.el).find('.percent').text(Math.round(percent));
                    },
                    barColor: chart.attr('rel'),
                    trackColor: 'rgba(0,0,0,0)', size: 39,
                    scaleLength: 0,
                    animation: 500,
                    lineWidth: 4,
                    lineCap: 'round',
                });
            });

            $('.chart.cpuStat-chart').data('easyPieChart').update(vm.cpuStat);
            $('.chart.memoryStat-chart').data('easyPieChart').update(vm.memoryStat);
        }


        const getCPUStats = function() {
            $log.debug("Getting CPU statistics");
            let deferred = $q.defer();

            AdminService.system.cpuStat(function(res) {
                vm.cpuStat = res.cpuStat;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting CPU statistics: "
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.reject(err);
            });

            return deferred.promise;
        };

        const getMemoryStats = function()  {
            $log.debug("Getting CPU statistics");
            let deferred = $q.defer();

            AdminService.system.memoryStat(function(res) {
                vm.memoryStat = res.memoryStat;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting memory statistics: "
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.reject(err);
            });

            return deferred.promise;
        };

        const getSystemTime = function() {
            $log.debug("Getting system time");
            let deferred = $q.defer();

            AdminService.system.time(function(res) {
                vm.systemTime = res.systemTime;
                deferred.resolve(true);
            }, function(err)  {
                const errData = err.data;
                $log.error("An error has occurred getting system time: "
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));

                deferred.reject(err);
            });

            return deferred.promise;
        };

        const getUTCTime = function() {
            $log.debug("Getting UTC time");
            let deferred = $q.defer();

            //vm.utcTime = moment.utc().format('LLLL');
            vm.utcTime = moment.utc().format('dddd, MMMM Do, YYYY hh:mm');
        };


        const systemStatisticsRefresh = function()  {
            $log.debug("Refresh system statistics");
            vm.isLoading = true;
            
            $q.all([
                getCPUStats(),
                getMemoryStats(),
                // getSystemTime()
            ]).then(function(res) {
                // const err = (!res[0] || !res[1] || !res[2]);
                const err = (!res[0] || !res[1]);
                if(err)  {
                    systemStatisticsNextLoad(++systemStatisticsPollingErrors * 2 * systemStatisticsPollingInterval);
                }
                else  {
                    getUTCTime();
                    loadSystemStatistics();
                    systemStatisticsPollingErrors = 0;
                    systemStatisticsNextLoad();
                }

                vm.isLoading = false;
                $log.debug("Done refresh system statistics".concat(err ? " with error" : ""));
            });
        };


       const init = function()  {
            $log.info("Initializing Page Top");
                if(vm.enableSystemStatistics)  {
                    systemStatisticsRefresh()
                }

                const userInfo = JSON.parse(localStorage.getItem('key_AOMS_LUMI_USERINFO'));
                if(userInfo && userInfo.roles)  {
                    const roles = userInfo.roles;
                    if(roles.includes('AOMS_ADMIN') || roles.includes('AOMS_SUPPORT') || roles.includes('ADMIN'))  {
                        vm.isAdmin = true;
                    }
                }

                // Show Projects modal if we are not in standalone mode and that we have no tenant
                if(!vm.standalone && LumiService.getTenant() === null)  {
                    vm.showProjectsModal();
                }
        };


        const cancelSystemStatisticsNextLoad = function() {
            $timeout.cancel(systemStatisticsPollingPromise);
        };

        const systemStatisticsNextLoad = function(pollingDelay) {
            pollingDelay = pollingDelay || systemStatisticsPollingInterval;

            //Always make sure the last timeout is cleared before starting a new one
            cancelSystemStatisticsNextLoad();

            if(isAlive)  {
                $log.debug("Poll system statistics with delay: ".concat(pollingDelay).concat( " milliseconds"));
                systemStatisticsPollingPromise = $timeout(systemStatisticsRefresh, pollingDelay);
            }
        };



       init();



        $scope.$on('$destroy', function() {
            $log.debug("Page Top scope destroyed. Stopping polling task...");
            cancelSystemStatisticsNextLoad();

            isAlive = false;
        });
    }


    function ProjectsCtrl($log, $mdDialog, moment, toastr, LumiService, OrganizationService, AuthService, AdminService, UserSettingsService, UtilService) {
        let vm = this;

        let alert;

        vm.isLoading = true;
        vm.readOnly = env.readOnly;
        vm.isEditingTenant = false;

        vm.selectedTenant = null;

        let companyId = null;

        let isInit = false;
        
        let displayTZ = env.defaultTZ;


        vm.onTenantSelected = function(tenant)  {
            if(vm.selectedTenant && vm.selectedTenant.id === tenant.id)  {
                vm.selectedTenant = null;
            }
            else  {
                vm.selectedTenant = {
                    id: tenant.id,
                    state: tenant.state
                };
            }
        };


        vm.getProjects = function()  {
            if(companyId)  {
                $log.info("Get list of projects");
                vm.selectedTenant = null;
                OrganizationService.tenants.tenantsByCompany({ companyId: companyId }, function(res) {
                    vm.tenants = res.sort((a, b) => b.creationDate - a.creationDate)
                        .map(t => { 
                            t.creationDate =  UtilService.convertUTCTimestamp(t.creationDate, displayTZ);
                            return t; 
                        });
                    vm.displayedTenants = [].concat(vm.tenants);
                }, function(err)  {
                    const errData = err.data;
                    showAlert("Error", "An error has occurred getting Projects"
                        .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
    
                    $log.error("An error has occurred getting projects: ".concat(errData ? JSON.stringify(errData) :
                        JSON.stringify(err)));
                }).$promise.finally(function()  {
                    vm.isLoading = false;
                });
            }
        };

        vm.stopProject = function(tenant)  {
            OrganizationService.tenantStates.update({ tenant: tenant, tenantStateTypeName: 'TERMINATED'}, function(res) {
                if(res.error)  {
                    $log.error("Tenant state failed to be updated to TERMINATED for tenant ".concat(tenant).concat(" on Alvin as there are existing node associations")); 
                    toastr.error("Cannot terminate Project #".concat(tenant).concat(" as there are existing node associations"));
                }
                else  {
                    $log.info("Tenant state updated to TERMINATED for tenant ".concat(tenant).concat(" on Alvin")); 
                    AdminService.tenants.terminate({ tenant: tenant }, function(res2) {
                        vm.getProjects();
                        $log.info("Tenant ".concat(tenant).concat(" terminated on Alfred")); 
                        toastr.success("Project #".concat(tenant).concat(" has been terminated successfully!"));
                    }, function(err)  {
                        const errData = err.data;
                        toastr.error("An error has occurred terminating Project #".concat(tenant)
                            .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
    
                        $log.error("An error has occurred terminating tenant ".concat(tenant).concat(" on Alfred: ")
                            .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                    });
                }
            }, function(err)  {
                const errData = err.data;
                toastr.error("An error has occurred terminating Project #".concat(tenant)
                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                $log.error("An error has occurred updating tenant state to TERMINATED for tenant ".concat(tenant).concat(" on Alvin: ")
                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
            });
        };

        vm.showNewProjectModal = function(ev) {
            if(companyId)  {
                $mdDialog.show({
                    controller: 'NewProjectModalCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'app/theme/components/pageTop/newProjectsModal.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:false,
                    openFrom: {left: 1500},
                    closeTo: {left: 1500},
                    multiple : true,
                    skipHide: true,
                    locals: {
                        companyId: companyId                
                    }
                }).then(function(res) {
                    $log.info("New Project has been created successfully: ".concat(JSON.stringify(res)));
                    toastr.success("Project #".concat(res.id).concat(" has been created successfully!"));
                    
                    vm.getProjects();
                }, function(errData)  {
                    vm.getProjects();
                });
            }
        };


        const init = function()  {
            if(!isInit)  {
                $log.info("Initializing Projects Modal");
                const companyInfo = LumiService.companyInfo();
                if(companyInfo)  {
                    companyId = companyInfo.companyId;

                    const userInfo = AuthService.userInfo();
                    if(userInfo)  {
                        vm.username = userInfo.username;
                        UserSettingsService.settings.getUserSetting({companyId: companyId, username: vm.username, userSettingType: 'Display Time Zone'}, function(res) {
                            if(res && res.val)  {
                                displayTZ = res.val;
                            }
                            else  {
                                $log.debug("Empty display time zone.  Defaulting to ").concat(displayTZ);    
                            }
                        }, function(err)  {
                            const errData = err.data;
        
                            $log.debug("An error has occurred getting display time zone.  Defaulting to ".concat(displayTZ).concat(": ")
                                .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));    
                        }).$promise.finally(function()  {
                            moment.tz.setDefault(displayTZ);
                            isInit = true;

                            const tenant = localStorage.getItem('key_AOMS_LUMI_TENANT'); 
                            vm.tenant = tenant != null ? parseInt(tenant) : null; 
                            vm.getProjects();
                        });
                    }
                }
            }
        };


        const showAlert = function(title, content) {
            alert = $mdDialog.alert({
                title: title,
                textContent: content,
                multiple : true,
                skipHide: true,
                ok: 'Close',
                clickOutsideToClose: true,
            });

            $mdDialog.show(alert)
                .finally(function() {
                    alert = undefined;
                });
        };


        vm.hide = function() {
            if(vm.selectedTenant && vm.selectedTenant.id !== vm.tenant)  {
                $mdDialog.hide(vm.selectedTenant.id);
            }
            else  {
                vm.cancel();        
            }
        };

        vm.cancel = function() {
            $mdDialog.cancel();
        };


        init();
    };

    function NewProjectModalCtrl($log, $timeout, $mdDialog, toastr, OrganizationService, AdminService, companyId) {
        let vm = this;
        vm.newProject = {};

        
        vm.addProject = function(){
            return $timeout(1000)
                .then(function()  {
                    if(vm.newProject)  {
                        const reqBody = {
                            name: vm.newProject.name,
                            description: vm.newProject.description,
                            companyId: companyId,
                            gatewayId: vm.newProject.gatewayId
                        };
                        
                        OrganizationService.tenants.save(reqBody, function(res) {
                            $log.info("Tenant created: ".concat(JSON.stringify(res))); 
                            AdminService.tenants.init({ tenant: res.id, project_name: res.name }, function(res2) {
                                $log.info("Tenant ".concat(res.id).concat(" initialized"));
                                vm.hide(res);
                            }, function(err)  {
                                const errData = err.data;
                                toastr.error("An error has occurred initializing Project #".concat(res.id)
                                    .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));
            
                                $log.error("An error has occurred initializing tenant ".concat(res.id).concat(": ")
                                    .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));
                                vm.cancel();
                            });
                        }, function(err)  {
                            const errData = err.data;
                            toastr.error("An error has occurred creating Project"
                                .concat(errData ? (" (".concat(errData.error).concat(")")) : ""));

                            $log.error("An error has occurred creating tenant: ".concat(errData ? JSON.stringify(errData) :
                                JSON.stringify(err)));
                            vm.cancel();
                        });
                    }
                    else  {
                        // Should not happen
                        toastr.error("An error has occurred creating Project (null project)");
                        vm.cancel();
                    }
                });
        };


        vm.hide = function(res) {
            $mdDialog.hide(res);
        };

        vm.cancel = function() {
            $mdDialog.cancel();
        };
    }

    
    function UserDetailsCtrl($log, $state, $mdDialog, moment, LumiService, AuthService, UserSettingsService, UtilService) {
        let vm = this;
        let exp = null;

        let isInit = false;


        vm.username = '';
        vm.roles = [];
        vm.expDisplay = 'Never';
        vm.displayTZ = env.defaultTZ;


        const userRoleColor = {
            AOMS_ADMIN : '#c62828',
            AOMS_SUPPORT : '#4527a0',
            ADMIN: '#ef6c00',
            DEFAULT: '#00695c',
            NONE: '#37474f',
        };


        vm.getUserRoleColour = function()  {
            const userInfo = JSON.parse(localStorage.getItem('key_AOMS_LUMI_USERINFO'));
            if(userInfo && userInfo.roles)  {
                const roles = userInfo.roles;
                if(roles.includes('AOMS_ADMIN'))  {
                    return userRoleColor.AOMS_ADMIN;
                }
                else if(roles.includes('AOMS_SUPPORT'))  {
                    return userRoleColor.AOMS_SUPPORT;
                }
                else if(roles.includes('ADMIN'))  {
                    return userRoleColor.ADMIN;
                }
                else  {
                    return userRoleColor.DEFAULT;
                }
            }
            return userRoleColor.NONE;
        };

        vm.getExpColour = function()  {
            if(exp)  {
                if(moment(exp).isBefore(moment().add(3, 'hours')))  {
                    return '#d32f2f';
                }
                else  {
                    return '#388e3c';
                }
            }
        };

        vm.changeStateEvents = function()  {
            $mdDialog.hide();
            $state.go('main.settings.user');
        };


        const init = function()  {
            if(!isInit)  {
                $log.info("Initializing User Details Dialog");
                const companyInfo = LumiService.companyInfo();
                const companyId = companyInfo ? companyInfo.companyId : null;

                const userInfo = AuthService.userInfo();
                if(userInfo)  {
                    UserSettingsService.settings.getUserSetting({companyId: companyId, username: userInfo.username, userSettingType: 'Display Time Zone'}, function(res) {
                        if(res && res.val)  {
                            vm.displayTZ = res.val;
                        }
                        else  {
                            $log.debug("Empty display time zone.  Defaulting to ").concat(displayTZ);    
                        }
                    }, function(err)  {
                        const errData = err.data;
    
                        $log.debug("An error has occurred getting display time zone.  Defaulting to ".concat(vm.displayTZ).concat(": ")
                            .concat(errData ? JSON.stringify(errData) : JSON.stringify(err)));    
                    }).$promise.finally(function()  {
                        vm.username = userInfo.username;
                        vm.roles = userInfo.roles;
                        if(userInfo.exp)  {
                            exp = userInfo.exp;
                            vm.expDisplay = UtilService.convertUTCTimestamp(exp, vm.displayTZ);
                        }
                        
                        isInit = true;
                    });
                }
            }
        };


        vm.hide = function() {
            $mdDialog.hide();
        };

        vm.cancel = function() {
            $mdDialog.cancel();
        };


        init();
    }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('AomsLumi.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('AomsLumi.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('AomsLumi').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/dashboard/dashboard.html','<dashboard-channel></dashboard-channel><br><br><dashboard-environ></dashboard-environ><br><br><dashboard-diagnostics></dashboard-diagnostics>');
$templateCache.put('app/pages/login/authCode.html','<md-dialog class="auth-code-modal" aria-label="Authorization"><md-content><md-content class="md-padding"><div class="alert alert-info" ng-if="vm.alvinAuthFailed"><strong><i class="fa fa-exclamation-triangle"></i> Authorization Failed</strong><p>Please check your authorization code and try again.</p></div><form name="authorizationForm" ng-submit="vm.submitAuthCode()"><div class="form-group"><label>Enter the 5-letter Authorization Code</label> <input type="password" maxlength="5" class="form-control" ng-model="vm.authCode" autofocus="" required=""></div><div ng-if="authorizationForm.$valid"><button type="submit" class="btn btn-default btn-auth">Submit</button></div></form></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/login/login.html','<div class="login"><main class="auth-main"><div class="auth-block"><br><div align="middle"><img src="assets/img/app/aoms-logo-white.png" alt="AOMS Technologies"></div><br><br><br><div class="alert alert-info" ng-if="vm.authFailed"><strong><i class="fa fa-exclamation-triangle"></i> Login Failed</strong><p>Please check your username and password and try again.</p></div><div layout="row" layout-sm="column" layout-align="center center" aria-label="wait" style="height: 50px; z-index: 10;" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" class="md-primary"></md-progress-circular></div><br><form class="form-horizontal" ng-submit="vm.login()"><div class="form-group"><label for="loginUsername" class="col-sm-2 control-label">Username</label><div class="col-sm-10"><input type="text" ng-model="vm.credentials.username" ng-disabled="!vm.isInit" class="form-control" id="loginUsername" placeholder="Username" autofocus="" required=""></div></div><div class="form-group"><label for="loginPassword" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" ng-model="vm.credentials.password" ng-disabled="!vm.isInit" class="form-control" id="loginPassword" placeholder="Password" required=""></div></div><br><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" ng-disabled="!vm.isInit" class="btn btn-default btn-auth">Sign in</button> <a href="" class="forgot-pass" style="color: #ccc; pointer-events:none;">Forgot password?</a></div></div></form><br><div class="auth-sep" ng-if="vm.allowAnonymousUsers"><span><span>or Continue as the Default Anonymous User</span></span></div><div align="middle" ng-if="vm.allowAnonymousUsers"><button class="btn btn-default btn-auth" ng-click="vm.loginAnonymously()">Continue</button></div></div></main></div>');
$templateCache.put('app/pages/main/main.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div><footer class="al-footer-right clearfix"><br><div class="al-footer-main clearfix"><div class="al-copy"><a href="http://www.aoms-tech.com/">Powered by AOMS Technologies</a><br></div></div></footer><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><div class="progress-info">Your profile is 70% Complete</div><div class="progress"><div class="progress-bar progress-bar-primary progress-bar-striped active" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width: 70%"></div></div><h3 class="with-line">General Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Picture</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Change Profile Picture</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div><div class="col-md-6"></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">First Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputFirstName" placeholder="" value="Anastasiya"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Last Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Department</label><div class="col-sm-9"><select class="form-control" selectpicker=""><option>Web Development</option><option>System Development</option><option>Sales</option><option>Human Resources</option></select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Occupation</label><div class="col-sm-9"><input type="text" class="form-control" id="inputOccupation" placeholder="" value="Front End Web Developer"></div></div></div></div><h3 class="with-line">Change Password</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputPassword" placeholder="" value="12345678"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label">Confirm Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputConfirmPassword" placeholder=""></div></div></div></div><h3 class="with-line">Contact Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputEmail3" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="email" class="form-control" id="inputEmail3" placeholder="" value="contact@akveo.com"></div></div><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">Phone</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" placeholder="" value="+1 (23) 456 7890"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Office Location</label><div class="col-sm-9"><select class="form-control" title="Standard Select" selectpicker=""><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class="form-group row clearfix"><label for="inputRoom" class="col-sm-3 control-label">Room</label><div class="col-sm-9"><input type="text" class="form-control" id="inputRoom" placeholder="" value="303"></div></div></div></div><h3 class="with-line">Social Profiles</h3><div class="social-profiles row clearfix"><div class="col-md-3 col-sm-4" ng-repeat="item in socialProfiles"><a class="sn-link" href="" ng-click="showModal(item)" ng-if="!item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span></a> <a class="sn-link connected" href="{{ item.href }}" target="_blank" ng-if="item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span> <em class="ion-ios-close-empty sn-link-close" ng-mousedown="unconnect(item)"></em></a></div></div><h3 class="with-line">Send Email Notifications</h3><div class="notification row clearfix"><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When I receive a message</label><div class="col-xs-4"><switch color="primary" ng-model="switches[0]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When Someone sends me an invitation</label><div class="col-xs-4"><switch color="primary" ng-model="switches[1]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When profile information changes</label><div class="col-xs-4"><switch color="primary" ng-model="switches[2]"></switch></div></div></div><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When anyone logs into your account from a new device or browser</label><div class="col-xs-4"><switch color="primary" ng-model="switches[3]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Weekly Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[4]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Daily Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[5]"></switch></div></div></div></div><button type="button" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Update Profile</button></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/signup/signup.html','<div class="login"><main class="auth-main"><div class="auth-block"><h1>Sign up to AOMS Admin</h1><a ui-sref="login" class="auth-link">Already have a AOMS Admin account? Login!</a><form class="form-horizontal"><div class="form-group"><label for="inputName3" class="col-sm-2 control-label">First Name</label><div class="col-sm-10"><input type="text" class="form-control" id="inputName3" placeholder="First Name"></div><label for="inputName4" class="col-sm-2 control-label">Last Name</label><div class="col-sm-10"><input type="text" class="form-control" id="inputName4" placeholder="Last Name"></div></div><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Username</label><div class="col-sm-10"><input type="text" class="form-control" id="inputEmail3" placeholder="Username"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-default btn-auth">Sign up</button></div></div></form><div class="auth-sep"><span><span>or Sign up with one click</span></span></div><div class="al-share-auth"><ul class="al-share clearfix"><li><i class="socicon socicon-facebook" title="Share on Facebook"></i></li><li><i class="socicon socicon-twitter" title="Share on Twitter"></i></li><li><i class="socicon socicon-google" title="Share on Google Plus"></i></li></ul></div></div></main></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" ng-if="isInit" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-if="!$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> Previous Step</button></li><li class="next"><button ng-if="!$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">Next Step<span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span ng-show="notifications && notifications.length > 0 && unreadNotifications > 0" ng-bind="unreadNotifications"></span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu" ng-click="$event.stopPropagation()"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a ng-click="markNotificationsAsRead()">Mark All as Read</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="notification in notifications | orderBy:\'+\': true track by $index"><div class="img-area"><img class="photo-msg-item" src="assets/img/theme/system.png"></div><div class="msg-area"><div ng-class="{\'readNotification\' : notification.isRead}" ng-bind-html="getNotification(notification)"></div><span ng-class="{\'readNotification\' : notification.isRead}">{{ notification.time }}</span><md-checkbox ng-show="!notification.isRead" ng-click="markNotificationAsRead($index)" aria-label="Mark As Read">Mark As Read</md-checkbox></div></a></div></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/newProjectsModal.tmpl.html','<md-dialog class="newProjectModal" aria-label="Create New Project"><md-toolbar><div class="md-toolbar-tools"><h3>Add New Project</h3><span flex=""></span></div></md-toolbar><md-content><md-content class="md-padding"><form class="settingform" name="newProjectForm"><div class="form-group" ng-class="{\'has-error\': newProjectForm.$invalid }"><label>Name</label> <input type="text" class="form-control" ng-model="vm.newProject.name" placeholder="New Project Name" required=""></div><div class="form-group" ng-class="{\'has-error\': newProjectForm.$invalid }"><label>Description</label> <input type="text" class="form-control" ng-model="vm.newProject.description" placeholder="New Project Description"></div><div class="form-group" ng-class="{\'has-error\': newProjectForm.$invalid }"><label>Gateway Id</label> <input type="text" class="form-control" ng-model="vm.newProject.gatewayId" placeholder="New Project Gateway Id" required=""></div><br><div ng-if="newProjectForm.$valid"><button progress-button="vm.addProject()" pb-style="rotate-side-down" class="width-100">Add Project</button></div><div ng-if="!newProjectForm.$valid"><button class="new-project-progress-button-invalid width-100">Add Project</button></div><div style="padding-top: 10px"><button class="new-project-progress-button-cancel width-100" ng-click="vm.cancel()">Cancel</button></div></form></md-content></md-content></md-dialog>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><div><a href="" class="al-logo clearfix"><span>AOMS</span>Admin</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a></div><div class="server-system-statistics clearfix" ng-if="vm.enableSystemStatistics"><div class="systemStat"><label>CPU Usage:</label><div class="chart cpuStat-chart" rel="{{vm.cpuStatColor}}" data-percent="{{vm.cpuStat}}"><span class="percent"></span></div></div><div class="systemStat"><label>Memory Usage:</label><div class="chart memoryStat-chart" rel="{{vm.memoryStatColor}}" data-percent="{{vm.memoryStat}}"><span class="percent"></span></div></div><div class="systemStat datetime"><label>UTC Time:</label> <span>{{vm.utcTime}}</span></div></div><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-if="vm.getUsername() == \'admin\'" src="assets/img/theme/aoms-favicon.png"> <img ng-if="vm.getUsername() != \'admin\'" src="assets/img/theme/no-photo.png"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="" ng-click="vm.showUserDetailsModal()" class="signout username-link" title="{{vm.getUsername()}}"><i class="fa fa-user"></i>{{vm.getUsername()}}</a></li><li><a href="" ng-click="vm.showProjectsModal()" class="signout username-link" title="Projects"><i class="fa fa-suitcase"></i>{{vm.getProjectTitle()}}</a></li><li><a href="" ng-click="vm.logout()" class="signout"><i class="fa fa-power-off"></i>Logout</a></li><li ng-if="vm.isAdmin && !vm.standalone"><a href="" ng-click="vm.fullLogout()" class="signout"><i class="fa fa-desktop"></i>Reset Company</a></li></ul></div><msg-center></msg-center></div></div>');
$templateCache.put('app/theme/components/pageTop/projectsModal.tmpl.html','<md-dialog class="projectsModal" aria-label="Projects"><md-toolbar><div class="md-toolbar-tools"><h3>Projects</h3><span flex=""></span><div flex="" layout="row"><md-button md-no-ink="" md-primary="" ng-if="!vm.readOnly" ng-disabled="vm.isLoading || vm.isEditingTenant" ng-click="vm.showNewProjectModal($ev)">Add</md-button><md-button md-no-ink="" md-primary="" ng-disabled="vm.isLoading || vm.isEditingTenant" ng-click="vm.getProjects()">Refresh</md-button><md-button md-no-ink="" md-primary="" ng-disabled="vm.isLoading || vm.isEditingTenant || vm.selectedTenant === null || vm.selectedTenant.state === \'TERMINATED\'" ng-click="vm.hide()">Select</md-button><md-button md-no-ink="" md-primary="" ng-if="!vm.readOnly" ng-disabled="vm.isLoading || vm.isEditingTenant || vm.selectedTenant === null || vm.selectedTenant.state === \'TERMINATED\'" ng-click="vm.stopProject(vm.selectedTenant.id)">Terminate</md-button><md-button md-no-ink="" md-danger="" ng-disabled="vm.tenant === null" ng-click="vm.cancel()">Cancel</md-button></div></div></md-toolbar><md-content style="padding: 15px;"><div class="project-modal-control-left"><md-input-container><label>Current Project ID</label> <input type="number" ng-model="vm.tenant" ng-disabled="true"></md-input-container></div><div class="table-container" st-table="vm.displayedTenants" st-safe-src="vm.tenants" ng-if="vm.tenants && vm.tenants.length > 0"><input st-search="name" class="form-control" placeholder="Search" type="search"><br><table class="table table-bordered"><thead><tr class="sortable"><th st-sort="id">ID</th><th st-sort="name">Name</th><th>Description</th><th st-sort="gatewayId">Gateway</th><th st-sort="creationDate" st-sort-default="reverse">Creation Date</th><th st-sort="state">Status</th></tr></thead><tbody><tr st-select-row="tenant" ng-click="vm.onTenantSelected(tenant)" ng-repeat="tenant in vm.displayedTenants"><td>{{tenant.id}}</td><td>{{tenant.name}}</td><td>{{tenant.description}}</td><td>{{tenant.gatewayId}}</td><td>{{tenant.creationDate}}</td><td>{{tenant.state}}</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-items-by-page="10" st-pagination=""></div></td></tr></tfoot></table></div><div class="user-instruction" ng-if="!vm.tenants || vm.tenants.length === 0"><br><br><br><br><h4>To create a new Project, click the Add button on the panel above</h4></div></md-content></md-dialog>');
$templateCache.put('app/theme/components/pageTop/userDetailsModal.tmpl.html','<md-dialog class="userStatusDetailsModal" aria-label="User Details"><md-toolbar><div class="md-toolbar-tools"><h3>User Details</h3><span flex=""></span></div></md-toolbar><md-content><md-content class="md-padding" ng-show="vm.username || vm.roles"><br><div>Username: <span ng-style="{\'color\': vm.getUserRoleColour()}">{{vm.username}}</span></div><md-divider></md-divider><br><div>Token Expiration: <span ng-style="{\'color\': vm.getExpColour()}">{{vm.expDisplay}}</span></div><md-divider></md-divider><br><div>Display Time Zone: <span>{{vm.displayTZ}}</span></div><md-divider></md-divider><br><br><table class="table table-bordered"><thead><tr class="sortable"><th>Assigned User Roles</th></tr></thead><tbody><tr ng-repeat="role in vm.roles"><td>{{role}}</td></tr></tbody></table><br><br><div><button class="user-details-usersetting-button" ng-click="vm.changeStateEvents()">User Settings</button></div><div style="padding-top: 10px"><button class="user-details-progress-button" ng-click="vm.hide()">OK</button></div></md-content></md-content></md-dialog>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/advanced/admin/admin.html','<div class="row" ng-if="vm.tenant !== null"><div class="col-md-12 col-lg-12"><div class="panel panel-primary bootstrap-panel admin-panel"><div class="panel-heading" style="color: #fafafa;">Admin Panel</div><div class="panel-body"><md-content class="md-padding"><div layout="row" flex="" class="content-wrapper"><div layout="row" layout-sm="column" layout-align="center center" aria-label="wait" style="height: 50px; z-index: 10;" ng-show="vm.isMasterSwitchLoading"><md-progress-circular md-mode="indeterminate" class="md-primary"></md-progress-circular></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" ng-if="!vm.readOnly"><md-content class="md-padding"><h5>Master Switch</h5><p style="font-style: italic;">To toggle the AOMS System</p><md-divider></md-divider><br><a ng-disabled="vm.isMasterSwitchLoading" ng-click="vm.toggle()" ng-cloak="" ng-class="vm.isOn.val === \'1\' ? \'btn master-switch-off-button\' : \'btn master-switch-on-button\'"><i class="fa fa-power-off fa-5x" style="text-align: center; padding-top: 10%;"></i><br><br>Turn {{vm.isOn.val === \'1\' ? \'Off\' : \'On\'}}<br></a><br><br><br></md-content></div></div></md-content></div></div></div></div>');
$templateCache.put('app/pages/advanced/channelManagement/channelActivationExecutionModal.tmpl.html','<md-dialog class="channelActivationExecutionModal" aria-label="Channel Activation"><md-toolbar><div class="md-toolbar-tools"><h3>Channel Activation</h3><span flex=""></span></div></md-toolbar><md-content><md-content class="md-padding"><table class="table table-bordered"><thead><tr class="table"><th>Task</th><th>Status</th></tr></thead><tbody><tr ng-repeat="executionStatus in vm.executionStatuses"><td>{{executionStatus.name}}</td><td ng-class="{\'status-value-success\': executionStatus.status === vm.executionStates.success, \'status-value-error\': executionStatus.status === vm.executionStates.error, \'status-value-pending\': executionStatus.status === vm.executionStates.pending, \'status-value-na\': executionStatus.status === vm.executionStates.na, \'status-value-none\': executionStatus.status === vm.executionStates.none}">{{executionStatus.status}}</td></tr></tbody></table><br><br><div><button class="channel-activation-execution-button" ng-disabled="vm.result === null" ng-click="vm.complete()">OK</button></div></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/advanced/channelManagement/channelManagement.html','<div class="row channelManager" ng-if="vm.tenant !== null"><div class="col-md-12"><div layout="row" layout-sm="column" layout-align="space-around" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" md-diameter="120" style="position:fixed; left:52%; bottom:38%; z-index: 10;"></md-progress-circular></div><div ba-panel="" ba-panel-class="with-scroll"><md-tabs md-dynamic-height="" md-primary="" md-border-bottom="" md-stretch-tabs="always"><md-tab label="Channel Activation Wizard" md-on-select="vm.initChannelActivationWizard()" ng-disabled="vm.isLoading || vm.isEditingChannelSettings || vm.isSelectingCalibrationFiles"><br><ba-wizard><ba-wizard-step title="Channel Selections" form="vm.channelsForm"><form name="vm.channelsForm" novalidate=""><div class="row"><div class="col-md-4 col-md-offset-4"><br><h3 style="text-align: center;">Please Specify Channels to Activate</h3><p style="text-align: center;">Or leave empty if there are no new channels to activate</p><div class="title-divider"></div><br><br><div class="alert alert-warning" style="text-align: center;"><strong>Warning!</strong> All matching channels that were previously activated will be decommissioned.</div><div class="form-group" ng-class="{\'has-error\': !vm.isChannelSelectionsValid && (vm.channelsForm.channelSelections.$dirty || vm.channelsForm.$submitted)}"><input type="text" class="form-control" name="channelSelections" placeholder="ex. 1, 2, 5-11, 15" ng-model="vm.channelSelections" ng-model-options="{ updateOn: \'blur\', allowInvalid: false }" ng-disabled="!vm.isInit || vm.isLoading || vm.isEditingChannelSettings || vm.isSelectingCalibrationFiles" ng-focus="oldChannelSelections = vm.channelSelections;" ng-change="vm.processChannelSelections(oldChannelSelections)" autofocus=""> <span class="help-block error-block basic-block">Invalid Channel Selections</span></div></div></div></form><br></ba-wizard-step><ba-wizard-step title="Configure Channels"><div class="row"><div class="col-md-6 col-xs-12 form-group"><p><strong>Existing Channels</strong></p><div class="oldChannelSettingsTable table-container" st-table="vm.displayedOldChannelSettings" st-safe-src="vm.oldChannelSettings" style="height:300px;"><table class="table table-bordered"><thead><tr class="sortable"><th class="table-id" st-sort="id" style="display:none;">ID</th><th>Channel ID</th><th>Serial Number</th><th>Extension Cable Length (m)</th></tr></thead><tbody><tr ng-repeat="oldChannelSettings in vm.oldChannelSettings | orderBy: vm.oldChannelSettings.channelId track by $index"><td style="display:none;">{{oldChannelSettings.channelSettingsData.id}}</td><td ng-class="vm.isNewChannel(oldChannelSettings.channelId) ? \'old-channelsettings-cell-replace\' : \'old-channelsettings-cell-normal\'">{{oldChannelSettings.channelId}}</td><td ng-class="vm.isNewChannel(oldChannelSettings.channelId) ? \'old-channelsettings-cell-replace\' : \'old-channelsettings-cell-normal\'">{{oldChannelSettings.serialNumber}}</td><td ng-class="vm.isNewChannel(oldChannelSettings.channelId) ? \'old-channelsettings-cell-replace\' : \'old-channelsettings-cell-normal\'">{{oldChannelSettings.channelSettingsData.LENGTH}}</td></tr></tbody></table></div></div><div class="col-md-6 col-xs-12 form-group"><p><strong>New Channels to Activate</strong></p><div class="newChannelSettingsTable table-container" st-table="vm.displayedNewChannelSettings" st-safe-src="vm.newChannelSettings" style="height:300px; overflow:auto;"><table class="table table-bordered"><thead><tr class="sortable"><th>Channel ID</th><th>Serial Number</th><th>Extension Cable Length (m)</th></tr></thead><tbody><tr ng-repeat="newChannelSettings in vm.newChannelSettings | orderBy: vm.newChannelSettings.channelId track by $index" class="editable-row"><td class="new-channelsettings-cell-normal">{{newChannelSettings.channelId}}</td><td class="new-channelsettings-cell-editable"><span editable-text="newChannelSettings.serialNumber" e-name="serialNumber" e-placeholder="ex. MTS-123456" e-form="rowform" onbeforesave="vm.validateNewSerialNumber($data)">{{newChannelSettings.serialNumber || \'Empty\'}}</span></td><td class="new-channelsettings-cell-editable"><span editable-number="newChannelSettings.channelSettingsData.LENGTH" e-step="0.01" e-name="length" e-placeholder="0" e-form="rowform">{{newChannelSettings.channelSettingsData.LENGTH || 0}}</span></td><td class="internalsetting-cell-normal"><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" onaftersave="vm.updateChannelSettings(newChannelSettings.channelId, $data)"><button type="submit" ng-disabled="rowform.$waiting || !vm.isInit || vm.isLoading || vm.isSelectingCalibrationFiles" class="btn btn-success editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="vm.isLoading" class="btn btn-danger editable-table-button btn-xs" ng-click="rowform.$cancel(); vm.isEditingChannelSettings = false;">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn editable-table-button btn-xs btn-primary" ng-click="rowform.$show(); vm.isEditingChannelSettings = true;" ng-show="vm.isInit && !vm.isLoading && !vm.isEditingChannelSettings && !vm.isSelectingCalibrationFiles">Edit</button></div></td></tr></tbody></table></div></div></div><br></ba-wizard-step><ba-wizard-step title="Configure Sensors"><div class="row"><div class="col-md-4 col-md-offset-4"><br><h3 style="text-align: center;">Please Select Sensors Calibration Files</h3><p style="text-align: center;">Each file should contain sensors calibration data for each of the new channels to activate</p><div class="title-divider"></div><br><br><div class="alert alert-info" style="text-align: center;">Sensors will be created if they do not exist in the system.</div><div class="sensor-config-upload-input-container"><div class="btn btn-primary btn-sm sensor-config-upload-input-button" ng-disabled="!vm.isInit || vm.isLoading || vm.isEditingChannelSettings || vm.isSelectingCalibrationFiles || !vm.newChannels || vm.newChannels.length === 0"><span>Choose Directory</span> <input type="file" data-directory-upload="" data-ng-model="vm.sensorsCalibrationFileSelections" ng-disabled="!vm.isInit || vm.isLoading || vm.isEditingChannelSettings || vm.isSelectingCalibrationFiles || !vm.newChannels || vm.newChannels.length === 0" ng-click="vm.onSelectingSensorsCalibrationDirectory()" ng-change="vm.onSensorsCalibrationDirectoryChanged()" webkitdirectory="" multiple=""></div><br><br><div class="sensor-config-file-container"><md-content flex="" layout="row" layout-align="center"><table class="table"><tbody><tr ng-repeat="sensorsCalibrationFileResult in vm.sensorsCalibrationFileResults | orderBy: vm.sensorsCalibrationFileResults.status track by $index"><td ng-class="sensorsCalibrationFileResult.status === \'Valid\' ? \'sensors-calibration-file-result-valid\' : \'sensors-calibration-file-result-invalid\'">{{sensorsCalibrationFileResult.filename}}</td><td ng-class="sensorsCalibrationFileResult.status === \'Valid\' ? \'sensors-calibration-file-result-valid\' : \'sensors-calibration-file-result-invalid\'">{{sensorsCalibrationFileResult.status}}</td></tr></tbody></table></md-content></div><br><br><div ng-show="vm.sensorsCalibrationFileSelections"><div><span style="color: #388e3c;">{{vm.availableSensorsCalibrationFiles}}</span><span>calibration files available in the directory</span></div><br><div><span style="color: #1976d2;">{{vm.matchedSensorsCalibrationFiles}}</span><span>channels to activate with matching calibration file</span></div><br><div><span style="color: #d32f2f;">{{vm.unmatchedSensorsCalibrationFiles}}</span><span>channels to activate without matching calibration file</span></div></div><br><br></div></div></div></ba-wizard-step><ba-wizard-step title="Review"><div class="row"><div class="col-md-4 col-md-offset-4"><br><h3 style="text-align: center;">Please Review Before Execution</h3><p style="text-align: center;">Ensure the information below are correct as changes made will be irreversible!</p><div class="title-divider"></div><br><br><div class="table-container" style="height: 300px;"><h6 style="text-align: center;"><strong>The following channels will be activated</strong></h6><md-content flex="" layout="row" layout-align="center"><table class="table" ng-if="vm.newChannels && vm.newChannels.length > 0"><thead><tr class="table"><th>Channel</th><th>Serial Number</th><th># Sensors to Calibrate</th></tr></thead><tbody><tr ng-repeat="channel in vm.newChannels | orderBy: vm.newChannels.channelId track by $index"><td>{{channel.channelId}}</td><td>{{channel.serialNumber}}</td><td ng-bind-html="vm.getNumSensorsCalibrations(channel.channelId)"></td></tr></tbody></table><span ng-if="!vm.newChannels || vm.newChannels.length ===0">NONE</span></md-content></div><br><br></div></div></ba-wizard-step><ba-wizard-step title="Execute"><div class="row"><h3 style="text-align: center;">Click Below to Complete</h3><div class="title-divider"></div><br><br><a ng-disabled="!vm.isInit || vm.isLoading || !vm.newChannels || vm.newChannels.length === 0" ng-click="vm.execute()" ng-cloak="" class="btn channel-activation-btn-sq-lg btn-primary btn-center"><i class="fa fa-cogs fa-5x" style="text-align: center; padding-top: 10%;"></i><br><br>Execute<br></a></div></ba-wizard-step></ba-wizard></md-tab><md-tab label="Decommission Channels" md-on-select="vm.resetDecommissionedChannelSelections(true)" ng-disabled="vm.isLoading || vm.isChannelActivationDirty()"><br><br><br><form name="vm.decommissionChannelsForm" novalidate=""><div class="row"><div class="col-md-4 col-md-offset-4"><br><h3 style="text-align: center;">Please Specify Channels to Decommission</h3><p style="text-align: center;">No effects will take place if the channels are already decommissioned or otherwise do not exist</p><div class="title-divider"></div><br><br><div class="alert alert-warning" style="text-align: center;"><strong>Warning!</strong> This action is irreversible</div><div class="form-group" ng-class="{\'has-error\': !vm.isDecommissionedChannelSelectionsValid && (vm.decommissionChannelsForm.decommissionedChannelSelections.$dirty || vm.decommissionChannelsForm.$submitted)}"><input type="text" class="form-control" name="decommissionedChannelSelections" placeholder="ex. 1, 2, 5-11, 15" ng-model="vm.decommissionedChannelSelections" ng-model-options="{ debounce: 250 }" ng-change="vm.processDecommissionedChannelSelections()" ng-disabled="vm.isLoading" autofocus=""> <span class="help-block error-block basic-block">Invalid Channel Selections</span></div><br><br><div ng-disabled="true"><button ng-class="vm.isDecommissionedChannelSelectionsValid ? \'channel-decommission-button\' : \'channel-decommission-button-invalid\'" ng-click="vm.decommissionChannels()">Submit</button></div></div></div></form><br><br></md-tab></md-tabs></div></div></div>');
$templateCache.put('app/pages/advanced/cableManagement/cableManagement.html','<div class="horizontal-scroll cableManager" ng-if="vm.tenant !== null"><md-content layout-padding=""><div style="min-height: 250px;"><br><br><div layout="row" layout-sm="column" layout-align="space-around" ng-show="vm.isEnvironSensorAlarmsLoading"><md-progress-circular md-mode="indeterminate" md-diameter="120" style="position:fixed; left:40%; bottom:7%; z-index: 10;"></md-progress-circular></div><div><md-button ng-disabled="vm.isLoading || vm.isEditingCable" class="md-button md-primary" md-no-ink="" ng-click="vm.getCables()">Refresh Cables and Nodes</md-button></div><div class="cableTable table-container" st-table="vm.displayedCables" st-safe-src="vm.cables"><table class="table table-bordered"><thead><tr class="sortable"><th>Cable ID</th><th>Node ID</th><th ng-show="!vm.isLoading && !vm.readOnly && !vm.isEditingCable" class="text-left"><a class="showNodeAssociationControl" ng-click="vm.showNodeAssociationModal($event)"><i class="fa fa-plus-circle" style="font-size:22px"></i></a></th></tr></thead><tbody><tr ng-repeat="cable in vm.cables" class="editable-row"><td class="cable-id-cell">{{cable.channelGroupId}}</td><td ng-class="environSensor.alarmData.id ? \'node-cell-normal\' : \'node-cell-none\'"><span editable-text="cable.nodeId" e-name="nodeId" e-form="cableForm">{{cable.nodeId ? (cable.nodeId || \'Empty\') : \'\'}}</span></td><td><form editable-form="" name="cableForm" ng-show="cableForm.$visible" class="form-buttons form-inline" onshow="vm.oldNodeId = cable.nodeId;" onaftersave="vm.createNodeAssociation(cable.id, cable.channelGroupId, cable.nodeId); vm.isEditingCable = false;"><button type="submit" ng-disabled="cableForm.$waiting" class="btn btn-success editable-table-button btn-xs">Save</button> <button type="button" class="btn btn-danger editable-table-button btn-xs" ng-click="cableForm.$cancel(); vm.isEditingCable = false;" ng-disabled="cableForm.$waiting">Cancel</button></form><div class="buttons" ng-show="!cableForm.$visible"><button class="btn editable-table-button btn-xs btn-primary" ng-click="cableForm.$show(); vm.isEditingCable = true;" ng-show="!vm.isEditingCable" ng-disabled="">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" style="width: 28%;" ng-show="!vm.isEditingCable" ng-click="vm.removeNodeAssociation(cable.id, cable.channelGroupId, cable.nodeId)">Remove Association</button></div></td></tr></tbody></table></div></div></md-content></div>');
$templateCache.put('app/pages/advanced/cableManagement/nodeAssociationModal.tmpl.html','<md-dialog class="nodeAssociationModal" aria-label="Create New Node Association"><md-toolbar><div class="md-toolbar-tools"><h3>Create New Node Association</h3><span flex=""></span></div></md-toolbar><md-content><md-content class="md-padding"><form class="settingform" name="assocForm"><div class="form-group" ng-class="{\'has-error\': assocForm.$invalid }"><label>Cable ID</label> <input type="text" class="form-control" ng-model="vm.nodeAssociation.cableId" required=""></div><div class="form-group" ng-class="{\'has-error\': assocForm.$invalid }"><label>Node ID</label> <input type="text" class="form-control" ng-model="vm.nodeAssociation.nodeId" required=""></div><br><div ng-if="assocForm.$valid"><button type="submit" progress-button="vm.createNodeAssociation()" pb-style="rotate-side-down">Add Node Association</button></div><div ng-if="!assocForm.$valid"><button type="submit" class="node-association-progress-button-invalid">Create Association</button></div><div style="padding-top: 10px"><button class="node-association-progress-button-cancel" ng-click="vm.cancel()">Cancel</button></div></form></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/advanced/internalsettings/internalsettings.html','<div class="horizontal-scroll internalSettings" ng-if="vm.tenant !== null"><md-content layout-padding=""><div style="min-height: 250px;"><div layout="row" layout-sm="column" layout-align="space-around" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" md-diameter="120" style="position:fixed; left:50%; bottom:40%; z-index: 10;"></md-progress-circular></div><div class="internalSettingsTable" st-table="vm.displayedInternalSettings" st-safe-src="vm.internalsettings"><table class="table table-bordered"><thead><tr class="sortable"><th class="table-id" st-sort="id" style="display:none;">ID</th><th>Setting</th><th>Value</th><th>Description</th><th ng-show="!vm.isLoading && !vm.readOnly && !vm.isEditingSetting && vm.internalsettings" class="text-left"><a class="showNewInternalSettingModalControl" ng-click="vm.showNewInternalSettingModal($event)"><i class="fa fa-plus-circle" style="font-size:22px"></i></a></th></tr></thead><tbody><tr ng-repeat="internalsetting in vm.internalsettings" class="editable-row"><td style="display:none;">{{internalsetting.id}}</td><td class="internalsetting-key-cell">{{internalsetting.key}}</td><td ng-class="internalsetting.val ? \'internalsetting-cell-normal\' : \'internalsetting-cell-none\'"><span editable-text="internalsetting.val" e-name="val" e-form="rowform">{{internalsetting.val || \'Empty\'}}</span></td><td ng-class="internalsetting.description ? \'internalsetting-cell-normal\' : \'internalsetting-cell-none\'"><span editable-text="internalsetting.description" e-name="description" e-form="rowform">{{internalsetting.description || \'Empty\'}}</span></td><td class="internalsetting-cell-normal"><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" onbeforesave="vm.updateInternalSetting(internalsetting, $data)"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Save</button> <button type="button" class="btn btn-danger editable-table-button btn-xs" ng-click="rowform.$cancel(); vm.isEditingSetting = false;" ng-disabled="rowform.$waiting">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible && !vm.readOnly"><button class="btn editable-table-button btn-xs btn-primary" ng-click="rowform.$show(); vm.isEditingSetting = true;" ng-show="!vm.isEditingSetting" ng-disabled="!internalsetting.canEdit">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-show="!vm.isEditingSetting" ng-disabled="!internalsetting.canEdit" ng-click="vm.deleteInternalSetting(internalsetting)">Remove</button></div></td></tr></tbody></table></div></div></md-content></div>');
$templateCache.put('app/pages/advanced/internalsettings/newInternalSettingModal.tmpl.html','<md-dialog class="newInternalSettingModal" aria-label="Create New Internal Setting"><md-toolbar><div class="md-toolbar-tools"><h3>Create New Setting</h3><span flex=""></span></div></md-toolbar><md-content><md-content class="md-padding"><form class="settingform" name="newInternalSettingForm"><div class="form-group"><label>Setting</label> <input type="text" class="form-control" ng-model="vm.internalSetting.key" required=""></div><div class="form-group"><label>Value</label> <input type="text" class="form-control" ng-model="vm.internalSetting.val" required=""></div><div class="form-group"><label>Description</label> <input type="text" class="form-control" ng-model="vm.internalSetting.description" required=""></div><br><div ng-if="newInternalSettingForm.$valid"><button type="submit" progress-button="vm.createInternalSetting()" pb-style="rotate-side-down">Create New Internal Setting</button></div><div ng-if="!newInternalSettingForm.$valid"><button type="submit" class="new-internalsetting-progress-button-invalid">Create New Internal Setting</button></div><div style="padding-top: 10px"><button class="new-internalsetting-progress-button-cancel" ng-click="vm.cancel()">Cancel</button></div></form></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/advanced/networking/networking.html','<div class="row networkingSettings" ng-if="vm.tenant !== null"><div class="col-md-8 col-lg-8"><div class="panel panel-primary bootstrap-panel settingform-panel"><div class="panel-heading">Networking Information</div><div class="panel-body"><div layout="row" layout-sm="column" layout-align="center center" aria-label="wait" style="height: 50px; z-index: 10;" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" class="md-primary"></md-progress-circular></div><form class="networkingsettingform" name="networkingSettingsForm" ng-show="vm.networkingsettings"><div class="form-group" ng-repeat="networkingsetting in vm.networkingsettings"><ng-form name="networkingSettingForm"><div ng-if="networkingsetting.selectOptions"><label>{{networkingsetting.display}}</label><ui-select ng-model="networkingsetting.val" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="selectOption in networkingsetting.selectOptions | filter: $select.search"><span ng-bind-html="selectOption"></span></ui-select-choices></ui-select></div><div ng-if="!networkingsetting.selectOptions"><label>{{networkingsetting.display}}</label> <input type="text" class="form-control" ng-model="networkingsetting.val" readonly=""></div></ng-form></div></form></div></div></div></div>');
$templateCache.put('app/pages/analysis/outlier/outlier.html','<div class="horizontal-scroll" ng-if="vm.tenant !== null"><div style="display: block;"><div class="form-group panel-control-block"><div class="form-group select-page-size-wrap"><label>Filter monitors by status<ui-select ng-model="vm.outlierDetectionJobFilter.status" on-select="vm.refreshData()" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false">ng-disabled="vm.isLoading"<ui-select-match placeholder="All"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="channelJobStatusType in vm.channelJobStatusTypes | filter: $select.search"><span ng-bind-html="channelJobStatusType"></span></ui-select-choices></ui-select></label></div><div class="form-group panel-control-block"><label>Filter monitors by cable<ui-select ng-model="vm.selectedChannelGroupId" on-select="vm.onCableFilterSelected($select.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" ng-disabled="vm.isLoading"><ui-select-match placeholder="All"><span>{{$select.selected.channelGroupId}}</span></ui-select-match><ui-select-choices repeat="channelGroup in vm.channelGroups | filter: $select.search"><span ng-bind-html="channelGroup.channelGroupId"></span></ui-select-choices></ui-select></label><md-button ng-class="\'md-primary\'" md-no-ink="" ng-click="vm.refreshData()">Refresh Monitors</md-button><md-button ng-class="\'md-primary\'" md-no-ink="" ng-click="vm.showOutlierDetectionJobModal($event, null)">Create New Monitor</md-button></div></div><md-divider></md-divider></div><div class="analysis-outlier table-container" st-table="vm.displayedOutlierDetectionJobsData" st-pipe="vm.serverPipe"><table class="table table-bordered" ng-if="vm.outlierDetectionJobs && vm.outlierDetectionJobs.length > 0"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="reverse">ID</th><th>Name</th><th>Description</th><th>Cable</th><th>Owner</th><th>Creation Date</th><th>Status</th><th>Alarms</th><th ng-disabled="vm.isLoading || vm.isViewingDetails" class="text-left"><a class="refreshControl" ng-click="vm.refreshData()"><i class="fa fa-refresh" style="font-size:22px"></i></a></th></tr></thead><div layout="row" layout-sm="column" layout-align="center center" aria-label="wait" style="height: 50px; z-index: 10;" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" class="md-primary"></md-progress-circular></div><tbody ng-show="!vm.isLoading"><tr ng-repeat="odj in vm.displayedOutlierDetectionJobs" ng-class="odj-cell-normal"><td class="table-id">{{odj.id}}</td><td>{{odj.channelJobName}}</td><td>{{odj.channelJobDescription}}</td><td>{{odj.channelGroupId}}</td><td>{{odj.username}}</td><td>{{odj.creationDate | date:\'medium\'}}</td><td ng-style="vm.getStatusColor(odj.status)">{{odj.status}}</td><td ng-class="vm.hasAlarm(odj) ? \'status-value-error\' : \'status-value-success\'">{{vm.hasAlarm(odj) ? \'TRIGGERED\' : \'NONE\'}}</td><td class="internalsetting-cell-normal"><div class="buttons"><button class="btn editable-table-button btn-xs btn-primary" ng-click="vm.showOutlierDetectionJobModal($event, odj)" ng-if="!vm.isLoading && !vm.isViewingDetails">View</button><button class="btn editable-table-button btn-xs btn-warning" ng-click="vm.restartOutlierDetectionJob(odj.id)" ng-if="!vm.isLoading && !vm.isViewingDetails && odj.status === \'TERMINATED\'">Restart</button> <button class="btn btn-danger editable-table-button btn-xs" ng-if="!vm.isLoading && !vm.isViewingDetails" ng-click="vm.stopOutlierDetectionJob(odj.id, odj.channelJobId, odj.status)">{{odj.status === \'RUNNING\' ? \'Terminate\' : \'Remove\'}}</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-items-by-page="20" st-pagination=""></div></td></tr></tfoot></table><div class="user-instruction" ng-if="!vm.isLoading && (!vm.outlierDetectionJobs || vm.outlierDetectionJobs.length === 0) && vm.outlierDetectionJobFilter.cgId === null"><br><br><br><br><h4>To create a new Outlier Monitor, click on the Create New Monitor button above</h4></div><div class="user-instruction" ng-if="!vm.readOnly && !vm.isLoading && (!vm.outlierDetectionJobs || vm.outlierDetectionJobs.length === 0) && vm.outlierDetectionJobFilter.cgId !== null"><br><br><br><br><h4>No Outlier Monitors found for Cable</h4></div></div></div>');
$templateCache.put('app/pages/analysis/outlier/outlierDetectionJobModal.tmpl.html','<md-dialog class="analysis-outlier-job" aria-label="Outlier Monitor"><md-toolbar><div class="md-toolbar-tools"><h3 style="padding-top:2px;">Outlier Monitor</h3><div class="analysis-outlier-job-control"><md-button aria-label="Close Outlier Monitor Dialog" ng-show="!vm.isLoading" ng-click="vm.cancel()" style="min-width: 1%;"><md-icon md-font-icon="fa fa-close"></md-icon></md-button></div><span flex=""></span></div></md-toolbar><md-content><md-content class="md-padding"><div><div layout="row" layout-sm="column" layout-align="space-around" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" md-diameter="120" style="position:fixed; left:40%; bottom:30%; z-index: 10;"></md-progress-circular></div><md-content ba-panel="" ba-panel-class="with-scroll"><md-tabs md-dynamic-height="" md-primary="" md-border-bottom="" md-stretch-tabs="always"><md-tab label="Input" ng-disabled="vm.isLoading"><br><div flex="" layout="row"><md-content flex="" layout-padding="" class="input-panel"><form class="outlierDetectionJobForm" name="newOutlierDetectionJobForm" ng-disabled="vm.isLoading"><div><md-input-container class="md-block" ng-if="!vm.isCreate"><label>Outlier Monitor ID</label> <input form="newOutlierDetectionJobForm" type="number" ng-model="vm.odj.id" readonly=""></md-input-container><md-input-container class="md-block"><label>Name</label> <input form="newOutlierDetectionJobForm" md-maxlength="45" required="" name="name" ng-model="vm.odj.channelJobName" ng-readonly="!vm.isCreate"></md-input-container><md-input-container class="md-block"><label>Description</label> <textarea form="newOutlierDetectionJobForm" md-maxlength="256" rows="1" ng-model="vm.odj.channelJobDescription" ng-readonly="!vm.isCreate"></textarea></md-input-container></div><br><div><md-input-container class="md-block"><label>Username</label> <input form="newOutlierDetectionJobForm" type="text" ng-model="vm.odj.username" class="field right" readonly=""></md-input-container><md-input-container class="md-block"><label>Type</label> <input form="newOutlierDetectionJobForm" type="text" ng-model="vm.odj.channelJobTypeName" class="field left" readonly=""></md-input-container></div><br><div><md-input-container class="md-block"><label>Visibility</label><md-select ng-model="vm.odj.channelJobVisibilityName" ng-disabled="!vm.isCreate" required=""><md-option ng-value="channelJobVisibility.name" ng-repeat="channelJobVisibility in vm.channelJobVisibilities">{{ channelJobVisibility.name }}</md-option></md-select><br ng-if="!vm.isCreate"></md-input-container></div><br><div><md-input-container class="md-block"><label>Channel Group</label><md-select ng-model="vm.odj.cgId" ng-disabled="!vm.isCreate || !vm.channelGroups || vm.channelGroups.length === 0" required=""><md-option ng-value="channelGroup.id" ng-repeat="channelGroup in vm.channelGroups">{{ channelGroup.channelGroupId }}</md-option></md-select></md-input-container><br><md-input-container class="md-block"><label>Sensor Type</label><md-select ng-model="vm.odj.sensorTypeName" ng-disabled="!vm.isCreate" required=""><md-option ng-value="sensorType.name" ng-repeat="sensorType in vm.sensorTypes">{{ sensorType.name }}</md-option></md-select></md-input-container></div><br><div><md-input-container class="md-block"><label>Refresh Rate (s)</label> <input form="newOutlierDetectionJobForm" type="number" min="1" step="1" ng-model="vm.odj.refreshRate" required="" ng-readonly="!vm.isCreate"></md-input-container></div><br><div ng-if="vm.isCreate"><md-input-container><label style="min-width:500px">Average Criterion</label><md-select ng-model="vm.odj.averageCriterionAlarmStatus" ng-disabled="true"><md-option ng-value="false">Yes</md-option><md-option ng-value="null">No</md-option></md-select></md-input-container></div><br ng-if="vm.isCreate"><div ng-if="vm.isCreate"><md-input-container><label style="min-width:500px">Change of Interval Criterion</label><md-select ng-model="vm.odj.rocCriterionAlarmStatus" ng-disabled="!vm.isCreate" ng-change="vm.odj.rocInterval = null;"><md-option ng-value="false">Yes</md-option><md-option ng-value="null">No</md-option></md-select></md-input-container></div><br ng-if="vm.isCreate"><div><md-input-container class="md-block" ng-if="vm.odj.hasOwnProperty(\'averageCriterionAlarmStatus\') && vm.odj.averageCriterionAlarmStatus !== null"><label>Average Threshold</label> <input form="newOutlierDetectionJobForm" type="number" step="0.01" ng-model="vm.singularAlarmThreshold" required="" ng-readonly="!vm.isCreate"><br></md-input-container><md-input-container class="md-block" ng-if="vm.odj.hasOwnProperty(\'rocCriterionAlarmStatus\') && vm.odj.rocCriterionAlarmStatus !== null"><label>Rate of Change Interval (s)</label> <input form="newOutlierDetectionJobForm" type="number" min="5" step="1" ng-model="vm.odj.rocInterval" required="" ng-readonly="!vm.isCreate"><br></md-input-container><div></div><div ng-if="vm.isCreate"><div ng-if="newOutlierDetectionJobForm.$valid"><button style="width:100%;" type="submit" progress-button="vm.createOutlierDetectionJob()" pb-style="rotate-side-down">Start Outlier Monitor</button></div><div ng-if="!newOutlierDetectionJobForm.$valid"><button type="submit" class="outlier-detection-job-progress-button-invalid">Start Outlier Monitor</button></div><div style="padding-top: 10px"><button class="outlier-detection-job-progress-button-cancel" ng-click="vm.cancel()">Cancel</button></div></div></div></form></md-content></div></md-tab><md-tab label="Latest" ng-if="!vm.isCreate" ng-disabled="vm.isLoading"><br><div><md-content flex="" layout-padding="" class="latest-panel">Outlier Monitor {{vm.odj.id}}<md-button style="margin-left: 5%;" md-no-ink="" ng-disabled="vm.odj.status !== \'RUNNING\'" ng-class="\'md-accent\'" ng-click="vm.terminateOutlierDetectionJob(vm.odj.id)">Terminate</md-button><md-button md-no-ink="" ng-disabled="vm.odj.status !== \'RUNNING\'" ng-class="\'md-primary\'" ng-click="vm.refresh()">Refresh Now</md-button><md-divider></md-divider><br><div style="display: flex;"><div style="margin-right: 25px"><div class="form-group"><label for="latest-cable">Channel Group</label> <input type="text" class="form-control input-field" id="latest-cable" value="{{vm.odj.channelGroupId}}" readonly=""></div></div><div style="margin-right: 25px"><div class="form-group"><label for="latest-status">Status</label> <input type="text" class="form-control" id="latest-status" value="{{vm.odj.status}}" ng-style="vm.getStatusColor(vm.odj.status)" readonly=""></div></div><div class="form-group"><label for="latest-alarms-triggered">Alarms Triggered</label> <input type="text" class="form-control" id="latest-alarms-triggered" value="{{vm.hasAlarm() ? \'TRIGGERED\' : \'NONE\'}}" ng-class="vm.hasAlarm() ? \'status-value-error\' : \'status-value-success\'" readonly=""></div></div><br><br><div ng-if="vm.odj.status === \'RUNNING\' && vm.sensorStatuses" st-safe-src="vm.sensorStatuses" st-table="vm.displayedSensorStatuses"><div style="display: flex; justify-content: flex-start;"><div class="form-group" style="margin-right: 50px"><label for="filter-sensor-status-channel">Filter by Channel</label> <input class="input-sm form-control" id="filter-sensor-status-channel" style="max-height: 50%;" st-search="channelId" placeholder="Channel ID" type="search" maxlength="50" ng-model="vm.filterSensorStatusChannel"></div><div class="form-group"><label for="filter-sensor-status-sensor">Filter by Sensor</label> <input class="input-sm form-control" id="filter-sensor-status-sensor" style="max-height: 50%;" st-search="sensorId" placeholder="Sensor ID" type="search" maxlength="50" ng-model="vm.filterSensorStatusSensor"></div></div><table class="table table-bordered"><thead><tr class="sortable"><th style="display: none; text-align: center;" st-sort="firstName">Channel</th><th style="text-align: center;" st-sort="channelId">Channel</th><th style="text-align: center;" st-sort="sensorId">Sensor</th><th style="text-align: center;" st-sort="averageCriterionAlarmStatus">Average Criterion</th><th style="text-align: center;" st-sort="rocCriterionAlarmStatus">ROC Criterion</th><th style="text-align: center;" st-sort="lastModified">Data Timestamp</th><th style="text-align: center;" st-sort="hasAlarm">Alarm</th></tr></thead><tbody><tr ng-repeat="sensorStatus in vm.displayedSensorStatuses"><td style="display: none; text-align: center;">{{sensorStatus.id}}</td><td style="text-align: center;">{{sensorStatus.channelId}}</td><td style="text-align: center;">{{sensorStatus.sensorId}}</td><td ng-class="{ \'status-value-neutral\' : sensorStatus.averageCriterionAlarmStatus === 2 || sensorStatus.averageCriterionAlarmStatus === 4, \'status-value-error\' : sensorStatus.averageCriterionAlarmStatus === 1 || sensorStatus.averageCriterionAlarmStatus === 3 }" style="text-align: center;"><span ng-if="sensorStatus.averageCriterionAlarmStatus !== 0">{{vm.getCriterionAlarmStatusName(sensorStatus.averageCriterionAlarmStatus)}}</span> <span ng-if="sensorStatus.averageCriterionAlarmStatus === 0">-</span></td><td ng-class="{ \'status-value-neutral\' : sensorStatus.rocCriterionAlarmStatus === 2 || sensorStatus.rocCriterionAlarmStatus === 4, \'status-value-error\' : sensorStatus.rocCriterionAlarmStatus === 1 || sensorStatus.rocCriterionAlarmStatus === 3 }" style="text-align: center;"><span ng-if="sensorStatus.rocCriterionAlarmStatus !== 0">{{vm.getCriterionAlarmStatusName(sensorStatus.rocCriterionAlarmStatus)}}</span> <span ng-if="sensorStatus.rocCriterionAlarmStatus === 0">-</span></td><td style="text-align: center;">{{sensorStatus.lastModified ? (sensorStatus.lastModified) : "-"}}</td><td style="text-align: center;"><span ng-if="!sensorStatus.lastModified">-</span> <i class="fa fa-bell-slash status-value-none" aria-hidden="true" ng-if="sensorStatus.lastModified && !sensorStatus.hasAlarm"></i> <i class="fa fa-bell faa-shake animated status-value-success" aria-hidden="true" ng-if="sensorStatus.lastModified && sensorStatus.hasAlarm"></i></td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-items-by-page="20" st-pagination=""></div></td></tr></tfoot></table></div><br><br></md-content></div></md-tab></md-tabs></md-content></div></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/dashboard/dashboardChannel/dashboardChannel.html','<div class="panel panel-primary bootstrap-panel channel-panel" ng-if="tenant !== null && enableDashboardChannel"><md-progress-circular md-mode="indeterminate" md-diameter="75" style="position:relative; left:45%; z-index: 10;" ng-show="isChannelsLoading"></md-progress-circular><div class="panel-heading"><i class="fa fa-bell faa-shake animated" aria-hidden="true" ng-hide="!displayChannelsStatusAlert">&nbsp;&nbsp;</i> Channels</div><div class="table-channel-wrapper horizontal-scroll" ng-show="channels.length > 0"><table class="table table-channel"><thead><tr><th>ID</th><th>Serial Number</th><th>Number of Sensors</th><th>Requires Attention</th><th>Status</th></tr></thead><tbody><tr class="table-channel-body-row" ng-repeat="channel in channels | limitTo: channelRowLimit track by $index"><td>{{channel.channelId}}</td><td>{{channel.serialNumber}}</td><td>{{channel.numSensors}}</td><td ng-class="channel.numErrSensors === 0 ? \'channel-attention-value-success\' : \'channel-attention-value-error\'">{{channel.numErrSensors}}</td><td><div ng-class="{\'channel-label\': true, \'channel-label-inactive\': !channel.isActive, \'channel-label-error\': channel.channelStatus > 0, \'channel-label-active\': (channel.isActive && channel.channelStatus === 0)}">{{channel.statusLabel}}</div></td><td><i class="fa fa-angle-right" ng-click="showDashboardChannelStatusModal($event, channel.channelId, channel.isActive)"></i></td></tr></tbody><tfoot ng-hide="channels.length <= channelRowLimit"><tr class="table-channel-footer-row"><td class="channel-row-expand-btn" colspan="100%" ng-click="modifyChannelRows()"><i ng-class="isChannelTableExpanded === false ? \'fa fa-angle-down\' : \'fa fa-angle-down rotate-up\'"></i></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/dashboard/dashboardChannel/dashboardChannelStatusModal.tmpl.html','<md-dialog class="dashboardChannelStatusModal" aria-label="Channel Details"><md-toolbar><div class="md-toolbar-tools"><h3>Channel Details</h3><span flex=""></span></div></md-toolbar><md-content><md-progress-circular md-mode="indeterminate" md-diameter="75" style="position:relative; left:40%; z-index: 10;" ng-show="vm.isChannelStatusLoading"></md-progress-circular><md-content class="md-padding" ng-show="!vm.isChannelStatusLoading">Channel {{vm.channelId}}<md-button md-no-ink="" ng-if="!vm.readOnly" ng-class="vm.isActive ? \'md-accent\' : \'md-primary\'" ng-click="vm.toggleChannel()" ng-show="vm.channelStatusTypes">{{vm.toggleChannelDisplay()}}</md-button><md-divider></md-divider><br><table class="table table-bordered"><thead><tr class="sortable"><th>Channel Statuses</th></tr></thead><tbody><tr ng-repeat="channelStatusType in vm.channelStatusTypes"><td ng-class="channelStatusType.description === \'OK\' ? \'status-value-success\' : \'status-value-error\'">{{channelStatusType.description}}</td></tr></tbody></table><br><br><table class="table table-bordered"><thead><tr class="sortable"><th style="text-align: center;">Sensor</th><th style="text-align: center;">Type</th><th style="text-align: center;">Sensor Statuses</th><th style="text-align: center;">Data</th><th style="text-align: center;">Data Timestamp</th></tr></thead><tbody><tr ng-repeat="sensor in vm.sensors"><td style="text-align: center;">{{sensor.sensorId}}</td><td style="text-align: center;">{{sensor.sensorType}}</td><td style="text-align: center;"><span ng-repeat="statusDescription in sensor.sensorStatusDescriptions" ng-class="statusDescription === \'OK\' ? \'status-value-success\' : \'status-value-error\'">{{statusDescription}}<br></span></td><td ng-if="sensor.sensorType===\'Temperature\'" ng-class="{ \'status-value-neutral\' : sensor.latestValueTimestamp }" style="text-align: center;"><span ng-if="sensor.latestValueTimestamp">{{sensor.latestValue | number: 1}} \xB0C</span> <span ng-if="!sensor.latestValueTimestamp">-</span></td><td ng-if="sensor.sensorType===\'Pressure\'" ng-class="{ \'status-value-neutral\' : sensor.latestValueTimestamp }" style="text-align: center;">{{sensor.latestValueTimestamp ? sensor.latestValue + " hPa" : "-"}}</td><td ng-if="sensor.sensorType===\'Humidity\'" ng-class="{ \'status-value-neutral\' : sensor.latestValueTimestamp }" style="text-align: center;"><span ng-if="sensor.latestValueTimestamp">{{sensor.latestValue | number: 1}}</span> <span ng-if="!sensor.latestValueTimestamp">-</span></td><td style="text-align: center;">{{sensor.latestValueTimestamp ? sensor.latestValueTimestamp : "-"}}</td></tr></tbody></table><br><br><div><button class="dashboard-channel-status-progress-button" ng-click="vm.hide()">OK</button></div></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/dashboard/dashboardDiagnostics/dashboardDiagnostics.html','<div class="panel panel-danger bootstrap-panel diagnostic-panel" ng-if="vm.tenant !== null && vm.enableDashboardDiagnostics"><md-progress-circular md-mode="indeterminate" md-diameter="75" style="position:relative; left:45%; z-index: 10;" ng-show="vm.isDiagnosticsLoading"></md-progress-circular><div class="panel-heading">Diagnostics</div><div class="table-diagnostic-wrapper horizontal-scroll" ng-show="vm.hasLatestEvent()"><table class="table table-diagnostic"><thead><tr><th>Event ID</th><th>Type</th><th>Log</th><th>Timestamp</th><th>Severity</th></tr></thead><tbody><tr class="table-diagnostic-body-row"><td>{{vm.latestEvent.id}}</td><td>{{vm.latestEvent.eventtypeName}}</td><td ng-class="\'diagnostics-event-log-value diagnostics-event-log-animation-\' + vm.latestEvent.severityName.toLowerCase()">{{vm.latestEvent.description}}</td><td>{{vm.latestEvent.timestamp}}</td><td><div ng-class="{\'diagnostic-label\' : true, [\'diagnostic-label-\' + vm.latestEvent.severityName.toLowerCase()] : true}">{{vm.latestEvent.severityName}}</div></td></tr></tbody><tfoot class="table-diagnostic-footer-row"><td colspan="4"></td><td><button class="md-button md-primary" ng-click="vm.changeStateEvents()">See Latest Events</button></td></tfoot></table></div></div>');
$templateCache.put('app/pages/dashboard/dashboardEnviron/dashboardEnviron.html','<div class="panel panel-info bootstrap-panel environ-panel" ng-if="tenant !== null && enableDashboardEnvironment"><md-progress-circular md-mode="indeterminate" md-diameter="75" style="position:relative; left:45%; z-index: 10;" ng-show="isEnvironLoading"></md-progress-circular><div class="panel-heading"><i class="fa fa-bell faa-shake animated" aria-hidden="true" ng-hide="!displayEnvironSensorsStatusAlert">&nbsp;&nbsp;</i> Environment</div><div class="table-environ-wrapper horizontal-scroll" ng-show="totalNumOfEnvironSensors > 0"><table class="table table-environ"><thead><tr><th>Sensor ID</th><th>Type</th><th>Value</th><th>Timestamp</th><th>Status</th></tr></thead><tbody><tr class="table-environ-body-row" ng-repeat="environTemperature in environTemperatures | limitTo: environRowLimitTemp track by $index"><td>{{environTemperature.sensorId}}</td><td>Temperature</td><td ng-if="environTemperature.id===0">??????????????</td><td ng-if="environTemperature.id!==0">{{environTemperature.temperature}} \xB0C</td><td ng-if="environTemperature.id===0">????-??-?? ??:??:??:???</td><td ng-if="environTemperature.id!==0">{{environTemperature.timestamp}}</td><td><div ng-class="\'environ-label\' + \' \' + (environTemperature.sensorStatus > 0 ? \'environ-label-error\': \'environ-label-active\')">{{environTemperature.statusLabel}}</div></td><td><i class="fa fa-angle-right" ng-click="showDashboardEnvironStatusModal($event, environTemperature.sensorId, \'Temperature\')"></i></td></tr><tr class="table-environ-body-row" ng-repeat="environPressure in environPressures | limitTo: environRowLimitPressure track by $index"><td>{{environPressure.sensorId}}</td><td>Pressure</td><td ng-if="environPressure.id===0">??????????????</td><td ng-if="environPressure.id!==0">{{environPressure.pressure}} kPa</td><td ng-if="environPressure.id===0">????-??-?? ??:??:??:???</td><td ng-if="environPressure.id!==0">{{environPressure.timestamp}}</td><td><div ng-class="\'environ-label\' + \' \' + (environPressure.sensorStatus > 0 ? \'environ-label-error\': \'environ-label-active\')">{{environPressure.statusLabel}}</div></td><td><i class="fa fa-angle-right" ng-click="showDashboardEnvironStatusModal($event, environPressure.sensorId, \'Pressure\')"></i></td></tr><tr class="table-environ-body-row" ng-repeat="environHumidity in environHumidities | limitTo: environRowLimitHumidity track by $index"><td>{{environHumidity.sensorId}}</td><td>Humidity</td><td ng-if="environHumidity.id===0">??????????????</td><td ng-if="environHumidity.id!==0">{{environHumidity.humidity}} %</td><td ng-if="environHumidity.id===0">????-??-?? ??:??:??:???</td><td ng-if="environHumidity.id!==0">{{environHumidity.timestamp}}</td><td><div ng-class="\'environ-label\' + \' \' + (environHumidity.sensorStatus > 0 ? \'environ-label-error\': \'environ-label-active\')">{{environHumidity.statusLabel}}</div></td><td><i class="fa fa-angle-right" ng-click="showDashboardEnvironStatusModal($event, environHumidity.sensorId, \'Humidity\')"></i></td></tr><tr class="table-environ-body-row" ng-repeat="environDewpoint in environDewpoints | limitTo: environRowLimitDewpoint track by $index"><td>{{environDewpoint.sensorId}}</td><td>Dewpoint</td><td ng-if="environDewpoint.id===0">??????????????</td><td ng-if="environDewpoint.id!==0">{{environDewpoint.dewpoint}} %</td><td ng-if="environDewpoint.id===0">????-??-?? ??:??:??:???</td><td ng-if="environDewpoint.id!==0">{{environDewpoint.timestamp}}</td><td><div ng-class="\'environ-label\' + \' \' + (environDewpoint.sensorStatus > 0 ? \'environ-label-error\': \'environ-label-active\')">{{environDewpoint.statusLabel}}</div></td><td><i class="fa fa-angle-right" ng-click="showDashboardEnvironStatusModal($event, environDewpoint.sensorId, \'Dewpoint\')"></i></td></tr></tbody><tfoot ng-hide="totalNumOfEnvironSensors <= environRowLimit"><tr class="table-environ-footer-row"><td class="environ-row-expand-btn" colspan="100%" ng-click="modifyEnvironRows()"><i ng-class="isEnvironTableExpanded === false ? \'fa fa-angle-down\' : \'fa fa-angle-down rotate-up\'"></i></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/dashboard/dashboardEnviron/dashboardEnvironStatusModal.tmpl.html','<md-dialog class="dashboardEnvironStatusModal" aria-label="Environ Status"><md-toolbar><div class="md-toolbar-tools"><h3>Environment Sensor Status</h3><span flex=""></span></div></md-toolbar><md-content><md-progress-circular md-mode="indeterminate" md-diameter="75" style="position:relative; left:40%; z-index: 10;" ng-show="vm.isEnvironStatusLoading"></md-progress-circular><md-content class="md-padding" ng-show="!vm.isEnvironStatusLoading">Sensor {{vm.environSensorId}}<md-divider></md-divider><br><table class="table table-bordered"><thead><tr class="sortable"><th>Sensor Statuses</th></tr></thead><tbody><tr ng-repeat="environSensorStatusType in vm.environSensorStatusTypes"><td ng-class="environSensorStatusType.description === \'OK\' ? \'status-value-success\' : \'status-value-error\'">{{environSensorStatusType.description}}</td></tr></tbody></table><br><br><table class="table table-bordered"><thead><tr class="sortable"><th>Sensor Alarm</th></tr></thead><tbody><td ng-class="vm.isAlarmTriggered ? \'status-value-error\' : \'status-value-success\'">{{(vm.isAlarmTriggered !== null && vm.isAlarmTriggered !== undefined) ? (vm.isAlarmTriggered ? "Triggered" : "None") : ""}}</td></tbody></table><br><br><div><button class="dashboard-environ-status-progress-button" ng-click="vm.hide()">OK</button></div></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/dashboard/dashboardStatus/dashboardStatus.html','<div class="row status-cards" ng-if="tenant !== null"><md-progress-circular md-mode="indeterminate" md-diameter="75" style="position:relative; left:45%; z-index: 10;" ng-show="isStatusLoading"></md-progress-circular><div class="status-cards-container" ng-repeat="status in statuses track by $index" ng-click="showDashboardStatusDetailsModal($event, status.name, status.description, status.isAlarm)"><div ba-panel=""><div class="status-card"><div class="card-label">Status</div><div class="card-content"><div>{{status.display}}</div><div class="card-content-value-xl" ng-style="{color: getStatusColor(status.percentageSuccess)}">{{status.percentageSuccess}} %</div><div class="card-content-label">Last Modified</div><div class="card-content-value">{{status.lastModified}}</div></div></div></div></div><div style="clear: left;"></div><div class="status-cards-container" ng-repeat="alarmStatus in alarmStatuses track by $index" ng-click="showDashboardStatusDetailsModal($event, alarmStatus.name, alarmStatus.description, alarmStatus.isAlarm)"><div ba-panel=""><div class="status-card"><div class="card-label">Alarm</div><div class="card-content"><div>{{alarmStatus.display}}</div><div class="card-content-value-xl" ng-style="{color: getAlarmColor(alarmStatus.percentageSuccess)}"><i ng-repeat="i in getAlarmIconDisplay(alarmStatus.percentageSuccess) track by $index" ng-if="alarmStatus.percentageSuccess < 100" ng-cloak="" class="fa fa-bomb faa-pulse animated" aria-hidden="true" style="font-size: 28px;"></i> <span ng-if="alarmStatus.percentageSuccess === 100" ng-cloak="">None</span></div><div class="card-content-label">Last Modified</div><div class="card-content-value">{{alarmStatus.lastModified}}</div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardStatus/dashboardStatusDetailsModal.tmpl.html','<md-dialog class="dashboardStatusDetailsModal" aria-label="Status Details"><md-toolbar><div class="md-toolbar-tools"><h3>{{vm.isAlarm ? \'Overall Alarm Details\' : \'Status Details\'}}</h3><span flex=""></span></div></md-toolbar><md-content><md-progress-circular md-mode="indeterminate" md-diameter="75" style="position:relative; left:40%; z-index: 10;" ng-show="vm.isStatusDetailsLoading"></md-progress-circular><md-content class="md-padding" ng-show="!vm.isStatusDetailsLoading">{{vm.statusDescription}}<md-divider></md-divider><br><table class="table table-bordered"><thead><tr class="sortable"><th>{{vm.isAlarm ? \'Alarms Summary\' : \'Current Statuses\'}}</th></tr></thead><tbody><tr ng-repeat="eventtype in vm.eventtypes"><td ng-class="eventtype.description === \'OK\' || eventtype.description === \'None\' ? \'status-value-success\' : \'status-value-error\'">{{eventtype.description}}</td></tr></tbody></table><br><br><div><button class="dashboard-status-progress-button" ng-click="vm.hide()">OK</button></div></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/data/measurement/measurementData.html','<div class="row measurementData" ng-if="vm.tenant !== null"><div class="col-md-12 col-lg-12"><div class="panel panel-primary bootstrap-panel data-panel"><div class="panel-heading">Measurement</div><div class="panel-body"><md-content class="md-padding"><md-tabs md-dynamic-height="" md-primary="" md-border-bottom=""><md-tab label="Real-time Data" md-on-select="vm.onRealtimeDataTabSelected()" md-on-deselect="vm.onRealtimeDataTabDeselected()" ng-if="vm.realTimeDataEnabled"><br><br><div><div class="form-group panel-control-block col-md-6 col-sm-12"><div class="form-group panel-control-block"><label>Channel<ui-select ng-model="vm.channel[\'realtime\']" on-select="vm.onChannelSelected(\'realtime\')" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.channels && vm.channels.length > 0 ? \'Select Channel\' : \'No Channels Available\'}}"><span>Channel {{$select.selected.channelId}}</span></ui-select-match><ui-select-choices repeat="channel in vm.channels | filter: $select.search"><span ng-bind-html="\'Channel \' + channel.channelId"></span></ui-select-choices></ui-select></label><md-button ng-if="!vm.readOnly && vm.channel[\'realtime\']" md-no-ink="" ng-class="vm.channel[\'realtime\'].isActive ? \'md-accent\' : \'md-primary\'" ng-click="vm.toggleChannel(\'realtime\')">{{vm.toggleChannelDisplay(\'realtime\')}}</md-button></div><br><div class="form-group" ng-if="vm.channel[\'realtime\'] && vm.channel[\'realtime\'].isActive"><label>Sensors<br><ui-select multiple="" limit="16" ng-model="vm.selectedSensorsMessages.realtime" class="btn-group bootstrap-select form-control" append-to-body="true" close-on-select="false" ng-change="vm.onSensorsSelected(\'realtime\')" ng-model-options="{debounce: 1250}" style="width: 350px;"><ui-select-match placeholder="{{vm.sensors.realtime && vm.sensors.realtime.length > 0 ? \'Select Sensors\' : \'No Sensors Available\'}}" <span="">Sensor {{$item.sensorId}}</ui-select-match><ui-select-choices repeat="sensor in vm.sensors.realtime | filter: $select.search"><span ng-bind-html="\'Sensor \' + sensor.sensorId"></span></ui-select-choices></ui-select></label></div></div><div class="form-group panel-control-block col-md-6 col-sm-12"><div class="radar-chart-block" ng-show="vm.selectedSensors.realtime && vm.selectedSensors.realtime.length > 0">Relational Radar Chart of the Latest Datapoints<md-divider></md-divider><br><canvas class="chart chart-radar" chart-data="vm.radarData" chart-options="vm.radarOptions" chart-labels="vm.radarLabels" width="334" height="250"></canvas></div></div></div><div ng-show="vm.selectedSensors.realtime && vm.selectedSensors.realtime.length > 0">Real-Time Measurement Data Graph<md-divider></md-divider><br><measurement-realtime-chart chart-options="vm.realtimeOptions" width="1000" height="470"></measurement-realtime-chart></div><br><br></md-tab><md-tab label="Snapshot Data" md-on-select="vm.onSnapshotDataTabSelected()" md-on-deselect="vm.onSnapshotDataTabDeselected()"><br><br><div class="form-group panel-control-block"><label>Channel<ui-select ng-model="vm.channel[\'snapshot\']" on-select="vm.onChannelSelected(\'snapshot\')" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.channels && vm.channels.length > 0 ? \'Select Channel\' : \'No Channels Available\'}}"><span>Channel {{$select.selected.channelId}}</span></ui-select-match><ui-select-choices repeat="channel in vm.channels | filter: $select.search"><span ng-bind-html="\'Channel \' + channel.channelId"></span></ui-select-choices></ui-select></label><md-button ng-if="!vm.readOnly && vm.channel[\'snapshot\']" md-no-ink="" ng-class="vm.channel[\'snapshot\'].isActive ? \'md-accent\' : \'md-primary\'" ng-click="vm.toggleChannel(\'snapshot\')">{{vm.toggleChannelDisplay(\'snapshot\')}}</md-button></div><br><div class="form-group" ng-if="vm.channel[\'snapshot\'] && vm.channel[\'snapshot\'].isActive"><label>Sensors<ui-select ng-model="vm.selectedSensorsMessages.snapshot" class="btn-group bootstrap-select form-control" append-to-body="true" ng-change="vm.onSensorsSelected(\'snapshot\')"><ui-select-match placeholder="{{vm.sensors.snapshot && vm.sensors.snapshot.length > 0 ? \'Select Sensor\' : \'No Sensors Available\'}}" <span="">Sensor {{$select.selected.sensorId}}</ui-select-match><ui-select-choices repeat="sensor in vm.sensors.snapshot | filter: $select.search"><span ng-bind-html="\'Sensor \' + sensor.sensorId"></span></ui-select-choices></ui-select></label></div><br><br><div ng-show="vm.selectedSensors.snapshot && vm.selectedSensors.snapshot.length > 0"><div ng-attr-id="{{\'anchor_\'.concat(vm.snapshotTypes.FIVE_MIN.id)}}" ng-class="vm.activeSnapshotId === vm.snapshotTypes.FIVE_MIN.id ? \'col-md-12 col-lg-12\' : \'col-md-6 col-lg-6\'"><md-content layout="column" flex="" ng-class="vm.activeSnapshotId === vm.snapshotTypes.FIVE_MIN.id ? \'md-padding measurement-data-snapshot-content-max\' : \'md-padding measurement-data-snapshot-content-min\'"><div><span>5-minute snapshot&nbsp;&nbsp;</span> <button type="button" class="btn btn-default" title="Refresh" ng-click="vm.refreshSnapshotOnClicked(vm.snapshotTypes.FIVE_MIN)"><span><i class="fa fa fa-refresh" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" title="Toggle Auto-Refresh" ng-if="vm.hasSnapshotData(vm.snapshotTypes.FIVE_MIN.id)" ng-click="vm.snapshotPollingToggled(vm.snapshotTypes.FIVE_MIN)"><span><i ng-class="vm.snapshotTypes.FIVE_MIN.toPoll ? \'fa fa-toggle-on\' : \'fa fa-toggle-off\'" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" ng-attr-title="{{vm.activeSnapshotId === vm.snapshotTypes.FIVE_MIN.id ? \'Compress\' : \'Expand\'}}" ng-if="vm.hasSnapshotData(vm.snapshotTypes.FIVE_MIN.id)" ng-click="vm.setActiveSnapshot(vm.snapshotTypes.FIVE_MIN.id)"><span><i ng-class="vm.activeSnapshotId === vm.snapshotTypes.FIVE_MIN.id ? \'fa fa-compress\' : \'fa fa-expand\'" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" title="Reset Zoom Level" ng-if="vm.hasSnapshotData(vm.snapshotTypes.FIVE_MIN.id)" ng-click="vm.resetSnapshotGraphZoom(vm.snapshotTypes.FIVE_MIN.name)"><span><i class="fa fa fa-undo" aria-hidden="true"></i></span></button></div><br><canvas ng-if="vm.hasSnapshotData(vm.snapshotTypes.FIVE_MIN.id)" class="chart chart-line" chart-data="vm.snapshotData[vm.snapshotTypes.FIVE_MIN.id]" chart-series="vm.getSnapshotSeries(vm.activeSnapshotId !== vm.snapshotTypes.FIVE_MIN.id, vm.snapshotTypes.FIVE_MIN.id)" chart-options="vm.getSnapshotOptions(vm.activeSnapshotId !== vm.snapshotTypes.FIVE_MIN.id, \'FIVE_MIN\')"></canvas><div class="user-instruction" ng-if="!vm.hasSnapshotData(vm.snapshotTypes.FIVE_MIN.id)"><h4>DATA UNAVAILABLE</h4></div></md-content></div><div ng-attr-id="{{\'anchor_\'.concat(vm.snapshotTypes.FIFTEEN_MIN.id)}}" ng-class="vm.activeSnapshotId === vm.snapshotTypes.FIFTEEN_MIN.id ? \'col-md-12 col-lg-12\' : \'col-md-6 col-lg-6\'"><md-content layout="column" flex="" ng-class="vm.activeSnapshotId === vm.snapshotTypes.FIFTEEN_MIN.id ? \'md-padding measurement-data-snapshot-content-max\' : \'md-padding measurement-data-snapshot-content-min\'"><div><span>15-minute snapshot&nbsp;&nbsp;</span> <button type="button" class="btn btn-default" title="Refresh" ng-click="vm.refreshSnapshotOnClicked(vm.snapshotTypes.FIFTEEN_MIN)"><span><i class="fa fa fa-refresh" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" title="Toggle Auto-Refresh" ng-if="vm.hasSnapshotData(vm.snapshotTypes.FIFTEEN_MIN.id)" ng-click="vm.snapshotPollingToggled(vm.snapshotTypes.FIFTEEN_MIN)"><span><i ng-class="vm.snapshotTypes.FIFTEEN_MIN.toPoll ? \'fa fa-toggle-on\' : \'fa fa-toggle-off\'" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" ng-attr-title="{{vm.activeSnapshotId === vm.snapshotTypes.FIFTEEN_MIN.id ? \'Compress\' : \'Expand\'}}" ng-if="vm.hasSnapshotData(vm.snapshotTypes.FIFTEEN_MIN.id)" ng-click="vm.setActiveSnapshot(vm.snapshotTypes.FIFTEEN_MIN.id)"><span><i ng-class="vm.activeSnapshotId === vm.snapshotTypes.FIFTEEN_MIN.id ? \'fa fa-compress\' : \'fa fa-expand\'" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" title="Reset Zoom Level" ng-if="vm.hasSnapshotData(vm.snapshotTypes.FIFTEEN_MIN.id)" ng-click="vm.resetSnapshotGraphZoom(vm.snapshotTypes.FIFTEEN_MIN.name)"><span><i class="fa fa fa-undo" aria-hidden="true"></i></span></button></div><br><canvas ng-if="vm.hasSnapshotData(vm.snapshotTypes.FIFTEEN_MIN.id)" class="chart chart-line" chart-data="vm.snapshotData[vm.snapshotTypes.FIFTEEN_MIN.id]" chart-series="vm.getSnapshotSeries(vm.activeSnapshotId !== vm.snapshotTypes.FIFTEEN_MIN.id, vm.snapshotTypes.FIFTEEN_MIN.id)" chart-options="vm.getSnapshotOptions(vm.activeSnapshotId !== vm.snapshotTypes.FIFTEEN_MIN.id, \'FIFTEEN_MIN\')"></canvas><div class="user-instruction" ng-if="!vm.hasSnapshotData(vm.snapshotTypes.FIFTEEN_MIN.id)"><h4>DATA UNAVAILABLE</h4></div></md-content></div><div ng-attr-id="{{\'anchor_\'.concat(vm.snapshotTypes.ONE_HOUR.id)}}" ng-class="vm.activeSnapshotId === vm.snapshotTypes.ONE_HOUR.id ? \'col-md-12 col-lg-12\' : \'col-md-6 col-lg-6\'"><md-content layout="column" flex="" ng-class="vm.activeSnapshotId === vm.snapshotTypes.ONE_HOUR.id ? \'md-padding measurement-data-snapshot-content-max\' : \'md-padding measurement-data-snapshot-content-min\'"><div><span>1-hour snapshot&nbsp;&nbsp;</span> <button type="button" class="btn btn-default" title="Refresh" ng-click="vm.refreshSnapshotOnClicked(vm.snapshotTypes.ONE_HOUR)"><span><i class="fa fa fa-refresh" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" title="Toggle Auto-Refresh" ng-if="vm.hasSnapshotData(vm.snapshotTypes.ONE_HOUR.id)" ng-click="vm.snapshotPollingToggled(vm.snapshotTypes.ONE_HOUR)"><span><i ng-class="vm.snapshotTypes.ONE_HOUR.toPoll ? \'fa fa-toggle-on\' : \'fa fa-toggle-off\'" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" ng-attr-title="{{vm.activeSnapshotId === vm.snapshotTypes.ONE_HOUR.id ? \'Compress\' : \'Expand\'}}" ng-if="vm.hasSnapshotData(vm.snapshotTypes.ONE_HOUR.id)" ng-click="vm.setActiveSnapshot(vm.snapshotTypes.ONE_HOUR.id)"><span><i ng-class="vm.activeSnapshotId === vm.snapshotTypes.ONE_HOUR.id ? \'fa fa-compress\' : \'fa fa-expand\'" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" title="Reset Zoom Level" ng-if="vm.hasSnapshotData(vm.snapshotTypes.ONE_HOUR.id)" ng-click="vm.resetSnapshotGraphZoom(vm.snapshotTypes.ONE_HOUR.name)"><span><i class="fa fa fa-undo" aria-hidden="true"></i></span></button></div><br><canvas ng-if="vm.hasSnapshotData(vm.snapshotTypes.ONE_HOUR.id)" class="chart chart-line" chart-data="vm.snapshotData[vm.snapshotTypes.ONE_HOUR.id]" chart-series="vm.getSnapshotSeries(vm.activeSnapshotId !== vm.snapshotTypes.ONE_HOUR.id, vm.snapshotTypes.ONE_HOUR.id)" chart-options="vm.getSnapshotOptions(vm.activeSnapshotId !== vm.snapshotTypes.ONE_HOUR.id, \'ONE_HOUR\')"></canvas><div class="user-instruction" ng-if="!vm.hasSnapshotData(vm.snapshotTypes.ONE_HOUR.id)"><h4>DATA UNAVAILABLE</h4></div></md-content></div><div ng-attr-id="{{\'anchor_\'.concat(vm.snapshotTypes.TWO_HOUR.id)}}" ng-class="vm.activeSnapshotId === vm.snapshotTypes.TWO_HOUR.id ? \'col-md-12 col-lg-12\' : \'col-md-6 col-lg-6\'"><md-content layout="column" flex="" ng-class="vm.activeSnapshotId === vm.snapshotTypes.TWO_HOUR.id ? \'md-padding measurement-data-snapshot-content-max\' : \'md-padding measurement-data-snapshot-content-min\'"><div><span>2-hour snapshot&nbsp;&nbsp;</span> <button type="button" class="btn btn-default" title="Refresh" ng-click="vm.refreshSnapshotOnClicked(vm.snapshotTypes.TWO_HOUR)"><span><i class="fa fa fa-refresh" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" title="Toggle Auto-Refresh" ng-if="vm.hasSnapshotData(vm.snapshotTypes.TWO_HOUR.id)" ng-click="vm.snapshotPollingToggled(vm.snapshotTypes.TWO_HOUR)"><span><i ng-class="vm.snapshotTypes.TWO_HOUR.toPoll ? \'fa fa-toggle-on\' : \'fa fa-toggle-off\'" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" ng-attr-title="{{vm.activeSnapshotId === vm.snapshotTypes.TWO_HOUR.id ? \'Compress\' : \'Expand\'}}" ng-if="vm.hasSnapshotData(vm.snapshotTypes.TWO_HOUR.id)" ng-click="vm.setActiveSnapshot(vm.snapshotTypes.TWO_HOUR.id)"><span><i ng-class="vm.activeSnapshotId === vm.snapshotTypes.TWO_HOUR.id ? \'fa fa-compress\' : \'fa fa-expand\'" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" title="Reset Zoom Level" ng-if="vm.hasSnapshotData(vm.snapshotTypes.TWO_HOUR.id)" ng-click="vm.resetSnapshotGraphZoom(vm.snapshotTypes.TWO_HOUR.name)"><span><i class="fa fa fa-undo" aria-hidden="true"></i></span></button></div><br><canvas ng-if="vm.hasSnapshotData(vm.snapshotTypes.TWO_HOUR.id)" class="chart chart-line" chart-data="vm.snapshotData[vm.snapshotTypes.TWO_HOUR.id]" chart-series="vm.getSnapshotSeries(vm.activeSnapshotId !== vm.snapshotTypes.TWO_HOUR.id, vm.snapshotTypes.TWO_HOUR.id)" chart-options="vm.getSnapshotOptions(vm.activeSnapshotId !== vm.snapshotTypes.TWO_HOUR.id, \'TWO_HOUR\')"></canvas><div class="user-instruction" ng-if="!vm.hasSnapshotData(vm.snapshotTypes.TWO_HOUR.id)"><h4>DATA UNAVAILABLE</h4></div></md-content></div><div ng-attr-id="{{\'anchor_\'.concat(vm.snapshotTypes.SIX_HOUR.id)}}" ng-class="vm.activeSnapshotId === vm.snapshotTypes.SIX_HOUR.id ? \'col-md-12 col-lg-12\' : \'col-md-6 col-lg-6\'"><md-content layout="column" flex="" ng-class="vm.activeSnapshotId === vm.snapshotTypes.SIX_HOUR.id ? \'md-padding measurement-data-snapshot-content-max\' : \'md-padding measurement-data-snapshot-content-min\'"><div><span>6-hour snapshot&nbsp;&nbsp;</span> <button type="button" class="btn btn-default" title="Refresh" ng-click="vm.refreshSnapshotOnClicked(vm.snapshotTypes.SIX_HOUR)"><span><i class="fa fa fa-refresh" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" title="Toggle Auto-Refresh" ng-if="vm.hasSnapshotData(vm.snapshotTypes.SIX_HOUR.id)" ng-click="vm.snapshotPollingToggled(vm.snapshotTypes.SIX_HOUR)"><span><i ng-class="vm.snapshotTypes.SIX_HOUR.toPoll ? \'fa fa-toggle-on\' : \'fa fa-toggle-off\'" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" ng-attr-title="{{vm.activeSnapshotId === vm.snapshotTypes.SIX_HOUR.id ? \'Compress\' : \'Expand\'}}" ng-if="vm.hasSnapshotData(vm.snapshotTypes.SIX_HOUR.id)" ng-click="vm.setActiveSnapshot(vm.snapshotTypes.SIX_HOUR.id)"><span><i ng-class="vm.activeSnapshotId === vm.snapshotTypes.SIX_HOUR.id ? \'fa fa-compress\' : \'fa fa-expand\'" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" title="Reset Zoom Level" ng-if="vm.hasSnapshotData(vm.snapshotTypes.SIX_HOUR.id)" ng-click="vm.resetSnapshotGraphZoom(vm.snapshotTypes.SIX_HOUR.name)"><span><i class="fa fa fa-undo" aria-hidden="true"></i></span></button></div><br><canvas ng-if="vm.hasSnapshotData(vm.snapshotTypes.SIX_HOUR.id)" class="chart chart-line" chart-data="vm.snapshotData[vm.snapshotTypes.SIX_HOUR.id]" chart-series="vm.getSnapshotSeries(vm.activeSnapshotId !== vm.snapshotTypes.SIX_HOUR.id, vm.snapshotTypes.SIX_HOUR.id)" chart-options="vm.getSnapshotOptions(vm.activeSnapshotId !== vm.snapshotTypes.SIX_HOUR.id, \'SIX_HOUR\')"></canvas><div class="user-instruction" ng-if="!vm.hasSnapshotData(vm.snapshotTypes.SIX_HOUR.id)"><h4>DATA UNAVAILABLE</h4></div></md-content></div><div ng-attr-id="{{\'anchor_\'.concat(vm.snapshotTypes.TWELVE_HOUR.id)}}" ng-class="vm.activeSnapshotId === vm.snapshotTypes.TWELVE_HOUR.id ? \'col-md-12 col-lg-12\' : \'col-md-6 col-lg-6\'"><md-content layout="column" flex="" ng-class="vm.activeSnapshotId === vm.snapshotTypes.TWELVE_HOUR.id ? \'md-padding measurement-data-snapshot-content-max\' : \'md-padding measurement-data-snapshot-content-min\'"><div><span>12-hour snapshot&nbsp;&nbsp;</span> <button type="button" class="btn btn-default" title="Refresh" ng-click="vm.refreshSnapshotOnClicked(vm.snapshotTypes.TWELVE_HOUR)"><span><i class="fa fa fa-refresh" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" title="Toggle Auto-Refresh" ng-if="vm.hasSnapshotData(vm.snapshotTypes.TWELVE_HOUR.id)" ng-click="vm.snapshotPollingToggled(vm.snapshotTypes.TWELVE_HOUR)"><span><i ng-class="vm.snapshotTypes.TWELVE_HOUR.toPoll ? \'fa fa-toggle-on\' : \'fa fa-toggle-off\'" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" ng-attr-title="{{vm.activeSnapshotId === vm.snapshotTypes.TWELVE_HOUR.id ? \'Compress\' : \'Expand\'}}" ng-if="vm.hasSnapshotData(vm.snapshotTypes.TWELVE_HOUR.id)" ng-click="vm.setActiveSnapshot(vm.snapshotTypes.TWELVE_HOUR.id)"><span><i ng-class="vm.activeSnapshotId === vm.snapshotTypes.TWELVE_HOUR.id ? \'fa fa-compress\' : \'fa fa-expand\'" aria-hidden="true"></i></span></button> <button type="button" class="btn btn-default" title="Reset Zoom Level" ng-if="vm.hasSnapshotData(vm.snapshotTypes.TWELVE_HOUR.id)" ng-click="vm.resetSnapshotGraphZoom(vm.snapshotTypes.TWELVE_HOUR.name)"><span><i class="fa fa fa-undo" aria-hidden="true"></i></span></button></div><br><canvas ng-if="vm.hasSnapshotData(vm.snapshotTypes.TWELVE_HOUR.id)" class="chart chart-line" chart-data="vm.snapshotData[vm.snapshotTypes.TWELVE_HOUR.id]" chart-series="vm.getSnapshotSeries(vm.activeSnapshotId !== vm.snapshotTypes.TWELVE_HOUR.id, vm.snapshotTypes.TWELVE_HOUR.id)" chart-options="vm.getSnapshotOptions(vm.activeSnapshotId !== vm.snapshotTypes.TWELVE_HOUR.id, \'TWELVE_HOUR\')"></canvas><div class="user-instruction" ng-if="!vm.hasSnapshotData(vm.snapshotTypes.TWELVE_HOUR.id)"><h4>DATA UNAVAILABLE</h4></div></md-content></div></div></md-tab><md-tab label="Historical Data" ng-if="vm.historicalDataEnabled"><br><br><uib-accordion close-others="true"><uib-accordion-group panel-class="panel-info bootstrap-panel accordion-panel"><uib-accordion-heading>Download Historical Data</uib-accordion-heading><md-content layout="column" flex="" class="md-padding"><div class="content-wrapper row"><div class="col-md-4"><div class="col-md-12 col-sm-6 col-xs-12" ng-if="vm.historicalChannelGranularity === \'channel\'"><div class="form-group panel-control-block"><label style="padding-right: 25px">Channel<ui-select ng-model="vm.channel[\'historicalDownload\']" on-select="vm.onChannelSelected(\'historicalDownload\')" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.channels && vm.channels.length > 0 ? \'Select Channel\' : \'No Channels Available\'}}"><span>Channel {{$select.selected.channelId}}</span></ui-select-match><ui-select-choices repeat="channel in vm.channels | filter: $select.search"><span ng-bind-html="\'Channel \' + channel.channelId"></span></ui-select-choices></ui-select></label></div></div><div class="col-md-12 col-sm-6 col-xs-12" ng-if="vm.historicalChannelGranularity === \'sensor\'"><div class="form-group panel-control-block"><label style="padding-right: 25px">Sensor Type<ui-select ng-model="vm.sensortype.historicalDownload" on-select="vm.onHistoricalSensorTypeSelected(\'historicalDownload\')" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.sensortypes.historicalDownload && vm.sensortypes.historicalDownload.length > 0 ? \'Select Type\' : \'No Types Available\'}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="sensortype in vm.sensortypes.historicalDownload | filter: $select.search"><span ng-bind-html="sensortype.name"></span></ui-select-choices></ui-select></label></div><br><div class="form-group select-page-size-wrap" ng-if="vm.sensortype.historicalDownload"><label style="padding-right: 25px">Sensors<ui-select multiple="" ng-model="vm.selectedSensorsMessages.historicalDownload" class="btn-group bootstrap-select form-control" append-to-body="true" close-on-select="false" ng-change="vm.onSensorsSelected(\'historicalDownload\')" ng-model-options="{debounce: 1250}" style="width: 170px;"><ui-select-match placeholder="{{vm.sensors.historicalDownload && vm.sensors.historicalDownload.length > 0 ? \'Select Sensors\' : \'No Sensors Available\'}}" <span="">Channel {{$item.channelId}} Sensor {{$item.sensorId}}</ui-select-match><ui-select-choices ui-select-header-group-selectable="" group-by="vm.historicalSensorsGroupBy" group-filter="vm.orderHistoricalSensorsGroupBy" repeat="sensor in vm.sensors.historicalDownload | filter: $select.search"><span ng-bind-html="\'Sensor \' + sensor.sensorId"></span></ui-select-choices></ui-select></label></div></div><div class="col-md-12 col-sm-6 col-xs-12"><div class="form-group panel-control-block" ng-if="vm.sensortype.historicalDownload && vm.selectedSensors.historicalDownload.length > 0"><label style="padding-right: 25px">Data Granularity<ui-select ng-model="vm.dataGranularity.historicalDownload" on-select="vm.onHistoricalDataGranularitySelected(\'historicalDownload\')" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.dataGranularities.historicalDownload && vm.dataGranularities.historicalDownload.length > 0 ? \'Select Granularity\' : \'No Granularities Available\'}}"><span>{{$select.selected.name.toUpperCase()}}</span></ui-select-match><ui-select-choices repeat="granularity in vm.dataGranularities.historicalDownload | filter: $select.search"><span ng-bind-html="granularity.name.toUpperCase()"></span></ui-select-choices></ui-select></label></div><div class="form-group panel-control-block" ng-if="vm.sensortype.historicalDownload && vm.selectedSensors.historicalDownload.length > 0 && vm.dataGranularity.historicalDownload"><label style="padding-right: 25px">Time Range<ui-select ng-model="vm.timeRangeOption.historicalDownload" on-select="vm.onHistoricalTimeRangeOptionSelected(\'historicalDownload\')" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{\'Select Time Range\'}}"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="timeRangeOption in vm.getHistoricalTimeRangeOptions(\'historicalDownload\') | filter: $select.search"><span ng-bind-html="timeRangeOption"></span></ui-select-choices></ui-select></label></div><div ng-if="vm.timeRangeOption.historicalDownload === \'Custom\'"><div layout="column" class="range layout-column"><div layout="row" flex=""><md-input-container class="md-input-has-placeholder"><label>From</label> <input mdc-datetime-picker="" date="true" time="true" type="text" placeholder="Date and Time" min-date="vm.historicalFromMin.historicalDownload" max-date="vm.historicalFromMax.historicalDownload" ng-model="vm.historicalFrom.historicalDownload" ng-change="vm.onCustomHistoricalTimeRangeChanged(\'historicalDownload\')" class="md-input"><div class="md-errors-spacer"></div></md-input-container><md-button aria-label="Delete Historical Download from datetime" style="min-width: 1%; min-height: 1%; margin-top: -6%;" ng-if="vm.historicalFrom.historicalDownload" ng-click="vm.onDeleteCustomHistoricalTimeRange(\'historicalDownload\', true)"><md-icon md-font-icon="fa fa-remove"></md-icon></md-button></div><div layout="row" flex="" ng-if="vm.historicalFrom.historicalDownload"><md-input-container class="md-input-has-placeholder"><label>To</label> <input mdc-datetime-picker="" date="true" time="true" type="text" placeholder="Date and Time" min-date="vm.historicalToMin.historicalDownload" max-date="vm.historicalToMax.historicalDownload" ng-model="vm.historicalTo.historicalDownload" ng-change="vm.onCustomHistoricalTimeRangeChanged(\'historicalDownload\')" class="md-input"><div class="md-errors-spacer"></div></md-input-container><md-button aria-label="Delete Historical Download to datetime" style="min-width: 1%; min-height: 1%; margin-top: -6%;" ng-if="vm.historicalTo.historicalDownload" ng-click="vm.onDeleteCustomHistoricalTimeRange(\'historicalDownload\', false)"><md-icon md-font-icon="fa fa-remove"></md-icon></md-button></div></div></div></div></div><div class="col-md-8"><div class="historical-download-block col-xs-12"><div class="form-group"><a ng-if="vm.hasHistoricalDownloadInputs() && vm.filetype.historicalDownload" ng-href="{{vm.getHistoricalDataFileLink()}}" ng-cloak="" class="btn btn-primary"><i class="fa fa-download fa-5x" style="text-align: center; padding-top: 10%;"></i><br><br>Download Historical Data<br></a> <a ng-show="vm.hasHistoricalDownloadInputs() && !vm.filetype.historicalDownload" href="" ng-disabled="true" ng-cloak="" class="btn btn-primary"><i class="fa fa-download fa-5x" style="text-align: center; padding-top: 10%;"></i><br><br>Download Historical Data<br></a></div><div class="form-group"><div ng-if="vm.hasHistoricalDownloadInputs()" ng-cloak=""><md-divider></md-divider><br><ui-select ng-model="vm.filetype.historicalDownload" on-select="vm.onHistoricalFileTypeSelected(\'historicalDownload\')" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.filetypes.historicalDownload && vm.filetypes.historicalDownload.length > 0 ? \'Select File Format\' : \'No File Formats Available\'}}"><span style="text-align: center;">{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="filetype in vm.filetypes.historicalDownload | filter: $select.search"><span ng-bind-html="filetype.name" style="text-align: center;"></span></ui-select-choices></ui-select></div></div><div class="user-instruction" ng-if="vm.sensortype.historicalDownload && !vm.hasHistoricalDownloadInputs()" ng-cloak=""><h4>SELECT SENSORS AND TIME RANGE ON THE LEFT</h4></div></div></div></div><br><br></md-content></uib-accordion-group><br><br><uib-accordion-group panel-class="panel-primary bootstrap-panel accordion-panel"><uib-accordion-heading>Historical Data Graph</uib-accordion-heading><md-content layout="column" flex="" class="md-padding"><div class="content-wrapper row"><div ng-if="!vm.historicalChartMaximized" class="col-md-4 col-sm-12"><div class="col-md-12 col-sm-6 col-xs-12" ng-if="vm.historicalChannelGranularity === \'channel\'"><div class="form-group panel-control-block"><label style="padding-right: 25px">Channel<ui-select ng-model="vm.channel[\'historicalChart\']" on-select="vm.onChannelSelected(\'historicalChart\')" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.channels && vm.channels.length > 0 ? \'Select Channel\' : \'No Channels Available\'}}"><span>Channel {{$select.selected.channelId}}</span></ui-select-match><ui-select-choices repeat="channel in vm.channels | filter: $select.search"><span ng-bind-html="\'Channel \' + channel.channelId"></span></ui-select-choices></ui-select></label></div></div><div class="col-md-12 col-sm-6 col-xs-12" ng-if="vm.historicalChannelGranularity === \'sensor\'"><div class="form-group panel-control-block"><label style="padding-right: 25px">Sensor Type<ui-select ng-model="vm.sensortype.historicalChart" on-select="vm.onHistoricalSensorTypeSelected(\'historicalChart\')" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.sensortypes.historicalChart && vm.sensortypes.historicalChart.length > 0 ? \'Select Type\' : \'No Types Available\'}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="sensortype in vm.sensortypes.historicalChart | filter: $select.search"><span ng-bind-html="sensortype.name"></span></ui-select-choices></ui-select></label></div><br><div class="form-group select-page-size-wrap" ng-if="vm.sensortype.historicalChart"><label style="padding-right: 25px">Sensors<ui-select multiple="" limit="3" ng-model="vm.selectedSensorsMessages.historicalChart" class="btn-group bootstrap-select form-control" append-to-body="true" close-on-select="false" ng-change="vm.onSensorsSelected(\'historicalChart\')" ng-model-options="{debounce: 1250}" style="width: 170px;"><ui-select-match placeholder="{{vm.sensors.historicalChart && vm.sensors.historicalChart.length > 0 ? \'Select up to 3 Sensors\' : \'No Sensors Available\'}}" <span="">Channel {{$item.channelId}} Sensor {{$item.sensorId}}</ui-select-match><ui-select-choices group-by="vm.historicalSensorsGroupBy" group-filter="vm.orderHistoricalSensorsGroupBy" repeat="sensor in vm.sensors.historicalChart | filter: $select.search"><span ng-bind-html="\'Sensor \' + sensor.sensorId"></span></ui-select-choices></ui-select></label></div></div><div class="col-md-12 col-sm-6 col-xs-12"><div class="form-group panel-control-block" ng-if="vm.sensortype.historicalChart && vm.selectedSensors.historicalChart.length > 0"><label style="padding-right: 25px">Data Granularity<ui-select ng-model="vm.dataGranularity.historicalChart" on-select="vm.onHistoricalDataGranularitySelected(\'historicalChart\')" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.dataGranularities.historicalChart && vm.dataGranularities.historicalChart.length > 0 ? \'Select Granularity\' : \'No Granularities Available\'}}"><span>{{$select.selected.name.toUpperCase()}}</span></ui-select-match><ui-select-choices repeat="granularity in vm.dataGranularities.historicalChart | filter: $select.search"><span ng-bind-html="granularity.name.toUpperCase()"></span></ui-select-choices></ui-select></label></div><div class="form-group panel-control-block" ng-if="vm.sensortype.historicalChart && vm.selectedSensors.historicalChart.length > 0 && vm.dataGranularity.historicalChart"><label style="padding-right: 25px">Time Range<ui-select ng-model="vm.timeRangeOption.historicalChart" on-select="vm.onHistoricalTimeRangeOptionSelected(\'historicalChart\')" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{\'Select Time Range\'}}"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="timeRangeOption in vm.getHistoricalTimeRangeOptions(\'historicalChart\') | filter: $select.search"><span ng-bind-html="timeRangeOption"></span></ui-select-choices></ui-select></label></div><div ng-if="vm.timeRangeOption.historicalChart === \'Custom\'"><div layout="column" class="range layout-column"><div layout="row" flex=""><md-input-container class="md-input-has-placeholder"><label>From</label> <input mdc-datetime-picker="" date="true" time="true" type="text" placeholder="Date and Time" min-date="vm.historicalFromMin.historicalChart" max-date="vm.historicalFromMax.historicalChart" ng-model="vm.historicalFrom.historicalChart" ng-change="vm.onCustomHistoricalTimeRangeChanged(\'historicalChart\')" class="md-input"><div class="md-errors-spacer"></div></md-input-container><md-button aria-label="Delete Historical Chart from datetime" style="min-width: 1%; min-height: 1%; margin-top: -6%;" ng-if="vm.historicalFrom.historicalChart" ng-click="vm.onDeleteCustomHistoricalTimeRange(\'historicalChart\', true)"><md-icon md-font-icon="fa fa-remove"></md-icon></md-button></div><div layout="row" flex="" ng-if="vm.historicalFrom.historicalChart"><md-input-container class="md-input-has-placeholder"><label>To</label> <input mdc-datetime-picker="" date="true" time="true" type="text" placeholder="Date and Time" min-date="vm.historicalToMin.historicalChart" max-date="vm.historicalToMax.historicalChart" ng-model="vm.historicalTo.historicalChart" ng-change="vm.onCustomHistoricalTimeRangeChanged(\'historicalChart\')" class="md-input"><div class="md-errors-spacer"></div></md-input-container><md-button aria-label="Delete Historical Chart to datetime" style="min-width: 1%; min-height: 1%; margin-top: -6%;" ng-if="vm.historicalTo.historicalChart" ng-click="vm.onDeleteCustomHistoricalTimeRange(\'historicalChart\', false)"><md-icon md-font-icon="fa fa-remove"></md-icon></md-button></div></div></div></div></div><div ng-class="{\'col-md-8\': !vm.historicalChartMaximized}" class="historical-chart-block col-sm-12"><div layout="row" layout-sm="column" layout-align="space-around" ng-show="vm.hasHistoricalChartInputs() && vm.isHistoricalChartLoading"><md-progress-circular md-mode="indeterminate" md-diameter="120" style="position:fixed; bottom:40%; z-index: 10;"></md-progress-circular></div><div><canvas ng-if="vm.hasHistoricalChartInputs() && vm.hasHistoricalChartData()" class="chart chart-line" chart-data="vm.historicalChartData" chart-series="vm.historicalChartSeries" chart-options="vm.historicalOptions"></canvas></div><div ng-if="vm.hasHistoricalChartInputs() && vm.hasHistoricalChartData()" layout="row" flex=""><button type="button" ng-click="vm.toggleHistoricalChartSize()" class="maximizeButton" ng-class="vm.historicalChartMaximized ? \'btn btn-warning btn-block\' : \'btn btn-success btn-block\'">{{vm.historicalChartSizeDisplay()}}</button> <button type="button" ng-click="vm.resetHistoricalGraphZoom()" class="maximizeButton btn btn-danger btn-block">Reset Zoom Level</button></div><div class="user-instruction" ng-if="vm.sensortype.historicalChart && !vm.hasHistoricalChartInputs()"><h4>SELECT SENSORS AND TIME RANGE ON THE LEFT</h4></div><div class="user-instruction" ng-if="vm.hasHistoricalChartInputs() && !vm.hasHistoricalChartData() && !vm.isHistoricalChartLoading"><h4>DATA UNAVAILABLE</h4></div></div></div><br><br></md-content></uib-accordion-group></uib-accordion></md-tab></md-tabs></md-content></div></div></div></div>');
$templateCache.put('app/pages/data/wavelength/wavelengthData.html','<div class="row wavelengthData" ng-if="vm.tenant !== null"><div class="col-md-12 col-lg-12"><div class="panel panel-primary bootstrap-panel data-panel"><div class="panel-heading">Wavelength</div><div class="panel-body"><md-content class="md-padding"><md-tabs md-dynamic-height="" md-primary="" md-border-bottom=""><md-tab label="Historical Data"><br><br><md-content layout="column" flex="" class="md-padding"><div flex="" class="content-wrapper row"><div flex="" class="col-md-4 col-sm-12"><div class="col-md-12 col-sm-6 col-xs-12"><div class="form-group panel-control-block"><label style="padding-right: 25px">Sensor Type<ui-select ng-model="vm.sensortype" on-select="vm.onHistoricalSensorTypeSelected()" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.sensortypes && vm.sensortypes.length > 0 ? \'Select Type\' : \'No Types Available\'}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="sensortype in vm.sensortypes | filter: $select.search"><span ng-bind-html="sensortype.name"></span></ui-select-choices></ui-select></label></div><br><div class="form-group select-page-size-wrap" ng-if="vm.sensortype"><label style="padding-right: 25px">Sensors<ui-select multiple="" ng-model="vm.selectedSensorsMessages" class="btn-group bootstrap-select form-control" append-to-body="true" close-on-select="false" ng-change="vm.onSensorsSelected()" ng-model-options="{debounce: 1250}" style="width: 170px;"><ui-select-match placeholder="{{vm.sensors && vm.sensors.length > 0 ? \'Select Sensors\' : \'No Sensors Available\'}}" <span="">Channel {{$item.channelId}} Sensor {{$item.sensorId}}</ui-select-match><ui-select-choices group-by="vm.historicalSensorsGroupBy" repeat="sensor in vm.sensors | filter: $select.search"><span ng-bind-html="\'Sensor \' + sensor.sensorId"></span></ui-select-choices></ui-select></label></div></div><div class="col-md-12 col-sm-6 col-xs-12"><div class="form-group panel-control-block" ng-if="vm.sensortype && vm.selectedSensors.length > 0"><label style="padding-right: 25px">Data Granularity<ui-select ng-model="vm.dataGranularity" on-select="vm.onHistoricalDataGranularitySelected()" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.dataGranularities && vm.dataGranularities.length > 0 ? \'Select Granularity\' : \'No Granularities Available\'}}"><span>{{$select.selected.name.toUpperCase()}}</span></ui-select-match><ui-select-choices repeat="granularity in vm.dataGranularities | filter: $select.search"><span ng-bind-html="granularity.name.toUpperCase()"></span></ui-select-choices></ui-select></label></div><div ng-if="vm.sensortype && vm.selectedSensors.length > 0 && vm.dataGranularity"><div layout="column" class="range layout-column"><div layout="row" flex=""><md-input-container class="md-input-has-placeholder"><label>From</label> <input mdc-datetime-picker="" date="true" time="true" type="text" placeholder="Date and Time" min-date="vm.historicalFromMin" max-date="vm.historicalFromMax" ng-model="vm.historicalFrom" ng-change="vm.onHistoricalTimeRangeChanged()" class="md-input"><div class="md-errors-spacer"></div></md-input-container><md-button aria-label="Delete Historical Download from datetime" style="min-width: 1%; min-height: 1%; margin-top: -6%;" ng-if="vm.historicalFrom" ng-click="vm.onDeleteHistoricalTimeRange(true)"><md-icon md-font-icon="fa fa-remove"></md-icon></md-button></div><div layout="row" flex="" ng-if="vm.historicalFrom"><md-input-container class="md-input-has-placeholder"><label>To</label> <input mdc-datetime-picker="" date="true" time="true" type="text" placeholder="Date and Time" min-date="vm.historicalToMin" max-date="vm.historicalToMax" ng-model="vm.historicalTo" ng-change="vm.onHistoricalTimeRangeChanged()" class="md-input"><div class="md-errors-spacer"></div></md-input-container><md-button aria-label="Delete Historical Download to datetime" style="min-width: 1%; min-height: 1%; margin-top: -6%;" ng-if="vm.historicalTo" ng-click="vm.onDeleteHistoricalTimeRange(false)"><md-icon md-font-icon="fa fa-remove"></md-icon></md-button></div></div></div></div></div><div class="historical-download-block col-md-8 col-sm-12"><div class="form-group"><a ng-if="vm.hasHistoricalDownloadInputs() && vm.filetype" ng-href="{{vm.getHistoricalDataFileLink()}}" ng-cloak="" class="btn btn-primary"><i class="fa fa-download fa-5x" style="text-align: center; padding-top: 10%;"></i><br><br>Download Historical Data<br></a> <a ng-show="vm.hasHistoricalDownloadInputs() && !vm.filetype" href="" ng-disabled="true" ng-cloak="" class="btn btn-primary"><i class="fa fa-download fa-5x" style="text-align: center; padding-top: 10%;"></i><br><br>Download Historical Data<br></a></div><div class="form-group"><div ng-if="vm.hasHistoricalDownloadInputs()" ng-cloak=""><md-divider></md-divider><br><ui-select ng-model="vm.filetype" on-select="vm.onHistoricalFileTypeSelected()" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.filetypes && vm.filetypes.length > 0 ? \'Select File Format\' : \'No File Formats Available\'}}"><span style="text-align: center;">{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="filetype in vm.filetypes | filter: $select.search"><span ng-bind-html="filetype.name" style="text-align: center;"></span></ui-select-choices></ui-select></div></div><div class="user-instruction" ng-if="vm.sensortype && !vm.hasHistoricalDownloadInputs()" ng-cloak=""><h4>SELECT SENSORS AND TIME RANGE ON THE LEFT</h4></div></div></div><br><br></md-content></md-tab></md-tabs></md-content></div></div></div></div>');
$templateCache.put('app/pages/diagnostics/events/events.html','<div class="horizontal-scroll" ng-if="vm.tenant !== null"><div class="diagnostics-events-header"><div class="diagnostics-events-filter form-group select-page-size-wrap"><label>Filtered by severity<ui-select ng-model="vm.severity" on-select="vm.onSeveritySelected()" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="All"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="severity in vm.severities | filter: $select.search"><span ng-bind-html="severity"></span></ui-select-choices></ui-select></label></div><button class="md-button md-primary diagnostic-events-refresh-btn" ng-click="vm.refreshServerPipe()">Refresh Table</button></div><div class="diagnostics-events table-container" st-table="vm.displayedEventsData" st-pipe="vm.serverPipe"><table class="table table-bordered"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="reverse">ID</th><th class="diagnostics-events-severity-header">Severity</th><th>Type</th><th>Log</th><th>Description</th><th>Timestamp</th></tr></thead><div layout="row" layout-sm="column" layout-align="center center" aria-label="wait" style="height: 50px; z-index: 10;" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" class="md-primary"></md-progress-circular></div><tbody ng-show="!vm.isLoading"><tr ng-repeat="event in vm.displayedEventsData"><td class="table-id">{{event.id}}</td><td class="diagnostic-events-severity-table-data"><div ng-class="{\'diagnostic-label\' : true, [\'diagnostic-label-\' + event.severityName.toLowerCase()] : true}">{{event.severityName}}</div></td><td>{{event.eventtypeName}}</td><td>{{event.log}}</td><td>{{event.description}}</td><td>{{event.timestamp | date:\'medium\'}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-items-by-page="20" st-pagination=""></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/diagnostics/channel/channeldiagnostics.html','<div class="row channel-diagnostics" ng-if="vm.tenant !== null"><div class="col-md-12 col-lg-12"><div class="panel panel-primary bootstrap-panel data-panel"><div class="panel-heading">Channel Diagnostics<div class="panel-title pull-right channel-diagnostics-timer-running" ng-if="vm.isInit && vm.chDiagTimeout !== null"><span style="white-space: nowrap;"><timer interval="1000" countdown="vm.chDiagTimeout" finish-callback="vm.onChDiagTimeout()">{{hours}} hour{{hoursS}}, {{minutes}} minute{{minutesS}}, {{seconds}} second{{secondsS}}</timer></span></div></div><div class="panel-body"><div layout="row" layout-sm="column" layout-align="center center" aria-label="wait" style="height: 50px; z-index: 10;" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" class="md-primary"></md-progress-circular></div><md-content class="md-padding"><div class="col-md-12 col-lg-12"><div class="form-group panel-control-block col-md-6 col-sm-12"><div class="form-group panel-control-block"><label>Diagnostic Channel<ui-select ng-model="vm.channel" ng-disabled="vm.isLoading || vm.diagnosticsStarted" on-select="vm.onChannelSelected()" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="{{vm.channels && vm.channels.length > 0 ? \'Select Diagnostic Channel\' : \'No Diagnostic Channels Available\'}}"><span>Channel {{$select.selected.channelId}}</span></ui-select-match><ui-select-choices repeat="channel in vm.channels | filter: $select.search"><span ng-bind-html="\'Channel \' + channel.channelId"></span></ui-select-choices></ui-select></label></div></div><div ng-if="vm.channel" class="form-group panel-control-block col-md-3 col-sm-6"><div><label for="channelDiagnosticsExtCableLen">Extension Cable Length (m)</label> <input type="number" class="form-control" id="channelDiagnosticsExtCableLen" ng-disabled="vm.isLoading || vm.diagnosticsStarted || vm.isSelectingCalibrationFile || vm.isExecutingSensorsCalibration" ng-change="vm.onExtensionCableLengthChanged()" min="0" step="0.01" ng-model="vm.extensionCableLength"></div><br><div><label class="btn btn-primary btn-sm" style="padding-top: 6px; color: white;" ng-disabled="vm.isLoading || vm.diagnosticsStarted || vm.isSelectingCalibrationFile || vm.isExecutingSensorsCalibration"><span>Choose Calibration File</span> <input type="file" data-file-upload="" data-ng-model="vm.sensorsCalibrationFile" ng-change="vm.onSensorsCalibrationFileChanged()" ng-disabled="vm.isLoading || vm.diagnosticsStarted || vm.isSelectingCalibrationFile || vm.isExecutingSensorsCalibration" hidden=""></label><br><div style="display:flex" ng-if="vm.sensorsCalibrationFile"><div><div>{{vm.sensorsCalibrationFile.name}}<br></div><div>{{vm.sensorsCalibrationFile.size}} byte(s)<br></div></div><div><md-button aria-label="Remove Calibration File" ng-show="!vm.isLoading" ng-disabled="vm.isLoading || vm.isSelectingCalibrationFile || vm.isExecutingSensorsCalibration" ng-click="vm.removeCalibrationFile()" style="min-width: 1%;"><md-icon md-font-icon="fa fa-close"></md-icon></md-button></div></div></div><br><md-divider></md-divider><br><div class="form-group"><button ng-class="!vm.diagnosticsStarted ? \'btn btn-primary btn-md\' : \'btn btn-danger btn-md\'" ng-click="vm.diagnosticsStateChanged()" ng-disabled="vm.isLoading || vm.isSelectingCalibrationFile || vm.isExecutingSensorsCalibration || vm.extensionCableLength === null">{{!vm.diagnosticsStarted ? \'Start Channel Diagnostics\' : \'Stop Channel Diagnostics\'}}</button></div></div></div><br><div ng-if="vm.diagnosticsStarted"><div class="panel-control-block col-md-3 col-sm-3"><h5>Channel Health</h5><input type="text" class="form-control" ng-style="vm.getHealthColor(vm.channelHealth)" ng-value="vm.channelHealth" readonly=""></div><div class="panel-control-block col-md-7 col-sm-7" ng-if="vm.sensors"><h5>Sensor Healths</h5><div class="table-container" st-safe-src="vm.sensors" st-table="vm.displayedDiagnosticSensors"><div class="form-group"><input class="input-sm form-control" style="max-height: 50%; max-width: 50%;" st-search="sensorId" placeholder="Search By Sensor ID" type="search" maxlength="10" ng-model="vm.filterSensor" ng-disabled="vm.isLoading"></div><table class="table table-bordered"><thead><tr class="sortable"><th style="display: none; text-align: center;" st-sort="id">ID</th><th>Sensor ID</th><th>Health</th></tr></thead><tbody><tr ng-repeat="sensor in vm.displayedDiagnosticSensors"><td style="display: none; text-align: center;">{{sensor.id}}</td><td style="text-align: center;">{{sensor.sensorId}}</td><td ng-style="vm.getHealthColor(sensor.health)" style="text-align: center;">{{sensor.health}}</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-items-by-page="20" st-pagination=""></div></td></tr></tfoot></table><div class="user-instruction" ng-if="!vm.isLoading && vm.sensors.length === 0"><br><br><br><br><h4>No Diagnostic Sensors Available</h4></div></div></div></div><br></md-content></div></div></div></div><br><br>');
$templateCache.put('app/pages/lumicon/maturity/maturity.html','<div class="horizontal-scroll" ng-if="vm.tenant !== null"><div style="display: block;"><div class="form-group panel-control-block"><div flex="" layout="row"><div class="form-group panel-control-block" style="padding-right: 1%;"><label>Filter jobs by status<ui-select ng-model="vm.maturityStrengthJobFilter.status" on-select="vm.refreshData()" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false">ng-disabled="vm.isLoading"<ui-select-match placeholder="All"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="channelJobStatusType in vm.channelJobStatusTypes | filter: $select.search"><span ng-bind-html="channelJobStatusType"></span></ui-select-choices></ui-select></label></div><div class="form-group panel-control-block" style="padding-right: 1%;"><label>Filter jobs by job group<ui-select ng-model="vm.selectedJobGroupId" on-select="vm.onJobGroupFilterSelected($select.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" ng-disabled="vm.isLoading"><ui-select-match placeholder="All"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="jobGroup in vm.jobGroups | filter: $select.search"><span ng-bind-html="jobGroup.name"></span></ui-select-choices></ui-select></label></div><div class="form-group panel-control-block" style="padding-right: 1%;"><label>Filter jobs by cable<ui-select ng-model="vm.selectedChannelGroupId" on-select="vm.onCableFilterSelected($select.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" ng-disabled="vm.isLoading"><ui-select-match placeholder="All"><span>{{$select.selected.channelGroupId}}</span></ui-select-match><ui-select-choices repeat="channelGroup in vm.channelGroups | filter: $select.search"><span ng-bind-html="channelGroup.channelGroupId"></span></ui-select-choices></ui-select></label></div></div><div><md-button ng-if="vm.readOnly" ng-class="\'md-primary\'" md-no-ink="" ng-click="vm.refreshData()">Refresh Jobs</md-button><md-button ng-if="!vm.readOnly" ng-class="\'md-primary\'" md-no-ink="" ng-click="vm.showMaturityStrengthJobGroupModal($event)">Create New Job Group</md-button><md-button ng-if="!vm.readOnly" ng-class="\'md-primary\'" md-no-ink="" ng-click="vm.showMaturityStrengthJobModal($event, null)">Create New Job</md-button></div></div><md-divider></md-divider></div><div class="lumicon-maturity table-container" st-table="vm.displayedMaturityStrengthJobsData" st-pipe="vm.serverPipe"><table class="table table-bordered" ng-if="vm.maturityStrengthJobs && vm.maturityStrengthJobs.length > 0"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="reverse">ID</th><th>Name</th><th>Job Group</th><th>Cable</th><th>Owner</th><th>Creation Date</th><th>Status</th><th>Alarms</th><th ng-disabled="vm.isLoading || vm.isViewingDetails" class="text-left"><a class="refreshControl" ng-click="vm.refreshData()"><i class="fa fa-refresh" style="font-size:22px"></i></a></th></tr></thead><div layout="row" layout-sm="column" layout-align="center center" aria-label="wait" style="height: 50px; z-index: 10;" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" class="md-primary"></md-progress-circular></div><tbody ng-show="!vm.isLoading"><tr ng-repeat="msj in vm.displayedMaturityStrengthJobs" ng-class="msj-cell-normal"><td class="table-id">{{msj.id}}</td><td>{{msj.channelJobName}}</td><td>{{msj.channelJobGroupName}}</td><td>{{msj.channelGroupId}}</td><td>{{msj.username}}</td><td>{{msj.creationDate | date:\'medium\'}}</td><td ng-style="vm.getStatusColor(msj.status)">{{msj.status}}</td><td ng-class="(msj.alarmSensors1 > 0 || msj.alarmSensors2 > 0) ? \'status-value-success\' : \'status-value-error\'">{{(msj.alarmSensors1 > 0 || msj.alarmSensors2 > 0) ? \'TRIGGERED\' : \'NONE\'}}</td><td class="internalsetting-cell-normal"><div class="buttons"><button class="btn editable-table-button btn-xs btn-primary" ng-click="vm.showMaturityStrengthJobModal($event, msj)" ng-disabled="vm.isLoading || vm.isViewingDetails || msj.status === \'NONE\' || msj.status === \'NEW\'">View</button> <button class="btn editable-table-button btn-xs btn-success" ng-click="vm.showMaturityStrengthDownloadModal($event, msj)" ng-disabled="vm.isLoading || vm.isViewingDetails || msj.status === \'NONE\' || msj.status === \'NEW\'">Download</button> <button class="btn btn-danger editable-table-button btn-xs" ng-if="!vm.readOnly" ng-disabled="vm.isLoading || vm.isViewingDetails" ng-click="vm.stopMaturityStrengthJob(msj.id, msj.channelJobId, msj.status)">{{msj.status === \'RUNNING\' ? \'Terminate\' : \'Remove\'}}</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-items-by-page="20" st-pagination=""></div></td></tr></tfoot></table><div class="user-instruction" ng-if="vm.readOnly && !vm.isLoading && (!vm.maturityStrengthJobs || vm.maturityStrengthJobs.length === 0)"><br><br><br><br><h4>No Maturity Strength Jobs Available</h4></div><div class="user-instruction" ng-if="!vm.readOnly && !vm.isLoading && (!vm.maturityStrengthJobs || vm.maturityStrengthJobs.length === 0) && vm.maturityStrengthJobFilter.cgId === null"><br><br><br><br><h4>To create a new Maturity Strength Job, click on the Create New Job button above</h4></div><div class="user-instruction" ng-if="!vm.readOnly && !vm.isLoading && (!vm.maturityStrengthJobs || vm.maturityStrengthJobs.length === 0) && vm.maturityStrengthJobFilter.cgId !== null"><br><br><br><br><h4>No Maturity Strength Jobs found for Cable</h4></div></div></div>');
$templateCache.put('app/pages/lumicon/maturity/maturityStrengthDownloadModal.tmpl.html','<md-dialog class="lumicon-maturity-download" aria-label="Download Maturity Strength Data"><md-toolbar><div class="md-toolbar-tools"><h3>Downloads</h3><span flex=""></span></div></md-toolbar><md-content style="margin: 10px 10px 10px 10px;"><md-content class="md-padding"><table class="table table-bordered"><thead><tr class="sortable"></tr><tr class="sortable"></tr></thead><tbody><tr ng-repeat="cat in vm.fileCats"><td>{{cat.display}}</td><td><div class="buttons"><a ng-show="cat.fileTypes.includes(\'CSV\')" ng-href="{{vm.getDownloadFileLink(cat.name, \'CSV\')}}" ng-cloak="" class="btn btn-info btn-xs">CSV</a> <a ng-show="cat.fileTypes.includes(\'XLSX\')" ng-href="{{vm.getDownloadFileLink(cat.name, \'XLSX\')}}" ng-cloak="" class="btn btn-info btn-xs">XLSX</a> <a ng-show="cat.fileTypes.includes(\'JSON\')" ng-href="{{vm.getDownloadFileLink(cat.name, \'JSON\')}}" ng-cloak="" class="btn btn-info btn-xs">JSON</a></div></td></tr></tbody></table><br><br><div><button ng-click="vm.hide()">OK</button></div></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/lumicon/maturity/maturityStrengthJobGroupModal.tmpl.html','<md-dialog class="lumicon-maturity-job-group" aria-label="Channel Job Group"><md-toolbar><div class="md-toolbar-tools"><h3>Create Channel Job Group</h3><span flex=""></span></div></md-toolbar><md-content><md-content class="md-padding"><form class="settingform" name="jobGroupForm"><div class="form-group" ng-class="{\'has-error\': jobGroupForm.$invalid }"><label>Name</label> <input type="text" class="form-control" ng-model="vm.jobGroup.name" required=""></div><div class="form-group"><label>Description</label> <input type="text" class="form-control" ng-model="vm.jobGroup.description"></div><br><div ng-if="jobGroupForm.$valid"><button type="submit" progress-button="vm.createJobGroup()" pb-style="rotate-side-down">Create Channel Job Group</button></div><div ng-if="!jobGroupForm.$valid"><button type="submit" class="job-group-progress-button-invalid">Create Channel Job Group</button></div><div style="padding-top: 10px"><button class="job-group-progress-button-cancel" ng-click="vm.cancel()">Cancel</button></div></form></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/lumicon/maturity/maturityStrengthJobModal.tmpl.html','<md-dialog class="lumicon-maturity-job" aria-label="Maturity Strength Job"><md-toolbar><div class="md-toolbar-tools"><h3 style="padding-top:2px;">Maturity Strength Job</h3><div><div class="lumicon-maturity-job-timer-terminated" ng-if="!vm.isCreate && vm.hasJobDuration"><span style="white-space: nowrap;">{{vm.jobDurationHours}} Hrs {{vm.jobDurationMinutes}} Mins {{vm.jobDurationSeconds}} Secs</span></div><div class="lumicon-maturity-job-timer-running" ng-if="!vm.isCreate && vm.msj.status === \'RUNNING\' && vm.msj.startDateMilliseconds"><span style="white-space: nowrap;"><timer start-time="vm.msj.startDateMilliseconds" max-time-unit="\'hour\'" interval="1000">{{hhours}} Hrs {{mminutes}} Mins {{sseconds}} Secs</timer></span></div></div><div class="lumicon-maturity-job-control"><md-button aria-label="Close Maturity Strength Job Dialog" ng-show="!vm.isLoading" ng-click="vm.cancel()" style="min-width: 1%;"><md-icon md-font-icon="fa fa-close"></md-icon></md-button></div><span flex=""></span></div></md-toolbar><div ng-if="vm.graphLinksEnabled"><ul><li><a href="" ng-click="vm.gotoAnchor(\'top\')">Top</a></li><li><a href="" ng-click="vm.gotoAnchor(\'maturity\')">Maturity Index</a></li><li><a href="" ng-click="vm.gotoAnchor(\'strength\')">Strength</a></li><li><a href="" ng-click="vm.gotoAnchor(\'temperature\')">Temperature</a></li><li><a href="" ng-click="vm.gotoAnchor(\'humidity\')">Humidity</a></li></ul><md-button style="padding-left: 15px;" md-no-ink="" ng-if="vm.selectedDataSensor" ng-class="\'md-primary\'" ng-click="vm.restartMasterPolling(true)">Refresh Now</md-button></div><md-content><md-content class="md-padding"><div><div layout="row" layout-sm="column" layout-align="space-around" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" md-diameter="120" style="position:fixed; left:40%; bottom:30%; z-index: 10;"></md-progress-circular></div><md-content ba-panel="" ba-panel-class="with-scroll"><md-tabs md-dynamic-height="" md-primary="" md-border-bottom="" md-stretch-tabs="always"><md-tab label="Input" md-on-select="vm.graphLinksEnabled = false;" ng-disabled="vm.isLoading"><br><div flex="" layout="row"><md-content flex="" layout-padding="" class="input-panel"><form class="maturityStrengthForm" name="newMaturityStrengthJobForm" ng-disabled="vm.isLoading"><div><md-input-container class="md-block" ng-if="!vm.isCreate"><label>Maturity Strength Job ID</label> <input form="newMaturityStrengthJobForm" type="number" ng-model="vm.msj.id" readonly=""></md-input-container><md-input-container class="md-block"><label>Name</label> <input form="newMaturityStrengthJobForm" md-maxlength="45" required="" name="name" ng-model="vm.msj.channelJobName" ng-readonly="!vm.isCreate"></md-input-container><md-input-container class="md-block"><label>Description</label> <textarea form="newMaturityStrengthJobForm" md-maxlength="256" rows="1" ng-model="vm.msj.channelJobDescription" ng-readonly="!vm.isCreate"></textarea></md-input-container></div><br><div><md-input-container class="md-block"><label>Username</label> <input form="newMaturityStrengthJobForm" type="text" ng-model="vm.msj.username" class="field right" readonly=""></md-input-container><md-input-container class="md-block"><label>Type</label> <input form="newMaturityStrengthJobForm" type="text" ng-model="vm.msj.channelJobTypeName" class="field left" readonly=""></md-input-container></div><br><div><md-input-container class="md-block"><label>Visibility</label><md-select ng-model="vm.msj.channelJobVisibilityName" ng-disabled="!vm.isCreate" required=""><md-option ng-value="channelJobVisibility.name" ng-repeat="channelJobVisibility in vm.channelJobVisibilities">{{ channelJobVisibility.name }}</md-option></md-select><br ng-if="!vm.isCreate"></md-input-container><md-input-container class="md-block"><label>Data Granularity</label><md-select ng-model="vm.msj.granularityName" ng-disabled="!vm.isCreate" required=""><md-option ng-value="granularity.name" ng-repeat="granularity in vm.dataGranularities">{{ granularity.name }}</md-option></md-select></md-input-container></div><br><div><div layout="row"><md-input-container class="md-block"><label>Job Group</label><md-select ng-model="vm.jobGroup" ng-disabled="!vm.isCreate"><md-option ng-value="jobGroup.id" ng-repeat="jobGroup in vm.jobGroups">{{ jobGroup.name }}</md-option></md-select></md-input-container><md-button md-no-ink="" ng-class="\'md-primary\'" ng-disabled="!vm.isCreate || !vm.jobGroup" ng-click="vm.jobGroup = null">Unselect Job Group</md-button></div><md-input-container class="md-block"><label>Cable</label><md-select ng-model="vm.msj.cgId" ng-change="vm.getSensorsFromTemperatureChannel()" placeholder="{{vm.channelGroups && vm.channelGroups.length > 0 ? \'Select Cable\' : \'No Cables Available\'}}" ng-disabled="!vm.isCreate || !vm.channelGroups || vm.channelGroups.length === 0" required=""><md-option ng-value="channelGroup.id" ng-repeat="channelGroup in vm.channelGroups">{{ channelGroup.channelGroupId }}</md-option></md-select></md-input-container><br><div class="form-group" ng-if="vm.isCreate"><label>Sensors<br><ui-select multiple="" limit="100" ng-model="vm.selectedSensorsMessages" class="btn-group bootstrap-select form-control" append-to-body="true" close-on-select="false" ng-change="vm.onSensorsSelected()" ng-model-options="{debounce: 1250}" style="width: 350px;" required=""><ui-select-match placeholder="{{vm.sensors && vm.sensors.length > 0 ? \'Select Sensors\' : \'No Sensors Available\'}}" <span="">Sensor {{$item.sensorId}}</ui-select-match><ui-select-choices repeat="sensor in vm.sensors | filter: $select.search"><span ng-bind-html="\'Sensor \' + sensor.sensorId"></span></ui-select-choices></ui-select></label></div></div><br><div><md-input-container class="md-block"><label>Datum Temperature (\xB0C)</label> <input form="newMaturityStrengthJobForm" type="number" step="0.01" ng-model="vm.msj.datumTemperature" required="" ng-readonly="!vm.isCreate"></md-input-container><md-input-container class="md-block"><label>Refresh Rate (s)</label> <input form="newMaturityStrengthJobForm" type="number" min="300" step="1" ng-model="vm.msj.refreshRate" required="" ng-readonly="!vm.isCreate"></md-input-container><md-input-container class="md-block"><label>Concrete Strength Alarm Threshold (MPa)</label> <input form="newMaturityStrengthJobForm" type="number" step="0.01" ng-model="vm.singularAlarmThreshold" ng-readonly="!vm.isCreate"></md-input-container></div><br><div><md-input-container class="md-block"><label>Maturity Function</label><md-select ng-model="vm.msj.maturityFunctionTypeName" ng-disabled="!vm.isCreate" required=""><md-option ng-value="maturityFunctionType.name" ng-repeat="maturityFunctionType in vm.maturityFunctionTypes">{{ maturityFunctionType.name }}</md-option></md-select></md-input-container><br ng-if="!vm.isCreate"><md-input-container class="md-block"><label>Maturity Strength Function</label><md-select ng-model="vm.msj.maturityStrengthFunctionTypeName" ng-change="vm.onMaturityStrengthFunctionSelected()" ng-disabled="!vm.isCreate" required=""><md-option ng-value="maturityStrengthFunctionType.name" ng-repeat="maturityStrengthFunctionType in vm.maturityStrengthFunctionTypes">{{ maturityStrengthFunctionType.name }}</md-option></md-select></md-input-container></div><br><div ng-if="vm.msj.maturityStrengthFunctionTypeName"><label style="color: grey; font-weight: normal">Maturity Strength Function Parameters</label><md-divider></md-divider><div ng-if="vm.isCreate"><div layout="row" ng-if="vm.displayMaturityStrengthFunctionParamField(0)"><md-input-container><label>Name</label> <input form="newMaturityStrengthJobForm" type="text" ng-model="vm.maturityStrengthFunctionParams[0].name" readonly=""></md-input-container><md-input-container><label>Value</label> <input form="newMaturityStrengthJobForm" type="number" step="0.0001" ng-model="vm.maturityStrengthFunctionParams[0].val"></md-input-container></div><div layout="row" ng-if="vm.displayMaturityStrengthFunctionParamField(1)"><md-input-container><label>Name</label> <input form="newMaturityStrengthJobForm" type="text" ng-model="vm.maturityStrengthFunctionParams[1].name" readonly=""></md-input-container><md-input-container><label>Value</label> <input form="newMaturityStrengthJobForm" type="number" step="0.0001" ng-model="vm.maturityStrengthFunctionParams[1].val"></md-input-container></div><div layout="row" ng-if="vm.displayMaturityStrengthFunctionParamField(2)"><md-input-container><label>Name</label> <input form="newMaturityStrengthJobForm" type="text" ng-model="vm.maturityStrengthFunctionParams[2].name" readonly=""></md-input-container><md-input-container><label>Value</label> <input form="newMaturityStrengthJobForm" type="number" step="0.0001" ng-model="vm.maturityStrengthFunctionParams[2].val"></md-input-container></div><div layout="row" ng-if="vm.displayMaturityStrengthFunctionParamField(3)"><md-input-container><label>Name</label> <input form="newMaturityStrengthJobForm" type="text" ng-model="vm.maturityStrengthFunctionParams[3].name" readonly=""></md-input-container><md-input-container><label>Value</label> <input form="newMaturityStrengthJobForm" type="number" step="0.0001" ng-model="vm.maturityStrengthFunctionParams[3].val"></md-input-container></div><div layout="row" ng-if="vm.displayMaturityStrengthFunctionParamField(4)"><md-input-container><label>Name</label> <input form="newMaturityStrengthJobForm" type="text" ng-model="vm.maturityStrengthFunctionParams[4].name" readonly=""></md-input-container><md-input-container><label>Value</label> <input form="newMaturityStrengthJobForm" type="number" step="0.0001" ng-model="vm.maturityStrengthFunctionParams[4].val"></md-input-container></div></div><table class="table table-bordered" ng-if="vm.msj.maturityStrengthFunctionParams && !vm.isCreate"><thead><tr class="sortable"><th>Name</th><th>Value</th></tr></thead><tbody><tr ng-repeat="maturityStrengthFunctionParam in vm.msj.maturityStrengthFunctionParams track by $index"><td><span>{{maturityStrengthFunctionParam.name || \'Empty\'}}</span></td><td><span>{{maturityStrengthFunctionParam.val || \'Empty\'}}</span></td></tr></tbody><br ng-if="!vm.isCreate"></table></div><br><div ng-if="vm.isCreate"><div ng-if="newMaturityStrengthJobForm.$valid"><button style="width:100%;" type="submit" progress-button="vm.createMaturityStrengthJob()" pb-style="rotate-side-down">Start Maturity Strength Job</button></div><div ng-if="!newMaturityStrengthJobForm.$valid"><button type="submit" class="maturity-strength-job-progress-button-invalid">Start Maturity Strength Job</button></div><div style="padding-top: 10px"><button class="maturity-strength-job-progress-button-cancel" ng-click="vm.cancel()">Cancel</button></div></div></form></md-content></div></md-tab><md-tab label="Latest" md-on-select="vm.graphLinksEnabled = false;" ng-if="!vm.isCreate" ng-disabled="vm.isLoading"><br><div><md-content flex="" layout-padding="" class="latest-panel">Maturity Strength Job {{vm.msj.id}}<md-button md-no-ink="" ng-disabled="vm.readOnly || vm.msj.status !== \'RUNNING\'" ng-class="\'md-accent\'" ng-click="vm.terminateMaturityStrengthJob(vm.msj.id)">Terminate</md-button><md-divider></md-divider><br><div style="display: flex;"><div style="margin-right: 25px"><div class="form-group"><label for="latest-cable">Cable</label> <input type="text" class="form-control input-field" id="latest-cable" value="{{vm.msj.channelGroupId}}" readonly=""></div><div class="form-group"><label for="latest-singular-alarm-threshold">Concrete Strength Alarm Threshold</label> <input type="text" class="form-control input-field" id="latest-singular-alarm-threshold" value="{{vm.singularAlarmThreshold ? vm.singularAlarmThreshold + \' MPa\' : \'NONE\'}}" readonly=""></div></div><div><div class="form-group"><label for="latest-status">Status</label> <input type="text" class="form-control" id="latest-status" value="{{vm.msj.status}}" ng-style="vm.getStatusColor(vm.msj.status)" readonly=""></div><div class="form-group"><label for="latest-alarms-triggered">Alarms Triggered</label> <input type="text" class="form-control" id="latest-alarms-triggered" value="{{(vm.msj.alarmSensors1 > 0 || vm.msj.alarmSensors2 > 0) ? \'TRIGGERED\' : \'NONE\'}}" ng-class="(vm.msj.alarmSensors1 > 0 || vm.msj.alarmSensors2 > 0) ? \'status-value-success\' : \'status-value-error\'" readonly=""></div></div></div><br><div style="display: flex;"><table class="table table-bordered" ng-if="vm.latestSensorsMsjData"><thead><tr class="sortable"><th style="display: none; text-align: center;">Channel</th><th style="text-align: center;">Sensor</th><th style="text-align: center;">Maturity Index (\xB15%)</th><th style="text-align: center;">Strength (\xB15%)</th><th style="text-align: center;">Data Timestamp</th><th style="text-align: center;">Alarm</th></tr></thead><tbody><tr ng-repeat="sensorsData in vm.latestSensorsMsjData"><td style="display: none; text-align: center;">{{sensorsData.channelId}}</td><td style="text-align: center;">{{sensorsData.sensorId}}</td><td ng-class="{ \'status-value-neutral\' : sensorsData.latestValueTimestamp }" style="text-align: center;"><span ng-if="sensorsData.latestValueTimestamp">{{sensorsData.latestMaturityIndex | number: 2}} \xB0CHrs</span> <span ng-if="!sensorsData.latestValueTimestamp">-</span></td><td ng-class="{ \'status-value-neutral\' : sensorsData.latestValueTimestamp, \'status-value-success status-success-flashing\' : sensorsData.latestValueTimestamp && sensorsData.alarmTriggered }" style="text-align: center;"><span ng-if="sensorsData.latestValueTimestamp">{{sensorsData.latestStrength | number: 2}} MPa</span> <span ng-if="!sensorsData.latestValueTimestamp">-</span></td><td style="text-align: center;">{{sensorsData.latestValueTimestamp ? (sensorsData.latestValueTimestamp) : "-"}}</td><td style="text-align: center;"><span ng-if="!sensorsData.latestValueTimestamp">-</span> <i class="fa fa-ban status-value-none" aria-hidden="true" ng-if="sensorsData.latestValueTimestamp && !vm.msj.alarmData"></i> <i class="fa fa-bell-slash status-value-none" aria-hidden="true" ng-if="sensorsData.latestValueTimestamp && vm.msj.alarmData && !sensorsData.alarmTriggered"></i> <i class="fa fa-bell faa-shake animated status-value-success" aria-hidden="true" ng-if="sensorsData.latestValueTimestamp && vm.msj.alarmData && sensorsData.alarmTriggered"></i></td></tr></tbody></table></div><br><br></md-content></div></md-tab><md-tab label="Graphs" id="anchor_top" md-on-select="vm.graphLinksEnabled = true;" ng-if="!vm.isCreate" ng-disabled="vm.isLoading"><br><div flex="" layout="row"><md-content flex="" layout-padding="" class="graph-panel"><div style="display: flex; justify-content: space-between;"><div>Maturity Strength Job {{vm.msj.id}}<md-button md-no-ink="" ng-disabled="vm.readOnly || vm.msj.status !== \'RUNNING\'" ng-class="\'md-accent\'" ng-click="vm.terminateMaturityStrengthJob(vm.msj.id)">Terminate</md-button></div><div class="form-group"><label for="graph-datum-temperature">Datum Temperature</label> <input type="text" class="form-control input-field" id="graph-datum-temperature" value="{{vm.msj.datumTemperature}}" readonly=""></div><div class="form-group select-page-size-wrap" ng-disabled="vm.isLoading"><label>Sensor<ui-select ng-model="vm.selectedDataSensor" on-select="vm.onDataSensorSelected()" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Select Sensor"><span>{{$select.selected.sensorId}}</span></ui-select-match><ui-select-choices repeat="temperatureSensor in vm.maturityStrengthJobSensors.temperature | filter: $select.search"><span ng-bind-html="temperatureSensor.sensorId"></span></ui-select-choices></ui-select></label></div></div><md-divider></md-divider><div ng-if="vm.selectedDataSensor"><div class="col-md-12 col-lg-12 maturity-strength-graph" id="anchor_temperature"><md-content class="md-padding" layout="column" flex=""><div class="maturity-strength-graph-label"><span>Temperature (\xB0C)&nbsp;&nbsp;</span> <button type="button" class="btn btn-default" title="Reset Zoom Level" ng-if="vm.getDataAvailability(\'temperature\')" ng-click="vm.resetMaturityStrengthGraphZoom(\'temperature\')"><span><i class="fa fa fa-undo" aria-hidden="true"></i></span></button></div><canvas ng-if="vm.getDataAvailability(\'temperature\')" class="chart chart-line" chart-data="vm.graphData.temperature" chart-series="vm.maturityStrengthGraphSeries.temperature" chart-options="vm.maturityStrengthGraphOptions.temperature"></canvas><div class="user-instruction" ng-if="!vm.getDataAvailability(\'temperature\')"><h4>DATA UNAVAILABLE</h4></div></md-content></div><div class="col-md-12 col-lg-12 maturity-strength-graph" id="anchor_maturity"><md-content class="md-padding" layout="column" flex=""><div class="maturity-strength-graph-label"><span>Maturity Index (\xB0CHrs)&nbsp;&nbsp;</span> <button type="button" class="btn btn-default" title="Reset Zoom Level" ng-if="vm.getDataAvailability(\'maturityIndex\')" ng-click="vm.resetMaturityStrengthGraphZoom(\'maturityIndex\')"><span><i class="fa fa fa-undo" aria-hidden="true"></i></span></button></div><canvas ng-if="vm.getDataAvailability(\'maturityIndex\')" class="chart chart-line" chart-data="vm.graphData.maturityIndex" chart-series="vm.maturityStrengthGraphSeries.maturityIndex" chart-options="vm.maturityStrengthGraphOptions.maturityIndex"></canvas><div class="user-instruction" ng-if="!vm.getDataAvailability(\'maturityIndex\')"><h4>DATA UNAVAILABLE</h4></div></md-content></div><div class="col-md-12 col-lg-12 maturity-strength-graph" id="anchor_strength"><md-content class="md-padding" layout="column" flex=""><div class="maturity-strength-graph-label"><span>Strength (MPa)&nbsp;&nbsp;</span> <button type="button" class="btn btn-default" title="Reset Zoom Level" ng-if="vm.getDataAvailability(\'strength\')" ng-click="vm.resetMaturityStrengthGraphZoom(\'strength\')"><span><i class="fa fa fa-undo" aria-hidden="true"></i></span></button></div><canvas ng-if="vm.getDataAvailability(\'strength\')" class="chart chart-line" chart-data="vm.graphData.strength" chart-series="vm.maturityStrengthGraphSeries.strength" chart-options="vm.maturityStrengthGraphOptions.strength"></canvas><div class="user-instruction" ng-if="!vm.getDataAvailability(\'strength\')"><h4>DATA UNAVAILABLE</h4></div></md-content></div><div class="col-md-12 col-lg-12 maturity-strength-graph" id="anchor_humidity"><md-content class="md-padding" layout="column" flex=""><div class="maturity-strength-graph-label"><span>Humidity&nbsp;&nbsp;</span> <button type="button" class="btn btn-default" title="Reset Zoom Level" ng-if="vm.getDataAvailability(\'humidity\')" ng-click="vm.resetMaturityStrengthGraphZoom(\'humidity\')"><span><i class="fa fa fa-undo" aria-hidden="true"></i></span></button></div><canvas ng-if="vm.getDataAvailability(\'humidity\')" class="chart chart-line" chart-data="vm.graphData.humidity" chart-series="vm.maturityStrengthGraphSeries.humidity" chart-options="vm.maturityStrengthGraphOptions.humidity"></canvas><div class="user-instruction" ng-if="!vm.getDataAvailability(\'humidity\')"><h4>DATA UNAVAILABLE</h4></div></md-content></div></div><div class="user-instruction-graph" ng-if="!vm.isLoading && !vm.selectedDataSensor"><span><h4>To view Maturity Strength graphs, first select a sensor from the above</h4></span> <span><h4>Then navigate with the links in the black nav bar</h4></span></div></md-content></div></md-tab></md-tabs></md-content></div></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/settings/alarm/alarm.html','<div class="horizontal-scroll alarmSettings" ng-if="vm.tenant !== null"><md-content layout-padding=""><md-tabs md-dynamic-height="" md-primary="" md-border-bottom=""><md-tab label="Environment Sensor Alarms" md-on-select="vm.refreshEnvironSensorAlarms()"><div style="min-height: 250px;"><br><br><div layout="row" layout-sm="column" layout-align="space-around" ng-show="vm.isEnvironSensorAlarmsLoading"><md-progress-circular md-mode="indeterminate" md-diameter="120" style="position:fixed; left:40%; bottom:7%; z-index: 10;"></md-progress-circular></div><div class="environSensorTable table-container" st-table="vm.displayedEnvironSensors" st-safe-src="vm.environSensors"><table class="table table-bordered"><thead><tr class="sortable"><th class="table-id" st-sort="id" style="display:none;">ID</th><th>Sensor ID</th><th>Type</th><th>Alarm ID</th><th>LBound<br>Low</th><th>LBound<br>Medium</th><th>LBound<br>High</th><th>HBound<br>Low</th><th>HBound<br>Medium</th><th>HBound<br>High</th></tr></thead><tbody><tr ng-repeat="environSensor in vm.environSensors" class="editable-row"><td style="display:none;">{{environSensor.id}}</td><td class="sensor-id-cell">{{environSensor.sensorId}}</td><td class="sensor-id-cell">{{environSensor.environSensorType}}</td><td class="alarm-id-cell"><ui-select ng-model="environSensor.alarmData.id" on-select="vm.onEnvironSensorAlarmChanged(environSensor, $item)" class="btn-group bootstrap-select form-control" append-to-body="true" spinner-enabled="true" search-enabled="false"><ui-select-match allow-clear="true" placeholder="None"><span>{{$select.selected.alarmData.id}}</span></ui-select-match><ui-select-choices repeat="environSensorAlarm.alarmData.id as environSensorAlarm in vm.environSensorAlarms"><span ng-bind-html="environSensorAlarm.alarmData.id"></span></ui-select-choices></ui-select></td><td ng-class="environSensor.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><span editable-number="environSensor.alarmData.lowThresholdLBound" e-step="0.01" e-name="lowThresholdLBound" e-form="rowform">{{environSensor.alarmData.id ? (environSensor.alarmData.lowThresholdLBound || \'Empty\') : \'\'}}</span></td><td ng-class="environSensor.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><span editable-number="environSensor.alarmData.mediumThresholdLBound" e-step="0.01" e-name="mediumThresholdLBound" e-form="rowform">{{environSensor.alarmData.id ? (environSensor.alarmData.mediumThresholdLBound || \'Empty\') : \'\'}}</span></td><td ng-class="environSensor.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><span editable-number="environSensor.alarmData.highThresholdLBound" e-step="0.01" e-name="highThresholdLBound" e-form="rowform">{{environSensor.alarmData.id ? (environSensor.alarmData.highThresholdLBound || \'Empty\') : \'\'}}</span></td><td ng-class="environSensor.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><span editable-number="environSensor.alarmData.lowThresholdHBound" e-step="0.01" e-name="lowThresholdHBound" e-form="rowform">{{environSensor.alarmData.id ? (environSensor.alarmData.lowThresholdHBound || \'Empty\') : \'\'}}</span></td><td ng-class="environSensor.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><span editable-number="environSensor.alarmData.mediumThresholdHBound" e-step="0.01" e-name="mediumThresholdHBound" e-form="rowform">{{environSensor.alarmData.id ? (environSensor.alarmData.mediumThresholdHBound || \'Empty\') : \'\'}}</span></td><td ng-class="environSensor.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><span editable-number="environSensor.alarmData.highThresholdHBound" e-step="0.01" e-name="highThresholdHBound" e-form="rowform">{{environSensor.alarmData.id ? (environSensor.alarmData.highThresholdHBound || \'Empty\') : \'\'}}</span></td><td ng-class="environSensor.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" onbeforesave="vm.setAlarmThresholds(environSensor.alarmData, $data, \'ENVIRON_SENSOR_THRESHOLD\')"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Save</button> <button type="button" class="btn btn-danger editable-table-button btn-xs" ng-click="rowform.$cancel(); vm.isEditingAlarm = false;" ng-disabled="rowform.$waiting">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn editable-table-button btn-xs" ng-class="environSensor.alarmData.id ? \'btn-primary\' : \'\'" ng-click="rowform.$show(); vm.isEditingAlarm = true;" ng-show="!vm.readOnly && !vm.isEditingAlarm" ng-disabled="!environSensor.alarmData.id">{{environSensor.alarmData.id ? \'Edit Alarm\' : \'No Alarm\'}}</button> <button class="btn btn-warning editable-table-button btn-xs" ng-show="!vm.readOnly && !vm.isEditingAlarm" ng-click="vm.showNewEnvironSensorAlarmModal($event, environSensor.sensorId, environSensor.environSensorType)">New Alarm</button></div></td></tr></tbody></table></div></div></md-tab><md-tab label="Channel Sensor Alarms" md-on-select="vm.refreshChannelAlarms()"><div style="min-height: 250px;"><br><br><div layout="row" layout-sm="column" layout-align="space-around" ng-show="vm.isChannelAlarmsLoading"><md-progress-circular md-mode="indeterminate" md-diameter="120" style="position:fixed; left:40%; bottom:7%; z-index: 10;"></md-progress-circular></div><div class="channelTable table-container" st-table="vm.displayedChannels" st-safe-src="vm.channels"><table class="table table-bordered"><thead><tr class="sortable"><th class="table-id" st-sort="id" style="display:none;">ID</th><th>Channel ID</th><th>Alarm ID</th><th>LBound<br>Low</th><th>LBound<br>Medium</th><th>LBound<br>High</th><th>HBound<br>Low</th><th>HBound<br>Medium</th><th>HBound<br>High</th></tr></thead><tbody><tr ng-repeat="channel in vm.channels" class="editable-row"><td style="display:none;">{{channel.id}}</td><td class="sensor-id-cell">{{channel.channelId}}</td><td class="alarm-id-cell"><ui-select ng-model="channel.alarmData.id" on-select="vm.onChannelAlarmChanged(channel, $item)" class="btn-group bootstrap-select form-control" append-to-body="true" spinner-enabled="true" search-enabled="false"><ui-select-match allow-clear="true" placeholder="None"><span>{{$select.selected.alarmData.id}}</span></ui-select-match><ui-select-choices repeat="channelAlarm.alarmData.id as channelAlarm in vm.channelAlarms"><span ng-bind-html="channelAlarm.alarmData.id"></span></ui-select-choices></ui-select></td><td ng-class="channel.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><span editable-number="channel.alarmData.lowThresholdLBound" e-step="0.01" e-name="lowThresholdLBound" e-form="rowform">{{channel.alarmData.id ? (channel.alarmData.lowThresholdLBound || \'Empty\') : \'\'}}</span></td><td ng-class="channel.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><span editable-number="channel.alarmData.mediumThresholdLBound" e-step="0.01" e-name="mediumThresholdLBound" e-form="rowform">{{channel.alarmData.id ? (channel.alarmData.mediumThresholdLBound || \'Empty\') : \'\'}}</span></td><td ng-class="channel.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><span editable-number="channel.alarmData.highThresholdLBound" e-step="0.01" e-name="highThresholdLBound" e-form="rowform">{{channel.alarmData.id ? (channel.alarmData.highThresholdLBound || \'Empty\') : \'\'}}</span></td><td ng-class="channel.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><span editable-number="channel.alarmData.lowThresholdHBound" e-step="0.01" e-name="lowThresholdHBound" e-form="rowform">{{channel.alarmData.id ? (channel.alarmData.lowThresholdHBound || \'Empty\') : \'\'}}</span></td><td ng-class="channel.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><span editable-number="channel.alarmData.mediumThresholdHBound" e-step="0.01" e-name="mediumThresholdHBound" e-form="rowform">{{channel.alarmData.id ? (channel.alarmData.mediumThresholdHBound || \'Empty\') : \'\'}}</span></td><td ng-class="channel.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><span editable-number="channel.alarmData.highThresholdHBound" e-step="0.01" e-name="highThresholdHBound" e-form="rowform">{{channel.alarmData.id ? (channel.alarmData.highThresholdHBound || \'Empty\') : \'\'}}</span></td><td ng-class="channel.alarmData.id ? \'alarm-cell-normal\' : \'alarm-cell-none\'"><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" onbeforesave="vm.setAlarmThresholds(channel.alarmData, $data, \'ENVIRON_SENSOR_THRESHOLD\')"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Save</button> <button type="button" class="btn btn-danger editable-table-button btn-xs" ng-click="rowform.$cancel(); vm.isEditingAlarm = false;" ng-disabled="rowform.$waiting">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn editable-table-button btn-xs" ng-class="channel.alarmData.id ? \'btn-primary\' : \'\'" ng-click="rowform.$show(); vm.isEditingAlarm = true;" ng-show="!vm.readOnly && !vm.isEditingAlarm" ng-disabled="!channel.alarmData.id">{{channel.alarmData.id ? \'Edit Alarm\' : \'No Alarm\'}}</button> <button class="btn btn-warning editable-table-button btn-xs" ng-show="!vm.readOnly && !vm.isEditingAlarm" ng-click="vm.showNewChannelAlarmModal($event, channel.channelId)">New Alarm</button></div></td></tr></tbody></table></div></div><br><br></md-tab></md-tabs></md-content></div>');
$templateCache.put('app/pages/settings/alarm/newChannelAlarmModal.tmpl.html','<md-dialog class="newAlarmModal" aria-label="Create New Alarm"><md-toolbar><div class="md-toolbar-tools"><h3>Create New Alarm</h3><span flex=""></span></div></md-toolbar><md-content><md-content class="md-padding">Channel {{vm.channelId}}<md-divider></md-divider><br><form class="settingform" name="newAlarmForm"><div class="form-group"><label>LBound Low</label> <input type="number" step="0.00001" class="form-control" ng-model="vm.alarmData.lowThresholdLBound"></div><div class="form-group"><label>LBound Medium</label> <input type="number" step="0.00001" class="form-control" ng-model="vm.alarmData.mediumThresholdLBound"></div><div class="form-group"><label>LBound High</label> <input type="number" step="0.00001" class="form-control" ng-model="vm.alarmData.highThresholdLBound"></div><div class="form-group"><label>HBound Low</label> <input type="number" step="0.00001" class="form-control" ng-model="vm.alarmData.lowThresholdHBound"></div><div class="form-group"><label>HBound Medium</label> <input type="number" step="0.00001" class="form-control" ng-model="vm.alarmData.mediumThresholdHBound"></div><div class="form-group"><label>HBound High</label> <input type="number" step="0.00001" class="form-control" ng-model="vm.alarmData.highThresholdHBound"></div><br><div ng-if="newAlarmForm.$valid"><button type="submit" progress-button="vm.createAlarm()" pb-style="rotate-side-down">Create & Assign New Alarm</button></div><div ng-if="!newAlarmForm.$valid"><button type="submit" class="new-alarm-progress-button-invalid">Create & Assign New Alarm</button></div><div style="padding-top: 10px"><button class="new-alarm-progress-button-cancel" ng-click="vm.cancel()">Cancel</button></div></form></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/settings/alarm/newEnvironSensorAlarmModal.tmpl.html','<md-dialog class="newAlarmModal" aria-label="Create New Alarm"><md-toolbar><div class="md-toolbar-tools"><h3>Create New Alarm</h3><span flex=""></span></div></md-toolbar><md-content><md-content class="md-padding">Environ Sensor {{vm.environSensorId}} - {{vm.environSensorType}}<md-divider></md-divider><br><form class="settingform" name="newAlarmForm"><div class="form-group"><label>LBound Low</label> <input type="number" step="0.00001" class="form-control" ng-model="vm.alarmData.lowThresholdLBound"></div><div class="form-group"><label>LBound Medium</label> <input type="number" step="0.00001" class="form-control" ng-model="vm.alarmData.mediumThresholdLBound"></div><div class="form-group"><label>LBound High</label> <input type="number" step="0.00001" class="form-control" ng-model="vm.alarmData.highThresholdLBound"></div><div class="form-group"><label>HBound Low</label> <input type="number" step="0.00001" class="form-control" ng-model="vm.alarmData.lowThresholdHBound"></div><div class="form-group"><label>HBound Medium</label> <input type="number" step="0.00001" class="form-control" ng-model="vm.alarmData.mediumThresholdHBound"></div><div class="form-group"><label>HBound High</label> <input type="number" step="0.00001" class="form-control" ng-model="vm.alarmData.highThresholdHBound"></div><br><div ng-if="newAlarmForm.$valid"><button type="submit" progress-button="vm.createAlarm()" pb-style="rotate-side-down">Create & Assign New Alarm</button></div><div ng-if="!newAlarmForm.$valid"><button type="submit" class="new-alarm-progress-button-invalid">Create & Assign New Alarm</button></div><div style="padding-top: 10px"><button class="new-alarm-progress-button-cancel" ng-click="vm.cancel()">Cancel</button></div></form></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/settings/channel/channel.html','<div class="row channelSettings" ng-if="vm.tenant !== null"><div class="col-md-12 col-lg-12"><div class="panel panel-primary bootstrap-panel settingform-panel"><div class="panel-heading">Channel Settings</div><div class="panel-body"><md-content class="md-padding"><md-tabs md-dynamic-height="" md-primary="" md-border-bottom=""><md-tab label="File Based Configuration" ng-if="!vm.readOnly && (vm.enableFileBasedChannelSettings || vm.enableFileBasedSensorsCalibrations)"><br><div layout="row" flex="" class="content-wrapper"><div class="col-md-6 col-lg-6 channel-config-upload-content" ng-if="vm.enableFileBasedChannelSettings"><md-content layout="column" flex="" class="md-padding"><h5>Upload Channel Settings File</h5><p style="font-style: italic;">To configure one or more Channels</p><md-divider></md-divider><br><label class="btn btn-primary btn-sm channel-config-upload-input-button" style="padding-top: 6px" ng-disabled="vm.isLoading || vm.isSelectingChannelSettingsFile || vm.isExecutingChannelSettingsRequests"><span>Choose File</span> <input type="file" data-file-upload="" data-ng-model="vm.channelSettingsFile" ng-change="vm.onChannelSettingsFileChanged()" hidden=""></label><br><div ng-if="vm.channelSettingsFile">{{vm.channelSettingsFile.name}}<br>{{vm.channelSettingsFile.size}} byte(s)<br></div></md-content><div class="channel-config-upload-button" ng-if="!vm.isChannelsLoading && !vm.isSelectingChannelSettingsFile && vm.hasChannelSettingsRequests"><button progress-button="vm.executeChannelSettingsRequests()" pb-style="rotate-side-down">Upload And Update</button></div></div><div class="col-md-6 col-lg-6 channel-config-upload-content" ng-if="vm.enableFileBasedSensorsCalibrations"><md-content layout="column" flex="" class="md-padding"><h5>Upload Sensors Calibration File</h5><p style="font-style: italic;">To configure all Sensors of a Channel</p><md-divider></md-divider><br><label class="btn btn-primary btn-sm" style="padding-top: 6px" ng-disabled="vm.isLoading || vm.isSelectingCalibrationFile || vm.isExecutingSensorsCalibration"><span>Choose File</span> <input type="file" data-file-upload="" data-ng-model="vm.sensorsCalibrationFile" ng-change="vm.onSensorsCalibrationFileChanged()" hidden=""></label><br><div ng-if="vm.sensorsCalibrationFile">{{vm.sensorsCalibrationFile.name}}<br>{{vm.sensorsCalibrationFile.size}} byte(s)<br></div></md-content><div class="channel-config-upload-button" ng-if="!vm.isChannelsLoading && !vm.isSelectingCalibrationFile && vm.hasSensorsCalibration"><button progress-button="vm.executeSensorsCalibration()" pb-style="rotate-side-down">Upload And Update</button></div></div></div></md-tab><md-tab label="View and Edit Configuration"><br><div layout="row" flex="" class="content-wrapper col-xs-12" ng-show="vm.channels && vm.channels.length === 0"><div class="content-wrapper"><div class="user-instruction"><h4>No channels available</h4></div></div></div><div class="col-xs-12" ng-show="vm.channels && vm.channels.length !== 0"><div class="col-xs-12 col-md-4"><md-content flex="" role="navigation" style="width: 100%; background-color: white;"><md-list><md-list-item ng-repeat="channel in vm.channels" ng-click="vm.onChannelSelected($index, channel.channelId, channel.serialNumber)" ng-class="{\'channel-selection\': vm.selectedChannelIndex===$index}"><div class="md-list-item-text"><p>Channel {{channel.channelId}}</p></div></md-list-item></md-list></md-content></div><div class="col-xs-12 col-md-8"><br><div class="user-instruction row" ng-if="vm.selectedChannelIndex===null || vm.selectedChannelIndex===undefined"><h4>Select a channel on the left to view and update settings</h4></div><div class="row" ng-if="vm.selectedChannelIndex!==null"><md-content class="md-padding">Select below to update individual sensor configuration for Channel {{vm.selectedChannelId}} ({{vm.selectedSerialNumber}})<md-divider></md-divider><br><ui-select ng-model="vm.selectedSensor" on-select="vm.onSensorSelected()" class="btn-group bootstrap-select form-group" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Select Sensor"><span>Sensor {{$select.selected.sensorId}}</span></ui-select-match><ui-select-choices repeat="sensor in vm.sensors | filter: $select.search"><span ng-bind-html="\'Sensor \' + sensor.sensorId"></span></ui-select-choices></ui-select><div class="form-group"><button class="btn btn-primary btn-md" ng-click="vm.showSensorConfigModal($event)" ng-disabled="vm.selectedSensor===null">Configure</button></div></md-content><md-content class="md-padding">Edit form below to update channel settings for Channel {{vm.selectedChannelId}} ({{vm.selectedSerialNumber}})<md-divider></md-divider><br><form class="settingform" name="channelSettingsForm" ng-show="vm.channelsettings"><div class="form-group"><label>Width</label> <input type="number" class="form-control" ng-model="vm.channelsettings.channelSettingsData.WIDTH" required=""></div><div class="form-group"><label>Noise Floor</label> <input type="number" class="form-control" ng-model="vm.channelsettings.channelSettingsData.NOISE_FLOOR" required=""></div><div class="form-group"><label>Width Level</label> <input type="number" class="form-control" ng-model="vm.channelsettings.channelSettingsData.WIDTH_LVL" required=""></div><div class="form-group"><label>Relative Threshold</label> <input type="number" class="form-control" ng-model="vm.channelsettings.channelSettingsData.REL_THRESHOLD" required=""></div><div class="form-group"><label>Length</label> <input type="number" class="form-control" ng-model="vm.channelsettings.channelSettingsData.LENGTH" required=""></div><br><div ng-if="channelSettingsForm.$valid && !vm.readOnly"><button progress-button="vm.updateChannelSettings()" pb-style="rotate-side-down" ng-disabled="vm.channelsettings == null">Update Channel Settings</button></div><div ng-if="!channelSettingsForm.$valid || vm.readOnly"><button class="channel-settings-progress-button-invalid" ng-disabled="vm.channelsettings == null || vm.readOnly">Update Channel Settings</button></div></form></md-content></div></div></div></md-tab></md-tabs></md-content></div></div></div></div>');
$templateCache.put('app/pages/settings/channel/sensorConfigModal.tmpl.html','<md-dialog class="sensorConfigModal" aria-label="Configure Channel Sensor"><md-toolbar><div class="md-toolbar-tools"><h3>Edit Sensor {{vm.sensorId}}</h3><span flex=""></span></div></md-toolbar><md-content><md-tabs md-dynamic-height="" md-border-bottom=""><md-tab label="Calibration MTS" ng-if="vm.sensorType.toUpperCase() === \'TEMPERATURE\'"><md-content class="md-padding"><form class="settingform" name="calibrationMTSForm"><div class="form-group"><label>Lambda A</label> <input type="number" class="form-control" ng-model="vm.calibrationMTSData.LAMBDA_A" required=""></div><div class="form-group"><label>Lambda B</label> <input type="number" class="form-control" ng-model="vm.calibrationMTSData.LAMBDA_B" required=""></div><div class="form-group"><label>T0</label> <input type="number" class="form-control" ng-model="vm.calibrationMTSData.T0" required=""></div><div class="form-group"><label>G2</label> <input type="number" class="form-control" ng-model="vm.calibrationMTSData.G2" required=""></div><div class="form-group"><label>G1</label> <input type="number" class="form-control" ng-model="vm.calibrationMTSData.G1" required=""></div><div class="form-group"><label>Const</label> <input type="number" class="form-control" ng-model="vm.calibrationMTSData.CONST" required=""></div><div class="form-group"><label>LBound</label> <input type="number" class="form-control" ng-model="vm.calibrationMTSData.LBOUND" required=""></div><div class="form-group"><label>HBound</label> <input type="number" class="form-control" ng-model="vm.calibrationMTSData.HBOUND" required=""></div><div class="form-group"><label>Offset</label> <input type="number" class="form-control" ng-model="vm.calibrationMTSData.OFFSET" required=""></div><br><div ng-if="calibrationMTSForm.$valid && !vm.readOnly"><button progress-button="vm.updateCalibrationMTS()" pb-style="rotate-side-down" ng-disabled="vm.calibrationMTSData == null">Update Calibration MTS</button></div><div ng-if="!calibrationMTSForm.$valid || vm.readOnly"><button class="channel-settings-progress-button-invalid" ng-disabled="vm.calibrationMTSData == null || vm.readOnly">Update Calibration MTS</button></div><div style="padding-top: 10px"><button class="channel-settings-progress-button-cancel" ng-click="vm.cancel()">Cancel</button></div></form></md-content></md-tab><md-tab label="Calibration LPS" ng-if="vm.sensorType.toUpperCase() === \'PRESSURE\'"><md-content class="md-padding"><form class="settingform" name="calibrationLPSForm" ng-submit="vm.submit()"><div class="form-group"><label>Lambda 0 A</label> <input type="number" class="form-control" ng-model="vm.calibrationLPSData.LAMBDA_0_A" required=""></div><div class="form-group"><label>G2 A</label> <input type="number" class="form-control" ng-model="vm.calibrationLPSData.G2_A" required=""></div><div class="form-group"><label>G1 A</label> <input type="number" class="form-control" ng-model="vm.calibrationLPSData.G1_A" required=""></div><div class="form-group"><label>CONST A</label> <input type="number" class="form-control" ng-model="vm.calibrationLPSData.CONST_A" required=""></div><div class="form-group"><label>LBound A</label> <input type="number" class="form-control" ng-model="vm.calibrationLPSData.LBOUND_A" required=""></div><div class="form-group"><label>HBound A</label> <input type="number" class="form-control" ng-model="vm.calibrationLPSData.HBOUND_A" required=""></div><div class="form-group"><label>Lambda 0 B</label> <input type="number" class="form-control" ng-model="vm.calibrationLPSData.LAMBDA_0_B" required=""></div><div class="form-group"><label>G2 B</label> <input type="number" class="form-control" ng-model="vm.calibrationLPSData.G2_B" required=""></div><div class="form-group"><label>G1 B</label> <input type="number" class="form-control" ng-model="vm.calibrationLPSData.G1_B" required=""></div><div class="form-group"><label>CONST B</label> <input type="number" class="form-control" ng-model="vm.calibrationLPSData.CONST_B" required=""></div><div class="form-group"><label>LBound B</label> <input type="number" class="form-control" ng-model="vm.calibrationLPSData.LBOUND_B" required=""></div><div class="form-group"><label>HBound B</label> <input type="number" class="form-control" ng-model="vm.calibrationLPSData.HBOUND_B" required=""></div><br><div ng-if="calibrationLPSForm.$valid && !vm.readOnly"><button progress-button="vm.updateCalibrationLPS()" pb-style="rotate-side-down" ng-disabled="vm.calibrationLPSData == null">Update Calibration LPS</button></div><div ng-if="!calibrationLPSForm.$valid || vm.readOnly"><button class="channel-settings-progress-button-invalid" ng-disabled="vm.calibrationLPSData == null || vm.readOnly">Update Calibration LPS</button></div><div style="padding-top: 10px"><button class="channel-settings-progress-button-cancel" ng-click="vm.cancel()">Cancel</button></div></form></md-content></md-tab><md-tab label="Calibration MHS" ng-if="vm.sensorType.toUpperCase() === \'HUMIDITY\'"><md-content class="md-padding"><form class="settingform" name="calibrationMHSForm"><div class="form-group"><label>Lambda A</label> <input type="number" class="form-control" ng-model="vm.calibrationMHSData.LAMBDA_A" required=""></div><div class="form-group"><label>Lambda B</label> <input type="number" class="form-control" ng-model="vm.calibrationMHSData.LAMBDA_B" required=""></div><div class="form-group"><label>T0</label> <input type="number" class="form-control" ng-model="vm.calibrationMHSData.T0" required=""></div><div class="form-group"><label>G2</label> <input type="number" class="form-control" ng-model="vm.calibrationMHSData.G2" required=""></div><div class="form-group"><label>G1</label> <input type="number" class="form-control" ng-model="vm.calibrationMHSData.G1" required=""></div><div class="form-group"><label>Const</label> <input type="number" class="form-control" ng-model="vm.calibrationMHSData.CONST" required=""></div><div class="form-group"><label>LBound</label> <input type="number" class="form-control" ng-model="vm.calibrationMHSData.LBOUND" required=""></div><div class="form-group"><label>HBound</label> <input type="number" class="form-control" ng-model="vm.calibrationMHSData.HBOUND" required=""></div><div class="form-group"><label>Offset</label> <input type="number" class="form-control" ng-model="vm.calibrationMHSData.OFFSET" required=""></div><br><div ng-if="calibrationMHSForm.$valid && !vm.readOnly"><button progress-button="vm.updateCalibrationMHS()" pb-style="rotate-side-down" ng-disabled="vm.calibrationMHSData == null">Update Calibration MHS</button></div><div ng-if="!calibrationMHSForm.$valid || vm.readOnly"><button class="channel-settings-progress-button-invalid" ng-disabled="vm.calibrationMHSData == null || vm.readOnly">Update Calibration MHS</button></div><div style="padding-top: 10px"><button class="channel-settings-progress-button-cancel" ng-click="vm.cancel()">Cancel</button></div></form></md-content></md-tab></md-tabs></md-content></md-dialog>');
$templateCache.put('app/pages/settings/email/emailnotification.html','<div class="row" ng-if="vm.tenant !== null"><div class="col-md-8 col-lg-8"><div class="panel panel-primary bootstrap-panel settingform-panel"><div class="panel-heading">Email Notification List <a class="showNewEmailModalControl" ng-click="vm.showNewEmailModal($event)"><i class="fa fa-plus-circle" style="font-size:22px" ng-show="!vm.isLoading && !vm.readOnly" ng-disabled="vm.isToggling"></i></a></div><div class="panel-body"><div layout="row" layout-sm="column" layout-align="center center" aria-label="wait" style="height: 50px; z-index: 10;" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" class="md-primary"></md-progress-circular></div><div><md-list><md-list-item ng-repeat="email in vm.emails"><md-button aria-label="Delete Email Notification" ng-click="vm.deleteNotificationEmail(email)"><md-icon md-font-icon="fa fa-remove"></md-icon></md-button><p>{{ email.email }}</p><md-switch class="md-secondary" ng-model="email.isActive" ng-disabled="vm.readOnly" ng-change="vm.toggleEmailNotification(email)"></md-switch></md-list-item></md-list></div></div></div></div></div>');
$templateCache.put('app/pages/settings/email/newEmailModal.tmpl.html','<md-dialog class="newEmailModal" aria-label="Create New Email Notification"><md-toolbar><div class="md-toolbar-tools"><h3>Add New Email Notification</h3><span flex=""></span></div></md-toolbar><md-content><md-content class="md-padding">Please enter a valid email address<md-divider></md-divider><br><form class="settingform" name="newEmailForm"><div class="form-group" ng-class="{\'has-error\': newEmailForm.$invalid }"><input type="email" class="form-control" ng-model="vm.newEmail" placeholder="email@example.com" required=""></div><br><div ng-if="newEmailForm.$valid"><button progress-button="vm.addNotificationEmail()" pb-style="rotate-side-down" class="width-100">Add Email</button></div><div ng-if="!newEmailForm.$valid"><button class="new-email-progress-button-invalid width-100">Add Email</button></div><div style="padding-top: 10px"><button class="new-email-progress-button-cancel width-100" ng-click="vm.cancel()">Cancel</button></div></form></md-content></md-content></md-dialog>');
$templateCache.put('app/pages/settings/general/general.html','<div class="row generalSettings" ng-if="vm.tenant !== null"><div class="col-md-8 col-lg-8"><div class="panel panel-primary bootstrap-panel settingform-panel"><div class="panel-heading">General Settings</div><div class="panel-body"><div layout="row" layout-sm="column" layout-align="center center" aria-label="wait" style="height: 50px; z-index: 10;" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" class="md-primary"></md-progress-circular></div><form class="generalsettingform" name="generalSettingsForm" ng-show="vm.generalsettings"><div class="form-group" ng-repeat="generalsetting in vm.generalsettings"><ng-form name="generalSettingForm"><div ng-if="generalsetting.selectOptions"><label>{{generalsetting.display}}</label><ui-select ng-model="generalsetting.val" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="selectOption in generalsetting.selectOptions | filter: $select.search"><span ng-bind-html="selectOption"></span></ui-select-choices></ui-select></div><div ng-if="!generalsetting.selectOptions"><label>{{generalsetting.display}}</label> <input type="text" class="form-control" ng-model="generalsetting.val" ng-disabled="!generalsetting.canEdit"></div></ng-form></div><br><div ng-if="generalSettingsForm.$valid && !vm.readOnly"><button progress-button="vm.updateGeneralSettings()" pb-style="rotate-side-down" ng-disabled="vm.generalsettings == null">Update General Settings</button></div><div ng-if="!generalSettingsForm.$valid || vm.readOnly"><button class="general-settings-progress-button-invalid" ng-disabled="vm.generalsettings == null || vm.readOnly">Update General Settings</button></div></form></div></div></div></div>');
$templateCache.put('app/pages/settings/user/user.html','<div class="row userSettings"><div class="col-md-8 col-lg-8"><div class="panel panel-primary bootstrap-panel settingform-panel"><div class="panel-heading">User Settings</div><div class="panel-body"><div layout="row" layout-sm="column" layout-align="center center" aria-label="wait" style="height: 50px; z-index: 10;" ng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" class="md-primary"></md-progress-circular></div><form class="usersettingform" name="userSettingsForm" ng-if="vm.usersettings && vm.usersettingOptions"><div class="form-group" ng-repeat="usersetting in vm.usersettings"><ng-form name="userSettingForm"><div ng-if="usersetting.isConstrained"><label>{{usersetting.name}}</label><ui-select ng-init="options = vm.filterUserSettingOptions(usersetting.name)" ng-model="usersetting.val" ng-disabled="vm.readOnly && !usersetting.supportReadOnly" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="selectOption in options | filter: $select.search"><span ng-bind-html="selectOption"></span></ui-select-choices></ui-select></div><div ng-if="!usersetting.isConstrained"><label>{{usersetting.display}}</label> <input type="text" class="form-control" ng-model="usersetting.val" ng-disabled="vm.readOnly && !usersetting.supportReadOnly"></div></ng-form></div><br><div ng-if="userSettingsForm.$valid"><button progress-button="vm.updateUserSettings()" pb-style="rotate-side-down" ng-disabled="vm.usersettings == null">Update User Settings</button></div><div ng-if="!userSettingsForm.$valid"><button class="user-settings-progress-button-invalid" ng-disabled="vm.usersettings == null">Update User Settings</button></div></form></div></div></div></div>');}]);